import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  Currency: string;
  Cursor: any;
  EncodedFileInput: string;
  EncodedFileOutput: any;
  JSON: any;
  Timestamp: string;
  Validator: any;
};

export type AcceptReturnAuthorizationInput = {
  approvalTypeName: ApprovalTypeName;
  returnAuthorizationId: Scalars['ID'];
};

export type Address = {
  __typename?: 'Address';
  addressee?: Maybe<Scalars['String']>;
  city: Scalars['String'];
  company: Scalars['String'];
  countryCode: Scalars['String'];
  phone: Scalars['String'];
  postalCode: Scalars['String'];
  street1: Scalars['String'];
  street2: Scalars['String'];
  street3: Scalars['String'];
  usState: Scalars['String'];
};

export type AdminBatchInviteUserInput = {
  email: Scalars['String'];
  storeId: Scalars['ID'];
  temporaryPassword: Scalars['String'];
  userRoleTemplateId: Scalars['ID'];
};

export type AppEvent = {
  __typename?: 'AppEvent';
  displayName: Scalars['String'];
  id: Scalars['ID'];
  name: AppEventName;
};

export type AppEventName =
  | 'insurance_appleCarePurchased'
  | 'itemFulfillment_edfRecordMissing'
  | 'platform_failedHttpRequest'
  | 'platform_invalidOrderDataSubmitted'
  | 'platform_serverInit'
  | 'platform_unsuccessfulHttpRequestMade'
  | 'returnAuthorization_accepted'
  | 'returnAuthorization_declined'
  | 'returnAuthorization_delivered'
  | 'returnAuthorization_received'
  | 'returnAuthorization_refundApproved'
  | 'returnAuthorization_refundDenied'
  | 'returnAuthorization_requestApproved'
  | 'returnAuthorization_requestDeclined'
  | 'returnAuthorization_requested'
  | 'returnAuthorization_returnLabelCreated'
  | 'salesOrder_cancelled'
  | 'salesOrder_created'
  | 'salesOrder_delivered'
  | 'salesOrder_fulfilled'
  | 'salesOrder_paymentReceived'
  | 'salesOrder_processing'
  | 'salesOrder_shipped';

export type AppleCareAgreement = Node & {
  __typename?: 'AppleCareAgreement';
  activatedAt?: Maybe<Scalars['Timestamp']>;
  agreementNumber: Scalars['String'];
  apiRequests: HttpRequestPage;
  expiresAt?: Maybe<Scalars['Timestamp']>;
  id: Scalars['ID'];
  lineItem: LineItem;
  serialNumber: Scalars['String'];
};


export type AppleCareAgreementApiRequestsArgs = {
  options: QueryHttpRequestsOptionsInput;
};

export type AppleCareAgreementPage = Page & {
  __typename?: 'AppleCareAgreementPage';
  nodes: Array<AppleCareAgreement>;
  pageInfo: PageInfo;
};

export type AppleCareFulfillment = {
  __typename?: 'AppleCareFulfillment';
  id: Scalars['ID'];
  skus: Array<Scalars['String']>;
};

export type ApplyListingManagementStrategyTemplateGroupsInput = {
  storeId: Scalars['ID'];
  templateGroupIds: Array<Scalars['ID']>;
};

export type ApprovalType = {
  __typename?: 'ApprovalType';
  displayName: Scalars['String'];
  id: Scalars['ID'];
  name: ApprovalTypeName;
};

export type ApprovalTypeName =
  | 'approved'
  | 'denied'
  | 'pending';

export type ApproveReturnAuthorizationInput = {
  approvalTypeName: ApprovalTypeName;
  returnAuthorizationId: Scalars['ID'];
};

export type AsnFormatProperty = {
  __typename?: 'AsnFormatProperty';
  customColumnHeader: Scalars['String'];
  defaultValue: Scalars['String'];
  id: Scalars['ID'];
  property: OrderProperty;
};

export type AssignRoleInput = {
  siteUserId: Scalars['ID'];
  storeIds?: InputMaybe<Array<Scalars['ID']>>;
  userRoleTemplateId: Scalars['ID'];
};

export type AuditLogEvent = Node & {
  __typename?: 'AuditLogEvent';
  content: Scalars['String'];
  id: Scalars['ID'];
  metaCreated: Scalars['Timestamp'];
  title: Scalars['String'];
  triggeringSiteUser?: Maybe<SiteUserFull>;
};

export type AuditLogEventPage = Page & {
  __typename?: 'AuditLogEventPage';
  nodes: Array<AuditLogEvent>;
  pageInfo: PageInfo;
};

export type BaseFulfillment = {
  __typename?: 'BaseFulfillment';
  deliveryStatus: DeliveryStatus;
  id: Scalars['ID'];
  lineItems: FulfillmentLineItemPage;
  order: Order;
  status: FulfillmentStatus;
  type: FulfillmentType;
};

export type Carton = {
  __typename?: 'Carton';
  createdTimestamp: Scalars['Timestamp'];
  id: Scalars['ID'];
  returnAuthorizations: Array<Tier1ReturnAuthorization>;
  shipment?: Maybe<Shipment>;
};

export type CatalystFulfillment = {
  __typename?: 'CatalystFulfillment';
  activNo: Scalars['String'];
  fuelPointsCardNumber: Scalars['String'];
  id: Scalars['ID'];
  planSku: Scalars['String'];
  referralId: Scalars['String'];
  servicePasscode: Scalars['String'];
};

export type ChargeLine = {
  __typename?: 'ChargeLine';
  id: Scalars['ID'];
  name: Scalars['String'];
  subtotalCents: Scalars['Currency'];
  taxTotalCents: Scalars['Currency'];
  totalCents: Scalars['Currency'];
};

export type ChargeLineTypeName =
  | 'discount'
  | 'fee'
  | 'shipping';

export type ChatMessage = Node & {
  __typename?: 'ChatMessage';
  content: Scalars['String'];
  id: Scalars['ID'];
  metaCreated: Scalars['Timestamp'];
  senderName: Scalars['String'];
};

export type ChatMessagePage = Page & {
  __typename?: 'ChatMessagePage';
  nodes: Array<ChatMessage>;
  pageInfo: PageInfo;
};

export type ComparisonOperator = {
  __typename?: 'ComparisonOperator';
  displayName: Scalars['String'];
  id: Scalars['ID'];
  name: ComparisonOperatorName;
};

export type ComparisonOperatorName =
  | 'contains'
  | 'doesNotContain'
  | 'is'
  | 'isNot';

export type CredentialTypeName =
  | 'acquisitions'
  | 'leaseMaintenance';

export type CustomOrderFormatFlow = {
  __typename?: 'CustomOrderFormatFlow';
  id: Scalars['ID'];
  propertyMapping: Array<CustomOrderFormatPropertyMapping>;
  store: Store;
};

export type CustomOrderFormatPropertyMapping = {
  __typename?: 'CustomOrderFormatPropertyMapping';
  defaultValueOnEmpty: Scalars['String'];
  id: Scalars['ID'];
  mapToProperty: OrderProperty;
  sourceDataLabel: Scalars['String'];
};

export type CustomOrderFormatPropertyMappingInput = {
  defaultValueOnEmpty: Scalars['String'];
  mapToPropertyName: OrderPropertyName;
  sourceDataLabel: Scalars['String'];
};

export type Customer = Node & {
  __typename?: 'Customer';
  email: Scalars['String'];
  firstName: Scalars['String'];
  fullName: Scalars['String'];
  id: Scalars['ID'];
  lastName: Scalars['String'];
  netSuiteRecord?: Maybe<NetSuiteRecord>;
  netSuiteWriteRequest?: Maybe<NetSuiteWriteRequest>;
  phoneNumber: Scalars['String'];
};

export type CustomerPage = Page & {
  __typename?: 'CustomerPage';
  nodes: Array<Customer>;
  pageInfo: PageInfo;
};

export type Daemon = {
  __typename?: 'Daemon';
  displayName: Scalars['String'];
  id: Scalars['ID'];
  name: DaemonName;
};

export type DaemonName =
  | 'automatedReports'
  | 'cacheCleanup'
  | 'cacheSalesOrders'
  | 'e1Sync'
  | 'emails'
  | 'fulfillments'
  | 'inventory_reconciliation_shopify'
  | 'inventory_reconciliation_woocommerce'
  | 'inventory_syncItems'
  | 'itemFulfillment'
  | 'magicJackReportShipments'
  | 'netSuite_adjustOrderTotals'
  | 'netSuite_approveSalesOrdersForFulfillment'
  | 'netSuite_generateRequests'
  | 'netSuite_resolveValidationErrors'
  | 'netSuite_syncCustomers'
  | 'netSuite_syncDiscountItems'
  | 'netSuite_syncItemQty'
  | 'netSuite_syncProducts'
  | 'netSuite_syncReturnAuthorizations'
  | 'netSuite_syncSalesOrders'
  | 'netSuite_syncTier1Records'
  | 'netSuite_transactionIdLookUp'
  | 'processSalesOrderCache'
  | 'reportOrderCompletion'
  | 'salesOrderCancellation_appleCare'
  | 'salesOrderCancellation_baseFulfillment'
  | 'salesOrderCancellation_cancelStaleOrders'
  | 'salesOrderCancellation_e1'
  | 'salesOrderCancellation_netSuite'
  | 'salesOrderCancellation_shipStation'
  | 'salesOrderCancellation_shopify'
  | 'salesOrderCancellation_smartPay'
  | 'salesOrderCancellation_wooCommerce'
  | 'shipStationCacheOrders'
  | 'shipStationCacheShipments'
  | 'shipStationProcessCache'
  | 'shipStationWriteNewOrders'
  | 'shipments'
  | 'shopify_inventory_sync_listings'
  | 'smartPayFulfillLeaseApplications'
  | 'smartpayCacheLeaseApplications'
  | 'syncChargeLinesWithDiscountItems'
  | 'syncDiscountItems_shopify'
  | 'syncDiscountItems_wooCommerce'
  | 'tier1_processCachedReturnAuthorizations'
  | 'webhookMaintenance'
  | 'wooCommerceCheckForUpdatesToUnfulfilledOrders'
  | 'woocommerce_inventory_sync_listings'
  | 'writeRecordsToE1';

export type DaemonRunTimeSeriesInput = {
  daemon: DaemonName;
  endDate: Scalars['Timestamp'];
  intervalSeconds: Scalars['Int'];
  startDate: Scalars['Timestamp'];
};

export type DatabaseReport = {
  __typename?: 'DatabaseReport';
  id: Scalars['ID'];
  name: Scalars['String'];
  results: Array<Array<RowData>>;
  sqlQuery: Scalars['String'];
};


export type DatabaseReportResultsArgs = {
  input: DatabaseReportResultsFilterInput;
};

export type DatabaseReportResultsFilterInput = {
  storeId: Scalars['ID'];
};

export type DeliveryStatus = {
  __typename?: 'DeliveryStatus';
  displayName: Scalars['String'];
  id: Scalars['ID'];
  name: DeliveryStatusName;
};

export type DeliveryStatusName =
  | 'awaitingShipment'
  | 'delivered'
  | 'returnToShipper'
  | 'shipped'
  | 'shippingDelayed';

export type DevEdgeFulfillment = {
  __typename?: 'DevEdgeFulfillment';
  deliveryId: Scalars['String'];
  id: Scalars['ID'];
  isTest: Scalars['Boolean'];
  targetId: Scalars['String'];
  targetType: Scalars['String'];
};

export type DeviceIdentifierType = {
  __typename?: 'DeviceIdentifierType';
  displayName: Scalars['String'];
  id: Scalars['ID'];
  name: DeviceIdentifierTypeName;
};

export type DeviceIdentifierTypeName =
  | 'iccid'
  | 'imei';

export type DeviceLedgerInfo = {
  __typename?: 'DeviceLedgerInfo';
  iccid: Scalars['String'];
  imei: Scalars['String'];
  sku: Scalars['String'];
};

export type Dimension = {
  __typename?: 'Dimension';
  unit: DimensionUnit;
  value: Scalars['Float'];
};

export type DimensionUnit =
  | 'feet'
  | 'inches';

export type DiscountTypeName =
  | 'fixedCart'
  | 'fixedProduct'
  | 'percent';

export type E1ColumnData = {
  __typename?: 'E1ColumnData';
  columnName: Scalars['String'];
  value: Scalars['String'];
};

export type E1DocumentIndex = {
  __typename?: 'E1DocumentIndex';
  createdAt: Scalars['Timestamp'];
  eDocumentNumber: Scalars['String'];
  id: Scalars['ID'];
  urlToE1Record: Scalars['String'];
};

export type E142FileData = {
  __typename?: 'E142FileData';
  detailRows: Array<Array<E1ColumnData>>;
  headerRow: Array<E1ColumnData>;
  id: Scalars['ID'];
};

export type E147FileData = {
  __typename?: 'E147FileData';
  addressRow: Array<E1ColumnData>;
  detailRows: Array<Array<E1ColumnData>>;
  headerRow: Array<E1ColumnData>;
  id: Scalars['ID'];
};

export type EligibleOrder = Node & {
  __typename?: 'EligibleOrder';
  criteria: Array<SatisfactionCriteria>;
  id: Scalars['ID'];
  order: Order;
};

export type EligibleOrderPage = Page & {
  __typename?: 'EligibleOrderPage';
  nodes: Array<EligibleOrder>;
  pageInfo: PageInfo;
};

export type EmailSettingInput = {
  appEventName: AppEventName;
  isActive: Scalars['Boolean'];
  templateId: Scalars['String'];
};

export type Employee = {
  __typename?: 'Employee';
  fullName: Scalars['String'];
  id: Scalars['ID'];
  internalId: Scalars['String'];
};

export type ExportAsnInput = {
  after: Scalars['Timestamp'];
  before: Scalars['Timestamp'];
  storeId: Scalars['ID'];
};

export type ExportReportInput = {
  reportId: Scalars['ID'];
  storeId: Scalars['ID'];
};

export type ExternalOrder = Node & {
  __typename?: 'ExternalOrder';
  externalId: Scalars['String'];
  id: Scalars['ID'];
  isArchived: Scalars['Boolean'];
  metaCreated: Scalars['Timestamp'];
  rawData: Scalars['JSON'];
  rawOrderNumber: Scalars['String'];
  store: Store;
  url: Scalars['String'];
  validationErrors: Array<Scalars['String']>;
};

export type ExternalOrdersPage = Page & {
  __typename?: 'ExternalOrdersPage';
  nodes: Array<ExternalOrder>;
  pageInfo: PageInfo;
};

export type FeatureName =
  | 'importSalesOrders'
  | 'reportInventoryLevels'
  | 'reportPriceLevels';

export type FulfillmentDestination = SmartPayMerchant;

export type FulfillmentLineItem = Node & {
  __typename?: 'FulfillmentLineItem';
  iccid: Scalars['String'];
  id: Scalars['ID'];
  imei: Scalars['String'];
  metaCreated: Scalars['Timestamp'];
  quantity: Scalars['Int'];
  sku: Scalars['String'];
};

export type FulfillmentLineItemPage = Page & {
  __typename?: 'FulfillmentLineItemPage';
  nodes: Array<FulfillmentLineItem>;
  pageInfo: PageInfo;
};

export type FulfillmentStatus = {
  __typename?: 'FulfillmentStatus';
  displayName: Scalars['String'];
  id: Scalars['ID'];
  name: FulfillmentStatusName;
};

export type FulfillmentStatusName =
  | 'cancelled'
  | 'completed'
  | 'error'
  | 'pending'
  | 'prepared';

export type FulfillmentType = {
  __typename?: 'FulfillmentType';
  displayName: Scalars['String'];
  id: Scalars['ID'];
  name: FulfillmentTypeName;
};

export type FulfillmentTypeName =
  | 'devEdge'
  | 'standard';

export type GenerateLineItemSkuSwapInput = {
  lineItemId: Scalars['ID'];
  quantity: Scalars['Int'];
  swappedProductId: Scalars['ID'];
};

export type GenerateReturnLabelInput = {
  returnAuthorizationId: Scalars['ID'];
};

export type GenerateShippingLabelForTier1ReturnAuthorizationsInput = {
  cartonDimensions: SaveCartonDimensionsInput;
  cartonWeight: SaveWeightInput;
  returnAuthorizationIds: Array<Scalars['ID']>;
  shipToAddress: SaveAddressInput;
};

export type GenerateSkuSwapInput = {
  lineItems: Array<GenerateLineItemSkuSwapInput>;
};

export type HttpRequest = Node & {
  __typename?: 'HttpRequest';
  didDiscardResponseBody: Scalars['Boolean'];
  httpStatusCode: Scalars['Int'];
  id: Scalars['ID'];
  metaCreated: Scalars['Timestamp'];
  method: HttpRequestMethodName;
  requestBody: Scalars['JSON'];
  responseBody: Scalars['JSON'];
  url: Scalars['String'];
};

export type HttpRequestMethodName =
  | 'get'
  | 'post';

export type HttpRequestPage = {
  __typename?: 'HttpRequestPage';
  nodes: Array<HttpRequest>;
  pageInfo: PageInfo;
};

export type ImportBrandInput = {
  name: Scalars['String'];
  netSuiteInternalId: Scalars['String'];
};

export type ImportDepartmentInput = {
  name: Scalars['String'];
  netSuiteInternalId: Scalars['String'];
};

export type ImportEmployeeInput = {
  fullName: Scalars['String'];
  netSuiteInternalId: Scalars['String'];
};

export type ImportInventoryItemInput = {
  description: Scalars['String'];
  deviceType: Scalars['String'];
  name: Scalars['String'];
  netSuiteInternalId: Scalars['String'];
  sku: Scalars['String'];
};

export type ImportInventoryLocationInput = {
  name: Scalars['String'];
  netSuiteInternalId: Scalars['String'];
};

export type ImportOrderInput = {
  detail: Array<ImportPropertyValue>;
  lineItems: Array<ImportOrderLineItemInput>;
};

export type ImportOrderLineItemInput = {
  values: Array<ImportPropertyValue>;
};

export type ImportOrdersFromCsvInput = {
  orders: Array<ImportOrderInput>;
  storeId: Scalars['ID'];
};

export type ImportPaymentMethodInput = {
  name: Scalars['String'];
  netSuiteInternalId: Scalars['String'];
};

export type ImportPropertyValue = {
  propertyName: OrderPropertyName;
  value: Scalars['String'];
};

export type ImportShipItemInput = {
  name: Scalars['String'];
  netSuiteInternalId: Scalars['String'];
  subsidiaryId: Scalars['ID'];
};

export type ImportSubsidiaryInput = {
  name: Scalars['String'];
  netSuiteInternalId: Scalars['String'];
};

export type InitiateRefundInput = {
  approvalTypeName: ApprovalTypeName;
  returnAuthorizationId: Scalars['ID'];
};

export type InitiateReturnAuthorizationInput = {
  initialNote: Scalars['String'];
  lineItems: Array<ReturnAuthorizationLineItemInput>;
  orderId: Scalars['ID'];
};

export type InventoryNumberAssignment = {
  __typename?: 'InventoryNumberAssignment';
  id: Scalars['ID'];
  inventoryNumber: Scalars['String'];
  type: InventoryNumberAssignmentType;
};

export type InventoryNumberAssignmentType = {
  __typename?: 'InventoryNumberAssignmentType';
  displayName: Scalars['String'];
  id: Scalars['ID'];
  name: InventoryNumberAssignmentTypeName;
};

export type InventoryNumberAssignmentTypeName =
  | 'iccid'
  | 'imei';

export type Invite = Node & {
  __typename?: 'Invite';
  claimant?: Maybe<SiteUserFull>;
  id: Scalars['ID'];
  isClaimed: Scalars['Boolean'];
  recipientEmail: Scalars['String'];
  sentTimestamp?: Maybe<Scalars['Timestamp']>;
};

export type InvitePage = Page & {
  __typename?: 'InvitePage';
  nodes: Array<Invite>;
  pageInfo: PageInfo;
};

export type InviteUserInput = {
  recipientEmail: Scalars['String'];
  storeId?: InputMaybe<Scalars['ID']>;
};

export type Item = Node & {
  __typename?: 'Item';
  baselineQuantity: Scalars['Int'];
  canManageInventory: Scalars['Boolean'];
  currentQuantity: Scalars['Int'];
  defaultCostDollars: Scalars['Currency'];
  defaultPriceDollars: Scalars['Currency'];
  defaultWholesalePriceDollars: Scalars['Currency'];
  deltaQuantity: Scalars['Int'];
  description: Scalars['String'];
  deviceType: Scalars['String'];
  id: Scalars['ID'];
  itemBaselineQuantities: Array<ItemBaselineQuantity>;
  itemLastModifiedDate: Scalars['String'];
  itemQtyLastModifiedDate: Scalars['String'];
  listingManagementStrategies: Array<ListingManagementStrategy>;
  listingManagementStrategyCount: Scalars['Int'];
  listings: ListingPage;
  name: Scalars['String'];
  netSuiteInternalId?: Maybe<Scalars['String']>;
  sku: Scalars['String'];
  weightUnit: WeightUnit;
  weightValue: Scalars['Float'];
};


export type ItemCanManageInventoryArgs = {
  storeId: Scalars['ID'];
};


export type ItemListingsArgs = {
  options: QueryListingsOptionsInput;
};

export type ItemBaselineQuantity = {
  __typename?: 'ItemBaselineQuantity';
  id: Scalars['ID'];
  itemId: Scalars['ID'];
  locationId?: Maybe<Scalars['ID']>;
  locationName?: Maybe<Scalars['String']>;
  quantity: Scalars['Int'];
};

export type ItemFulfillment = Node & {
  __typename?: 'ItemFulfillment';
  createdTimestamp: Scalars['Timestamp'];
  id: Scalars['ID'];
  lineItems: Array<ItemFulfillmentLineItem>;
  netSuiteRecord?: Maybe<NetSuiteRecord>;
  order: Order;
};

export type ItemFulfillmentLineItem = {
  __typename?: 'ItemFulfillmentLineItem';
  assignments: Array<InventoryNumberAssignment>;
  id: Scalars['ID'];
  item: Item;
  quantity: Scalars['Int'];
};

export type ItemPage = Page & {
  __typename?: 'ItemPage';
  nodes: Array<Item>;
  pageInfo: PageInfo;
};

export type ItemReceipt = {
  __typename?: 'ItemReceipt';
  id: Scalars['ID'];
  lineItems: Array<ItemReceiptLineItem>;
  metaCreated: Scalars['Timestamp'];
  receivedBy: SiteUserFull;
  returnAuthorization: ReturnAuthorization;
};

export type ItemReceiptLineItem = {
  __typename?: 'ItemReceiptLineItem';
  id: Scalars['ID'];
  inventoryNumber: Scalars['String'];
  product: Product;
  refundAmountCents: Scalars['Currency'];
};

export type JiraTicket = Node & {
  __typename?: 'JiraTicket';
  context: Scalars['JSON'];
  createdAt: Scalars['Timestamp'];
  description: Scalars['String'];
  id: Scalars['ID'];
  key: Scalars['String'];
  labels: Array<Scalars['String']>;
  status: JiraTicketStatus;
  title: Scalars['String'];
};

export type JiraTicketPage = Page & {
  __typename?: 'JiraTicketPage';
  nodes: Array<JiraTicket>;
  pageInfo: PageInfo;
};

export type JiraTicketStatus =
  | 'inProgress'
  | 'notStarted'
  | 'resolved';

export type LeaseApplicationStatus = {
  __typename?: 'LeaseApplicationStatus';
  displayName: Scalars['String'];
  id: Scalars['ID'];
  name: LeaseApplicationStatusName;
};

export type LeaseApplicationStatusName =
  | 'complete'
  | 'incomplete'
  | 'notApplicable';

export type LeaseApplicationStep = {
  __typename?: 'LeaseApplicationStep';
  id: Scalars['ID'];
  name: LeaseApplicationStepName;
  status: LeaseApplicationStatus;
};

export type LeaseApplicationStepName = {
  __typename?: 'LeaseApplicationStepName';
  displayName: Scalars['String'];
  id: Scalars['ID'];
  name: LeaseApplicationStepNameName;
};

export type LeaseApplicationStepNameName =
  | 'activated'
  | 'agreement'
  | 'application'
  | 'cart'
  | 'confirmation'
  | 'fraudCheck'
  | 'funding'
  | 'lease';

export type LifeCycleStep = {
  __typename?: 'LifeCycleStep';
  approvalType: ApprovalTypeName;
  completedOn?: Maybe<Scalars['Timestamp']>;
  label: Scalars['String'];
};

export type LineItem = {
  __typename?: 'LineItem';
  appleCareAgreement?: Maybe<AppleCareAgreement>;
  discountTotalCents: Scalars['Currency'];
  feeTotalCents: Scalars['Currency'];
  id: Scalars['ID'];
  itemTotalCents: Scalars['Currency'];
  lineReference?: Maybe<Scalars['String']>;
  order: Order;
  product: Product;
  quantity: Scalars['Int'];
  refundAmountCents: Scalars['Currency'];
  swaps: Array<SkuSwap>;
  taxTotalCents: Scalars['Currency'];
};

export type LineItemLite = {
  __typename?: 'LineItemLite';
  discountTotalCents: Scalars['Currency'];
  feeTotalCents: Scalars['Currency'];
  id: Scalars['ID'];
  itemTotalCents: Scalars['Currency'];
  productName: Scalars['String'];
  quantity: Scalars['Int'];
  refundAmountCents: Scalars['Currency'];
  sku: Scalars['String'];
  taxTotalCents: Scalars['Currency'];
};

export type LineItemUnbundler = Node & {
  __typename?: 'LineItemUnbundler';
  comparisonOperator: ComparisonOperator;
  feeCents: Scalars['Currency'];
  id: Scalars['ID'];
  priceCents: Scalars['Currency'];
  productName: Scalars['String'];
  sku: Scalars['String'];
  store: Store;
  value: Scalars['String'];
};

export type LineItemUnbundlerPage = Page & {
  __typename?: 'LineItemUnbundlerPage';
  nodes: Array<LineItemUnbundler>;
  pageInfo: PageInfo;
};

export type Listing = Node & {
  __typename?: 'Listing';
  id: Scalars['ID'];
  imageUrl: Scalars['String'];
  item?: Maybe<Item>;
  regularPriceDollars: Scalars['Currency'];
  salePriceDollars: Scalars['Currency'];
  store: Store;
  urlToListing: Scalars['String'];
};

export type ListingManagementStrategy = {
  __typename?: 'ListingManagementStrategy';
  id: Scalars['ID'];
  isActive: Scalars['Boolean'];
  item: Item;
  priceDollars: Scalars['String'];
  store: Store;
};

export type ListingManagementStrategyTemplate = Node & {
  __typename?: 'ListingManagementStrategyTemplate';
  id: Scalars['ID'];
  item: Item;
  priceDollars: Scalars['String'];
};

export type ListingManagementStrategyTemplateGroup = Node & {
  __typename?: 'ListingManagementStrategyTemplateGroup';
  createdTimestamp: Scalars['Timestamp'];
  id: Scalars['ID'];
  name: Scalars['String'];
  templateCount: Scalars['Int'];
  templates: ListingManagementStrategyTemplatePage;
};

export type ListingManagementStrategyTemplateGroupsPage = {
  __typename?: 'ListingManagementStrategyTemplateGroupsPage';
  nodes: Array<ListingManagementStrategyTemplateGroup>;
  pageInfo: PageInfo;
};

export type ListingManagementStrategyTemplatePage = Page & {
  __typename?: 'ListingManagementStrategyTemplatePage';
  nodes: Array<ListingManagementStrategyTemplate>;
  pageInfo: PageInfo;
};

export type ListingPage = Page & {
  __typename?: 'ListingPage';
  nodes: Array<Listing>;
  pageInfo: PageInfo;
};

export type MfaMethod =
  | 'sms'
  | 'softwareToken';

export type MissingDiscountItem = {
  __typename?: 'MissingDiscountItem';
  discountItemId: Scalars['ID'];
  discountType: Scalars['String'];
  rate: Scalars['String'];
};

export type MissingProduct = {
  __typename?: 'MissingProduct';
  name: Scalars['String'];
  productId: Scalars['ID'];
  sku: Scalars['String'];
};

export type Mutation = {
  __typename?: 'Mutation';
  acceptReturnAuthorization?: Maybe<ReturnAuthorization>;
  adminBatchInviteUsers: Array<SiteUserFull>;
  applyListingManagementStrategyTemplateGroups: Array<Item>;
  approveReturnAuthorization?: Maybe<ReturnAuthorization>;
  archiveStore?: Maybe<Scalars['Boolean']>;
  archiveWriteRequestValidationErrors?: Maybe<Scalars['Boolean']>;
  assignRole: Array<UserRoleAssignment>;
  cacheAndProcessOrders: Scalars['Boolean'];
  clearInvalidWriteRequests?: Maybe<Scalars['Boolean']>;
  closeOrder?: Maybe<Order>;
  closeOrderAsCustomer?: Maybe<OrderLite>;
  deleteListingManagementStrategy?: Maybe<Item>;
  deleteReturnAuthorization: Scalars['Boolean'];
  deleteThirdPartyAccount: Scalars['Boolean'];
  deleteUserRoleTemplate: Scalars['Boolean'];
  generateReturnLabel?: Maybe<ReturnAuthorization>;
  generateShippingLabelForTier1ReturnAuthorizations?: Maybe<Carton>;
  generateSkuSwap: Scalars['Boolean'];
  importInventoryItems: Scalars['Boolean'];
  importNetSuiteBrands: Scalars['Boolean'];
  importNetSuiteDepartments: Scalars['Boolean'];
  importNetSuiteEmployees: Scalars['Boolean'];
  importNetSuiteInventoryLocations: Scalars['Boolean'];
  importNetSuitePaymentMethods: Scalars['Boolean'];
  importNetSuiteShipItems: Scalars['Boolean'];
  importNetSuiteSubsidiaries: Scalars['Boolean'];
  importOrdersFromCsv: Scalars['Boolean'];
  initiateRefund?: Maybe<Refund>;
  initiateReturnAuthorization?: Maybe<ReturnAuthorization>;
  initiateReturnAuthorizationAsCustomer?: Maybe<ReturnAuthorizationLite>;
  inviteUser?: Maybe<Invite>;
  mockFulfillOrder?: Maybe<Order>;
  mockFulfillTelgoo5Orders: Scalars['Boolean'];
  overrideCachedOrder: Scalars['Boolean'];
  overrideLeaseApplication: Scalars['String'];
  ping: Scalars['Boolean'];
  receiveReturnAuthorization?: Maybe<ReturnAuthorization>;
  receiveTier1ReturnAuthorization?: Maybe<Tier1ReturnAuthorization>;
  regenerateWriteRequest?: Maybe<NetSuiteWriteRequest>;
  registerUser?: Maybe<SiteUserFull>;
  resendEmail: Scalars['Boolean'];
  reverseReturnAuthorizationAcceptanceDecision?: Maybe<ReturnAuthorization>;
  reverseReturnAuthorizationApprovalDecision?: Maybe<ReturnAuthorization>;
  reverseReturnAuthorizationRefundDenialDecision?: Maybe<ReturnAuthorization>;
  reviewCachedOrders: Scalars['Boolean'];
  runAllJobs: Scalars['Boolean'];
  runScheduledJob: Scalars['Boolean'];
  saveAndValidateWriteRequest?: Maybe<NetSuiteWriteRequest>;
  saveAsnFormat: Array<AsnFormatProperty>;
  saveAuditLogEvent?: Maybe<AuditLogEvent>;
  saveCustomOrderFormatFlow?: Maybe<CustomOrderFormatFlow>;
  saveCustomer?: Maybe<Customer>;
  saveFullPartner?: Maybe<Partner>;
  saveIncidentEvent: Scalars['Boolean'];
  saveItem?: Maybe<Item>;
  saveItemReceipt: ItemReceipt;
  saveListingManagementStrategiesByItem?: Maybe<Item>;
  saveListingManagementStrategiesByStore: Array<Item>;
  saveListingManagementStrategy?: Maybe<Item>;
  saveListingManagementStrategyTemplateGroup?: Maybe<ListingManagementStrategyTemplateGroup>;
  saveOrder?: Maybe<Order>;
  savePaymentMethodMappings: Scalars['Boolean'];
  saveRepairCodes: Array<RepairCode>;
  saveScheduledJob?: Maybe<ScheduledJob>;
  saveShippingServices: Scalars['Boolean'];
  saveSoftwareVersions: Array<SoftwareVersion>;
  saveStore?: Maybe<Store>;
  saveStoreEmailSettings: Array<StoreEmailSetting>;
  saveThirdPartyAccount?: Maybe<ThirdPartyAccount>;
  saveTriageObservation?: Maybe<Tier1ReturnAuthorization>;
  saveTriageReasons: Array<TriageReason>;
  saveTriageWorkflows?: Maybe<Array<Maybe<TriageWorkflow>>>;
  saveUser?: Maybe<SiteUserFull>;
  saveUserRoleTemplate?: Maybe<UserRoleTemplate>;
  sendChatMessage?: Maybe<ChatMessage>;
  sendChatMessageAsCustomer?: Maybe<ChatMessage>;
  setUserPreferredMfaMethod: Scalars['Boolean'];
  submitQualityControlCheck?: Maybe<Tier1ReturnAuthorization>;
  syncOrderToNetSuite: Scalars['Boolean'];
  testPing: Scalars['Boolean'];
  toggleExternalOrderArchived: Scalars['Boolean'];
  toggleFeatureForStore: Scalars['Boolean'];
  toggleListingManagementStrategiesForItem?: Maybe<Item>;
  triageTier1ReturnAuthorization?: Maybe<Tier1ReturnAuthorization>;
  unassignRole: Scalars['Boolean'];
  writeOrderToE1: Scalars['Boolean'];
};


export type MutationAcceptReturnAuthorizationArgs = {
  input: AcceptReturnAuthorizationInput;
};


export type MutationAdminBatchInviteUsersArgs = {
  input: Array<AdminBatchInviteUserInput>;
};


export type MutationApplyListingManagementStrategyTemplateGroupsArgs = {
  input: ApplyListingManagementStrategyTemplateGroupsInput;
};


export type MutationApproveReturnAuthorizationArgs = {
  input: ApproveReturnAuthorizationInput;
};


export type MutationArchiveStoreArgs = {
  storeId: Scalars['ID'];
};


export type MutationArchiveWriteRequestValidationErrorsArgs = {
  writeRequestId: Scalars['ID'];
};


export type MutationAssignRoleArgs = {
  input: AssignRoleInput;
};


export type MutationCacheAndProcessOrdersArgs = {
  orderId?: InputMaybe<Scalars['String']>;
  startTime?: InputMaybe<Scalars['Timestamp']>;
  storeId: Scalars['ID'];
};


export type MutationClearInvalidWriteRequestsArgs = {
  storeId?: InputMaybe<Scalars['ID']>;
  writeRequestId?: InputMaybe<Scalars['ID']>;
};


export type MutationCloseOrderArgs = {
  orderId: Scalars['ID'];
};


export type MutationCloseOrderAsCustomerArgs = {
  orderId: Scalars['ID'];
};


export type MutationDeleteListingManagementStrategyArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteReturnAuthorizationArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteThirdPartyAccountArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteUserRoleTemplateArgs = {
  id: Scalars['ID'];
};


export type MutationGenerateReturnLabelArgs = {
  input: GenerateReturnLabelInput;
};


export type MutationGenerateShippingLabelForTier1ReturnAuthorizationsArgs = {
  input: GenerateShippingLabelForTier1ReturnAuthorizationsInput;
};


export type MutationGenerateSkuSwapArgs = {
  input: GenerateSkuSwapInput;
};


export type MutationImportInventoryItemsArgs = {
  input: Array<ImportInventoryItemInput>;
};


export type MutationImportNetSuiteBrandsArgs = {
  input: Array<ImportBrandInput>;
};


export type MutationImportNetSuiteDepartmentsArgs = {
  input: Array<ImportDepartmentInput>;
};


export type MutationImportNetSuiteEmployeesArgs = {
  input: Array<ImportEmployeeInput>;
};


export type MutationImportNetSuiteInventoryLocationsArgs = {
  input: Array<ImportInventoryLocationInput>;
};


export type MutationImportNetSuitePaymentMethodsArgs = {
  input: Array<ImportPaymentMethodInput>;
};


export type MutationImportNetSuiteShipItemsArgs = {
  input: Array<ImportShipItemInput>;
};


export type MutationImportNetSuiteSubsidiariesArgs = {
  input: Array<ImportSubsidiaryInput>;
};


export type MutationImportOrdersFromCsvArgs = {
  input: ImportOrdersFromCsvInput;
};


export type MutationInitiateRefundArgs = {
  input: InitiateRefundInput;
};


export type MutationInitiateReturnAuthorizationArgs = {
  input: InitiateReturnAuthorizationInput;
};


export type MutationInitiateReturnAuthorizationAsCustomerArgs = {
  input: InitiateReturnAuthorizationInput;
};


export type MutationInviteUserArgs = {
  input: InviteUserInput;
};


export type MutationMockFulfillOrderArgs = {
  orderId: Scalars['ID'];
};


export type MutationOverrideCachedOrderArgs = {
  input: OverrideCachedOrderInput;
};


export type MutationOverrideLeaseApplicationArgs = {
  input: OverrideLeaseApplicationInput;
};


export type MutationReceiveReturnAuthorizationArgs = {
  input: ReceiveReturnAuthorizationInput;
};


export type MutationReceiveTier1ReturnAuthorizationArgs = {
  input: ReceiveTier1ReturnAuthorizationInput;
};


export type MutationRegenerateWriteRequestArgs = {
  id: Scalars['ID'];
};


export type MutationRegisterUserArgs = {
  input: RegisterUserInput;
};


export type MutationResendEmailArgs = {
  input: ResendEmailInput;
};


export type MutationReverseReturnAuthorizationAcceptanceDecisionArgs = {
  returnAuthorizationId: Scalars['ID'];
};


export type MutationReverseReturnAuthorizationApprovalDecisionArgs = {
  returnAuthorizationId: Scalars['ID'];
};


export type MutationReverseReturnAuthorizationRefundDenialDecisionArgs = {
  returnAuthorizationId: Scalars['ID'];
};


export type MutationReviewCachedOrdersArgs = {
  ids: Array<Scalars['ID']>;
};


export type MutationRunScheduledJobArgs = {
  scheduledJobId: Scalars['ID'];
};


export type MutationSaveAndValidateWriteRequestArgs = {
  input: SaveAndValidateWriteRequestInput;
};


export type MutationSaveAsnFormatArgs = {
  input: SaveAsnFormatInput;
};


export type MutationSaveAuditLogEventArgs = {
  input: SaveAuditLogEventInput;
};


export type MutationSaveCustomOrderFormatFlowArgs = {
  input: SaveCustomOrderFormatFlowInput;
};


export type MutationSaveCustomerArgs = {
  input: SaveCustomerInput;
};


export type MutationSaveFullPartnerArgs = {
  input: SaveFullPartnerInput;
};


export type MutationSaveIncidentEventArgs = {
  input: SaveIncidentEventInput;
};


export type MutationSaveItemArgs = {
  input: SaveItemInput;
};


export type MutationSaveItemReceiptArgs = {
  input: SaveItemReceiptInput;
};


export type MutationSaveListingManagementStrategiesByItemArgs = {
  input: SaveListingManagementStrategiesByItemInput;
};


export type MutationSaveListingManagementStrategiesByStoreArgs = {
  input: SaveListingManagementStrategiesByStoreInput;
};


export type MutationSaveListingManagementStrategyArgs = {
  input: SaveListingManagementStrategyInput;
};


export type MutationSaveListingManagementStrategyTemplateGroupArgs = {
  input: SaveListingManagementStrategyTemplateGroupInput;
};


export type MutationSaveOrderArgs = {
  input: SaveSalesOrderInput;
};


export type MutationSavePaymentMethodMappingsArgs = {
  input: SavePaymentMethodMappingsInput;
};


export type MutationSaveRepairCodesArgs = {
  input: SaveRepairCodesInput;
};


export type MutationSaveScheduledJobArgs = {
  input: SaveScheduledJobInput;
};


export type MutationSaveShippingServicesArgs = {
  input: SaveShippingServicesInput;
};


export type MutationSaveSoftwareVersionsArgs = {
  input: SaveSoftwareVersionsInput;
};


export type MutationSaveStoreArgs = {
  input: SaveStoreInput;
};


export type MutationSaveStoreEmailSettingsArgs = {
  input: SaveStoreEmailSettingsInput;
};


export type MutationSaveThirdPartyAccountArgs = {
  input: SaveThirdPartyAccountInput;
};


export type MutationSaveTriageObservationArgs = {
  input: SaveTriageObservationInput;
};


export type MutationSaveTriageReasonsArgs = {
  input: SaveTriageReasonsInput;
};


export type MutationSaveTriageWorkflowsArgs = {
  input: SaveTriageWorkflowsInput;
};


export type MutationSaveUserArgs = {
  input: SaveUserInput;
};


export type MutationSaveUserRoleTemplateArgs = {
  input: SaveUserRoleTemplateInput;
};


export type MutationSendChatMessageArgs = {
  input: SendChatMessageInput;
};


export type MutationSendChatMessageAsCustomerArgs = {
  input: SendChatMessageInput;
};


export type MutationSetUserPreferredMfaMethodArgs = {
  email: Scalars['String'];
  mfaMethod?: InputMaybe<MfaMethod>;
};


export type MutationSubmitQualityControlCheckArgs = {
  input: SubmitQualityControlCheckInput;
};


export type MutationSyncOrderToNetSuiteArgs = {
  orderId: Scalars['ID'];
};


export type MutationToggleExternalOrderArchivedArgs = {
  input: ToggleExternalOrderArchivedInput;
};


export type MutationToggleFeatureForStoreArgs = {
  input: ToggleFeatureInput;
};


export type MutationToggleListingManagementStrategiesForItemArgs = {
  input: ToggleListingManagementStrategiesForItemInput;
};


export type MutationTriageTier1ReturnAuthorizationArgs = {
  input: TriageTier1ReturnAuthorizationInput;
};


export type MutationUnassignRoleArgs = {
  id: Scalars['ID'];
};


export type MutationWriteOrderToE1Args = {
  orderId: Scalars['ID'];
};

export type NetSuiteBrand = {
  __typename?: 'NetSuiteBrand';
  id: Scalars['ID'];
  name: Scalars['String'];
  netSuiteInternalId: Scalars['String'];
};

export type NetSuiteDepartment = {
  __typename?: 'NetSuiteDepartment';
  id: Scalars['ID'];
  internalId: Scalars['String'];
  name: Scalars['String'];
};

export type NetSuiteEligibilityDetails = {
  __typename?: 'NetSuiteEligibilityDetails';
  allProductsInNetSuite: Scalars['Boolean'];
  customerEmail?: Maybe<Scalars['String']>;
  customerInNetSuite: Scalars['Boolean'];
  customerMissingReason?: Maybe<Scalars['String']>;
  discountItemsSynced: Scalars['Boolean'];
  hasMappedPaymentMethod: Scalars['Boolean'];
  hasShippingService: Scalars['Boolean'];
  missingDiscountItems: Array<MissingDiscountItem>;
  missingProducts: Array<MissingProduct>;
  orderId: Scalars['ID'];
  orderInNetSuite: Scalars['Boolean'];
  orderNumber: Scalars['String'];
  paymentMethodMissingReason?: Maybe<Scalars['String']>;
  rawPaymentMethod?: Maybe<Scalars['String']>;
  requestedShippingService?: Maybe<Scalars['String']>;
  shippingServiceMissingReason?: Maybe<Scalars['String']>;
  storeHasDepartment: Scalars['Boolean'];
  storeHasLocation: Scalars['Boolean'];
  storeHasTaxItem: Scalars['Boolean'];
  storeMissingReason?: Maybe<Scalars['String']>;
  writeRequestGenerated: Scalars['Boolean'];
};

export type NetSuiteInventoryLocation = {
  __typename?: 'NetSuiteInventoryLocation';
  id: Scalars['ID'];
  internalId?: Maybe<Scalars['String']>;
  name: Scalars['String'];
};

export type NetSuitePaymentMethod = Node & {
  __typename?: 'NetSuitePaymentMethod';
  id: Scalars['ID'];
  internalId: Scalars['String'];
  name: Scalars['String'];
};

export type NetSuiteRecord = {
  __typename?: 'NetSuiteRecord';
  createdAt: Scalars['Timestamp'];
  id: Scalars['ID'];
  interChangeInternalId: Scalars['String'];
  netSuiteInternalId: Scalars['String'];
  recordUrl: Scalars['String'];
  transactionId: Scalars['String'];
  type: NetSuiteRecordType;
};

export type NetSuiteRecordType = {
  __typename?: 'NetSuiteRecordType';
  displayName: Scalars['String'];
  id: Scalars['ID'];
  name: NetSuiteRecordTypeName;
};

export type NetSuiteRecordTypeName =
  | 'cashSale'
  | 'customRecord'
  | 'customer'
  | 'discountItem'
  | 'inventoryAdjustment'
  | 'inventoryItem'
  | 'itemFulfillment'
  | 'itemReceipt'
  | 'markupItem'
  | 'returnAuthorization'
  | 'salesOrder';

export type NetSuiteSubsidiary = {
  __typename?: 'NetSuiteSubsidiary';
  id: Scalars['ID'];
  internalId: Scalars['String'];
  name: Scalars['String'];
};

export type NetSuiteTaxItem = {
  __typename?: 'NetSuiteTaxItem';
  id: Scalars['ID'];
  isTaxable: Scalars['Boolean'];
  name: Scalars['String'];
};

export type NetSuiteWriteRequest = Node & {
  __typename?: 'NetSuiteWriteRequest';
  customer?: Maybe<Customer>;
  format: NetSuiteWriteRequestFormat;
  id: Scalars['ID'];
  order?: Maybe<Order>;
  record?: Maybe<NetSuiteRecord>;
  requestData: Scalars['JSON'];
  returnAuthorization?: Maybe<ReturnAuthorization>;
  tier1ItemReceipt?: Maybe<Tier1ItemReceipt>;
  tier1ReturnAuthorization?: Maybe<Tier1ReturnAuthorization>;
  validationErrors: Array<Scalars['String']>;
};

export type NetSuiteWriteRequestFormat =
  | 'cartonPrintRequest'
  | 'customer'
  | 'returnAuthorization'
  | 'salesOrder'
  | 'tier1InventoryAdjustment'
  | 'tier1ItemReceipt'
  | 'tier1ReturnAuthorization'
  | 'unknown';

export type NetSuiteWriteRequestPage = Page & {
  __typename?: 'NetSuiteWriteRequestPage';
  nodes: Array<NetSuiteWriteRequest>;
  pageInfo: PageInfo;
};

export type Node = {
  id: Scalars['ID'];
};

export type Order = Node & {
  __typename?: 'Order';
  auditLog: AuditLogEventPage;
  billingAddress: Address;
  cacheLastUpdatedTimestamp?: Maybe<Scalars['Timestamp']>;
  cancelledAt?: Maybe<Scalars['Timestamp']>;
  customer: Customer;
  discountLines: Array<ChargeLine>;
  discountTotalCents: Scalars['Currency'];
  e1Data?: Maybe<E147FileData>;
  e1Data42File?: Maybe<E142FileData>;
  e1DeviceLedger: Array<DeviceLedgerInfo>;
  e1DocumentIndex?: Maybe<E1DocumentIndex>;
  externalId: Scalars['String'];
  feeLines: Array<ChargeLine>;
  feeTotalCents: Scalars['Currency'];
  fulfillment?: Maybe<BaseFulfillment>;
  id: Scalars['ID'];
  itemFulfillment?: Maybe<ItemFulfillment>;
  lifeCycle: Array<LifeCycleStep>;
  lineItems: Array<LineItem>;
  messages: ChatMessagePage;
  metaCreated: Scalars['Timestamp'];
  netSuitePaymentMethod?: Maybe<NetSuitePaymentMethod>;
  netSuiteRecord?: Maybe<NetSuiteRecord>;
  netSuiteWriteRequest?: Maybe<NetSuiteWriteRequest>;
  orderDate: Scalars['Timestamp'];
  orderNumber: Scalars['String'];
  overallOrderStatus: OverallOrderStatus;
  paymentMethod: PaymentMethod;
  rawSourceOrder?: Maybe<ExternalOrder>;
  refunds: Array<Refund>;
  requestedShippingService: Scalars['String'];
  returnAuthorizations: ReturnAuthorizationPage;
  shipStationOrder?: Maybe<ShipStationOrder>;
  shipStationShipment?: Maybe<ShipStationShipment>;
  shipment?: Maybe<Shipment>;
  shippingAddress: Address;
  shippingLines: Array<ChargeLine>;
  shippingTotalCents: Scalars['Currency'];
  smartPayLeaseApplication?: Maybe<SmartPayLeaseApplication>;
  status: OrderStatus;
  store: Store;
  taxTotalCents: Scalars['Currency'];
  totalCents: Scalars['Currency'];
  urlToStoreRecord: Scalars['String'];
};

export type OrderCountTimeSeriesInput = {
  endDate: Scalars['Timestamp'];
  intervalSeconds: Scalars['Int'];
  startDate: Scalars['Timestamp'];
  storeId?: InputMaybe<Scalars['ID']>;
};

export type OrderLite = {
  __typename?: 'OrderLite';
  customerEmail: Scalars['String'];
  customerFullName: Scalars['String'];
  discountTotalCents: Scalars['Currency'];
  feeTotalCents: Scalars['Currency'];
  id: Scalars['ID'];
  itemFulfillment?: Maybe<ItemFulfillment>;
  lifeCycle: Array<LifeCycleStep>;
  lineItems: Array<LineItemLite>;
  messages: ChatMessagePage;
  orderDate: Scalars['Timestamp'];
  orderNumber: Scalars['String'];
  overallOrderStatus: OverallOrderStatus;
  paymentMethod: PaymentMethod;
  returnAuthorizations: Array<ReturnAuthorizationLite>;
  shipment?: Maybe<Array<Maybe<Shipment>>>;
  shippingAddress: Address;
  shippingTotalCents: Scalars['Currency'];
  storeName: Scalars['String'];
  taxTotalCents: Scalars['Currency'];
  totalCents: Scalars['Currency'];
};

export type OrderPage = Page & {
  __typename?: 'OrderPage';
  nodes: Array<Order>;
  pageInfo: PageInfo;
};

export type OrderProperty = {
  __typename?: 'OrderProperty';
  displayName: Scalars['String'];
  id: Scalars['ID'];
  name: OrderPropertyName;
};

export type OrderPropertyName =
  | 'billingAddress_city'
  | 'billingAddress_company'
  | 'billingAddress_countryCode'
  | 'billingAddress_postalCode'
  | 'billingAddress_street1'
  | 'billingAddress_street2'
  | 'billingAddress_usStateAbbrev'
  | 'customField_1'
  | 'customField_2'
  | 'customField_3'
  | 'customField_4'
  | 'customField_5'
  | 'customField_6'
  | 'customField_7'
  | 'customField_8'
  | 'customField_9'
  | 'customField_10'
  | 'customField_11'
  | 'customField_12'
  | 'customField_13'
  | 'customField_14'
  | 'customField_15'
  | 'customField_16'
  | 'customField_17'
  | 'customField_18'
  | 'customField_19'
  | 'customField_20'
  | 'customer_email'
  | 'customer_firstName'
  | 'customer_fullName'
  | 'customer_lastName'
  | 'customer_phoneNumber'
  | 'lineItem_feeTotalDollars'
  | 'lineItem_iccid'
  | 'lineItem_imei'
  | 'lineItem_itemTotalDollars'
  | 'lineItem_lineTotalDollars'
  | 'lineItem_pricePaidDollars'
  | 'lineItem_productName'
  | 'lineItem_quantity'
  | 'lineItem_sku'
  | 'lineItem_taxTotalDollars'
  | 'order_date'
  | 'order_dateShipped'
  | 'order_id'
  | 'order_identifier'
  | 'order_paymentMethod'
  | 'order_promotionType'
  | 'order_shippingCarrier'
  | 'order_shippingMethod'
  | 'order_shippingTotalDollars'
  | 'order_totalDollars'
  | 'order_trackingNumber'
  | 'other_unboundProperty'
  | 'shippingAddress_city'
  | 'shippingAddress_company'
  | 'shippingAddress_countryCode'
  | 'shippingAddress_postalCode'
  | 'shippingAddress_street1'
  | 'shippingAddress_street2'
  | 'shippingAddress_usStateAbbrev';

export type OrderState =
  | 'awaitingApproval'
  | 'awaitingFulfillment'
  | 'awaitingPayment'
  | 'inTransit';

export type OrderStatus = {
  __typename?: 'OrderStatus';
  displayName: Scalars['String'];
  id: Scalars['ID'];
  name: OrderStatusName;
};

export type OrderStatusName =
  | 'cancelled'
  | 'completed'
  | 'failed'
  | 'onHold'
  | 'pending'
  | 'processing'
  | 'refunded';

export type OverallOrderStatus = {
  __typename?: 'OverallOrderStatus';
  displayName: Scalars['String'];
  id: Scalars['ID'];
  name: OverallOrderStatusName;
};

export type OverallOrderStatusName =
  | 'cancelled'
  | 'completed'
  | 'open'
  | 'processing';

export type OverrideCachedOrderInput = {
  externalOrderId: Scalars['ID'];
  rawData: Scalars['JSON'];
};

export type OverrideLeaseApplicationInput = {
  applicationNumber: Scalars['String'];
  leaseApplicationId: Scalars['ID'];
  overrideSkus?: InputMaybe<Array<OverrideSkuInput>>;
};

export type OverrideSkuInput = {
  originalSku: Scalars['String'];
  overrideSku: Scalars['String'];
  shouldSend: Scalars['Boolean'];
};

export type Page = {
  nodes: Array<Node>;
  pageInfo: PageInfo;
};

export type PageInfo = {
  __typename?: 'PageInfo';
  nextPage?: Maybe<Scalars['Cursor']>;
  pages: Array<Scalars['Cursor']>;
  previousPage?: Maybe<Scalars['Cursor']>;
  totalRows: Scalars['Int'];
};

export type PaginationInput = {
  after?: InputMaybe<Scalars['Cursor']>;
  first?: InputMaybe<Scalars['Int']>;
};

export type Partner = Node & {
  __typename?: 'Partner';
  id: Scalars['ID'];
  name: Scalars['String'];
  stores: StorePage;
  websiteUrl: Scalars['String'];
};

export type PaymentMethod = {
  __typename?: 'PaymentMethod';
  displayName: Scalars['String'];
  id: Scalars['ID'];
  name: PaymentMethodName;
};

export type PaymentMethodMapping = Node & {
  __typename?: 'PaymentMethodMapping';
  id: Scalars['ID'];
  isTaxable: Scalars['Boolean'];
  paymentMethod: NetSuitePaymentMethod;
  paymentMethodText: Scalars['String'];
};

export type PaymentMethodName =
  | 'affirm'
  | 'braintreeCreditCard'
  | 'braintreePayPal'
  | 'coupon'
  | 'klarnaPayments'
  | 'paypal'
  | 'shopifyPayments'
  | 'smartPay'
  | 'stripe'
  | 'unknown';

export type Permission = {
  __typename?: 'Permission';
  displayName: Scalars['String'];
  group: PermissionGroup;
  id: Scalars['ID'];
  name: PermissionName;
};

export type PermissionGroup = {
  __typename?: 'PermissionGroup';
  displayName: Scalars['String'];
  id: Scalars['ID'];
  name: PermissionGroupName;
  permissions: Array<Permission>;
};

export type PermissionGroupName =
  | 'customer'
  | 'insurance'
  | 'inventory'
  | 'itemFulfillment'
  | 'itemReceipt'
  | 'permission'
  | 'platform'
  | 'refund'
  | 'reporting'
  | 'returnAuthorization'
  | 'salesOrder'
  | 'store'
  | 'testing'
  | 'thirdPartyAccount'
  | 'tier1'
  | 'user'
  | 'writeRequest';

export type PermissionName =
  | 'customer_editPersonalInformation'
  | 'customer_email'
  | 'customer_viewCustomer'
  | 'insurance_viewAppleCareAgreement'
  | 'inventory_createSkuSwap'
  | 'inventory_deleteListingManagementStrategy'
  | 'inventory_moduleAccess'
  | 'inventory_saveItem'
  | 'inventory_saveListingManagementStrategy'
  | 'inventory_saveListingManagementStrategyTemplateGroup'
  | 'inventory_updateInventoryLevel'
  | 'inventory_updateStoreListingPrice'
  | 'inventory_viewInventoryLevels'
  | 'inventory_viewItem'
  | 'inventory_viewItemList'
  | 'inventory_viewListing'
  | 'inventory_viewListingManagementStrategy'
  | 'inventory_viewListingManagementStrategyTemplateGroup'
  | 'inventory_viewProduct'
  | 'inventory_viewStoreListing'
  | 'itemFulfillment_view'
  | 'itemReceipt_create'
  | 'itemReceipt_view'
  | 'permission_assignRole'
  | 'permission_updateRole'
  | 'permission_viewRole'
  | 'platform_godMode'
  | 'platform_netSuiteSelectiveSync'
  | 'platform_receiveEmails'
  | 'platform_runScheduledJob'
  | 'platform_updateCustomOrderFormat'
  | 'platform_updateNetSuiteInventory'
  | 'platform_viewCustomOrderFormat'
  | 'platform_viewEnums'
  | 'platform_viewJiraTickets'
  | 'platform_viewNetSuiteDepartments'
  | 'platform_viewNetSuiteInventory'
  | 'platform_viewNetSuiteLocations'
  | 'platform_viewNetSuitePaymentMethods'
  | 'platform_viewNetSuiteShipItems'
  | 'platform_viewNetSuiteSubsidiaries'
  | 'platform_viewNetSuiteTaxItems'
  | 'platform_viewScheduledJobs'
  | 'platform_viewShipStationStores'
  | 'refund_approval'
  | 'refund_undoDenial'
  | 'refund_view'
  | 'reporting_downloadAsn'
  | 'reporting_downloadSalesOrderCsv'
  | 'reporting_updateAutomatedReportRecipient'
  | 'reporting_viewOrderCount'
  | 'reporting_viewReports'
  | 'returnAuthorization_acceptance'
  | 'returnAuthorization_addAuditLogEvent'
  | 'returnAuthorization_approval'
  | 'returnAuthorization_create'
  | 'returnAuthorization_delete'
  | 'returnAuthorization_downloadLabel'
  | 'returnAuthorization_generateLabel'
  | 'returnAuthorization_sendMessage'
  | 'returnAuthorization_undoAcceptance'
  | 'returnAuthorization_undoApproval'
  | 'returnAuthorization_view'
  | 'returnAuthorization_viewAuditLogEvents'
  | 'returnAuthorization_viewMessages'
  | 'returnAuthorization_viewShipment'
  | 'salesOrder_addAuditLogEvent'
  | 'salesOrder_cancel'
  | 'salesOrder_create'
  | 'salesOrder_editAddress'
  | 'salesOrder_reviewCachedOrder'
  | 'salesOrder_sendMessage'
  | 'salesOrder_view'
  | 'salesOrder_viewAuditLogEvents'
  | 'salesOrder_viewE1Link'
  | 'salesOrder_viewMessages'
  | 'salesOrder_viewShipment'
  | 'salesOrder_viewStoreLink'
  | 'store_archive'
  | 'store_create'
  | 'store_updateAsnSettings'
  | 'store_updateBrand'
  | 'store_updateEmailSettings'
  | 'store_updateErpSettings'
  | 'store_updateFeatureSettings'
  | 'store_updateImportSettings'
  | 'store_updatePaymentMethodMapping'
  | 'store_updateShippingService'
  | 'store_viewAsnSettings'
  | 'store_viewEmailSettings'
  | 'store_viewPaymentMethodMapping'
  | 'store_viewSettings'
  | 'store_viewShippingService'
  | 'thirdPartyAccount_deleteThirdPartyAccount'
  | 'thirdPartyAccount_updateThirdPartyAccount'
  | 'thirdPartyAccount_viewThirdPartyAccounts'
  | 'tier1_generateShippingLabel'
  | 'tier1_saveItemReceipt'
  | 'tier1_savePrintRequestSettings'
  | 'tier1_saveRepairCode'
  | 'tier1_saveReturnAuthorizationTriage'
  | 'tier1_saveTriageObservation'
  | 'tier1_saveTriageReason'
  | 'tier1_saveTriageWorkflow'
  | 'tier1_viewItemReceipt'
  | 'tier1_viewRepairCode'
  | 'tier1_viewReturnAuthorization'
  | 'tier1_viewReturnAuthorizationTriage'
  | 'tier1_viewShipment'
  | 'tier1_viewTriageObservation'
  | 'tier1_viewTriageReason'
  | 'tier1_viewTriageWorkflow'
  | 'user_invite'
  | 'user_view'
  | 'user_viewInvites'
  | 'writeRequest_editWriteRequest'
  | 'writeRequest_regenerateWriteRequest'
  | 'writeRequest_viewWriteRequest';

export type Product = Node & {
  __typename?: 'Product';
  id: Scalars['ID'];
  name: Scalars['String'];
  netSuiteRecord?: Maybe<NetSuiteRecord>;
  sku: Scalars['String'];
  storeListing?: Maybe<Listing>;
  weight: Weight;
};


export type ProductStoreListingArgs = {
  storeId: Scalars['ID'];
};

export type ProductsPage = Page & {
  __typename?: 'ProductsPage';
  nodes: Array<Product>;
  pageInfo: PageInfo;
};

export type QualityControlCheck = {
  __typename?: 'QualityControlCheck';
  createdBy: SiteUserFull;
  createdTimestamp: Scalars['Timestamp'];
  id: Scalars['ID'];
  softwareVersion: SoftwareVersion;
};

export type Query = {
  __typename?: 'Query';
  allRawPaymentMethods: Array<Scalars['String']>;
  appEvents: Array<AppEvent>;
  appleCareAgreements: AppleCareAgreementPage;
  asnFormat: Array<AsnFormatProperty>;
  cachedOrder?: Maybe<ExternalOrder>;
  cachedOrderCount: Scalars['Int'];
  cachedOrders: ExternalOrdersPage;
  canCloseOrder: Scalars['Boolean'];
  canDeleteReturnAuthorization: Scalars['Boolean'];
  canInitiateReturnAuthorization: Scalars['Boolean'];
  customer?: Maybe<Customer>;
  customers: CustomerPage;
  daemonRunTimeSeries: TimeSeries;
  databaseReport?: Maybe<DatabaseReport>;
  databaseReports: Array<DatabaseReport>;
  departments: Array<NetSuiteDepartment>;
  eligibleOrdersNotInNetSuite: EligibleOrderPage;
  employees: Array<Employee>;
  exportAsn?: Maybe<Scalars['EncodedFileOutput']>;
  exportItemList?: Maybe<Scalars['EncodedFileOutput']>;
  exportNetSuiteXmlRequests?: Maybe<Scalars['EncodedFileOutput']>;
  exportReport?: Maybe<Scalars['EncodedFileOutput']>;
  inventoryLocations: Array<NetSuiteInventoryLocation>;
  invite?: Maybe<Invite>;
  invites: InvitePage;
  item?: Maybe<Item>;
  items: ItemPage;
  jiraTickets: JiraTicketPage;
  lineItemUnbundlingRules: LineItemUnbundlerPage;
  listingManagementStrategyTemplateGroup?: Maybe<ListingManagementStrategyTemplateGroup>;
  listingManagementStrategyTemplateGroups: ListingManagementStrategyTemplateGroupsPage;
  loggedInUser?: Maybe<SiteUserFull>;
  netSuiteBrands: Array<NetSuiteBrand>;
  netSuiteEligibilityDetails?: Maybe<NetSuiteEligibilityDetails>;
  netSuitePaymentMethods: Array<NetSuitePaymentMethod>;
  netSuiteWriteRequest?: Maybe<NetSuiteWriteRequest>;
  netSuiteWriteRequests: NetSuiteWriteRequestPage;
  notMappedRequestedShippingServices: Array<Scalars['String']>;
  order?: Maybe<Order>;
  orderCount: Scalars['Int'];
  orderCountTimeSeries: TimeSeries;
  orderLite?: Maybe<OrderLite>;
  orderProperties: Array<OrderProperty>;
  orderStatuses: Array<OrderStatus>;
  orders: OrderPage;
  ordersAsCsv: Scalars['EncodedFileOutput'];
  paymentMethods: Array<PaymentMethod>;
  permissionGroups: Array<PermissionGroup>;
  preValidateCsvImport: Array<Scalars['String']>;
  product?: Maybe<Product>;
  products: ProductsPage;
  refund?: Maybe<Refund>;
  returnAuthorization?: Maybe<ReturnAuthorization>;
  returnAuthorizationLite?: Maybe<ReturnAuthorizationLite>;
  returnAuthorizations: ReturnAuthorizationPage;
  salesChannels: Array<SalesChannel>;
  scheduledJobs: ScheduledJobPage;
  sendGridEmailRequests: SendGridEmailRequestPage;
  sendGridOrder?: Maybe<Scalars['JSON']>;
  sendGridReturnAuthorization?: Maybe<Scalars['JSON']>;
  shipItems: ShipItemPage;
  shipStationStores: Array<ShipStationStore>;
  siteUser?: Maybe<SiteUserFull>;
  siteUsers: SiteUserFullPage;
  smartPayLeaseApplicationStepNames: Array<LeaseApplicationStepName>;
  softwareVersions: Array<SoftwareVersion>;
  store?: Maybe<Store>;
  storeBrand?: Maybe<StoreBrand>;
  stores: StorePage;
  subsidiaries: Array<NetSuiteSubsidiary>;
  taxItems: Array<NetSuiteTaxItem>;
  testE1Connection: Scalars['Boolean'];
  testNetSuiteConnection: Scalars['Boolean'];
  testStoreConnection: Scalars['Boolean'];
  thirdPartyAccount?: Maybe<ThirdPartyAccount>;
  thirdPartyAccounts: ThirdPartyAccountPage;
  tier1ReturnAuthorization?: Maybe<Tier1ReturnAuthorization>;
  tier1ReturnAuthorizationGroup?: Maybe<Tier1ReturnAuthorizationGroup>;
  tier1ReturnAuthorizationGroups: Tier1ReturnAuthorizationGroupPage;
  tier1ReturnAuthorizations: Tier1ReturnAuthorizationPage;
  userRoleTemplates: UserRoleTemplatePage;
  userStatuses: Array<UserStatus>;
  validateCachedOrder: Array<Scalars['String']>;
};


export type QueryAllRawPaymentMethodsArgs = {
  storeId: Scalars['ID'];
};


export type QueryAppEventsArgs = {
  options?: InputMaybe<QueryAppEventsOptionsInput>;
};


export type QueryAppleCareAgreementsArgs = {
  options: QueryAppleCareAgreementsOptions;
};


export type QueryAsnFormatArgs = {
  storeId: Scalars['ID'];
};


export type QueryCachedOrderArgs = {
  id: Scalars['ID'];
};


export type QueryCachedOrderCountArgs = {
  options: QueryCachedOrdersOptionsInput;
};


export type QueryCachedOrdersArgs = {
  options: QueryCachedOrdersOptionsInput;
};


export type QueryCanCloseOrderArgs = {
  orderId: Scalars['ID'];
};


export type QueryCanDeleteReturnAuthorizationArgs = {
  id: Scalars['ID'];
};


export type QueryCanInitiateReturnAuthorizationArgs = {
  orderId: Scalars['ID'];
};


export type QueryCustomerArgs = {
  id: Scalars['ID'];
};


export type QueryCustomersArgs = {
  options?: InputMaybe<QueryCustomersOptionsInput>;
};


export type QueryDaemonRunTimeSeriesArgs = {
  input: DaemonRunTimeSeriesInput;
};


export type QueryDatabaseReportArgs = {
  id: Scalars['ID'];
};


export type QueryEligibleOrdersNotInNetSuiteArgs = {
  options?: InputMaybe<QueryEligibleOrdersNotInNetSuiteOptionsInput>;
};


export type QueryExportAsnArgs = {
  input: ExportAsnInput;
};


export type QueryExportItemListArgs = {
  options?: InputMaybe<QueryItemsOptionsInput>;
};


export type QueryExportNetSuiteXmlRequestsArgs = {
  orderIds: Array<Scalars['ID']>;
};


export type QueryExportReportArgs = {
  input: ExportReportInput;
};


export type QueryInviteArgs = {
  input: QueryInviteInput;
};


export type QueryInvitesArgs = {
  input: QueryInvitesInput;
};


export type QueryItemArgs = {
  id: Scalars['ID'];
};


export type QueryItemsArgs = {
  options?: InputMaybe<QueryItemsOptionsInput>;
};


export type QueryJiraTicketsArgs = {
  options: QueryJiraTicketsOptionsInput;
};


export type QueryLineItemUnbundlingRulesArgs = {
  storeId?: InputMaybe<Scalars['ID']>;
};


export type QueryListingManagementStrategyTemplateGroupArgs = {
  id: Scalars['ID'];
};


export type QueryListingManagementStrategyTemplateGroupsArgs = {
  options: QueryListingManagementStrategyTemplateGroupsOptionsInput;
};


export type QueryNetSuiteEligibilityDetailsArgs = {
  orderId: Scalars['ID'];
};


export type QueryNetSuiteWriteRequestArgs = {
  id: Scalars['ID'];
};


export type QueryNetSuiteWriteRequestsArgs = {
  options?: InputMaybe<QueryNetSuiteWriteRequestsOptionsInput>;
};


export type QueryNotMappedRequestedShippingServicesArgs = {
  storeId: Scalars['ID'];
};


export type QueryOrderArgs = {
  id: Scalars['ID'];
};


export type QueryOrderCountArgs = {
  options: QueryOrdersOptionsInput;
};


export type QueryOrderCountTimeSeriesArgs = {
  input: OrderCountTimeSeriesInput;
};


export type QueryOrderLiteArgs = {
  input: QueryOrderLiteInput;
};


export type QueryOrderPropertiesArgs = {
  onlyImportable?: InputMaybe<Scalars['Boolean']>;
};


export type QueryOrdersArgs = {
  options: QueryOrdersOptionsInput;
};


export type QueryOrdersAsCsvArgs = {
  options?: InputMaybe<QueryOrdersAsCsvOptionsInput>;
};


export type QueryPreValidateCsvImportArgs = {
  input: ImportOrdersFromCsvInput;
};


export type QueryProductArgs = {
  id: Scalars['ID'];
};


export type QueryProductsArgs = {
  options: QueryProductsOptionsInput;
};


export type QueryRefundArgs = {
  id: Scalars['ID'];
};


export type QueryReturnAuthorizationArgs = {
  id: Scalars['ID'];
};


export type QueryReturnAuthorizationLiteArgs = {
  id: Scalars['ID'];
};


export type QueryReturnAuthorizationsArgs = {
  options?: InputMaybe<QueryReturnAuthorizationsOptionsInput>;
};


export type QueryScheduledJobsArgs = {
  options: QueryScheduledJobsOptions;
};


export type QuerySendGridEmailRequestsArgs = {
  options: QuerySendGridEmailRequestsOptionsInput;
};


export type QuerySendGridOrderArgs = {
  id: Scalars['ID'];
};


export type QuerySendGridReturnAuthorizationArgs = {
  id: Scalars['ID'];
};


export type QueryShipItemsArgs = {
  options?: InputMaybe<QueryShipItemsOptionsInput>;
};


export type QuerySiteUserArgs = {
  id: Scalars['ID'];
};


export type QuerySiteUsersArgs = {
  options: QuerySiteUsersOptions;
};


export type QueryStoreArgs = {
  id: Scalars['ID'];
};


export type QueryStoreBrandArgs = {
  storeId: Scalars['ID'];
};


export type QueryStoresArgs = {
  options: QueryStoresOptionsInput;
};


export type QueryTestStoreConnectionArgs = {
  storeId: Scalars['ID'];
};


export type QueryThirdPartyAccountArgs = {
  id: Scalars['ID'];
};


export type QueryThirdPartyAccountsArgs = {
  options?: InputMaybe<QueryThirdPartyAccountsOptionsInput>;
};


export type QueryTier1ReturnAuthorizationArgs = {
  id: Scalars['ID'];
};


export type QueryTier1ReturnAuthorizationGroupArgs = {
  id: Scalars['ID'];
};


export type QueryTier1ReturnAuthorizationGroupsArgs = {
  options?: InputMaybe<QueryTier1ReturnAuthorizationGroupsOptionsInput>;
};


export type QueryTier1ReturnAuthorizationsArgs = {
  options?: InputMaybe<QueryTier1ReturnAuthorizationsOptionsInput>;
};


export type QueryUserRoleTemplatesArgs = {
  options?: InputMaybe<QueryUserRoleTemplateOptionsInput>;
};


export type QueryValidateCachedOrderArgs = {
  input: OverrideCachedOrderInput;
};

export type QueryAppEventsFilterInput = {
  orderId?: InputMaybe<Scalars['ID']>;
  returnAuthorizationId?: InputMaybe<Scalars['ID']>;
};

export type QueryAppEventsOptionsInput = {
  filter?: InputMaybe<QueryAppEventsFilterInput>;
};

export type QueryAppleCareAgreementsFilterInput = {
  omniFreeText?: InputMaybe<Scalars['String']>;
};

export type QueryAppleCareAgreementsOptions = {
  filter?: InputMaybe<QueryAppleCareAgreementsFilterInput>;
  paginationInput?: InputMaybe<PaginationInput>;
  sort?: InputMaybe<QueryAppleCareAgreementsSortInput>;
};

export type QueryAppleCareAgreementsSortField =
  | 'orderDate';

export type QueryAppleCareAgreementsSortInput = {
  direction: SortDirection;
  field: QueryAppleCareAgreementsSortField;
};

export type QueryCachedOrdersFilterInput = {
  after?: InputMaybe<Scalars['Timestamp']>;
  inValidationState?: InputMaybe<Array<ValidationState>>;
  isProcessed?: InputMaybe<Scalars['Boolean']>;
  orderNumber?: InputMaybe<Scalars['String']>;
  salesChannel?: InputMaybe<SalesChannelName>;
  storeId?: InputMaybe<Scalars['ID']>;
};

export type QueryCachedOrdersOptionsInput = {
  filter?: InputMaybe<QueryCachedOrdersFilterInput>;
  paginationInput?: InputMaybe<PaginationInput>;
  sort?: InputMaybe<QueryCachedOrdersSortInput>;
};

export type QueryCachedOrdersSortField =
  | 'createdDate';

export type QueryCachedOrdersSortInput = {
  direction: SortDirection;
  field: QueryCachedOrdersSortField;
};

export type QueryCustomersFilterInput = {
  omniFreeText?: InputMaybe<Scalars['String']>;
};

export type QueryCustomersOptionsInput = {
  filter?: InputMaybe<QueryCustomersFilterInput>;
  paginationInput?: InputMaybe<PaginationInput>;
  sort?: InputMaybe<QueryCustomersSortInput>;
};

export type QueryCustomersSortField =
  | 'email'
  | 'firstName'
  | 'lastName';

export type QueryCustomersSortInput = {
  direction: SortDirection;
  field: QueryCustomersSortField;
};

export type QueryDaemonRunsFilterInput = {
  after?: InputMaybe<Scalars['Timestamp']>;
  before?: InputMaybe<Scalars['Timestamp']>;
  name?: InputMaybe<DaemonName>;
};

export type QueryDaemonRunsOptions = {
  filter?: InputMaybe<QueryDaemonRunsFilterInput>;
  paginationInput?: InputMaybe<PaginationInput>;
};

export type QueryEligibleOrdersNotInNetSuiteFilterInput = {
  omniFreeText?: InputMaybe<Scalars['String']>;
  storeId?: InputMaybe<Scalars['ID']>;
};

export type QueryEligibleOrdersNotInNetSuiteOptionsInput = {
  filter?: InputMaybe<QueryEligibleOrdersNotInNetSuiteFilterInput>;
  paginationInput?: InputMaybe<PaginationInput>;
};

export type QueryHttpRequestsFilterInput = {
  httpStatusCode?: InputMaybe<Scalars['Int']>;
  method?: InputMaybe<HttpRequestMethodName>;
  omniFreeText?: InputMaybe<Scalars['String']>;
};

export type QueryHttpRequestsOptionsInput = {
  filter?: InputMaybe<QueryHttpRequestsFilterInput>;
  paginationInput?: InputMaybe<PaginationInput>;
  sort?: InputMaybe<QueryHttpRequestsSortInput>;
};

export type QueryHttpRequestsSortField =
  | 'metaCreated';

export type QueryHttpRequestsSortInput = {
  direction: SortDirection;
  field: QueryHttpRequestsSortField;
};

export type QueryInviteInput = {
  code?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
};

export type QueryInvitesInput = {
  onlyAdministrators?: InputMaybe<Scalars['Boolean']>;
  storeId?: InputMaybe<Scalars['ID']>;
};

export type QueryItemsFilterInput = {
  hasListingForStoreId?: InputMaybe<Scalars['ID']>;
  hasListingManagementStrategyForStoreId?: InputMaybe<Scalars['ID']>;
  omniFreeText?: InputMaybe<Scalars['String']>;
};

export type QueryItemsOptionsInput = {
  filter?: InputMaybe<QueryItemsFilterInput>;
  paginationInput?: InputMaybe<PaginationInput>;
  sort?: InputMaybe<QueryItemsSortInput>;
};

export type QueryItemsSortField =
  | 'name'
  | 'sku';

export type QueryItemsSortInput = {
  direction: SortDirection;
  field: QueryItemsSortField;
};

export type QueryJiraTicketsFilterInput = {
  after?: InputMaybe<Scalars['Timestamp']>;
  before?: InputMaybe<Scalars['Timestamp']>;
  omniFreeText?: InputMaybe<Scalars['String']>;
};

export type QueryJiraTicketsOptionsInput = {
  filter?: InputMaybe<QueryJiraTicketsFilterInput>;
  paginationInput?: InputMaybe<PaginationInput>;
  sort?: InputMaybe<QueryJiraTicketsSortInput>;
  useJiraAsSource?: InputMaybe<Scalars['Boolean']>;
};

export type QueryJiraTicketsSortField =
  | 'createdAt'
  | 'key'
  | 'title';

export type QueryJiraTicketsSortInput = {
  direction: SortDirection;
  field: QueryJiraTicketsSortField;
};

export type QueryListingManagementStrategyTemplateGroupsOptionsInput = {
  paginationInput?: InputMaybe<PaginationInput>;
};

export type QueryListingsFilterInput = {
  omniFreeText?: InputMaybe<Scalars['String']>;
};

export type QueryListingsOptionsInput = {
  filter?: InputMaybe<QueryListingsFilterInput>;
};

export type QueryNetSuiteWriteRequestsFilterInput = {
  hasValidationError?: InputMaybe<Scalars['Boolean']>;
  omniFreeText?: InputMaybe<Scalars['String']>;
  storeId?: InputMaybe<Scalars['ID']>;
};

export type QueryNetSuiteWriteRequestsOptionsInput = {
  filter?: InputMaybe<QueryNetSuiteWriteRequestsFilterInput>;
  paginationInput?: InputMaybe<PaginationInput>;
};

export type QueryOrderLiteInput = {
  email?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  orderNumber?: InputMaybe<Scalars['String']>;
};

export type QueryOrdersAsCsvOptionsInput = {
  filter?: InputMaybe<QueryOrdersFilterInput>;
  sort?: InputMaybe<QueryOrdersSortInput>;
};

export type QueryOrdersFilterInput = {
  after?: InputMaybe<Scalars['Timestamp']>;
  before?: InputMaybe<Scalars['Timestamp']>;
  hasUnresolvedSkuMismatches?: InputMaybe<Scalars['Boolean']>;
  inState?: InputMaybe<OrderState>;
  omniFreeText?: InputMaybe<Scalars['String']>;
  salesChannel?: InputMaybe<SalesChannelName>;
  storeId?: InputMaybe<Scalars['ID']>;
  storeType?: InputMaybe<StoreTypeName>;
  withLeaseApplicationStepCompleted?: InputMaybe<Array<LeaseApplicationStepNameName>>;
  withPaymentMethod?: InputMaybe<PaymentMethodName>;
  withStatus?: InputMaybe<Array<OrderStatusName>>;
};

export type QueryOrdersOptionsInput = {
  filter?: InputMaybe<QueryOrdersFilterInput>;
  paginationInput?: InputMaybe<PaginationInput>;
  sort?: InputMaybe<QueryOrdersSortInput>;
};

export type QueryOrdersSortField =
  | 'orderDate'
  | 'orderNumber';

export type QueryOrdersSortInput = {
  direction: SortDirection;
  field: QueryOrdersSortField;
};

export type QueryProductsFilterInput = {
  omniFreeText?: InputMaybe<Scalars['String']>;
};

export type QueryProductsOptionsInput = {
  filter?: InputMaybe<QueryProductsFilterInput>;
  paginationInput?: InputMaybe<PaginationInput>;
  sort?: InputMaybe<QueryProductsSortInput>;
};

export type QueryProductsSortField =
  | 'name'
  | 'sku';

export type QueryProductsSortInput = {
  direction: SortDirection;
  field: QueryProductsSortField;
};

export type QueryReturnAuthorizationsFilterInput = {
  acceptanceApprovalStatus?: InputMaybe<Array<ApprovalTypeName>>;
  after?: InputMaybe<Scalars['Timestamp']>;
  authorizationApprovalStatus?: InputMaybe<Array<ApprovalTypeName>>;
  before?: InputMaybe<Scalars['Timestamp']>;
  isReceived?: InputMaybe<Scalars['Boolean']>;
  omniFreeText?: InputMaybe<Scalars['String']>;
  refundApprovalStatus?: InputMaybe<Array<ApprovalTypeName>>;
  shippingLabelPrinted?: InputMaybe<Scalars['Boolean']>;
  storeId?: InputMaybe<Scalars['ID']>;
};

export type QueryReturnAuthorizationsOptionsInput = {
  filter?: InputMaybe<QueryReturnAuthorizationsFilterInput>;
  paginationInput?: InputMaybe<PaginationInput>;
  sort?: InputMaybe<QueryReturnAuthorizationsSortInput>;
};

export type QueryReturnAuthorizationsSortField =
  | 'approvalDate'
  | 'customerEmail'
  | 'customerFullName'
  | 'customerPhoneNumber'
  | 'orderAmount'
  | 'orderDate'
  | 'orderNumber'
  | 'returnDate'
  | 'returnNumber'
  | 'storeName';

export type QueryReturnAuthorizationsSortInput = {
  direction: SortDirection;
  field: QueryReturnAuthorizationsSortField;
};

export type QueryScheduledJobsFilterInput = {
  omniFreeText?: InputMaybe<Scalars['String']>;
  onlyJobsThatCanRunNow?: InputMaybe<Scalars['Boolean']>;
};

export type QueryScheduledJobsOptions = {
  filter?: InputMaybe<QueryScheduledJobsFilterInput>;
  paginationInput?: InputMaybe<PaginationInput>;
};

export type QuerySendGridEmailRequestsFilterInput = {
  after?: InputMaybe<Scalars['Timestamp']>;
  appEvent?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['Timestamp']>;
  orderId?: InputMaybe<Scalars['ID']>;
  returnAuthorizationId?: InputMaybe<Scalars['ID']>;
};

export type QuerySendGridEmailRequestsOptionsInput = {
  filter?: InputMaybe<QuerySendGridEmailRequestsFilterInput>;
  paginationInput?: InputMaybe<PaginationInput>;
  sort?: InputMaybe<QuerySendGridEmailRequestsSortInput>;
};

export type QuerySendGridEmailRequestsSortField =
  | 'appEvent'
  | 'createdAt'
  | 'templateId';

export type QuerySendGridEmailRequestsSortInput = {
  direction: SortDirection;
  field: QuerySendGridEmailRequestsSortField;
};

export type QueryShipItemsFilterInput = {
  omniFreeText?: InputMaybe<Scalars['String']>;
  subsidiaryId?: InputMaybe<Scalars['ID']>;
};

export type QueryShipItemsOptionsInput = {
  filter?: InputMaybe<QueryShipItemsFilterInput>;
  sort?: InputMaybe<QueryShipItemsSortInput>;
};

export type QueryShipItemsSortField =
  | 'name';

export type QueryShipItemsSortInput = {
  direction: SortDirection;
  field: QueryShipItemsSortField;
};

export type QuerySiteUsersFilterInput = {
  omniFreeText?: InputMaybe<Scalars['String']>;
  onlyAdministrators?: InputMaybe<Scalars['Boolean']>;
};

export type QuerySiteUsersOptions = {
  filter?: InputMaybe<QuerySiteUsersFilterInput>;
  paginationInput?: InputMaybe<PaginationInput>;
  sort?: InputMaybe<QuerySiteUsersSortInput>;
};

export type QuerySiteUsersSortField =
  | 'email'
  | 'fullName';

export type QuerySiteUsersSortInput = {
  direction: SortDirection;
  field: QuerySiteUsersSortField;
};

export type QueryStoresFilterInput = {
  featuresEnabled?: InputMaybe<Array<FeatureName>>;
  omniFreeText?: InputMaybe<Scalars['String']>;
  salesChannel?: InputMaybe<SalesChannelName>;
  types?: InputMaybe<Array<StoreTypeName>>;
};

export type QueryStoresOptionsInput = {
  filter?: InputMaybe<QueryStoresFilterInput>;
  paginationInput?: InputMaybe<PaginationInput>;
  sort?: InputMaybe<QueryStoresSortInput>;
};

export type QueryStoresSortField =
  | 'name';

export type QueryStoresSortInput = {
  direction: SortDirection;
  field: QueryStoresSortField;
};

export type QueryThirdPartyAccountsFilterInput = {
  omniFreeText?: InputMaybe<Scalars['String']>;
};

export type QueryThirdPartyAccountsOptionsInput = {
  filter?: InputMaybe<QueryThirdPartyAccountsFilterInput>;
  paginationInput?: InputMaybe<PaginationInput>;
  sort?: InputMaybe<QueryThirdPartyAccountsSortInput>;
};

export type QueryThirdPartyAccountsSortField =
  | 'accountNumber'
  | 'name';

export type QueryThirdPartyAccountsSortInput = {
  direction: SortDirection;
  field: QueryThirdPartyAccountsSortField;
};

export type QueryTier1ReturnAuthorizationGroupsFilterInput = {
  requiresCarton?: InputMaybe<Scalars['Boolean']>;
  storeId?: InputMaybe<Scalars['ID']>;
};

export type QueryTier1ReturnAuthorizationGroupsOptionsInput = {
  filter?: InputMaybe<QueryTier1ReturnAuthorizationGroupsFilterInput>;
  paginationInput?: InputMaybe<PaginationInput>;
};

export type QueryTier1ReturnAuthorizationsFilterInput = {
  excludeWithSerialNumber?: InputMaybe<Scalars['Boolean']>;
  inState?: InputMaybe<Tier1ReturnAuthorizationState>;
  itemId?: InputMaybe<Scalars['ID']>;
  omniFreeText?: InputMaybe<Scalars['String']>;
  returnAuthorizationGroupId?: InputMaybe<Scalars['ID']>;
  storeId?: InputMaybe<Scalars['ID']>;
};

export type QueryTier1ReturnAuthorizationsOptionsInput = {
  filter?: InputMaybe<QueryTier1ReturnAuthorizationsFilterInput>;
  paginationInput?: InputMaybe<PaginationInput>;
  sort?: InputMaybe<QueryTier1ReturnAuthorizationsSortInput>;
};

export type QueryTier1ReturnAuthorizationsSortField =
  | 'createdTimestamp'
  | 'referenceNumber';

export type QueryTier1ReturnAuthorizationsSortInput = {
  direction: SortDirection;
  field: QueryTier1ReturnAuthorizationsSortField;
};

export type QueryUserRoleTemplateFilterInput = {
  omniFreeText?: InputMaybe<Scalars['String']>;
  visibilityScopeName?: InputMaybe<VisibilityScopeName>;
};

export type QueryUserRoleTemplateOptionsInput = {
  filter?: InputMaybe<QueryUserRoleTemplateFilterInput>;
  paginationInput?: InputMaybe<PaginationInput>;
};

export type ReceiveReturnAuthorizationInput = {
  receivedLineItems: Array<ReceiveReturnAuthorizationLineItemInput>;
  returnAuthorizationId: Scalars['ID'];
};

export type ReceiveReturnAuthorizationLineItemInput = {
  inventoryNumber: Scalars['String'];
  refundAmountCents: Scalars['Currency'];
  returnAuthorizationLineItemId: Scalars['ID'];
};

export type ReceiveTier1ReturnAuthorizationInput = {
  itemId: Scalars['ID'];
  returnAuthorizationId: Scalars['ID'];
  serialNumber: Scalars['String'];
};

export type Refund = {
  __typename?: 'Refund';
  amountCents: Scalars['Currency'];
  apiRequests: HttpRequestPage;
  approvalType: ApprovalType;
  approvedBy: SiteUserFull;
  id: Scalars['ID'];
  metaCreated: Scalars['Timestamp'];
  store: Store;
};


export type RefundApiRequestsArgs = {
  options: QueryHttpRequestsOptionsInput;
};

export type RegisterUserInput = {
  email: Scalars['String'];
  inviteCode: Scalars['String'];
};

export type RepairCode = {
  __typename?: 'RepairCode';
  id: Scalars['ID'];
  repairCode: Scalars['String'];
};

export type ResendEmailInput = {
  appEvent: AppEventName;
  id: Scalars['ID'];
};

export type ReturnAuthorization = Node & {
  __typename?: 'ReturnAuthorization';
  acceptance?: Maybe<ReturnAuthorizationAcceptance>;
  approval?: Maybe<ReturnAuthorizationApproval>;
  auditLog: AuditLogEventPage;
  customer: Customer;
  id: Scalars['ID'];
  itemReceipt?: Maybe<ItemReceipt>;
  lifeCycle: Array<LifeCycleStep>;
  lineItems: Array<ReturnAuthorizationLineItem>;
  messages: ChatMessagePage;
  netSuiteRecord?: Maybe<NetSuiteRecord>;
  netSuiteWriteRequest?: Maybe<NetSuiteWriteRequest>;
  order: Order;
  refund?: Maybe<Refund>;
  returnDate: Scalars['Timestamp'];
  returnNumber: Scalars['String'];
  shipment?: Maybe<Shipment>;
  store: Store;
};

export type ReturnAuthorizationAcceptance = {
  __typename?: 'ReturnAuthorizationAcceptance';
  acceptedBy: SiteUserFull;
  approvalType: ApprovalType;
  id: Scalars['ID'];
  metaCreated: Scalars['Timestamp'];
};

export type ReturnAuthorizationApproval = {
  __typename?: 'ReturnAuthorizationApproval';
  approvalType: ApprovalType;
  approvedBy: SiteUserFull;
  id: Scalars['ID'];
  metaCreated: Scalars['Timestamp'];
};

export type ReturnAuthorizationLineItem = Node & {
  __typename?: 'ReturnAuthorizationLineItem';
  id: Scalars['ID'];
  product: Product;
  quantity: Scalars['Int'];
  reasonForReturn: Scalars['String'];
  refundAmountCents: Scalars['Currency'];
  serialNumber: Scalars['String'];
};

export type ReturnAuthorizationLineItemInput = {
  lineItemId: Scalars['String'];
  quantity: Scalars['Int'];
  reasonForReturn: Scalars['String'];
  refundAmountCents: Scalars['Currency'];
  serialNumber: Scalars['String'];
};

export type ReturnAuthorizationLineItemLite = {
  __typename?: 'ReturnAuthorizationLineItemLite';
  id: Scalars['ID'];
  productName: Scalars['String'];
  quantity: Scalars['Int'];
  reasonForReturn: Scalars['String'];
  serialNumber: Scalars['String'];
  sku: Scalars['String'];
};

export type ReturnAuthorizationLite = {
  __typename?: 'ReturnAuthorizationLite';
  id: Scalars['ID'];
  lifeCycle: Array<LifeCycleStep>;
  lineItems: Array<ReturnAuthorizationLineItemLite>;
  messages: ChatMessagePage;
  order: OrderLite;
  receivedInventoryNumbers: Array<Scalars['String']>;
  returnNumber: Scalars['String'];
  shipment?: Maybe<Shipment>;
};

export type ReturnAuthorizationPage = Page & {
  __typename?: 'ReturnAuthorizationPage';
  nodes: Array<ReturnAuthorization>;
  pageInfo: PageInfo;
};

export type ReturnAuthorizationTriage = {
  __typename?: 'ReturnAuthorizationTriage';
  createdBy: SiteUserFull;
  createdTimestamp: Scalars['Timestamp'];
  id: Scalars['ID'];
  repairCode: Scalars['String'];
  replacementSerialNumber: Scalars['String'];
  technicianComment: Scalars['String'];
  workflow: TriageWorkflow;
};

export type RowData = {
  __typename?: 'RowData';
  columnName: Scalars['String'];
  value: Scalars['String'];
};

export type SalesChannel = {
  __typename?: 'SalesChannel';
  displayName: Scalars['String'];
  id: Scalars['ID'];
  name: SalesChannelName;
};

export type SalesChannelName =
  | 'ecommerce'
  | 'thirdPartyLogistics';

export type SatisfactionCriteria = {
  __typename?: 'SatisfactionCriteria';
  code: Scalars['String'];
  description: Scalars['String'];
  status: SatisfactionCriteriaStatus;
};

export type SatisfactionCriteriaStatus =
  | 'complete'
  | 'pending';

export type SaveAddressInput = {
  addressee?: InputMaybe<Scalars['String']>;
  city: Scalars['String'];
  company: Scalars['String'];
  countryCode: Scalars['String'];
  phone: Scalars['String'];
  postalCode: Scalars['String'];
  street1: Scalars['String'];
  street2: Scalars['String'];
  street3?: InputMaybe<Scalars['String']>;
  usState: Scalars['String'];
};

export type SaveAndValidateWriteRequestInput = {
  requestData: Scalars['JSON'];
  writeRequestId: Scalars['ID'];
};

export type SaveAsnFormatInput = {
  properties: Array<SaveAsnFormatPropertyInput>;
  storeId: Scalars['ID'];
};

export type SaveAsnFormatPropertyInput = {
  customColumnHeader: Scalars['String'];
  defaultValue: Scalars['String'];
  propertyName: OrderPropertyName;
};

export type SaveAuditLogEventInput = {
  content: Scalars['String'];
  id?: InputMaybe<Scalars['ID']>;
  orderId?: InputMaybe<Scalars['ID']>;
  returnAuthorizationId?: InputMaybe<Scalars['ID']>;
  sendsEmail: Scalars['Boolean'];
  title: Scalars['String'];
};

export type SaveCartonDimensionsInput = {
  height: SaveDimensionInput;
  length: SaveDimensionInput;
  width: SaveDimensionInput;
};

export type SaveCustomOrderFormatFlowInput = {
  id?: InputMaybe<Scalars['ID']>;
  propertyMapping: Array<CustomOrderFormatPropertyMappingInput>;
  storeId?: InputMaybe<Scalars['ID']>;
};

export type SaveCustomerInput = {
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  lastName?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
};

export type SaveDimensionInput = {
  unit: DimensionUnit;
  value: Scalars['Float'];
};

export type SaveFullPartnerInput = {
  fetchHistoricalDataSince?: InputMaybe<Scalars['Timestamp']>;
  name: Scalars['String'];
  stores: Array<SaveStoreInput>;
  websiteUrl: Scalars['String'];
};

export type SaveIncidentEventInput = {
  context?: InputMaybe<Scalars['JSON']>;
  description: Scalars['String'];
  title: Scalars['String'];
  uniqueId: Scalars['String'];
};

export type SaveItemInput = {
  defaultPriceDollars?: InputMaybe<Scalars['Currency']>;
  defaultWholesalePriceDollars?: InputMaybe<Scalars['Currency']>;
  itemId: Scalars['ID'];
  overwriteExistingPrices?: InputMaybe<Scalars['Boolean']>;
};

export type SaveItemReceiptInput = {
  id: Scalars['ID'];
  lineItems: Array<ReceiveReturnAuthorizationLineItemInput>;
};

export type SaveListingManagementStrategiesByItemInput = {
  itemId: Scalars['ID'];
  storesToDisable: Array<Scalars['ID']>;
  storesToEnable: Array<SaveListingManagementStrategiesByItem_StoreInput>;
};

export type SaveListingManagementStrategiesByItem_StoreInput = {
  priceDollars?: InputMaybe<Scalars['String']>;
  storeId: Scalars['ID'];
};

export type SaveListingManagementStrategiesByStoreInput = {
  items: Array<SaveListingManagementStrategiesByStoreInput_ItemInput>;
  storeId: Scalars['ID'];
};

export type SaveListingManagementStrategiesByStoreInput_ItemInput = {
  itemId: Scalars['ID'];
  priceDollars: Scalars['String'];
};

export type SaveListingManagementStrategyInput = {
  id: Scalars['ID'];
  overwriteRelatedItemPrices: Scalars['Boolean'];
  priceDollars: Scalars['String'];
};

export type SaveListingManagementStrategyTemplateGroupInput = {
  id?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
  templates?: InputMaybe<Array<SaveListingManagementStrategyTemplateGroup_TemplateInput>>;
};

export type SaveListingManagementStrategyTemplateGroup_TemplateInput = {
  itemId: Scalars['ID'];
  priceDollars: Scalars['String'];
};

export type SavePaymentMethodMappingInput = {
  id?: InputMaybe<Scalars['ID']>;
  isTaxable?: InputMaybe<Scalars['Boolean']>;
  paymentMethodId?: InputMaybe<Scalars['ID']>;
  paymentMethodText?: InputMaybe<Scalars['String']>;
};

export type SavePaymentMethodMappingsInput = {
  paymentMethods: Array<SavePaymentMethodMappingInput>;
  storeId: Scalars['ID'];
};

export type SaveRepairCodesInput = {
  repairCode: Array<Scalars['String']>;
  storeId: Scalars['ID'];
};

export type SaveSalesOrderInput = {
  billingAddress?: InputMaybe<SaveAddressInput>;
  id: Scalars['ID'];
  shippingAddress?: InputMaybe<SaveAddressInput>;
};

export type SaveScheduledJobInput = {
  id: Scalars['ID'];
  isActive: Scalars['Boolean'];
};

export type SaveSftpMeta = {
  ackFileDirectory: Scalars['String'];
  baseUrl: Scalars['String'];
  orderFileDirectory: Scalars['String'];
  password: Scalars['String'];
  shipFileDirectory: Scalars['String'];
  username: Scalars['String'];
};

export type SaveShippingServiceInput = {
  id?: InputMaybe<Scalars['ID']>;
  requestedShippingService?: InputMaybe<Scalars['String']>;
  shipItemId?: InputMaybe<Scalars['ID']>;
  thirdPartyAccountId?: InputMaybe<Scalars['ID']>;
};

export type SaveShippingServicesInput = {
  services: Array<SaveShippingServiceInput>;
  storeId: Scalars['ID'];
};

export type SaveShopifyMeta = {
  adminToken: Scalars['String'];
  baseUrl: Scalars['String'];
};

export type SaveSmartPayMerchantCredentialInput = {
  password: Scalars['String'];
  type: CredentialTypeName;
  userPool: Scalars['String'];
  username: Scalars['String'];
};

export type SaveSmartPayMerchantInput = {
  credentials: Array<SaveSmartPayMerchantCredentialInput>;
  merchantKey: Scalars['String'];
};

export type SaveSoftwareVersionInput = {
  id?: InputMaybe<Scalars['ID']>;
  name: Scalars['String'];
};

export type SaveSoftwareVersionsInput = {
  softwareVersions: Array<SaveSoftwareVersionInput>;
  storeId: Scalars['ID'];
};

export type SaveStoreBrandInput = {
  buttonColorHex?: InputMaybe<Scalars['String']>;
  logo?: InputMaybe<Scalars['EncodedFileInput']>;
  primaryColorHex?: InputMaybe<Scalars['String']>;
  secondaryColorHex?: InputMaybe<Scalars['String']>;
};

export type SaveStoreEmailSettingsInput = {
  fromEmail: Scalars['String'];
  fromName: Scalars['String'];
  settings: Array<EmailSettingInput>;
  storeId: Scalars['ID'];
};

export type SaveStoreInput = {
  additionalSupportText?: InputMaybe<Scalars['String']>;
  automatedReportEmailRecipient?: InputMaybe<Scalars['String']>;
  avaTaxCompanyCode?: InputMaybe<Scalars['String']>;
  brand?: InputMaybe<SaveStoreBrandInput>;
  brandId?: InputMaybe<Scalars['ID']>;
  creditCardDynamicDescriptor?: InputMaybe<Scalars['String']>;
  departmentId?: InputMaybe<Scalars['ID']>;
  id?: InputMaybe<Scalars['ID']>;
  inventoryLocationId?: InputMaybe<Scalars['ID']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  limitProcessingToSkus?: InputMaybe<Array<Scalars['String']>>;
  name?: InputMaybe<Scalars['String']>;
  netSuiteClientInternalId?: InputMaybe<Scalars['String']>;
  orderPrefix?: InputMaybe<Scalars['String']>;
  packingSlipInformation?: InputMaybe<Scalars['String']>;
  partnerId?: InputMaybe<Scalars['ID']>;
  printRequestFunctionInternalId?: InputMaybe<Scalars['String']>;
  printRequestLabelInternalId?: InputMaybe<Scalars['String']>;
  printRequestPrinterInternalId?: InputMaybe<Scalars['String']>;
  salesChannelName?: InputMaybe<SalesChannelName>;
  salesRepresentativeEmployeeId?: InputMaybe<Scalars['ID']>;
  settings?: InputMaybe<SaveStoreSettingsInput>;
  sftpMeta?: InputMaybe<SaveSftpMeta>;
  shopifyMeta?: InputMaybe<SaveShopifyMeta>;
  smartPayMerchant?: InputMaybe<SaveSmartPayMerchantInput>;
  subsidiaryId?: InputMaybe<Scalars['ID']>;
  taxItemId?: InputMaybe<Scalars['ID']>;
  telgoo5Meta?: InputMaybe<SaveTelgoo5Meta>;
  tier1PrintRequestLabelType?: InputMaybe<Scalars['String']>;
  triageWorkflows?: InputMaybe<Array<SaveTriageWorkflowInput>>;
  type?: InputMaybe<StoreTypeName>;
  wooCommerceMeta?: InputMaybe<SaveWooCommerceMeta>;
  zenDeskUrl?: InputMaybe<Scalars['String']>;
};

export type SaveStoreSettingsInput = {
  ignoresSkuSuffixes?: InputMaybe<Scalars['Boolean']>;
  krogerPlanSKUs?: InputMaybe<Array<Scalars['String']>>;
  prefixNewOrders: Scalars['Boolean'];
  writesDiscountLine?: InputMaybe<Scalars['Boolean']>;
  writesToCatalyst?: InputMaybe<Scalars['Boolean']>;
  writesToShipStation?: InputMaybe<Scalars['Boolean']>;
};

export type SaveTelgoo5Meta = {
  allowableIPAddresses: Array<Scalars['String']>;
  apiUrl: Scalars['String'];
  customerId: Scalars['String'];
  partnerName: Scalars['String'];
  sourceUrl: Scalars['String'];
};

export type SaveThirdPartyAccountInput = {
  accountNumber?: InputMaybe<Scalars['String']>;
  address?: InputMaybe<SaveAddressInput>;
  addressee?: InputMaybe<Scalars['String']>;
  attention?: InputMaybe<Scalars['String']>;
  carrierType?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
};

export type SaveTriageObservationInput = {
  returnAuthorizationId: Scalars['ID'];
  triageReasonId: Scalars['ID'];
};

export type SaveTriageReasonsInput = {
  reasons: Array<Scalars['String']>;
  storeId: Scalars['ID'];
};

export type SaveTriageWorkflowInput = {
  id?: InputMaybe<Scalars['ID']>;
  isEnabled: Scalars['Boolean'];
  name: Scalars['String'];
  netSuiteBinInternalId: Scalars['String'];
  triageWorkflowTypeName: TriageWorkflowTypeName;
};

export type SaveTriageWorkflowsInput = {
  storeId: Scalars['ID'];
  triageWorkflowsInput: Array<SaveTriageWorkflowInput>;
};

export type SaveUserInput = {
  id: Scalars['ID'];
  status?: InputMaybe<UserStatusName>;
};

export type SaveUserRoleTemplateInput = {
  description?: InputMaybe<Scalars['String']>;
  displayName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  permissions?: InputMaybe<Array<PermissionName>>;
  visibilityScopeName?: InputMaybe<VisibilityScopeName>;
};

export type SaveVirtualDeviceIdentifierInput = {
  type: DeviceIdentifierTypeName;
  value: Scalars['String'];
};

export type SaveVirtualDeviceInput = {
  id?: InputMaybe<Scalars['ID']>;
  identifiers?: InputMaybe<Array<SaveVirtualDeviceIdentifierInput>>;
  isInUse?: InputMaybe<Scalars['Boolean']>;
  sku?: InputMaybe<Scalars['String']>;
  storeId?: InputMaybe<Scalars['ID']>;
};

export type SaveWeightInput = {
  unit: WeightUnit;
  value: Scalars['Float'];
};

export type SaveWooCommerceMeta = {
  baseUrl: Scalars['String'];
  consumerKey: Scalars['String'];
  consumerSecret: Scalars['String'];
};

export type ScanEvent = {
  __typename?: 'ScanEvent';
  id: Scalars['ID'];
  scannedAt: Scalars['Timestamp'];
  type: ScanEventType;
};

export type ScanEventType = {
  __typename?: 'ScanEventType';
  displayName: Scalars['String'];
  id: Scalars['ID'];
  name: ScanEventTypeName;
};

export type ScanEventTypeName =
  | 'delivered'
  | 'returnedToSender'
  | 'shipped';

export type ScheduledJob = {
  __typename?: 'ScheduledJob';
  averageRunTimeSeconds: Scalars['Float'];
  daemon: Daemon;
  id: Scalars['ID'];
  isActive: Scalars['Boolean'];
  isIndependent: Scalars['Boolean'];
  repeatPeriodSeconds: Scalars['Int'];
  runParameters: Scalars['JSON'];
  runs: ScheduledJobRunPage;
  windowEndTime?: Maybe<Scalars['String']>;
  windowStartTime?: Maybe<Scalars['String']>;
};


export type ScheduledJobRunsArgs = {
  options: ScheduledJobRunQueryOptions;
};

export type ScheduledJobPage = {
  __typename?: 'ScheduledJobPage';
  nodes: Array<ScheduledJob>;
  pageInfo: PageInfo;
};

export type ScheduledJobRun = {
  __typename?: 'ScheduledJobRun';
  endTimestamp?: Maybe<Scalars['Timestamp']>;
  id: Scalars['ID'];
  startTimestamp: Scalars['Timestamp'];
};

export type ScheduledJobRunPage = {
  __typename?: 'ScheduledJobRunPage';
  nodes: Array<ScheduledJobRun>;
  pageInfo: PageInfo;
};

export type ScheduledJobRunQueryFilterInput = {
  after?: InputMaybe<Scalars['Timestamp']>;
};

export type ScheduledJobRunQueryOptions = {
  filter?: InputMaybe<ScheduledJobRunQueryFilterInput>;
  paginationInput: PaginationInput;
};

export type SendChatMessageInput = {
  content?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  orderId?: InputMaybe<Scalars['ID']>;
  returnAuthorizationId?: InputMaybe<Scalars['ID']>;
};

export type SendGridEmailRequest = Node & {
  __typename?: 'SendGridEmailRequest';
  appEvent?: Maybe<AppEvent>;
  createdAt: Scalars['Timestamp'];
  dynamicTemplateData: Scalars['JSON'];
  errorReason?: Maybe<Scalars['String']>;
  errorResponse?: Maybe<Scalars['JSON']>;
  fromData: Scalars['JSON'];
  id: Scalars['ID'];
  orderId?: Maybe<Scalars['ID']>;
  recipientEmails: Array<Scalars['String']>;
  returnAuthorizationId?: Maybe<Scalars['ID']>;
  status: SendGridEmailStatus;
  templateId: Scalars['String'];
};

export type SendGridEmailRequestPage = Page & {
  __typename?: 'SendGridEmailRequestPage';
  nodes: Array<SendGridEmailRequest>;
  pageInfo: PageInfo;
};

export type SendGridEmailStatus = {
  __typename?: 'SendGridEmailStatus';
  displayName: Scalars['String'];
  id: Scalars['ID'];
  name: SendGridEmailStatusName;
};

export type SendGridEmailStatusName =
  | 'bounce'
  | 'deferred'
  | 'delivered'
  | 'dropped'
  | 'failed'
  | 'processed';

export type SftpStoreMetaData = {
  __typename?: 'SftpStoreMetaData';
  ackFileDirectory: Scalars['String'];
  baseUrl: Scalars['String'];
  id: Scalars['ID'];
  orderFileDirectory: Scalars['String'];
  password: Scalars['String'];
  shipFileDirectory: Scalars['String'];
  username: Scalars['String'];
};

export type ShipItem = Node & {
  __typename?: 'ShipItem';
  id: Scalars['ID'];
  internalId: Scalars['String'];
  name: Scalars['String'];
};

export type ShipItemPage = Page & {
  __typename?: 'ShipItemPage';
  nodes: Array<ShipItem>;
  pageInfo: PageInfo;
};

export type ShipStationOrder = {
  __typename?: 'ShipStationOrder';
  id: Scalars['ID'];
  rawData: Scalars['JSON'];
};

export type ShipStationShipment = {
  __typename?: 'ShipStationShipment';
  id: Scalars['ID'];
  rawData: Scalars['JSON'];
};

export type ShipStationStore = {
  __typename?: 'ShipStationStore';
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type Shipment = {
  __typename?: 'Shipment';
  carrierCode: Scalars['String'];
  createdAt: Scalars['Timestamp'];
  id: Scalars['ID'];
  labelUrl: Scalars['String'];
  order?: Maybe<Order>;
  returnAuthorization?: Maybe<ReturnAuthorization>;
  scanEvent?: Maybe<ScanEvent>;
  scanEvents: Array<ScanEvent>;
  serviceCode: Scalars['String'];
  trackingNumber: Scalars['String'];
  trackingUrl: Scalars['String'];
};


export type ShipmentScanEventArgs = {
  type: ScanEventTypeName;
};

export type ShippingService = Node & {
  __typename?: 'ShippingService';
  id: Scalars['ID'];
  requestedShippingService: Scalars['String'];
  shipItem?: Maybe<ShipItem>;
  store: Store;
  thirdPartyAccount?: Maybe<ThirdPartyAccount>;
};

export type ShopifyStoreMetaData = {
  __typename?: 'ShopifyStoreMetaData';
  adminToken: Scalars['String'];
  baseUrl: Scalars['String'];
  id: Scalars['ID'];
};

export type SiteUserFull = Node & {
  __typename?: 'SiteUserFull';
  assignedRoles: Array<UserRoleAssignment>;
  authProviderUserId: Scalars['String'];
  email: Scalars['String'];
  fullName: Scalars['String'];
  id: Scalars['ID'];
  isSuperAdmin: Scalars['Boolean'];
  permissions: Array<Permission>;
  status: UserStatus;
};


export type SiteUserFullPermissionsArgs = {
  storeId?: InputMaybe<Scalars['ID']>;
};

export type SiteUserFullPage = Page & {
  __typename?: 'SiteUserFullPage';
  nodes: Array<SiteUserFull>;
  pageInfo: PageInfo;
};

export type SkuSwap = {
  __typename?: 'SkuSwap';
  id: Scalars['ID'];
  product: Product;
  quantity: Scalars['Int'];
};

export type SmartPayLeaseApplication = Node & {
  __typename?: 'SmartPayLeaseApplication';
  apiRequests: HttpRequestPage;
  applicationNumber: Scalars['String'];
  approvalAmountCents: Scalars['Currency'];
  id: Scalars['ID'];
  isActive: Scalars['Boolean'];
  merchant: SmartPayMerchant;
  merchantOrderId: Scalars['String'];
  order: Order;
  steps: Array<LeaseApplicationStep>;
};


export type SmartPayLeaseApplicationApiRequestsArgs = {
  options: QueryHttpRequestsOptionsInput;
};

export type SmartPayLeaseApplicationPage = Page & {
  __typename?: 'SmartPayLeaseApplicationPage';
  nodes: Array<SmartPayLeaseApplication>;
  pageInfo: PageInfo;
};

export type SmartPayMerchant = {
  __typename?: 'SmartPayMerchant';
  id: Scalars['ID'];
  leaseApplications: SmartPayLeaseApplicationPage;
  merchantKey: Scalars['String'];
};

export type SoftwareVersion = {
  __typename?: 'SoftwareVersion';
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type SortDirection =
  | 'ascending'
  | 'descending';

export type Store = Node & {
  __typename?: 'Store';
  additionalSupportText: Scalars['String'];
  automatedReportEmailRecipient: Scalars['String'];
  avaTaxCompanyCode: Scalars['String'];
  brand?: Maybe<NetSuiteBrand>;
  buttonColorHex: Scalars['String'];
  creditCardDynamicDescriptor: Scalars['String'];
  customOrderFormatFlow?: Maybe<CustomOrderFormatFlow>;
  department?: Maybe<NetSuiteDepartment>;
  emailSettings: Array<StoreEmailSetting>;
  fulfillmentDestination?: Maybe<FulfillmentDestination>;
  id: Scalars['ID'];
  inventoryLocation?: Maybe<NetSuiteInventoryLocation>;
  invites: InvitePage;
  isActive: Scalars['Boolean'];
  isFeatureDisabled: Scalars['Boolean'];
  limitProcessingToSkus: Array<Scalars['String']>;
  listings: ListingPage;
  logoUrl: Scalars['String'];
  metaData?: Maybe<StoreMetaData>;
  name: Scalars['String'];
  netSuiteClientInternalId: Scalars['String'];
  orderPrefix: Scalars['String'];
  orders: OrderPage;
  packingSlipInformation: Scalars['String'];
  partner: Partner;
  paymentMethodMappings: Array<PaymentMethodMapping>;
  primaryColorHex: Scalars['String'];
  printRequestFunctionInternalId: Scalars['String'];
  printRequestLabelInternalId: Scalars['String'];
  printRequestPrinterInternalId: Scalars['String'];
  repairCodes: Array<RepairCode>;
  salesChannel: SalesChannel;
  salesOrderValidator: Scalars['Validator'];
  salesRepresentativeEmployee?: Maybe<Employee>;
  secondaryColorHex: Scalars['String'];
  sendGridFromEmail: Scalars['String'];
  sendGridFromName: Scalars['String'];
  shipFromAddress: Address;
  shippingServices: Array<ShippingService>;
  softwareVersions: Array<SoftwareVersion>;
  statistics: StoreStatistics;
  storeSettings: StoreSettings;
  subsidiary?: Maybe<NetSuiteSubsidiary>;
  taxItem?: Maybe<NetSuiteTaxItem>;
  tier1PrintRequestLabelType: Scalars['String'];
  triageReasons: Array<TriageReason>;
  triageWorkflows: Array<TriageWorkflow>;
  type: StoreType;
  users: SiteUserFullPage;
  zenDeskUrl: Scalars['String'];
};


export type StoreIsFeatureDisabledArgs = {
  featureName: FeatureName;
};


export type StoreListingsArgs = {
  options?: InputMaybe<QueryListingsOptionsInput>;
};


export type StoreOrdersArgs = {
  options: QueryOrdersOptionsInput;
};


export type StoreStatisticsArgs = {
  after?: InputMaybe<Scalars['Timestamp']>;
  before?: InputMaybe<Scalars['Timestamp']>;
};

export type StoreBrand = {
  __typename?: 'StoreBrand';
  buttonColorHex: Scalars['String'];
  id: Scalars['ID'];
  logoUrl: Scalars['String'];
  primaryColorHex: Scalars['String'];
  secondaryColorHex: Scalars['String'];
};

export type StoreEmailSetting = {
  __typename?: 'StoreEmailSetting';
  appEvent: AppEvent;
  id: Scalars['ID'];
  isActive: Scalars['Boolean'];
  templateId: Scalars['String'];
};

export type StoreMetaData = SftpStoreMetaData | ShopifyStoreMetaData | Telgoo5StoreMetaData | WooCommerceStoreMetaData;

export type StorePage = Page & {
  __typename?: 'StorePage';
  nodes: Array<Store>;
  pageInfo: PageInfo;
};

export type StoreSettings = {
  __typename?: 'StoreSettings';
  ignoresSkuSuffixes: Scalars['Boolean'];
  krogerPlanSKUs: Array<Scalars['String']>;
  location: Scalars['JSON'];
  prefixNewOrders: Scalars['Boolean'];
  useAndRemoveOrderPrefix: Scalars['Boolean'];
  writesDiscountLine: Scalars['Boolean'];
  writesToCatalyst: Scalars['Boolean'];
  writesToShipStation: Scalars['Boolean'];
};

export type StoreStatistics = {
  __typename?: 'StoreStatistics';
  orderCountIn42File: Scalars['Int'];
  orderCountIn47File: Scalars['Int'];
  orderCountInShipStation: Scalars['Int'];
  orderCountInSource: Scalars['Int'];
};

export type StoreType = {
  __typename?: 'StoreType';
  displayName: Scalars['String'];
  id: Scalars['ID'];
  name: StoreTypeName;
};

export type StoreTypeName =
  | 'cleoTier1'
  | 'customizableFormat'
  | 'magicJack'
  | 'shopify'
  | 'shopify_ecommerce'
  | 'tMobileDevEdge'
  | 'telgoo5'
  | 'wooCommerce'
  | 'wooCommerce_buyWithAmazon';

export type SubmitQualityControlCheckInput = {
  returnAuthorizationId: Scalars['ID'];
  softwareVersionId: Scalars['ID'];
};

export type Telgoo5StoreMetaData = {
  __typename?: 'Telgoo5StoreMetaData';
  apiUrl: Scalars['String'];
  customerId: Scalars['String'];
  id: Scalars['ID'];
  partnerName: Scalars['String'];
  sourceUrl: Scalars['String'];
};

export type ThirdPartyAccount = Node & {
  __typename?: 'ThirdPartyAccount';
  accountNumber: Scalars['String'];
  address: Address;
  addressee: Scalars['String'];
  attention: Scalars['String'];
  carrierType: Scalars['String'];
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type ThirdPartyAccountPage = Page & {
  __typename?: 'ThirdPartyAccountPage';
  nodes: Array<ThirdPartyAccount>;
  pageInfo: PageInfo;
};

export type Tier1ItemReceipt = {
  __typename?: 'Tier1ItemReceipt';
  createdBy: SiteUserFull;
  createdTimestamp: Scalars['Timestamp'];
  id: Scalars['ID'];
  item: Item;
  netSuiteRecord?: Maybe<NetSuiteRecord>;
  netSuiteWriteRequest?: Maybe<NetSuiteWriteRequest>;
  serialNumber: Scalars['String'];
};

export type Tier1ReturnAuthorization = Node & {
  __typename?: 'Tier1ReturnAuthorization';
  carton?: Maybe<Carton>;
  createdTimestamp: Scalars['Timestamp'];
  customerComment: Scalars['String'];
  expectedSerialNumber: Scalars['String'];
  group: Tier1ReturnAuthorizationGroup;
  id: Scalars['ID'];
  inboundTrackingNumber: Scalars['String'];
  item: Item;
  itemReceipt?: Maybe<Tier1ItemReceipt>;
  netSuiteRecord?: Maybe<NetSuiteRecord>;
  netSuiteWriteRequest?: Maybe<NetSuiteWriteRequest>;
  observation?: Maybe<TriageObservation>;
  originalLineNumber: Scalars['Int'];
  problemStatements: Array<Scalars['String']>;
  qualityControlCheck?: Maybe<QualityControlCheck>;
  returnNumber: Scalars['String'];
  selectedTriage?: Maybe<ReturnAuthorizationTriage>;
};

export type Tier1ReturnAuthorizationGroup = Node & {
  __typename?: 'Tier1ReturnAuthorizationGroup';
  createdTimestamp: Scalars['Timestamp'];
  id: Scalars['ID'];
  referenceNumber: Scalars['String'];
  returnAuthorizations: Tier1ReturnAuthorizationPage;
  store: Store;
  totalReturnCount: Scalars['Int'];
};


export type Tier1ReturnAuthorizationGroupReturnAuthorizationsArgs = {
  options?: InputMaybe<QueryTier1ReturnAuthorizationsOptionsInput>;
};

export type Tier1ReturnAuthorizationGroupPage = Page & {
  __typename?: 'Tier1ReturnAuthorizationGroupPage';
  nodes: Array<Tier1ReturnAuthorizationGroup>;
  pageInfo: PageInfo;
};

export type Tier1ReturnAuthorizationPage = Page & {
  __typename?: 'Tier1ReturnAuthorizationPage';
  nodes: Array<Tier1ReturnAuthorization>;
  pageInfo: PageInfo;
};

export type Tier1ReturnAuthorizationState =
  | 'awaitingQualityControl'
  | 'awaitingTriage'
  | 'awaitingTriageObservation'
  | 'preAlert'
  | 'readyForLabel';

export type TimeSeries = {
  __typename?: 'TimeSeries';
  intervalSeconds: Scalars['Int'];
  series: Array<TimeSeriesPoint>;
  yUnit: Scalars['String'];
};

export type TimeSeriesPoint = {
  __typename?: 'TimeSeriesPoint';
  x: Scalars['Timestamp'];
  y: Scalars['Float'];
};

export type ToggleExternalOrderArchivedInput = {
  externalOrderId: Scalars['ID'];
};

export type ToggleFeatureInput = {
  enabled: Scalars['Boolean'];
  featureName: FeatureName;
  storeId: Scalars['ID'];
};

export type ToggleListingManagementStrategiesForItemInput = {
  isActive: Scalars['Boolean'];
  itemId: Scalars['ID'];
};

export type TriageObservation = {
  __typename?: 'TriageObservation';
  createdBy: SiteUserFull;
  createdTimestamp: Scalars['Timestamp'];
  id: Scalars['ID'];
  reasonText: Scalars['String'];
};

export type TriageReason = {
  __typename?: 'TriageReason';
  id: Scalars['ID'];
  reasonText: Scalars['String'];
};

export type TriageTier1ReturnAuthorizationInput = {
  repairCodeId?: InputMaybe<Scalars['ID']>;
  replacementSerialNumber?: InputMaybe<Scalars['String']>;
  returnAuthorizationId: Scalars['ID'];
  technicianComment?: InputMaybe<Scalars['String']>;
  triageWorkflowId: Scalars['ID'];
};

export type TriageWorkflow = {
  __typename?: 'TriageWorkflow';
  id: Scalars['ID'];
  isEnabled: Scalars['Boolean'];
  name: Scalars['String'];
  netSuiteBinInternalId: Scalars['String'];
  type: TriageWorkflowType;
};

export type TriageWorkflowType = {
  __typename?: 'TriageWorkflowType';
  displayName: Scalars['String'];
  id: Scalars['ID'];
  name: TriageWorkflowTypeName;
};

export type TriageWorkflowTypeName =
  | 'credit'
  | 'receiving'
  | 'replacement'
  | 'restock'
  | 'return'
  | 'scrap'
  | 'triage';

export type UpdateListingPriceInput = {
  listingId: Scalars['ID'];
  overwriteExistingPrices?: InputMaybe<Scalars['Boolean']>;
  priceDollars: Scalars['String'];
};

export type UserRoleAssignment = {
  __typename?: 'UserRoleAssignment';
  id: Scalars['ID'];
  roleTemplate: UserRoleTemplate;
  store?: Maybe<Store>;
  user: SiteUserFull;
};

export type UserRoleTemplate = Node & {
  __typename?: 'UserRoleTemplate';
  description: Scalars['String'];
  displayName: Scalars['String'];
  id: Scalars['ID'];
  permissions: Array<Permission>;
  visibilityScope: VisibilityScope;
};

export type UserRoleTemplatePage = Page & {
  __typename?: 'UserRoleTemplatePage';
  nodes: Array<UserRoleTemplate>;
  pageInfo: PageInfo;
};

export type UserStatus = {
  __typename?: 'UserStatus';
  displayName: Scalars['String'];
  id: Scalars['ID'];
  name: UserStatusName;
};

export type UserStatusName =
  | 'approved'
  | 'denied'
  | 'pendingApproval';

export type ValidationState =
  | 'invalid'
  | 'invalidArchived'
  | 'notValidated'
  | 'valid';

export type VirtualDevice = {
  __typename?: 'VirtualDevice';
  availabilityStatus: VirtualDeviceAvailabilityStatus;
  id: Scalars['ID'];
  identifiers: Array<VirtualDeviceIdentifier>;
  sku: Scalars['String'];
};

export type VirtualDeviceAvailabilityStatus = {
  __typename?: 'VirtualDeviceAvailabilityStatus';
  displayName: Scalars['String'];
  id: Scalars['ID'];
  name: VirtualDeviceAvailabilityStatusName;
};

export type VirtualDeviceAvailabilityStatusName =
  | 'available'
  | 'inUse'
  | 'reserved';

export type VirtualDeviceIdentifier = {
  __typename?: 'VirtualDeviceIdentifier';
  device: VirtualDevice;
  id: Scalars['ID'];
  type: DeviceIdentifierType;
  value: Scalars['String'];
};

export type VisibilityScope = {
  __typename?: 'VisibilityScope';
  displayName: Scalars['String'];
  id: Scalars['ID'];
  name: VisibilityScopeName;
};

export type VisibilityScopeName =
  | 'global'
  | 'hidden'
  | 'storeSpecific';

export type Weight = {
  __typename?: 'Weight';
  unit: WeightUnit;
  value: Scalars['Float'];
};

export type WeightUnit =
  | 'grams'
  | 'kilograms'
  | 'ounces'
  | 'pounds'
  | 'unknown';

export type WooCommerceStoreMetaData = {
  __typename?: 'WooCommerceStoreMetaData';
  baseUrl: Scalars['String'];
  consumerKey: Scalars['String'];
  consumerSecret: Scalars['String'];
  id: Scalars['ID'];
};

export type AdministratorInvitesWidgetQueryVariables = Exact<{ [key: string]: never; }>;


export type AdministratorInvitesWidgetQuery = { __typename?: 'Query', invites: { __typename?: 'InvitePage', pageInfo: { __typename?: 'PageInfo', nextPage?: any | null, pages: Array<any>, previousPage?: any | null, totalRows: number }, nodes: Array<{ __typename?: 'Invite', id: string, recipientEmail: string, sentTimestamp?: string | null, claimant?: { __typename?: 'SiteUserFull', id: string } | null }> } };

export type AdministratorsWidgetQueryVariables = Exact<{ [key: string]: never; }>;


export type AdministratorsWidgetQuery = { __typename?: 'Query', siteUsers: { __typename?: 'SiteUserFullPage', pageInfo: { __typename?: 'PageInfo', nextPage?: any | null, pages: Array<any>, previousPage?: any | null, totalRows: number }, nodes: Array<{ __typename?: 'SiteUserFull', id: string, email: string, fullName: string, status: { __typename?: 'UserStatus', id: string, name: UserStatusName, displayName: string } }> } };

export type SaveUserMutationVariables = Exact<{
  input: SaveUserInput;
}>;


export type SaveUserMutation = { __typename?: 'Mutation', saveUser?: { __typename?: 'SiteUserFull', id: string, status: { __typename?: 'UserStatus', id: string, name: UserStatusName, displayName: string } } | null };

export type AppSettings_AssignedPermissionsTabQueryVariables = Exact<{ [key: string]: never; }>;


export type AppSettings_AssignedPermissionsTabQuery = { __typename?: 'Query', siteUsers: { __typename?: 'SiteUserFullPage', pageInfo: { __typename?: 'PageInfo', nextPage?: any | null, pages: Array<any>, previousPage?: any | null, totalRows: number }, nodes: Array<{ __typename?: 'SiteUserFull', id: string, email: string, fullName: string, assignedRoles: Array<{ __typename?: 'UserRoleAssignment', id: string }> }> } };

export type AssignRoleMutationVariables = Exact<{
  input: AssignRoleInput;
}>;


export type AssignRoleMutation = { __typename?: 'Mutation', assignRole: Array<{ __typename?: 'UserRoleAssignment', id: string }> };

export type AssignRoleModalQueryVariables = Exact<{
  siteUserId: Scalars['ID'];
}>;


export type AssignRoleModalQuery = { __typename?: 'Query', siteUser?: { __typename?: 'SiteUserFull', id: string, assignedRoles: Array<{ __typename?: 'UserRoleAssignment', id: string, roleTemplate: { __typename?: 'UserRoleTemplate', id: string }, store?: { __typename?: 'Store', id: string } | null }> } | null };

export type UnassignRoleMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type UnassignRoleMutation = { __typename?: 'Mutation', unassignRole: boolean };

export type AppSettings_AssignedPermissionsTab_UserDetailSectionQueryVariables = Exact<{
  siteUserId: Scalars['ID'];
}>;


export type AppSettings_AssignedPermissionsTab_UserDetailSectionQuery = { __typename?: 'Query', siteUser?: { __typename?: 'SiteUserFull', id: string, email: string, fullName: string, assignedRoles: Array<{ __typename?: 'UserRoleAssignment', id: string, roleTemplate: { __typename?: 'UserRoleTemplate', id: string, displayName: string }, store?: { __typename?: 'Store', id: string, name: string } | null }> } | null };

export type EnumPermissionFieldsFragment = { __typename?: 'Permission', id: string, name: PermissionName, displayName: string, group: { __typename?: 'PermissionGroup', id: string, name: PermissionGroupName, displayName: string } };

export type AppSettingsActivity_RolesTabQueryVariables = Exact<{ [key: string]: never; }>;


export type AppSettingsActivity_RolesTabQuery = { __typename?: 'Query', permissionGroups: Array<{ __typename?: 'PermissionGroup', id: string, name: PermissionGroupName, displayName: string, permissions: Array<{ __typename?: 'Permission', id: string, name: PermissionName, displayName: string, group: { __typename?: 'PermissionGroup', id: string, name: PermissionGroupName, displayName: string } }> }>, userRoleTemplates: { __typename?: 'UserRoleTemplatePage', pageInfo: { __typename?: 'PageInfo', nextPage?: any | null, pages: Array<any>, previousPage?: any | null, totalRows: number }, nodes: Array<{ __typename?: 'UserRoleTemplate', id: string, displayName: string, description: string, visibilityScope: { __typename?: 'VisibilityScope', id: string, name: VisibilityScopeName, displayName: string }, permissions: Array<{ __typename?: 'Permission', id: string, name: PermissionName, displayName: string, group: { __typename?: 'PermissionGroup', id: string, name: PermissionGroupName, displayName: string } }> }> } };

export type DeleteUserRoleTemplateMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteUserRoleTemplateMutation = { __typename?: 'Mutation', deleteUserRoleTemplate: boolean };

export type SaveUserRoleTemplateMutationVariables = Exact<{
  input: SaveUserRoleTemplateInput;
}>;


export type SaveUserRoleTemplateMutation = { __typename?: 'Mutation', saveUserRoleTemplate?: { __typename?: 'UserRoleTemplate', id: string, displayName: string, description: string, permissions: Array<{ __typename?: 'Permission', id: string, name: PermissionName, displayName: string }> } | null };

export type AppleCareAgreementsActivityQueryVariables = Exact<{
  cursor?: InputMaybe<Scalars['Cursor']>;
  filter?: InputMaybe<QueryAppleCareAgreementsFilterInput>;
  sort?: InputMaybe<QueryAppleCareAgreementsSortInput>;
}>;


export type AppleCareAgreementsActivityQuery = { __typename?: 'Query', appleCareAgreements: { __typename?: 'AppleCareAgreementPage', pageInfo: { __typename?: 'PageInfo', nextPage?: any | null, pages: Array<any>, previousPage?: any | null, totalRows: number }, nodes: Array<{ __typename?: 'AppleCareAgreement', id: string, agreementNumber: string, activatedAt?: string | null, serialNumber: string, lineItem: { __typename?: 'LineItem', id: string, order: { __typename?: 'Order', id: string, orderNumber: string, orderDate: string, store: { __typename?: 'Store', id: string } }, product: { __typename?: 'Product', id: string, name: string, sku: string } }, apiRequests: { __typename?: 'HttpRequestPage', pageInfo: { __typename?: 'PageInfo', nextPage?: any | null, pages: Array<any>, previousPage?: any | null, totalRows: number }, nodes: Array<{ __typename?: 'HttpRequest', id: string, metaCreated: string, method: HttpRequestMethodName, url: string, httpStatusCode: number, requestBody: any, responseBody: any }> } }> } };

export type CustomersActivityQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Cursor']>;
  filter?: InputMaybe<QueryCustomersFilterInput>;
  sort?: InputMaybe<QueryCustomersSortInput>;
}>;


export type CustomersActivityQuery = { __typename?: 'Query', customers: { __typename?: 'CustomerPage', pageInfo: { __typename?: 'PageInfo', nextPage?: any | null, pages: Array<any>, previousPage?: any | null, totalRows: number }, nodes: Array<{ __typename?: 'Customer', id: string, email: string, firstName: string, lastName: string, phoneNumber: string, netSuiteRecord?: { __typename?: 'NetSuiteRecord', id: string, createdAt: string, netSuiteInternalId: string, recordUrl: string, transactionId: string } | null }> } };

export type EditCustomerModalQueryVariables = Exact<{
  customerId: Scalars['ID'];
}>;


export type EditCustomerModalQuery = { __typename?: 'Query', customer?: { __typename?: 'Customer', id: string, firstName: string, lastName: string, email: string, phoneNumber: string, netSuiteRecord?: { __typename?: 'NetSuiteRecord', id: string, createdAt: string, netSuiteInternalId: string, recordUrl: string, transactionId: string } | null } | null };

export type SaveCustomerMutationVariables = Exact<{
  input: SaveCustomerInput;
}>;


export type SaveCustomerMutation = { __typename?: 'Mutation', saveCustomer?: { __typename?: 'Customer', id: string, email: string, firstName: string, lastName: string, phoneNumber: string } | null };

export type CacheAndProcessOrdersMutationVariables = Exact<{
  storeId: Scalars['ID'];
  startTime?: InputMaybe<Scalars['Timestamp']>;
  orderId?: InputMaybe<Scalars['String']>;
}>;


export type CacheAndProcessOrdersMutation = { __typename?: 'Mutation', cacheAndProcessOrders: boolean };

export type DataCacheActivityQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Cursor']>;
  filter?: InputMaybe<QueryCachedOrdersFilterInput>;
  sort?: InputMaybe<QueryCachedOrdersSortInput>;
}>;


export type DataCacheActivityQuery = { __typename?: 'Query', cachedOrders: { __typename?: 'ExternalOrdersPage', pageInfo: { __typename?: 'PageInfo', nextPage?: any | null, pages: Array<any>, previousPage?: any | null, totalRows: number }, nodes: Array<{ __typename?: 'ExternalOrder', id: string, metaCreated: string, rawData: any, validationErrors: Array<string>, store: { __typename?: 'Store', id: string, type: { __typename?: 'StoreType', id: string, name: StoreTypeName, displayName: string } } }> } };

export type ToggleDataCacheExternalOrderArchivedMutationVariables = Exact<{
  input: ToggleExternalOrderArchivedInput;
}>;


export type ToggleDataCacheExternalOrderArchivedMutation = { __typename?: 'Mutation', toggleExternalOrderArchived: boolean };

export type JiraTicketsTabQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Cursor']>;
  filter?: InputMaybe<QueryJiraTicketsFilterInput>;
  sort?: InputMaybe<QueryJiraTicketsSortInput>;
}>;


export type JiraTicketsTabQuery = { __typename?: 'Query', jiraTickets: { __typename?: 'JiraTicketPage', pageInfo: { __typename?: 'PageInfo', nextPage?: any | null, pages: Array<any>, previousPage?: any | null, totalRows: number }, nodes: Array<{ __typename?: 'JiraTicket', id: string, createdAt: string, key: string, title: string, description: string, context: any, labels: Array<string> }> } };

export type LoadTabQueryVariables = Exact<{
  start: Scalars['Timestamp'];
  end: Scalars['Timestamp'];
}>;


export type LoadTabQuery = { __typename?: 'Query', orderCountTimeSeries: { __typename?: 'TimeSeries', intervalSeconds: number, yUnit: string, series: Array<{ __typename?: 'TimeSeriesPoint', x: string, y: number }> }, cacheSalesOrdersTimeSeries: { __typename?: 'TimeSeries', series: Array<{ __typename?: 'TimeSeriesPoint', x: string, y: number }> }, processSalesOrderCacheTimeSeries: { __typename?: 'TimeSeries', series: Array<{ __typename?: 'TimeSeriesPoint', x: string, y: number }> }, wooCommerceCheckForUpdatesToUnfulfilledOrdersTimeSeries: { __typename?: 'TimeSeries', series: Array<{ __typename?: 'TimeSeriesPoint', x: string, y: number }> } };

export type ImportInventoryItemsMutationVariables = Exact<{
  input: Array<ImportInventoryItemInput> | ImportInventoryItemInput;
}>;


export type ImportInventoryItemsMutation = { __typename?: 'Mutation', importInventoryItems: boolean };

export type ImportNetSuiteDepartmentsMutationVariables = Exact<{
  input: Array<ImportDepartmentInput> | ImportDepartmentInput;
}>;


export type ImportNetSuiteDepartmentsMutation = { __typename?: 'Mutation', importNetSuiteDepartments: boolean };

export type ImportNetSuiteEmployeesMutationVariables = Exact<{
  input: Array<ImportEmployeeInput> | ImportEmployeeInput;
}>;


export type ImportNetSuiteEmployeesMutation = { __typename?: 'Mutation', importNetSuiteEmployees: boolean };

export type ImportNetSuiteSubsidiariesModalQueryVariables = Exact<{ [key: string]: never; }>;


export type ImportNetSuiteSubsidiariesModalQuery = { __typename?: 'Query', subsidiaries: Array<{ __typename?: 'NetSuiteSubsidiary', id: string, name: string }> };

export type ImportNetSuiteInventoryLocationsMutationVariables = Exact<{
  input: Array<ImportInventoryLocationInput> | ImportInventoryLocationInput;
}>;


export type ImportNetSuiteInventoryLocationsMutation = { __typename?: 'Mutation', importNetSuiteInventoryLocations: boolean };

export type ImportInventoryLocationsModalQueryVariables = Exact<{ [key: string]: never; }>;


export type ImportInventoryLocationsModalQuery = { __typename?: 'Query', subsidiaries: Array<{ __typename?: 'NetSuiteSubsidiary', id: string, name: string }> };

export type ImportNetSuiteShipItemsMutationVariables = Exact<{
  input: Array<ImportShipItemInput> | ImportShipItemInput;
}>;


export type ImportNetSuiteShipItemsMutation = { __typename?: 'Mutation', importNetSuiteShipItems: boolean };

export type ImportNetSuiteShipItemsModalQueryVariables = Exact<{ [key: string]: never; }>;


export type ImportNetSuiteShipItemsModalQuery = { __typename?: 'Query', subsidiaries: Array<{ __typename?: 'NetSuiteSubsidiary', id: string, name: string }> };

export type ImportNetSuiteSubsidiariesMutationVariables = Exact<{
  input: Array<ImportSubsidiaryInput> | ImportSubsidiaryInput;
}>;


export type ImportNetSuiteSubsidiariesMutation = { __typename?: 'Mutation', importNetSuiteSubsidiaries: boolean };

export type ImportNetSuitePaymentMethodsMutationVariables = Exact<{
  input: Array<ImportPaymentMethodInput> | ImportPaymentMethodInput;
}>;


export type ImportNetSuitePaymentMethodsMutation = { __typename?: 'Mutation', importNetSuitePaymentMethods: boolean };

export type ImportPaymentMethodsModalQueryVariables = Exact<{ [key: string]: never; }>;


export type ImportPaymentMethodsModalQuery = { __typename?: 'Query', subsidiaries: Array<{ __typename?: 'NetSuiteSubsidiary', id: string, name: string }> };

export type DebugActivity_NetSuiteRecordsTabQueryVariables = Exact<{ [key: string]: never; }>;


export type DebugActivity_NetSuiteRecordsTabQuery = { __typename?: 'Query', shipItems: { __typename?: 'ShipItemPage', nodes: Array<{ __typename?: 'ShipItem', id: string, name: string, internalId: string }> }, subsidiaries: Array<{ __typename?: 'NetSuiteSubsidiary', id: string, name: string, internalId: string }>, departments: Array<{ __typename?: 'NetSuiteDepartment', id: string, name: string, internalId: string }>, employees: Array<{ __typename?: 'Employee', id: string, fullName: string, internalId: string }>, items: { __typename?: 'ItemPage', nodes: Array<{ __typename?: 'Item', id: string, sku: string, name: string, description: string, netSuiteInternalId?: string | null }> }, netSuitePaymentMethods: Array<{ __typename?: 'NetSuitePaymentMethod', id: string, name: string, internalId: string }>, inventoryLocations: Array<{ __typename?: 'NetSuiteInventoryLocation', id: string, name: string, internalId?: string | null }> };

export type DebugActivity_RolesTabQueryVariables = Exact<{ [key: string]: never; }>;


export type DebugActivity_RolesTabQuery = { __typename?: 'Query', permissionGroups: Array<{ __typename?: 'PermissionGroup', id: string, name: PermissionGroupName, displayName: string, permissions: Array<{ __typename?: 'Permission', id: string, name: PermissionName, displayName: string, group: { __typename?: 'PermissionGroup', id: string, name: PermissionGroupName, displayName: string } }> }>, userRoleTemplates: { __typename?: 'UserRoleTemplatePage', pageInfo: { __typename?: 'PageInfo', nextPage?: any | null, pages: Array<any>, previousPage?: any | null, totalRows: number }, nodes: Array<{ __typename?: 'UserRoleTemplate', id: string, displayName: string, description: string, permissions: Array<{ __typename?: 'Permission', id: string, name: PermissionName, displayName: string, group: { __typename?: 'PermissionGroup', id: string, name: PermissionGroupName, displayName: string } }> }> } };

export type MockFulfillTelgoo5OrdersMutationVariables = Exact<{ [key: string]: never; }>;


export type MockFulfillTelgoo5OrdersMutation = { __typename?: 'Mutation', mockFulfillTelgoo5Orders: boolean };

export type PingNetSuiteQueryVariables = Exact<{ [key: string]: never; }>;


export type PingNetSuiteQuery = { __typename?: 'Query', testNetSuiteConnection: boolean };

export type PingE1QueryVariables = Exact<{ [key: string]: never; }>;


export type PingE1Query = { __typename?: 'Query', testE1Connection: boolean };

export type RunAllJobsMutationVariables = Exact<{ [key: string]: never; }>;


export type RunAllJobsMutation = { __typename?: 'Mutation', runAllJobs: boolean };

export type RunScheduledJobMutationVariables = Exact<{
  scheduledJobId: Scalars['ID'];
}>;


export type RunScheduledJobMutation = { __typename?: 'Mutation', runScheduledJob: boolean };

export type SaveScheduledJobMutationVariables = Exact<{
  input: SaveScheduledJobInput;
}>;


export type SaveScheduledJobMutation = { __typename?: 'Mutation', saveScheduledJob?: { __typename?: 'ScheduledJob', id: string, isActive: boolean, windowStartTime?: string | null, windowEndTime?: string | null, repeatPeriodSeconds: number, isIndependent: boolean, averageRunTimeSeconds: number, runParameters: any, runs: { __typename?: 'ScheduledJobRunPage', pageInfo: { __typename?: 'PageInfo', nextPage?: any | null, pages: Array<any>, previousPage?: any | null, totalRows: number }, nodes: Array<{ __typename?: 'ScheduledJobRun', id: string, startTimestamp: string, endTimestamp?: string | null }> }, daemon: { __typename?: 'Daemon', id: string, name: DaemonName, displayName: string } } | null };

export type ScheduledJobTable_ScheduledJobFieldsFragment = { __typename?: 'ScheduledJob', id: string, isActive: boolean, windowStartTime?: string | null, windowEndTime?: string | null, repeatPeriodSeconds: number, isIndependent: boolean, averageRunTimeSeconds: number, runParameters: any, runs: { __typename?: 'ScheduledJobRunPage', pageInfo: { __typename?: 'PageInfo', nextPage?: any | null, pages: Array<any>, previousPage?: any | null, totalRows: number }, nodes: Array<{ __typename?: 'ScheduledJobRun', id: string, startTimestamp: string, endTimestamp?: string | null }> }, daemon: { __typename?: 'Daemon', id: string, name: DaemonName, displayName: string } };

export type ScheduledJobsTabQueryVariables = Exact<{
  filter: QueryScheduledJobsFilterInput;
}>;


export type ScheduledJobsTabQuery = { __typename?: 'Query', scheduledJobs: { __typename?: 'ScheduledJobPage', pageInfo: { __typename?: 'PageInfo', nextPage?: any | null, pages: Array<any>, previousPage?: any | null, totalRows: number }, nodes: Array<{ __typename?: 'ScheduledJob', id: string, isActive: boolean, windowStartTime?: string | null, windowEndTime?: string | null, repeatPeriodSeconds: number, isIndependent: boolean, averageRunTimeSeconds: number, runParameters: any, runs: { __typename?: 'ScheduledJobRunPage', pageInfo: { __typename?: 'PageInfo', nextPage?: any | null, pages: Array<any>, previousPage?: any | null, totalRows: number }, nodes: Array<{ __typename?: 'ScheduledJobRun', id: string, startTimestamp: string, endTimestamp?: string | null }> }, daemon: { __typename?: 'Daemon', id: string, name: DaemonName, displayName: string } }> } };

export type TestPingMutationVariables = Exact<{ [key: string]: never; }>;


export type TestPingMutation = { __typename?: 'Mutation', testPing: boolean };

export type ApplyListingManagementStrategyTemplateGroupsMutationVariables = Exact<{
  input: ApplyListingManagementStrategyTemplateGroupsInput;
}>;


export type ApplyListingManagementStrategyTemplateGroupsMutation = { __typename?: 'Mutation', applyListingManagementStrategyTemplateGroups: Array<{ __typename?: 'Item', id: string, listingManagementStrategies: Array<{ __typename?: 'ListingManagementStrategy', id: string, isActive: boolean, priceDollars: string, store: { __typename?: 'Store', id: string, name: string, isInventoryManagementDisabled: boolean } }> }> };

export type ApplyTemplatesToStoreModalQueryVariables = Exact<{ [key: string]: never; }>;


export type ApplyTemplatesToStoreModalQuery = { __typename?: 'Query', listingManagementStrategyTemplateGroups: { __typename?: 'ListingManagementStrategyTemplateGroupsPage', pageInfo: { __typename?: 'PageInfo', nextPage?: any | null, pages: Array<any>, previousPage?: any | null, totalRows: number }, nodes: Array<{ __typename?: 'ListingManagementStrategyTemplateGroup', id: string, name: string, templateCount: number }> } };

export type ExportItemListQueryVariables = Exact<{
  options: QueryItemsOptionsInput;
}>;


export type ExportItemListQuery = { __typename?: 'Query', exportItemList?: any | null };

export type InventoryActivity_ItemTabItemFieldsFragment = { __typename?: 'Item', id: string, sku: string, name: string, defaultPriceDollars: string, defaultWholesalePriceDollars: string, defaultCostDollars: string, listingManagementStrategyCount: number, currentQuantity: number, itemQtyLastModifiedDate: string, itemLastModifiedDate: string };

export type InventoryActivity_ItemTabQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Cursor']>;
  filter?: InputMaybe<QueryItemsFilterInput>;
  sort?: InputMaybe<QueryItemsSortInput>;
}>;


export type InventoryActivity_ItemTabQuery = { __typename?: 'Query', items: { __typename?: 'ItemPage', pageInfo: { __typename?: 'PageInfo', nextPage?: any | null, pages: Array<any>, previousPage?: any | null, totalRows: number }, nodes: Array<{ __typename?: 'Item', id: string, sku: string, name: string, defaultPriceDollars: string, defaultWholesalePriceDollars: string, defaultCostDollars: string, listingManagementStrategyCount: number, currentQuantity: number, itemQtyLastModifiedDate: string, itemLastModifiedDate: string }> } };

export type BulkUpdateListedStoresModalQueryVariables = Exact<{
  itemId: Scalars['ID'];
}>;


export type BulkUpdateListedStoresModalQuery = { __typename?: 'Query', stores: { __typename?: 'StorePage', pageInfo: { __typename?: 'PageInfo', nextPage?: any | null, pages: Array<any>, previousPage?: any | null, totalRows: number }, nodes: Array<{ __typename?: 'Store', id: string, name: string, isInventoryManagementDisabled: boolean }> }, item?: { __typename?: 'Item', id: string, defaultPriceDollars: string, listings: { __typename?: 'ListingPage', pageInfo: { __typename?: 'PageInfo', nextPage?: any | null, pages: Array<any>, previousPage?: any | null, totalRows: number }, nodes: Array<{ __typename?: 'Listing', id: string, regularPriceDollars: string, store: { __typename?: 'Store', id: string } }> }, listingManagementStrategies: Array<{ __typename?: 'ListingManagementStrategy', id: string, priceDollars: string, store: { __typename?: 'Store', id: string } }> } | null };

export type SaveListingManagementStrategiesByItemMutationVariables = Exact<{
  input: SaveListingManagementStrategiesByItemInput;
}>;


export type SaveListingManagementStrategiesByItemMutation = { __typename?: 'Mutation', saveListingManagementStrategiesByItem?: { __typename?: 'Item', id: string, listings: { __typename?: 'ListingPage', pageInfo: { __typename?: 'PageInfo', nextPage?: any | null, pages: Array<any>, previousPage?: any | null, totalRows: number }, nodes: Array<{ __typename?: 'Listing', id: string, regularPriceDollars: string, urlToListing: string, store: { __typename?: 'Store', id: string, logoUrl: string, name: string } }> }, listingManagementStrategies: Array<{ __typename?: 'ListingManagementStrategy', id: string, isActive: boolean, priceDollars: string, store: { __typename?: 'Store', id: string } }> } | null };

export type DeleteListingManagementStrategyMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteListingManagementStrategyMutation = { __typename?: 'Mutation', deleteListingManagementStrategy?: { __typename?: 'Item', id: string, listingManagementStrategies: Array<{ __typename?: 'ListingManagementStrategy', id: string }> } | null };

export type InventoryActivity_ItemDetailDrawerQueryVariables = Exact<{
  itemId: Scalars['ID'];
}>;


export type InventoryActivity_ItemDetailDrawerQuery = { __typename?: 'Query', item?: { __typename?: 'Item', id: string, sku: string, name: string, description: string, weightValue: number, weightUnit: WeightUnit, defaultPriceDollars: string, defaultWholesalePriceDollars: string, defaultCostDollars: string, deviceType: string, listingManagementStrategies: Array<{ __typename?: 'ListingManagementStrategy', id: string, isActive: boolean, priceDollars: string, store: { __typename?: 'Store', id: string, name: string, isInventoryManagementDisabled: boolean } }>, itemBaselineQuantities: Array<{ __typename?: 'ItemBaselineQuantity', id: string, itemId: string, quantity: number, locationId?: string | null, locationName?: string | null }> } | null };

export type ToggleListingManagementStrategiesForItemMutationVariables = Exact<{
  input: ToggleListingManagementStrategiesForItemInput;
}>;


export type ToggleListingManagementStrategiesForItemMutation = { __typename?: 'Mutation', toggleListingManagementStrategiesForItem?: { __typename?: 'Item', id: string, listingManagementStrategies: Array<{ __typename?: 'ListingManagementStrategy', id: string, isActive: boolean }> } | null };

export type SaveItemPriceMutationVariables = Exact<{
  input: SaveItemInput;
}>;


export type SaveItemPriceMutation = { __typename?: 'Mutation', saveItem?: { __typename?: 'Item', id: string, defaultPriceDollars: string, defaultWholesalePriceDollars: string, listings: { __typename?: 'ListingPage', pageInfo: { __typename?: 'PageInfo', nextPage?: any | null, pages: Array<any>, previousPage?: any | null, totalRows: number }, nodes: Array<{ __typename?: 'Listing', id: string, regularPriceDollars: string, urlToListing: string, store: { __typename?: 'Store', id: string, logoUrl: string, name: string } }> }, listingManagementStrategies: Array<{ __typename?: 'ListingManagementStrategy', id: string, isActive: boolean, priceDollars: string, store: { __typename?: 'Store', id: string } }> } | null };

export type SaveListingManagementStrategyMutationVariables = Exact<{
  input: SaveListingManagementStrategyInput;
}>;


export type SaveListingManagementStrategyMutation = { __typename?: 'Mutation', saveListingManagementStrategy?: { __typename?: 'Item', id: string, listingManagementStrategies: Array<{ __typename?: 'ListingManagementStrategy', id: string, priceDollars: string }> } | null };

export type ListItemModalQueryVariables = Exact<{
  storeId: Scalars['ID'];
}>;


export type ListItemModalQuery = { __typename?: 'Query', items: { __typename?: 'ItemPage', pageInfo: { __typename?: 'PageInfo', nextPage?: any | null, pages: Array<any>, previousPage?: any | null, totalRows: number }, nodes: Array<{ __typename?: 'Item', id: string, sku: string, name: string, defaultPriceDollars: string }> } };

export type SaveListingManagementStrategiesByStoreMutationVariables = Exact<{
  input: SaveListingManagementStrategiesByStoreInput;
}>;


export type SaveListingManagementStrategiesByStoreMutation = { __typename?: 'Mutation', saveListingManagementStrategiesByStore: Array<{ __typename?: 'Item', id: string, sku: string, name: string, defaultPriceDollars: string, defaultWholesalePriceDollars: string, defaultCostDollars: string, listingManagementStrategyCount: number, currentQuantity: number, itemQtyLastModifiedDate: string, itemLastModifiedDate: string, listingManagementStrategies: Array<{ __typename?: 'ListingManagementStrategy', id: string, priceDollars: string, isActive: boolean }> }> };

export type InventoryActivity_TemplateTabQueryVariables = Exact<{ [key: string]: never; }>;


export type InventoryActivity_TemplateTabQuery = { __typename?: 'Query', listingManagementStrategyTemplateGroups: { __typename?: 'ListingManagementStrategyTemplateGroupsPage', pageInfo: { __typename?: 'PageInfo', nextPage?: any | null, pages: Array<any>, previousPage?: any | null, totalRows: number }, nodes: Array<{ __typename?: 'ListingManagementStrategyTemplateGroup', id: string, createdTimestamp: string, name: string, templateCount: number }> } };

export type SaveListingManagementStrategyTemplateGroupMutationVariables = Exact<{
  input: SaveListingManagementStrategyTemplateGroupInput;
}>;


export type SaveListingManagementStrategyTemplateGroupMutation = { __typename?: 'Mutation', saveListingManagementStrategyTemplateGroup?: { __typename?: 'ListingManagementStrategyTemplateGroup', id: string, createdTimestamp: string, name: string, templateCount: number, templates: { __typename?: 'ListingManagementStrategyTemplatePage', pageInfo: { __typename?: 'PageInfo', nextPage?: any | null, pages: Array<any>, previousPage?: any | null, totalRows: number }, nodes: Array<{ __typename?: 'ListingManagementStrategyTemplate', id: string, priceDollars: string, item: { __typename?: 'Item', id: string, sku: string, name: string } }> } } | null };

export type InventoryActivity_TemplateTab_TemplateGroupDrawerQueryVariables = Exact<{
  templateId: Scalars['ID'];
}>;


export type InventoryActivity_TemplateTab_TemplateGroupDrawerQuery = { __typename?: 'Query', listingManagementStrategyTemplateGroup?: { __typename?: 'ListingManagementStrategyTemplateGroup', id: string, name: string, templates: { __typename?: 'ListingManagementStrategyTemplatePage', pageInfo: { __typename?: 'PageInfo', nextPage?: any | null, pages: Array<any>, previousPage?: any | null, totalRows: number }, nodes: Array<{ __typename?: 'ListingManagementStrategyTemplate', id: string, priceDollars: string, item: { __typename?: 'Item', id: string, sku: string, name: string } }> } } | null };

export type PendingWritesTabQueryVariables = Exact<{
  filter?: InputMaybe<QueryEligibleOrdersNotInNetSuiteFilterInput>;
}>;


export type PendingWritesTabQuery = { __typename?: 'Query', eligibleOrdersNotInNetSuite: { __typename?: 'EligibleOrderPage', pageInfo: { __typename?: 'PageInfo', nextPage?: any | null, pages: Array<any>, previousPage?: any | null, totalRows: number }, nodes: Array<{ __typename?: 'EligibleOrder', id: string, order: { __typename?: 'Order', id: string, orderNumber: string, orderDate: string, store: { __typename?: 'Store', id: string } }, criteria: Array<{ __typename?: 'SatisfactionCriteria', status: SatisfactionCriteriaStatus, code: string, description: string }> }> } };

export type ExportNetSuiteXmlRequestsQueryVariables = Exact<{
  orderIds: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type ExportNetSuiteXmlRequestsQuery = { __typename?: 'Query', exportNetSuiteXmlRequests?: any | null };

export type NetSuiteActivity_SoapRequestTabQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Cursor']>;
  filter?: InputMaybe<QueryOrdersFilterInput>;
  sort?: InputMaybe<QueryOrdersSortInput>;
}>;


export type NetSuiteActivity_SoapRequestTabQuery = { __typename?: 'Query', orders: { __typename?: 'OrderPage', pageInfo: { __typename?: 'PageInfo', nextPage?: any | null, pages: Array<any>, previousPage?: any | null, totalRows: number }, nodes: Array<{ __typename?: 'Order', id: string, orderNumber: string, orderDate: string, customer: { __typename?: 'Customer', id: string, email: string }, store: { __typename?: 'Store', id: string, name: string, department?: { __typename?: 'NetSuiteDepartment', id: string, name: string } | null, inventoryLocation?: { __typename?: 'NetSuiteInventoryLocation', id: string, name: string } | null, subsidiary?: { __typename?: 'NetSuiteSubsidiary', id: string, name: string } | null, taxItem?: { __typename?: 'NetSuiteTaxItem', id: string, name: string } | null } }> } };

export type ArchiveValidationErrorsMutationVariables = Exact<{
  writeRequestId: Scalars['ID'];
}>;


export type ArchiveValidationErrorsMutation = { __typename?: 'Mutation', archiveWriteRequestValidationErrors?: boolean | null };

export type ClearValidationErrorsMutationVariables = Exact<{
  storeId?: InputMaybe<Scalars['ID']>;
  writeRequestId?: InputMaybe<Scalars['ID']>;
}>;


export type ClearValidationErrorsMutation = { __typename?: 'Mutation', clearInvalidWriteRequests?: boolean | null };

export type EditWriteRequestModalQueryVariables = Exact<{
  writeRequestId: Scalars['ID'];
}>;


export type EditWriteRequestModalQuery = { __typename?: 'Query', netSuiteWriteRequest?: { __typename?: 'NetSuiteWriteRequest', id: string, format: NetSuiteWriteRequestFormat, validationErrors: Array<string>, requestData: any } | null };

export type RegenerateWriteRequestMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type RegenerateWriteRequestMutation = { __typename?: 'Mutation', regenerateWriteRequest?: { __typename?: 'NetSuiteWriteRequest', id: string, requestData: any, validationErrors: Array<string>, customer?: { __typename?: 'Customer', id: string, email: string } | null, order?: { __typename?: 'Order', id: string, orderNumber: string } | null, record?: { __typename?: 'NetSuiteRecord', id: string } | null } | null };

export type SaveAndValidateWriteRequestMutationVariables = Exact<{
  input: SaveAndValidateWriteRequestInput;
}>;


export type SaveAndValidateWriteRequestMutation = { __typename?: 'Mutation', saveAndValidateWriteRequest?: { __typename?: 'NetSuiteWriteRequest', id: string, requestData: any, validationErrors: Array<string>, customer?: { __typename?: 'Customer', id: string, email: string } | null, order?: { __typename?: 'Order', id: string, orderNumber: string } | null, record?: { __typename?: 'NetSuiteRecord', id: string } | null } | null };

export type NetSuite_ValidationErrorsTabQueryVariables = Exact<{
  storeId?: InputMaybe<Scalars['ID']>;
}>;


export type NetSuite_ValidationErrorsTabQuery = { __typename?: 'Query', netSuiteWriteRequests: { __typename?: 'NetSuiteWriteRequestPage', pageInfo: { __typename?: 'PageInfo', nextPage?: any | null, pages: Array<any>, previousPage?: any | null, totalRows: number }, nodes: Array<{ __typename?: 'NetSuiteWriteRequest', id: string, format: NetSuiteWriteRequestFormat, requestData: any, validationErrors: Array<string>, customer?: { __typename?: 'Customer', id: string, email: string } | null, order?: { __typename?: 'Order', id: string, orderNumber: string } | null, record?: { __typename?: 'NetSuiteRecord', id: string } | null, returnAuthorization?: { __typename?: 'ReturnAuthorization', id: string, returnNumber: string } | null }> } };

export type OrderDetailActivityQueryVariables = Exact<{
  orderId: Scalars['ID'];
}>;


export type OrderDetailActivityQuery = { __typename?: 'Query', order?: { __typename?: 'Order', id: string, orderNumber: string, orderDate: string, customer: { __typename?: 'Customer', id: string, firstName: string, lastName: string, email: string }, status: { __typename?: 'OrderStatus', id: string, name: OrderStatusName, displayName: string }, paymentMethod: { __typename?: 'PaymentMethod', id: string, name: PaymentMethodName, displayName: string }, netSuitePaymentMethod?: { __typename?: 'NetSuitePaymentMethod', id: string, name: string } | null, smartPayLeaseApplication?: { __typename?: 'SmartPayLeaseApplication', id: string, applicationNumber: string, steps: Array<{ __typename?: 'LeaseApplicationStep', id: string, name: { __typename?: 'LeaseApplicationStepName', id: string, name: LeaseApplicationStepNameName, displayName: string }, status: { __typename?: 'LeaseApplicationStatus', id: string, name: LeaseApplicationStatusName, displayName: string } }> } | null, shipStationOrder?: { __typename?: 'ShipStationOrder', id: string, rawData: any } | null, shipStationShipment?: { __typename?: 'ShipStationShipment', id: string, rawData: any } | null, shipment?: { __typename?: 'Shipment', id: string, carrierCode: string, trackingNumber: string } | null, billingAddress: { __typename?: 'Address', street1: string, street2: string, city: string, usState: string, postalCode: string, company: string, phone: string }, shippingAddress: { __typename?: 'Address', street1: string, street2: string, city: string, usState: string, postalCode: string, company: string, phone: string }, e1Data?: { __typename?: 'E147FileData', headerRow: Array<{ __typename?: 'E1ColumnData', columnName: string, value: string }>, addressRow: Array<{ __typename?: 'E1ColumnData', columnName: string, value: string }>, detailRows: Array<Array<{ __typename?: 'E1ColumnData', columnName: string, value: string }>> } | null, lineItems: Array<{ __typename?: 'LineItem', id: string, itemTotalCents: string, taxTotalCents: string, quantity: number, product: { __typename?: 'Product', id: string, sku: string, name: string } }>, rawSourceOrder?: { __typename?: 'ExternalOrder', id: string, externalId: string, rawData: any } | null, e1DeviceLedger: Array<{ __typename?: 'DeviceLedgerInfo', sku: string, imei: string, iccid: string }> } | null };

export type OverrideLeaseApplicationMutationVariables = Exact<{
  input: OverrideLeaseApplicationInput;
}>;


export type OverrideLeaseApplicationMutation = { __typename?: 'Mutation', overrideLeaseApplication: string };

export type OverrideLeaseApplicationModalQueryVariables = Exact<{
  orderId: Scalars['ID'];
}>;


export type OverrideLeaseApplicationModalQuery = { __typename?: 'Query', order?: { __typename?: 'Order', id: string, lineItems: Array<{ __typename?: 'LineItem', id: string, itemTotalCents: string, taxTotalCents: string, product: { __typename?: 'Product', id: string, sku: string } }>, e1DeviceLedger: Array<{ __typename?: 'DeviceLedgerInfo', iccid: string, imei: string, sku: string }>, smartPayLeaseApplication?: { __typename?: 'SmartPayLeaseApplication', id: string, applicationNumber: string } | null } | null };

export type SmartPayLeaseApplicationSectionQueryVariables = Exact<{
  orderId: Scalars['ID'];
}>;


export type SmartPayLeaseApplicationSectionQuery = { __typename?: 'Query', order?: { __typename?: 'Order', id: string, smartPayLeaseApplication?: { __typename?: 'SmartPayLeaseApplication', id: string, applicationNumber: string, apiRequests: { __typename?: 'HttpRequestPage', nodes: Array<{ __typename?: 'HttpRequest', id: string, metaCreated: string, method: HttpRequestMethodName, httpStatusCode: number, url: string, requestBody: any, responseBody: any }> }, steps: Array<{ __typename?: 'LeaseApplicationStep', id: string, name: { __typename?: 'LeaseApplicationStepName', id: string, name: LeaseApplicationStepNameName, displayName: string }, status: { __typename?: 'LeaseApplicationStatus', id: string, name: LeaseApplicationStatusName, displayName: string } }> } | null } | null };

export type ExportOrdersQueryVariables = Exact<{
  options: QueryOrdersAsCsvOptionsInput;
}>;


export type ExportOrdersQuery = { __typename?: 'Query', ordersAsCsv: any };

export type MockFulfillOrderMutationVariables = Exact<{
  orderId: Scalars['ID'];
}>;


export type MockFulfillOrderMutation = { __typename?: 'Mutation', mockFulfillOrder?: { __typename?: 'Order', id: string } | null };

export type ReconciliationReportActivityQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Cursor']>;
  filter?: InputMaybe<QueryOrdersFilterInput>;
  sort?: InputMaybe<QueryOrdersSortInput>;
}>;


export type ReconciliationReportActivityQuery = { __typename?: 'Query', orders: { __typename?: 'OrderPage', pageInfo: { __typename?: 'PageInfo', nextPage?: any | null, pages: Array<any>, previousPage?: any | null, totalRows: number }, nodes: Array<{ __typename?: 'Order', id: string, orderNumber: string, metaCreated: string, cacheLastUpdatedTimestamp?: string | null, orderDate: string, totalCents: string, paymentMethod: { __typename?: 'PaymentMethod', id: string, name: PaymentMethodName, displayName: string }, rawSourceOrder?: { __typename?: 'ExternalOrder', id: string, externalId: string, url: string } | null, store: { __typename?: 'Store', id: string, metaData?: { __typename?: 'SftpStoreMetaData' } | { __typename?: 'ShopifyStoreMetaData', id: string, baseUrl: string } | { __typename?: 'Telgoo5StoreMetaData' } | { __typename?: 'WooCommerceStoreMetaData', id: string, baseUrl: string } | null }, status: { __typename?: 'OrderStatus', id: string, name: OrderStatusName, displayName: string }, lineItems: Array<{ __typename?: 'LineItem', id: string }>, shipStationOrder?: { __typename?: 'ShipStationOrder', id: string, rawData: any } | null, shipment?: { __typename?: 'Shipment', id: string } | null, e1Data?: { __typename?: 'E147FileData', detailRows: Array<Array<{ __typename?: 'E1ColumnData', columnName: string, value: string }>> } | null, e1Data42File?: { __typename?: 'E142FileData', detailRows: Array<Array<{ __typename?: 'E1ColumnData', columnName: string, value: string }>> } | null, smartPayLeaseApplication?: { __typename?: 'SmartPayLeaseApplication', id: string, applicationNumber: string, steps: Array<{ __typename?: 'LeaseApplicationStep', id: string, name: { __typename?: 'LeaseApplicationStepName', id: string, name: LeaseApplicationStepNameName, displayName: string }, status: { __typename?: 'LeaseApplicationStatus', id: string, name: LeaseApplicationStatusName, displayName: string } }> } | null, shipStationShipment?: { __typename?: 'ShipStationShipment', id: string, rawData: any } | null, e1DeviceLedger: Array<{ __typename?: 'DeviceLedgerInfo', sku: string }> }> } };

export type ReconciliationReportActivity_FiltersQueryVariables = Exact<{ [key: string]: never; }>;


export type ReconciliationReportActivity_FiltersQuery = { __typename?: 'Query', orderStatuses: Array<{ __typename?: 'OrderStatus', id: string, name: OrderStatusName, displayName: string }> };

export type WriteOrderToE1MutationVariables = Exact<{
  orderId: Scalars['ID'];
}>;


export type WriteOrderToE1Mutation = { __typename?: 'Mutation', writeOrderToE1: boolean };

export type ReturnAuthorizationDetailActivityQueryVariables = Exact<{
  returnAuthorizationId: Scalars['ID'];
}>;


export type ReturnAuthorizationDetailActivityQuery = { __typename?: 'Query', returnAuthorization?: { __typename?: 'ReturnAuthorization', id: string, store: { __typename?: 'Store', id: string, name: string }, order: { __typename?: 'Order', id: string }, customer: { __typename?: 'Customer', id: string, fullName: string, email: string, phoneNumber: string } } | null };

export type LookUpReturnAuthorizationQueryVariables = Exact<{
  searchText: Scalars['String'];
}>;


export type LookUpReturnAuthorizationQuery = { __typename?: 'Query', returnAuthorizations: { __typename?: 'ReturnAuthorizationPage', nodes: Array<{ __typename?: 'ReturnAuthorization', id: string, returnNumber: string, order: { __typename?: 'Order', id: string, orderNumber: string } }> } };

export type ReturnAuthorizationsActivity_ReturnAuthorizationTableQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Cursor']>;
  filter?: InputMaybe<QueryReturnAuthorizationsFilterInput>;
  sort?: InputMaybe<QueryReturnAuthorizationsSortInput>;
}>;


export type ReturnAuthorizationsActivity_ReturnAuthorizationTableQuery = { __typename?: 'Query', returnAuthorizations: { __typename?: 'ReturnAuthorizationPage', pageInfo: { __typename?: 'PageInfo', nextPage?: any | null, pages: Array<any>, previousPage?: any | null, totalRows: number }, nodes: Array<{ __typename?: 'ReturnAuthorization', id: string, returnDate: string, returnNumber: string, lineItems: Array<{ __typename?: 'ReturnAuthorizationLineItem', id: string, quantity: number }>, customer: { __typename?: 'Customer', id: string, firstName: string, lastName: string, phoneNumber: string, email: string, netSuiteWriteRequest?: { __typename?: 'NetSuiteWriteRequest', id: string, validationErrors: Array<string> } | null, netSuiteRecord?: { __typename?: 'NetSuiteRecord', id: string, createdAt: string, netSuiteInternalId: string, recordUrl: string, transactionId: string } | null }, store: { __typename?: 'Store', id: string, name: string }, shipment?: { __typename?: 'Shipment', id: string, labelUrl: string, shippedScanEvent?: { __typename?: 'ScanEvent', id: string } | null, deliveredScanEvent?: { __typename?: 'ScanEvent', id: string } | null } | null, order: { __typename?: 'Order', id: string, orderDate: string, orderNumber: string, totalCents: string, netSuiteWriteRequest?: { __typename?: 'NetSuiteWriteRequest', id: string, validationErrors: Array<string> } | null, netSuiteRecord?: { __typename?: 'NetSuiteRecord', id: string, createdAt: string, netSuiteInternalId: string, recordUrl: string, transactionId: string } | null, rawSourceOrder?: { __typename?: 'ExternalOrder', id: string, externalId: string, url: string } | null, itemFulfillment?: { __typename?: 'ItemFulfillment', id: string, lineItems: Array<{ __typename?: 'ItemFulfillmentLineItem', id: string, quantity: number }> } | null }, approval?: { __typename?: 'ReturnAuthorizationApproval', id: string, metaCreated: string, approvalType: { __typename?: 'ApprovalType', id: string, name: ApprovalTypeName, displayName: string } } | null, itemReceipt?: { __typename?: 'ItemReceipt', id: string, metaCreated: string, lineItems: Array<{ __typename?: 'ItemReceiptLineItem', id: string }> } | null, acceptance?: { __typename?: 'ReturnAuthorizationAcceptance', id: string, metaCreated: string, approvalType: { __typename?: 'ApprovalType', id: string, name: ApprovalTypeName, displayName: string } } | null, netSuiteWriteRequest?: { __typename?: 'NetSuiteWriteRequest', id: string, validationErrors: Array<string> } | null, netSuiteRecord?: { __typename?: 'NetSuiteRecord', id: string, createdAt: string, netSuiteInternalId: string, recordUrl: string, transactionId: string } | null }> } };

export type ReturnAuthorizationsActivity_TabBarQueryVariables = Exact<{
  storeId?: InputMaybe<Scalars['ID']>;
}>;


export type ReturnAuthorizationsActivity_TabBarQuery = { __typename?: 'Query', pendingApproval: { __typename?: 'ReturnAuthorizationPage', pageInfo: { __typename?: 'PageInfo', nextPage?: any | null, pages: Array<any>, previousPage?: any | null, totalRows: number } }, pendingShippingLabel: { __typename?: 'ReturnAuthorizationPage', pageInfo: { __typename?: 'PageInfo', nextPage?: any | null, pages: Array<any>, previousPage?: any | null, totalRows: number } }, pendingReceipt: { __typename?: 'ReturnAuthorizationPage', pageInfo: { __typename?: 'PageInfo', nextPage?: any | null, pages: Array<any>, previousPage?: any | null, totalRows: number } }, pendingAcceptance: { __typename?: 'ReturnAuthorizationPage', pageInfo: { __typename?: 'PageInfo', nextPage?: any | null, pages: Array<any>, previousPage?: any | null, totalRows: number } }, pendingRefund: { __typename?: 'ReturnAuthorizationPage', pageInfo: { __typename?: 'PageInfo', nextPage?: any | null, pages: Array<any>, previousPage?: any | null, totalRows: number } } };

export type ReturnAuthorizationsActivity_DeprecatedQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Cursor']>;
  filter?: InputMaybe<QueryReturnAuthorizationsFilterInput>;
  sort?: InputMaybe<QueryReturnAuthorizationsSortInput>;
}>;


export type ReturnAuthorizationsActivity_DeprecatedQuery = { __typename?: 'Query', returnAuthorizations: { __typename?: 'ReturnAuthorizationPage', pageInfo: { __typename?: 'PageInfo', nextPage?: any | null, pages: Array<any>, previousPage?: any | null, totalRows: number }, nodes: Array<{ __typename?: 'ReturnAuthorization', id: string, returnNumber: string, returnDate: string, customer: { __typename?: 'Customer', id: string, email: string }, store: { __typename?: 'Store', id: string }, order: { __typename?: 'Order', id: string }, shipment?: { __typename?: 'Shipment', id: string, labelUrl: string, trackingNumber: string, departureScanEvent?: { __typename?: 'ScanEvent', id: string, scannedAt: string } | null, deliveryScanEvent?: { __typename?: 'ScanEvent', id: string, scannedAt: string } | null } | null, approval?: { __typename?: 'ReturnAuthorizationApproval', id: string, approvalType: { __typename?: 'ApprovalType', id: string, name: ApprovalTypeName, displayName: string } } | null, acceptance?: { __typename?: 'ReturnAuthorizationAcceptance', id: string, approvalType: { __typename?: 'ApprovalType', id: string, name: ApprovalTypeName, displayName: string } } | null, itemReceipt?: { __typename?: 'ItemReceipt', id: string } | null, refund?: { __typename?: 'Refund', id: string, approvalType: { __typename?: 'ApprovalType', id: string, name: ApprovalTypeName, displayName: string } } | null, lineItems: Array<{ __typename?: 'ReturnAuthorizationLineItem', id: string, quantity: number, refundAmountCents: string, product: { __typename?: 'Product', id: string, sku: string, name: string } }> }> } };

export type AppleCareAgreementsWidgetQueryVariables = Exact<{ [key: string]: never; }>;


export type AppleCareAgreementsWidgetQuery = { __typename?: 'Query', appleCareAgreements: { __typename?: 'AppleCareAgreementPage', pageInfo: { __typename?: 'PageInfo', nextPage?: any | null, pages: Array<any>, previousPage?: any | null, totalRows: number }, nodes: Array<{ __typename?: 'AppleCareAgreement', id: string, agreementNumber: string, activatedAt?: string | null, serialNumber: string, lineItem: { __typename?: 'LineItem', id: string, order: { __typename?: 'Order', id: string, orderNumber: string, orderDate: string }, product: { __typename?: 'Product', id: string, name: string, sku: string } } }> } };

export type CurrentDevelopmentWorkWidgetQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Cursor']>;
  filter?: InputMaybe<QueryJiraTicketsFilterInput>;
  sort?: InputMaybe<QueryJiraTicketsSortInput>;
}>;


export type CurrentDevelopmentWorkWidgetQuery = { __typename?: 'Query', jiraTickets: { __typename?: 'JiraTicketPage', pageInfo: { __typename?: 'PageInfo', nextPage?: any | null, pages: Array<any>, previousPage?: any | null, totalRows: number }, nodes: Array<{ __typename?: 'JiraTicket', id: string, createdAt: string, key: string, title: string, status: JiraTicketStatus }> } };

export type OrderListWidgetQueryVariables = Exact<{
  salesChannel?: InputMaybe<SalesChannelName>;
}>;


export type OrderListWidgetQuery = { __typename?: 'Query', orders: { __typename?: 'OrderPage', pageInfo: { __typename?: 'PageInfo', nextPage?: any | null, pages: Array<any>, previousPage?: any | null, totalRows: number }, nodes: Array<{ __typename?: 'Order', id: string, orderNumber: string, orderDate: string }> } };

export type RecentReturnAuthorizationListWidgetQueryVariables = Exact<{ [key: string]: never; }>;


export type RecentReturnAuthorizationListWidgetQuery = { __typename?: 'Query', returnAuthorizations: { __typename?: 'ReturnAuthorizationPage', pageInfo: { __typename?: 'PageInfo', nextPage?: any | null, pages: Array<any>, previousPage?: any | null, totalRows: number }, nodes: Array<{ __typename?: 'ReturnAuthorization', id: string, returnDate: string, returnNumber: string, store: { __typename?: 'Store', id: string, name: string } }> } };

export type SkuSwapWidgetQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Cursor']>;
  filter?: InputMaybe<QueryOrdersFilterInput>;
  sort?: InputMaybe<QueryOrdersSortInput>;
}>;


export type SkuSwapWidgetQuery = { __typename?: 'Query', orders: { __typename?: 'OrderPage', pageInfo: { __typename?: 'PageInfo', nextPage?: any | null, pages: Array<any>, previousPage?: any | null, totalRows: number }, nodes: Array<{ __typename?: 'Order', id: string, orderNumber: string, orderDate: string }> } };

export type SaveStoreMutationVariables = Exact<{
  input: SaveStoreInput;
}>;


export type SaveStoreMutation = { __typename?: 'Mutation', saveStore?: { __typename?: 'Store', id: string, name: string, orderPrefix: string, partner: { __typename?: 'Partner', id: string }, metaData?: { __typename?: 'SftpStoreMetaData', id: string, baseUrl: string, username: string, password: string, orderFileDirectory: string, ackFileDirectory: string, shipFileDirectory: string } | { __typename?: 'ShopifyStoreMetaData', id: string, baseUrl: string, adminToken: string } | { __typename?: 'Telgoo5StoreMetaData' } | { __typename?: 'WooCommerceStoreMetaData', id: string, baseUrl: string, consumerKey: string, consumerSecret: string } | null } | null };

export type StoreListWidgetQueryVariables = Exact<{ [key: string]: never; }>;


export type StoreListWidgetQuery = { __typename?: 'Query', stores: { __typename?: 'StorePage', pageInfo: { __typename?: 'PageInfo', nextPage?: any | null, pages: Array<any>, previousPage?: any | null, totalRows: number }, nodes: Array<{ __typename?: 'Store', id: string, orderPrefix: string, name: string, logoUrl: string, primaryColorHex: string, secondaryColorHex: string, buttonColorHex: string, type: { __typename?: 'StoreType', id: string, name: StoreTypeName, displayName: string }, metaData?: { __typename?: 'SftpStoreMetaData', id: string, baseUrl: string, orderFileDirectory: string, ackFileDirectory: string, shipFileDirectory: string } | { __typename?: 'ShopifyStoreMetaData', id: string, baseUrl: string } | { __typename?: 'Telgoo5StoreMetaData', id: string, apiUrl: string } | { __typename?: 'WooCommerceStoreMetaData', id: string, baseUrl: string } | null }> } };

export type TestStoreConnectionQueryVariables = Exact<{
  storeId: Scalars['ID'];
}>;


export type TestStoreConnectionQuery = { __typename?: 'Query', testStoreConnection: boolean };

export type EditCachedOrderModalQueryVariables = Exact<{
  externalOrderId: Scalars['ID'];
}>;


export type EditCachedOrderModalQuery = { __typename?: 'Query', cachedOrder?: { __typename?: 'ExternalOrder', id: string, metaCreated: string, rawData: any, validationErrors: Array<string>, store: { __typename?: 'Store', id: string, salesOrderValidator: any, type: { __typename?: 'StoreType', id: string, name: StoreTypeName, displayName: string } } } | null };

export type SalesOrdersActivity_NewOrderTableQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Cursor']>;
  filter?: InputMaybe<QueryCachedOrdersFilterInput>;
  sort?: InputMaybe<QueryCachedOrdersSortInput>;
}>;


export type SalesOrdersActivity_NewOrderTableQuery = { __typename?: 'Query', cachedOrders: { __typename?: 'ExternalOrdersPage', pageInfo: { __typename?: 'PageInfo', nextPage?: any | null, pages: Array<any>, previousPage?: any | null, totalRows: number }, nodes: Array<{ __typename?: 'ExternalOrder', id: string, metaCreated: string, rawOrderNumber: string, validationErrors: Array<string>, store: { __typename?: 'Store', id: string, name: string } }> } };

export type ReviewCachedOrdersMutationVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type ReviewCachedOrdersMutation = { __typename?: 'Mutation', reviewCachedOrders: boolean };

export type SalesOrdersActivity_TabBarQueryVariables = Exact<{
  salesChannelName: SalesChannelName;
  storeId?: InputMaybe<Scalars['ID']>;
  searchText?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['Timestamp']>;
}>;


export type SalesOrdersActivity_TabBarQuery = { __typename?: 'Query', newOrders: number, awaitingPayment: number, awaitingApproval: number, awaitingFulfillment: number, inTransit: number };

export type SalesOrderActivity_TableQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Cursor']>;
  filter?: InputMaybe<QueryOrdersFilterInput>;
  sort?: InputMaybe<QueryOrdersSortInput>;
}>;


export type SalesOrderActivity_TableQuery = { __typename?: 'Query', orders: { __typename?: 'OrderPage', pageInfo: { __typename?: 'PageInfo', nextPage?: any | null, pages: Array<any>, previousPage?: any | null, totalRows: number }, nodes: Array<{ __typename?: 'Order', id: string, orderNumber: string, orderDate: string, totalCents: string, customer: { __typename?: 'Customer', id: string, email: string, netSuiteRecord?: { __typename?: 'NetSuiteRecord', id: string, createdAt: string, netSuiteInternalId: string, recordUrl: string, transactionId: string } | null, netSuiteWriteRequest?: { __typename?: 'NetSuiteWriteRequest', id: string, validationErrors: Array<string> } | null }, e1DocumentIndex?: { __typename?: 'E1DocumentIndex', id: string, urlToE1Record: string } | null, netSuiteRecord?: { __typename?: 'NetSuiteRecord', id: string, createdAt: string, netSuiteInternalId: string, recordUrl: string, transactionId: string } | null, netSuiteWriteRequest?: { __typename?: 'NetSuiteWriteRequest', id: string, validationErrors: Array<string> } | null, netSuitePaymentMethod?: { __typename?: 'NetSuitePaymentMethod', id: string, name: string } | null, shipment?: { __typename?: 'Shipment', id: string, trackingNumber: string, trackingUrl: string } | null, store: { __typename?: 'Store', id: string, name: string }, lineItems: Array<{ __typename?: 'LineItem', id: string, quantity: number }>, itemFulfillment?: { __typename?: 'ItemFulfillment', id: string, netSuiteRecord?: { __typename?: 'NetSuiteRecord', id: string, createdAt: string, netSuiteInternalId: string, recordUrl: string, transactionId: string } | null } | null, paymentMethod: { __typename?: 'PaymentMethod', id: string, name: PaymentMethodName, displayName: string } }> } };

export type AdminStoreSettingsActivityQueryVariables = Exact<{
  storeId: Scalars['ID'];
}>;


export type AdminStoreSettingsActivityQuery = { __typename?: 'Query', store?: { __typename?: 'Store', id: string, type: { __typename?: 'StoreType', name: StoreTypeName } } | null };

export type ArchiveStoreMutationVariables = Exact<{
  storeId: Scalars['ID'];
}>;


export type ArchiveStoreMutation = { __typename?: 'Mutation', archiveStore?: boolean | null };

export type DeleteThirdPartyAccountMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteThirdPartyAccountMutation = { __typename?: 'Mutation', deleteThirdPartyAccount: boolean };

export type SaveThirdPartyAccountMutationVariables = Exact<{
  input: SaveThirdPartyAccountInput;
}>;


export type SaveThirdPartyAccountMutation = { __typename?: 'Mutation', saveThirdPartyAccount?: { __typename?: 'ThirdPartyAccount', id: string, name: string, accountNumber: string, address: { __typename?: 'Address', street1: string, street2: string, city: string, usState: string, postalCode: string } } | null };

export type SaveThirdPartyAccountModalQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type SaveThirdPartyAccountModalQuery = { __typename?: 'Query', thirdPartyAccount?: { __typename?: 'ThirdPartyAccount', id: string, name: string, accountNumber: string, carrierType: string, attention: string, addressee: string, address: { __typename?: 'Address', phone: string, street1: string, street2: string, street3: string, city: string, usState: string, postalCode: string, countryCode: string } } | null };

export type ThirdPartyAccountActivityQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Cursor']>;
  filter?: InputMaybe<QueryThirdPartyAccountsFilterInput>;
  sort?: InputMaybe<QueryThirdPartyAccountsSortInput>;
}>;


export type ThirdPartyAccountActivityQuery = { __typename?: 'Query', thirdPartyAccounts: { __typename?: 'ThirdPartyAccountPage', pageInfo: { __typename?: 'PageInfo', nextPage?: any | null, pages: Array<any>, previousPage?: any | null, totalRows: number }, nodes: Array<{ __typename?: 'ThirdPartyAccount', id: string, name: string, accountNumber: string, carrierType: string, addressee: string, attention: string, address: { __typename?: 'Address', street1: string, street2: string, city: string, usState: string, postalCode: string } }> } };

export type ThirdPartyLogisticsActivityQueryVariables = Exact<{
  storeTypes: Array<StoreTypeName> | StoreTypeName;
}>;


export type ThirdPartyLogisticsActivityQuery = { __typename?: 'Query', stores: { __typename?: 'StorePage', pageInfo: { __typename?: 'PageInfo', nextPage?: any | null, pages: Array<any>, previousPage?: any | null, totalRows: number }, nodes: Array<{ __typename?: 'Store', id: string, orderPrefix: string, name: string }> } };

export type Tier1ReturnAuthorizationDetailActivity_ActionBarQueryVariables = Exact<{
  returnAuthorizationId: Scalars['ID'];
}>;


export type Tier1ReturnAuthorizationDetailActivity_ActionBarQuery = { __typename?: 'Query', tier1ReturnAuthorization?: { __typename?: 'Tier1ReturnAuthorization', id: string, expectedSerialNumber: string, group: { __typename?: 'Tier1ReturnAuthorizationGroup', id: string, referenceNumber: string, store: { __typename?: 'Store', id: string, triageWorkflows: Array<{ __typename?: 'TriageWorkflow', id: string, isEnabled: boolean, type: { __typename?: 'TriageWorkflowType', id: string, name: TriageWorkflowTypeName, displayName: string } }> } }, netSuiteRecord?: { __typename?: 'NetSuiteRecord', id: string, createdAt: string, netSuiteInternalId: string, recordUrl: string, transactionId: string } | null, itemReceipt?: { __typename?: 'Tier1ItemReceipt', id: string, serialNumber: string } | null, observation?: { __typename?: 'TriageObservation', id: string } | null, selectedTriage?: { __typename?: 'ReturnAuthorizationTriage', id: string, workflow: { __typename?: 'TriageWorkflow', id: string, type: { __typename?: 'TriageWorkflowType', id: string, name: TriageWorkflowTypeName, displayName: string } } } | null, qualityControlCheck?: { __typename?: 'QualityControlCheck', id: string } | null, carton?: { __typename?: 'Carton', id: string } | null } | null };

export type DeviceInformationWidgetQueryVariables = Exact<{
  returnAuthorizationId: Scalars['ID'];
}>;


export type DeviceInformationWidgetQuery = { __typename?: 'Query', tier1ReturnAuthorization?: { __typename?: 'Tier1ReturnAuthorization', id: string, expectedSerialNumber: string, item: { __typename?: 'Item', id: string, name: string, sku: string }, itemReceipt?: { __typename?: 'Tier1ItemReceipt', id: string, serialNumber: string, item: { __typename?: 'Item', id: string, sku: string, name: string } } | null, qualityControlCheck?: { __typename?: 'QualityControlCheck', id: string, softwareVersion: { __typename?: 'SoftwareVersion', id: string, name: string } } | null } | null };

export type ObservedFailureWidgetQueryVariables = Exact<{
  returnAuthorizationId: Scalars['ID'];
}>;


export type ObservedFailureWidgetQuery = { __typename?: 'Query', tier1ReturnAuthorization?: { __typename?: 'Tier1ReturnAuthorization', id: string, observation?: { __typename?: 'TriageObservation', id: string, createdTimestamp: string, reasonText: string, createdBy: { __typename?: 'SiteUserFull', id: string, email: string, fullName: string } } | null } | null };

export type RmaSourceInformationWidgetQueryVariables = Exact<{
  returnAuthorizationId: Scalars['ID'];
}>;


export type RmaSourceInformationWidgetQuery = { __typename?: 'Query', tier1ReturnAuthorization?: { __typename?: 'Tier1ReturnAuthorization', id: string, createdTimestamp: string, inboundTrackingNumber: string, returnNumber: string, netSuiteRecord?: { __typename?: 'NetSuiteRecord', id: string, createdAt: string, netSuiteInternalId: string, recordUrl: string, transactionId: string } | null, netSuiteWriteRequest?: { __typename?: 'NetSuiteWriteRequest', id: string, validationErrors: Array<string> } | null, group: { __typename?: 'Tier1ReturnAuthorizationGroup', id: string, referenceNumber: string, store: { __typename?: 'Store', id: string, name: string } }, itemReceipt?: { __typename?: 'Tier1ItemReceipt', id: string, createdTimestamp: string } | null } | null };

export type ReportedDeviceIssueWidgetQueryVariables = Exact<{
  returnAuthorizationId: Scalars['ID'];
}>;


export type ReportedDeviceIssueWidgetQuery = { __typename?: 'Query', tier1ReturnAuthorization?: { __typename?: 'Tier1ReturnAuthorization', id: string, problemStatements: Array<string>, customerComment: string } | null };

export type Tier1ReturnAuthorizationLifeCycleWidgetQueryVariables = Exact<{
  returnAuthorizationId: Scalars['ID'];
}>;


export type Tier1ReturnAuthorizationLifeCycleWidgetQuery = { __typename?: 'Query', tier1ReturnAuthorization?: { __typename?: 'Tier1ReturnAuthorization', id: string, createdTimestamp: string, itemReceipt?: { __typename?: 'Tier1ItemReceipt', id: string, serialNumber: string, createdTimestamp: string } | null, observation?: { __typename?: 'TriageObservation', id: string, createdTimestamp: string } | null, selectedTriage?: { __typename?: 'ReturnAuthorizationTriage', id: string, createdTimestamp: string, replacementSerialNumber: string, workflow: { __typename?: 'TriageWorkflow', id: string, type: { __typename?: 'TriageWorkflowType', id: string, name: TriageWorkflowTypeName, displayName: string } } } | null, qualityControlCheck?: { __typename?: 'QualityControlCheck', id: string, createdTimestamp: string } | null, carton?: { __typename?: 'Carton', id: string, createdTimestamp: string } | null, group: { __typename?: 'Tier1ReturnAuthorizationGroup', id: string, referenceNumber: string, store: { __typename?: 'Store', id: string, name: string } } } | null };

export type TriageDecisionWidgetQueryVariables = Exact<{
  returnAuthorizationId: Scalars['ID'];
}>;


export type TriageDecisionWidgetQuery = { __typename?: 'Query', tier1ReturnAuthorization?: { __typename?: 'Tier1ReturnAuthorization', id: string, selectedTriage?: { __typename?: 'ReturnAuthorizationTriage', id: string, createdTimestamp: string, repairCode: string, replacementSerialNumber: string, technicianComment: string, createdBy: { __typename?: 'SiteUserFull', id: string, fullName: string }, workflow: { __typename?: 'TriageWorkflow', id: string, type: { __typename?: 'TriageWorkflowType', id: string, name: TriageWorkflowTypeName, displayName: string } } } | null } | null };

export type LookUpTier1ReturnAuthorizationModalQueryVariables = Exact<{
  searchText: Scalars['String'];
}>;


export type LookUpTier1ReturnAuthorizationModalQuery = { __typename?: 'Query', tier1ReturnAuthorizations: { __typename?: 'Tier1ReturnAuthorizationPage', pageInfo: { __typename?: 'PageInfo', nextPage?: any | null, pages: Array<any>, previousPage?: any | null, totalRows: number }, nodes: Array<{ __typename?: 'Tier1ReturnAuthorization', id: string, item: { __typename?: 'Item', id: string, name: string }, group: { __typename?: 'Tier1ReturnAuthorizationGroup', id: string, referenceNumber: string, store: { __typename?: 'Store', id: string, name: string }, returnAuthorizations: { __typename?: 'Tier1ReturnAuthorizationPage', pageInfo: { __typename?: 'PageInfo', nextPage?: any | null, pages: Array<any>, previousPage?: any | null, totalRows: number }, nodes: Array<{ __typename?: 'Tier1ReturnAuthorization', id: string, expectedSerialNumber: string, itemReceipt?: { __typename?: 'Tier1ItemReceipt', id: string } | null, item: { __typename?: 'Item', id: string, sku: string, name: string } }> } } }> } };

export type GenerateShippingLabelForTier1ReturnAuthorizationsMutationVariables = Exact<{
  input: GenerateShippingLabelForTier1ReturnAuthorizationsInput;
}>;


export type GenerateShippingLabelForTier1ReturnAuthorizationsMutation = { __typename?: 'Mutation', generateShippingLabelForTier1ReturnAuthorizations?: { __typename?: 'Carton', id: string, shipment?: { __typename?: 'Shipment', id: string, labelUrl: string } | null } | null };

export type PrintLabelModalQueryVariables = Exact<{
  returnAuthorizationGroupId: Scalars['ID'];
}>;


export type PrintLabelModalQuery = { __typename?: 'Query', tier1ReturnAuthorizationGroup?: { __typename?: 'Tier1ReturnAuthorizationGroup', id: string, referenceNumber: string, returnAuthorizations: { __typename?: 'Tier1ReturnAuthorizationPage', pageInfo: { __typename?: 'PageInfo', nextPage?: any | null, pages: Array<any>, previousPage?: any | null, totalRows: number }, nodes: Array<{ __typename?: 'Tier1ReturnAuthorization', id: string, createdTimestamp: string, returnNumber: string, netSuiteRecord?: { __typename?: 'NetSuiteRecord', id: string, transactionId: string } | null, itemReceipt?: { __typename?: 'Tier1ItemReceipt', id: string, serialNumber: string, item: { __typename?: 'Item', id: string, sku: string, name: string, weightValue: number, weightUnit: WeightUnit } } | null }> } } | null };

export type PrintLabelTableQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Cursor']>;
  filter?: InputMaybe<QueryTier1ReturnAuthorizationGroupsFilterInput>;
}>;


export type PrintLabelTableQuery = { __typename?: 'Query', tier1ReturnAuthorizationGroups: { __typename?: 'Tier1ReturnAuthorizationGroupPage', pageInfo: { __typename?: 'PageInfo', nextPage?: any | null, pages: Array<any>, previousPage?: any | null, totalRows: number }, nodes: Array<{ __typename?: 'Tier1ReturnAuthorizationGroup', id: string, createdTimestamp: string, referenceNumber: string, totalReturnCount: number, readyForLabel: { __typename?: 'Tier1ReturnAuthorizationPage', pageInfo: { __typename?: 'PageInfo', nextPage?: any | null, pages: Array<any>, previousPage?: any | null, totalRows: number }, nodes: Array<{ __typename?: 'Tier1ReturnAuthorization', id: string, createdTimestamp: string }> } }> } };

export type LookUpTier1ReturnAuthorizationByDetailsQueryVariables = Exact<{
  storeId: Scalars['ID'];
  itemId: Scalars['ID'];
  inState: Tier1ReturnAuthorizationState;
}>;


export type LookUpTier1ReturnAuthorizationByDetailsQuery = { __typename?: 'Query', tier1ReturnAuthorizations: { __typename?: 'Tier1ReturnAuthorizationPage', pageInfo: { __typename?: 'PageInfo', nextPage?: any | null, pages: Array<any>, previousPage?: any | null, totalRows: number }, nodes: Array<{ __typename?: 'Tier1ReturnAuthorization', id: string, createdTimestamp: string, group: { __typename?: 'Tier1ReturnAuthorizationGroup', id: string, referenceNumber: string }, item: { __typename?: 'Item', id: string, sku: string, name: string } }> } };

export type ReturnAuthorizationGroupTableQueryVariables = Exact<{
  filter?: InputMaybe<QueryTier1ReturnAuthorizationsFilterInput>;
}>;


export type ReturnAuthorizationGroupTableQuery = { __typename?: 'Query', tier1ReturnAuthorizations: { __typename?: 'Tier1ReturnAuthorizationPage', pageInfo: { __typename?: 'PageInfo', nextPage?: any | null, pages: Array<any>, previousPage?: any | null, totalRows: number }, nodes: Array<{ __typename?: 'Tier1ReturnAuthorization', id: string, expectedSerialNumber: string, netSuiteRecord?: { __typename?: 'NetSuiteRecord', id: string, createdAt: string, netSuiteInternalId: string, recordUrl: string, transactionId: string } | null, netSuiteWriteRequest?: { __typename?: 'NetSuiteWriteRequest', id: string, validationErrors: Array<string> } | null, item: { __typename?: 'Item', id: string, name: string, sku: string }, group: { __typename?: 'Tier1ReturnAuthorizationGroup', id: string, createdTimestamp: string, referenceNumber: string, totalReturnCount: number, store: { __typename?: 'Store', id: string, name: string } } }> } };

export type Tier1ReturnAuthorizationsActivity_TabBarQueryVariables = Exact<{
  storeId?: InputMaybe<Scalars['ID']>;
  searchText: Scalars['String'];
}>;


export type Tier1ReturnAuthorizationsActivity_TabBarQuery = { __typename?: 'Query', preAlert: { __typename?: 'Tier1ReturnAuthorizationPage', pageInfo: { __typename?: 'PageInfo', nextPage?: any | null, pages: Array<any>, previousPage?: any | null, totalRows: number } }, awaitingTriageObservation: { __typename?: 'Tier1ReturnAuthorizationPage', pageInfo: { __typename?: 'PageInfo', nextPage?: any | null, pages: Array<any>, previousPage?: any | null, totalRows: number } }, awaitingTriage: { __typename?: 'Tier1ReturnAuthorizationPage', pageInfo: { __typename?: 'PageInfo', nextPage?: any | null, pages: Array<any>, previousPage?: any | null, totalRows: number } }, awaitingQualityControl: { __typename?: 'Tier1ReturnAuthorizationPage', pageInfo: { __typename?: 'PageInfo', nextPage?: any | null, pages: Array<any>, previousPage?: any | null, totalRows: number } }, readyForLabel: { __typename?: 'Tier1ReturnAuthorizationPage', pageInfo: { __typename?: 'PageInfo', nextPage?: any | null, pages: Array<any>, previousPage?: any | null, totalRows: number } } };

export type Tier1ReturnAuthorizationsActivity_TableQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Cursor']>;
  filter?: InputMaybe<QueryTier1ReturnAuthorizationsFilterInput>;
  sort?: InputMaybe<QueryTier1ReturnAuthorizationsSortInput>;
}>;


export type Tier1ReturnAuthorizationsActivity_TableQuery = { __typename?: 'Query', tier1ReturnAuthorizations: { __typename?: 'Tier1ReturnAuthorizationPage', pageInfo: { __typename?: 'PageInfo', nextPage?: any | null, pages: Array<any>, previousPage?: any | null, totalRows: number }, nodes: Array<{ __typename?: 'Tier1ReturnAuthorization', id: string, createdTimestamp: string, returnNumber: string, expectedSerialNumber: string, observation?: { __typename?: 'TriageObservation', id: string, reasonText: string } | null, item: { __typename?: 'Item', id: string, name: string, sku: string }, itemReceipt?: { __typename?: 'Tier1ItemReceipt', id: string, createdTimestamp: string, netSuiteWriteRequest?: { __typename?: 'NetSuiteWriteRequest', id: string, validationErrors: Array<string> } | null, netSuiteRecord?: { __typename?: 'NetSuiteRecord', id: string, createdAt: string, netSuiteInternalId: string, recordUrl: string, transactionId: string } | null } | null, carton?: { __typename?: 'Carton', id: string, shipment?: { __typename?: 'Shipment', id: string, labelUrl: string } | null } | null, netSuiteWriteRequest?: { __typename?: 'NetSuiteWriteRequest', id: string, validationErrors: Array<string> } | null, netSuiteRecord?: { __typename?: 'NetSuiteRecord', id: string, createdAt: string, netSuiteInternalId: string, recordUrl: string, transactionId: string } | null, group: { __typename?: 'Tier1ReturnAuthorizationGroup', id: string, referenceNumber: string, store: { __typename?: 'Store', id: string, name: string } } }> } };

export type OverrideCachedOrderMutationVariables = Exact<{
  input: OverrideCachedOrderInput;
}>;


export type OverrideCachedOrderMutation = { __typename?: 'Mutation', overrideCachedOrder: boolean };

export type ValidateCachedOrderQueryVariables = Exact<{
  input: OverrideCachedOrderInput;
}>;


export type ValidateCachedOrderQuery = { __typename?: 'Query', validateCachedOrder: Array<string> };

export type ValidateOrderActivityQueryVariables = Exact<{
  externalOrderId: Scalars['ID'];
}>;


export type ValidateOrderActivityQuery = { __typename?: 'Query', cachedOrder?: { __typename?: 'ExternalOrder', id: string, metaCreated: string, rawData: any, validationErrors: Array<string>, store: { __typename?: 'Store', id: string, salesOrderValidator: any, type: { __typename?: 'StoreType', id: string, name: StoreTypeName, displayName: string } } } | null };

export type RegisterActivityQueryVariables = Exact<{
  code: Scalars['String'];
}>;


export type RegisterActivityQuery = { __typename?: 'Query', invite?: { __typename?: 'Invite', id: string, isClaimed: boolean } | null };

export type RootActivityQueryVariables = Exact<{ [key: string]: never; }>;


export type RootActivityQuery = { __typename?: 'Query', loggedInUser?: { __typename?: 'SiteUserFull', id: string, isSuperAdmin: boolean, permissions: Array<{ __typename?: 'Permission', id: string, name: PermissionName }> } | null, stores: { __typename?: 'StorePage', pageInfo: { __typename?: 'PageInfo', nextPage?: any | null, pages: Array<any>, previousPage?: any | null, totalRows: number }, nodes: Array<{ __typename?: 'Store', id: string, name: string }> } };

export type CustomerChatWidgetQueryVariables = Exact<{
  id: Scalars['ID'];
  queryOrder: Scalars['Boolean'];
}>;


export type CustomerChatWidgetQuery = { __typename?: 'Query', returnAuthorizationLite?: { __typename?: 'ReturnAuthorizationLite', id: string, messages: { __typename?: 'ChatMessagePage', nodes: Array<{ __typename?: 'ChatMessage', id: string, metaCreated: string, content: string, senderName: string }> } } | null, orderLite?: { __typename?: 'OrderLite', id: string, messages: { __typename?: 'ChatMessagePage', nodes: Array<{ __typename?: 'ChatMessage', id: string, metaCreated: string, content: string, senderName: string }> } } | null };

export type CustomerOrderActionsWidgetQueryVariables = Exact<{
  orderId: Scalars['ID'];
}>;


export type CustomerOrderActionsWidgetQuery = { __typename?: 'Query', canInitiateReturnAuthorization: boolean, canCloseOrder: boolean, orderLite?: { __typename?: 'OrderLite', id: string, overallOrderStatus: { __typename?: 'OverallOrderStatus', id: string, name: OverallOrderStatusName, displayName: string }, returnAuthorizations: Array<{ __typename?: 'ReturnAuthorizationLite', id: string }> } | null };

export type LineItemsWidgetQueryVariables = Exact<{
  orderId: Scalars['ID'];
}>;


export type LineItemsWidgetQuery = { __typename?: 'Query', orderLite?: { __typename?: 'OrderLite', id: string, lineItems: Array<{ __typename?: 'LineItemLite', id: string, productName: string, sku: string, quantity: number, itemTotalCents: string, taxTotalCents: string, feeTotalCents: string, refundAmountCents: string }> } | null };

export type SummaryInformationWidgetQueryVariables = Exact<{
  orderId: Scalars['ID'];
}>;


export type SummaryInformationWidgetQuery = { __typename?: 'Query', orderLite?: { __typename?: 'OrderLite', id: string, orderNumber: string, orderDate: string, overallOrderStatus: { __typename?: 'OverallOrderStatus', id: string, name: OverallOrderStatusName, displayName: string } } | null };

export type LookupOrderQueryVariables = Exact<{
  email: Scalars['String'];
  orderNumber: Scalars['String'];
}>;


export type LookupOrderQuery = { __typename?: 'Query', orderLite?: { __typename?: 'OrderLite', id: string, orderNumber: string, orderDate: string, customerEmail: string, customerFullName: string, lineItems: Array<{ __typename?: 'LineItemLite', id: string, productName: string, quantity: number, sku: string }> } | null };

export type OrderLookupActivityQueryVariables = Exact<{
  storeId: Scalars['ID'];
}>;


export type OrderLookupActivityQuery = { __typename?: 'Query', storeBrand?: { __typename?: 'StoreBrand', id: string, logoUrl: string } | null };

export type StoreReferralActivityQueryVariables = Exact<{
  email: Scalars['String'];
  orderNumber: Scalars['String'];
}>;


export type StoreReferralActivityQuery = { __typename?: 'Query', orderLite?: { __typename?: 'OrderLite', id: string } | null };

export type ExportReportQueryVariables = Exact<{
  reportId: Scalars['ID'];
  storeId: Scalars['ID'];
}>;


export type ExportReportQuery = { __typename?: 'Query', exportReport?: any | null };

export type StoreDetailActivity_OrderListPaneQueryVariables = Exact<{
  storeId: Scalars['ID'];
  omniFreeText: Scalars['String'];
}>;


export type StoreDetailActivity_OrderListPaneQuery = { __typename?: 'Query', orders: { __typename?: 'OrderPage', pageInfo: { __typename?: 'PageInfo', nextPage?: any | null, pages: Array<any>, previousPage?: any | null, totalRows: number }, nodes: Array<{ __typename?: 'Order', id: string, orderNumber: string, orderDate: string, customer: { __typename?: 'Customer', id: string, firstName: string, lastName: string, email: string } }> } };

export type StoreDetailActivityQueryVariables = Exact<{ [key: string]: never; }>;


export type StoreDetailActivityQuery = { __typename?: 'Query', loggedInUser?: { __typename?: 'SiteUserFull', id: string, isSuperAdmin: boolean, permissions: Array<{ __typename?: 'Permission', id: string, name: PermissionName }> } | null, databaseReports: Array<{ __typename?: 'DatabaseReport', id: string, name: string }> };

export type StoreListActivityQueryVariables = Exact<{ [key: string]: never; }>;


export type StoreListActivityQuery = { __typename?: 'Query', loggedInUser?: { __typename?: 'SiteUserFull', id: string, isSuperAdmin: boolean, permissions: Array<{ __typename?: 'Permission', id: string, name: PermissionName }> } | null, stores: { __typename?: 'StorePage', pageInfo: { __typename?: 'PageInfo', nextPage?: any | null, pages: Array<any>, previousPage?: any | null, totalRows: number }, nodes: Array<{ __typename?: 'Store', id: string, name: string, logoUrl: string }> } };

export type StoreSettingsActivity_UsersTabQueryVariables = Exact<{
  storeId: Scalars['ID'];
}>;


export type StoreSettingsActivity_UsersTabQuery = { __typename?: 'Query', store?: { __typename?: 'Store', id: string, invites: { __typename?: 'InvitePage', pageInfo: { __typename?: 'PageInfo', nextPage?: any | null, pages: Array<any>, previousPage?: any | null, totalRows: number }, nodes: Array<{ __typename?: 'Invite', id: string, isClaimed: boolean, sentTimestamp?: string | null, recipientEmail: string, claimant?: { __typename?: 'SiteUserFull', id: string, fullName: string } | null }> }, users: { __typename?: 'SiteUserFullPage', pageInfo: { __typename?: 'PageInfo', nextPage?: any | null, pages: Array<any>, previousPage?: any | null, totalRows: number }, nodes: Array<{ __typename?: 'SiteUserFull', id: string, fullName: string, email: string, status: { __typename?: 'UserStatus', id: string, name: UserStatusName, displayName: string } }> } } | null };

export type TransactionListActivity_OrderListTabQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Cursor']>;
  filter?: InputMaybe<QueryOrdersFilterInput>;
  sort?: InputMaybe<QueryOrdersSortInput>;
}>;


export type TransactionListActivity_OrderListTabQuery = { __typename?: 'Query', orders: { __typename?: 'OrderPage', pageInfo: { __typename?: 'PageInfo', nextPage?: any | null, pages: Array<any>, previousPage?: any | null, totalRows: number }, nodes: Array<{ __typename?: 'Order', id: string, orderDate: string, orderNumber: string, totalCents: string, requestedShippingService: string, overallOrderStatus: { __typename?: 'OverallOrderStatus', id: string, name: OverallOrderStatusName, displayName: string }, customer: { __typename?: 'Customer', id: string, firstName: string, lastName: string, email: string }, paymentMethod: { __typename?: 'PaymentMethod', id: string, name: PaymentMethodName, displayName: string }, shipment?: { __typename?: 'Shipment', id: string, createdAt: string, trackingNumber: string } | null }> } };

export type TransactionListActivity_ReturnAuthorizationListTabQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Cursor']>;
  filter?: InputMaybe<QueryReturnAuthorizationsFilterInput>;
  sort?: InputMaybe<QueryReturnAuthorizationsSortInput>;
}>;


export type TransactionListActivity_ReturnAuthorizationListTabQuery = { __typename?: 'Query', returnAuthorizations: { __typename?: 'ReturnAuthorizationPage', pageInfo: { __typename?: 'PageInfo', nextPage?: any | null, pages: Array<any>, previousPage?: any | null, totalRows: number }, nodes: Array<{ __typename?: 'ReturnAuthorization', id: string, returnNumber: string, returnDate: string, order: { __typename?: 'Order', id: string }, customer: { __typename?: 'Customer', id: string, email: string }, approval?: { __typename?: 'ReturnAuthorizationApproval', id: string, approvalType: { __typename?: 'ApprovalType', id: string, name: ApprovalTypeName, displayName: string } } | null, acceptance?: { __typename?: 'ReturnAuthorizationAcceptance', id: string, approvalType: { __typename?: 'ApprovalType', id: string, name: ApprovalTypeName, displayName: string } } | null, itemReceipt?: { __typename?: 'ItemReceipt', id: string, metaCreated: string, lineItems: Array<{ __typename?: 'ItemReceiptLineItem', id: string }> } | null, refund?: { __typename?: 'Refund', id: string, approvalType: { __typename?: 'ApprovalType', id: string, name: ApprovalTypeName, displayName: string } } | null, lineItems: Array<{ __typename?: 'ReturnAuthorizationLineItem', id: string, quantity: number, reasonForReturn: string, product: { __typename?: 'Product', id: string, sku: string, name: string } }> }> } };

export type PageInfoFieldsFragment = { __typename?: 'PageInfo', nextPage?: any | null, pages: Array<any>, previousPage?: any | null, totalRows: number };

export type NetSuiteRecordFieldsFragment = { __typename?: 'NetSuiteRecord', id: string, createdAt: string, netSuiteInternalId: string, recordUrl: string, transactionId: string };

export type WriteRequestFieldsFragment = { __typename?: 'NetSuiteWriteRequest', id: string, validationErrors: Array<string> };

export type ReturnAuthorizationTriageFieldsFragment = { __typename?: 'ReturnAuthorizationTriage', id: string, createdTimestamp: string, workflow: { __typename?: 'TriageWorkflow', id: string, type: { __typename?: 'TriageWorkflowType', id: string, name: TriageWorkflowTypeName, displayName: string } } };

export type AuthRedirectorQueryVariables = Exact<{ [key: string]: never; }>;


export type AuthRedirectorQuery = { __typename?: 'Query', loggedInUser?: { __typename?: 'SiteUserFull', id: string, isSuperAdmin: boolean, status: { __typename?: 'UserStatus', id: string, name: UserStatusName, displayName: string } } | null };

export type ExportAsnQueryVariables = Exact<{
  input: ExportAsnInput;
}>;


export type ExportAsnQuery = { __typename?: 'Query', exportAsn?: any | null };

export type ImportOrdersFromCsvMutationVariables = Exact<{
  input: ImportOrdersFromCsvInput;
}>;


export type ImportOrdersFromCsvMutation = { __typename?: 'Mutation', importOrdersFromCsv: boolean };

export type ImportOrdersModalQueryVariables = Exact<{
  storeId: Scalars['ID'];
}>;


export type ImportOrdersModalQuery = { __typename?: 'Query', store?: { __typename?: 'Store', id: string, orderPrefix: string, storeSettings: { __typename?: 'StoreSettings', prefixNewOrders: boolean }, customOrderFormatFlow?: { __typename?: 'CustomOrderFormatFlow', id: string, propertyMapping: Array<{ __typename?: 'CustomOrderFormatPropertyMapping', id: string, defaultValueOnEmpty: string, sourceDataLabel: string, mapToProperty: { __typename?: 'OrderProperty', id: string, name: OrderPropertyName, displayName: string } }> } | null } | null };

export type PreValidateCsvImportQueryVariables = Exact<{
  input: ImportOrdersFromCsvInput;
}>;


export type PreValidateCsvImportQuery = { __typename?: 'Query', preValidateCsvImport: Array<string> };

export type InviteUserMutationVariables = Exact<{
  input: InviteUserInput;
}>;


export type InviteUserMutation = { __typename?: 'Mutation', inviteUser?: { __typename?: 'Invite', id: string, sentTimestamp?: string | null, recipientEmail: string } | null };

export type SelectItemsModalQueryVariables = Exact<{
  storeId: Scalars['ID'];
  checkInventoryManagement: Scalars['Boolean'];
}>;


export type SelectItemsModalQuery = { __typename?: 'Query', items: { __typename?: 'ItemPage', pageInfo: { __typename?: 'PageInfo', nextPage?: any | null, pages: Array<any>, previousPage?: any | null, totalRows: number }, nodes: Array<{ __typename?: 'Item', id: string, sku: string, name: string, defaultPriceDollars: string, canManageInventory?: boolean }> } };

export type SingleOrderRecordNavigatorQueryVariables = Exact<{
  orderId: Scalars['ID'];
}>;


export type SingleOrderRecordNavigatorQuery = { __typename?: 'Query', orderLite?: { __typename?: 'OrderLite', id: string, orderNumber: string, returnAuthorizations: Array<{ __typename?: 'ReturnAuthorizationLite', id: string, returnNumber: string }> } | null };

export type StoreFeatureToggleQueryVariables = Exact<{
  storeId: Scalars['ID'];
  featureName: FeatureName;
}>;


export type StoreFeatureToggleQuery = { __typename?: 'Query', store?: { __typename?: 'Store', id: string, isFeatureDisabled: boolean } | null };

export type ToggleFeatureForStoreMutationVariables = Exact<{
  storeId: Scalars['ID'];
  featureName: FeatureName;
  enabled: Scalars['Boolean'];
}>;


export type ToggleFeatureForStoreMutation = { __typename?: 'Mutation', toggleFeatureForStore: boolean };

export type StoreThemeProviderQueryVariables = Exact<{
  storeId: Scalars['ID'];
}>;


export type StoreThemeProviderQuery = { __typename?: 'Query', storeBrand?: { __typename?: 'StoreBrand', id: string, primaryColorHex: string, secondaryColorHex: string, buttonColorHex: string } | null };

export type LoggedInUserPermissionsQueryVariables = Exact<{
  storeId?: InputMaybe<Scalars['ID']>;
}>;


export type LoggedInUserPermissionsQuery = { __typename?: 'Query', loggedInUser?: { __typename?: 'SiteUserFull', id: string, permissions: Array<{ __typename?: 'Permission', id: string, name: PermissionName, displayName: string }> } | null };

export type CustomerActivityTemplateQueryVariables = Exact<{
  storeId: Scalars['ID'];
}>;


export type CustomerActivityTemplateQuery = { __typename?: 'Query', storeBrand?: { __typename?: 'StoreBrand', id: string, logoUrl: string } | null };

export type PartnerActivityTemplateQueryVariables = Exact<{
  storeId: Scalars['ID'];
}>;


export type PartnerActivityTemplateQuery = { __typename?: 'Query', store?: { __typename?: 'Store', id: string, logoUrl: string } | null };

export type SaveAuditLogEventMutationVariables = Exact<{
  input: SaveAuditLogEventInput;
}>;


export type SaveAuditLogEventMutation = { __typename?: 'Mutation', saveAuditLogEvent?: { __typename?: 'AuditLogEvent', id: string, metaCreated: string, title: string, content: string, triggeringSiteUser?: { __typename?: 'SiteUserFull', id: string, fullName: string } | null } | null };

export type ReceiveReturnAuthorizationMutationVariables = Exact<{
  input: ReceiveReturnAuthorizationInput;
}>;


export type ReceiveReturnAuthorizationMutation = { __typename?: 'Mutation', receiveReturnAuthorization?: { __typename?: 'ReturnAuthorization', id: string, itemReceipt?: { __typename?: 'ItemReceipt', id: string, lineItems: Array<{ __typename?: 'ItemReceiptLineItem', id: string, refundAmountCents: string, product: { __typename?: 'Product', id: string, sku: string, name: string } }> } | null } | null };

export type ReceiveReturnAuthorizationModalQueryVariables = Exact<{
  returnAuthorizationId: Scalars['ID'];
}>;


export type ReceiveReturnAuthorizationModalQuery = { __typename?: 'Query', returnAuthorization?: { __typename?: 'ReturnAuthorization', id: string, returnNumber: string, store: { __typename?: 'Store', id: string }, netSuiteWriteRequest?: { __typename?: 'NetSuiteWriteRequest', id: string, validationErrors: Array<string> } | null, netSuiteRecord?: { __typename?: 'NetSuiteRecord', id: string, createdAt: string, netSuiteInternalId: string, recordUrl: string, transactionId: string } | null, itemReceipt?: { __typename?: 'ItemReceipt', id: string, lineItems: Array<{ __typename?: 'ItemReceiptLineItem', id: string, inventoryNumber: string, refundAmountCents: string, product: { __typename?: 'Product', id: string, name: string, sku: string } }> } | null, lineItems: Array<{ __typename?: 'ReturnAuthorizationLineItem', id: string, quantity: number, refundAmountCents: string, serialNumber: string, product: { __typename?: 'Product', id: string, sku: string, name: string } }> } | null };

export type SaveItemReceiptMutationVariables = Exact<{
  input: SaveItemReceiptInput;
}>;


export type SaveItemReceiptMutation = { __typename?: 'Mutation', saveItemReceipt: { __typename?: 'ItemReceipt', id: string, lineItems: Array<{ __typename?: 'ItemReceiptLineItem', id: string, inventoryNumber: string, product: { __typename?: 'Product', id: string, sku: string, name: string } }> } };

export type RefundDetailModalQueryVariables = Exact<{
  refundId: Scalars['ID'];
}>;


export type RefundDetailModalQuery = { __typename?: 'Query', refund?: { __typename?: 'Refund', id: string, metaCreated: string, apiRequests: { __typename?: 'HttpRequestPage', pageInfo: { __typename?: 'PageInfo', nextPage?: any | null, pages: Array<any>, previousPage?: any | null, totalRows: number }, nodes: Array<{ __typename?: 'HttpRequest', id: string, metaCreated: string, httpStatusCode: number, requestBody: any, responseBody: any, url: string, method: HttpRequestMethodName }> } } | null };

export type ResendEmailMutationVariables = Exact<{
  input: ResendEmailInput;
}>;


export type ResendEmailMutation = { __typename?: 'Mutation', resendEmail: boolean };

export type ReturnAuthorizationSummarySectionQueryVariables = Exact<{
  returnAuthorizationId: Scalars['ID'];
}>;


export type ReturnAuthorizationSummarySectionQuery = { __typename?: 'Query', returnAuthorization?: { __typename?: 'ReturnAuthorization', id: string, returnNumber: string, netSuiteWriteRequest?: { __typename?: 'NetSuiteWriteRequest', id: string, validationErrors: Array<string> } | null, netSuiteRecord?: { __typename?: 'NetSuiteRecord', id: string, createdAt: string, netSuiteInternalId: string, recordUrl: string, transactionId: string } | null, store: { __typename?: 'Store', id: string }, lineItems: Array<{ __typename?: 'ReturnAuthorizationLineItem', id: string, serialNumber: string, quantity: number, reasonForReturn: string, product: { __typename?: 'Product', id: string, sku: string, name: string } }>, customer: { __typename?: 'Customer', id: string, firstName: string, lastName: string, netSuiteWriteRequest?: { __typename?: 'NetSuiteWriteRequest', id: string, validationErrors: Array<string> } | null, netSuiteRecord?: { __typename?: 'NetSuiteRecord', id: string, createdAt: string, netSuiteInternalId: string, recordUrl: string, transactionId: string } | null }, order: { __typename?: 'Order', id: string, orderNumber: string, orderDate: string, netSuiteWriteRequest?: { __typename?: 'NetSuiteWriteRequest', id: string, validationErrors: Array<string> } | null, netSuiteRecord?: { __typename?: 'NetSuiteRecord', id: string, createdAt: string, netSuiteInternalId: string, recordUrl: string, transactionId: string } | null } } | null };

export type SendChatMessageMutationVariables = Exact<{
  input: SendChatMessageInput;
}>;


export type SendChatMessageMutation = { __typename?: 'Mutation', sendChatMessage?: { __typename?: 'ChatMessage', id: string, content: string, senderName: string } | null };

export type SendChatMessageAsCustomerMutationVariables = Exact<{
  content: Scalars['String'];
  orderId?: InputMaybe<Scalars['ID']>;
  returnAuthorizationId?: InputMaybe<Scalars['ID']>;
}>;


export type SendChatMessageAsCustomerMutation = { __typename?: 'Mutation', sendChatMessageAsCustomer?: { __typename?: 'ChatMessage', id: string, content: string, metaCreated: string } | null };

export type AppEventSelectFieldQueryVariables = Exact<{
  options: QueryAppEventsOptionsInput;
}>;


export type AppEventSelectFieldQuery = { __typename?: 'Query', appEvents: Array<{ __typename?: 'AppEvent', id: string, name: AppEventName, displayName: string }> };

export type ItemSelectFieldQueryVariables = Exact<{
  options: QueryItemsOptionsInput;
}>;


export type ItemSelectFieldQuery = { __typename?: 'Query', items: { __typename?: 'ItemPage', pageInfo: { __typename?: 'PageInfo', nextPage?: any | null, pages: Array<any>, previousPage?: any | null, totalRows: number }, nodes: Array<{ __typename?: 'Item', id: string, name: string, sku: string }> } };

export type LeaseApplicationStepNameSelectFieldQueryVariables = Exact<{ [key: string]: never; }>;


export type LeaseApplicationStepNameSelectFieldQuery = { __typename?: 'Query', smartPayLeaseApplicationStepNames: Array<{ __typename?: 'LeaseApplicationStepName', id: string, name: LeaseApplicationStepNameName, displayName: string }> };

export type NetSuiteBrandSelectFieldQueryVariables = Exact<{ [key: string]: never; }>;


export type NetSuiteBrandSelectFieldQuery = { __typename?: 'Query', netSuiteBrands: Array<{ __typename?: 'NetSuiteBrand', id: string, name: string }> };

export type NetSuiteDepartmentSelectFieldQueryVariables = Exact<{ [key: string]: never; }>;


export type NetSuiteDepartmentSelectFieldQuery = { __typename?: 'Query', departments: Array<{ __typename?: 'NetSuiteDepartment', id: string, name: string }> };

export type NetSuiteEmployeeSelectFieldQueryVariables = Exact<{ [key: string]: never; }>;


export type NetSuiteEmployeeSelectFieldQuery = { __typename?: 'Query', employees: Array<{ __typename?: 'Employee', id: string, fullName: string }> };

export type NetSuiteLocationSelectFieldQueryVariables = Exact<{ [key: string]: never; }>;


export type NetSuiteLocationSelectFieldQuery = { __typename?: 'Query', inventoryLocations: Array<{ __typename?: 'NetSuiteInventoryLocation', id: string, name: string }> };

export type NetSuitePaymentMethodSelectFieldQueryVariables = Exact<{ [key: string]: never; }>;


export type NetSuitePaymentMethodSelectFieldQuery = { __typename?: 'Query', netSuitePaymentMethods: Array<{ __typename?: 'NetSuitePaymentMethod', id: string, name: string, internalId: string }> };

export type NetSuiteSubsidiarySelectFieldQueryVariables = Exact<{ [key: string]: never; }>;


export type NetSuiteSubsidiarySelectFieldQuery = { __typename?: 'Query', subsidiaries: Array<{ __typename?: 'NetSuiteSubsidiary', id: string, name: string }> };

export type NetSuiteTaxItemSelectFieldQueryVariables = Exact<{ [key: string]: never; }>;


export type NetSuiteTaxItemSelectFieldQuery = { __typename?: 'Query', taxItems: Array<{ __typename?: 'NetSuiteTaxItem', id: string, name: string }> };

export type OrderPropertySelectFieldQueryVariables = Exact<{ [key: string]: never; }>;


export type OrderPropertySelectFieldQuery = { __typename?: 'Query', orderProperties: Array<{ __typename?: 'OrderProperty', id: string, name: OrderPropertyName, displayName: string }> };

export type PaymentMethodSelectFieldQueryVariables = Exact<{ [key: string]: never; }>;


export type PaymentMethodSelectFieldQuery = { __typename?: 'Query', paymentMethods: Array<{ __typename?: 'PaymentMethod', id: string, name: PaymentMethodName, displayName: string }> };

export type ProductSelectFieldQueryVariables = Exact<{
  options: QueryProductsOptionsInput;
}>;


export type ProductSelectFieldQuery = { __typename?: 'Query', products: { __typename?: 'ProductsPage', pageInfo: { __typename?: 'PageInfo', nextPage?: any | null, pages: Array<any>, previousPage?: any | null, totalRows: number }, nodes: Array<{ __typename?: 'Product', id: string, name: string, sku: string }> } };

export type RepairCodeSelectFieldQueryVariables = Exact<{
  storeId: Scalars['ID'];
}>;


export type RepairCodeSelectFieldQuery = { __typename?: 'Query', store?: { __typename?: 'Store', id: string, repairCodes: Array<{ __typename?: 'RepairCode', id: string, repairCode: string }> } | null };

export type ReturnAuthorizationSelectFieldQueryVariables = Exact<{
  storeId: Scalars['ID'];
}>;


export type ReturnAuthorizationSelectFieldQuery = { __typename?: 'Query', returnAuthorizations: { __typename?: 'ReturnAuthorizationPage', nodes: Array<{ __typename?: 'ReturnAuthorization', id: string, returnNumber: string }> } };

export type SalesChannelSelectFieldQueryVariables = Exact<{ [key: string]: never; }>;


export type SalesChannelSelectFieldQuery = { __typename?: 'Query', salesChannels: Array<{ __typename?: 'SalesChannel', id: string, name: SalesChannelName, displayName: string }> };

export type SalesOrderSelectFieldQueryVariables = Exact<{
  storeId: Scalars['ID'];
}>;


export type SalesOrderSelectFieldQuery = { __typename?: 'Query', orders: { __typename?: 'OrderPage', nodes: Array<{ __typename?: 'Order', id: string, orderNumber: string }> } };

export type ShipItemFieldQueryVariables = Exact<{
  subsidiaryId: Scalars['ID'];
}>;


export type ShipItemFieldQuery = { __typename?: 'Query', shipItems: { __typename?: 'ShipItemPage', pageInfo: { __typename?: 'PageInfo', nextPage?: any | null, pages: Array<any>, previousPage?: any | null, totalRows: number }, nodes: Array<{ __typename?: 'ShipItem', id: string, name: string }> } };

export type ShipStationStoreSelectFieldQueryVariables = Exact<{ [key: string]: never; }>;


export type ShipStationStoreSelectFieldQuery = { __typename?: 'Query', shipStationStores: Array<{ __typename?: 'ShipStationStore', id: string, name: string }> };

export type SoftwareVersionSelectFieldQueryVariables = Exact<{
  storeId: Scalars['ID'];
}>;


export type SoftwareVersionSelectFieldQuery = { __typename?: 'Query', store?: { __typename?: 'Store', id: string, softwareVersions: Array<{ __typename?: 'SoftwareVersion', id: string, name: string }> } | null };

export type StoreSelectFieldQueryVariables = Exact<{
  featuresEnabled?: InputMaybe<Array<FeatureName> | FeatureName>;
  salesChannel?: InputMaybe<SalesChannelName>;
  types?: InputMaybe<Array<StoreTypeName> | StoreTypeName>;
}>;


export type StoreSelectFieldQuery = { __typename?: 'Query', stores: { __typename?: 'StorePage', pageInfo: { __typename?: 'PageInfo', nextPage?: any | null, pages: Array<any>, previousPage?: any | null, totalRows: number }, nodes: Array<{ __typename?: 'Store', id: string, name: string }> } };

export type ThirdPartyAccountSelectFieldQueryVariables = Exact<{ [key: string]: never; }>;


export type ThirdPartyAccountSelectFieldQuery = { __typename?: 'Query', thirdPartyAccounts: { __typename?: 'ThirdPartyAccountPage', nodes: Array<{ __typename?: 'ThirdPartyAccount', id: string, name: string, accountNumber: string }> } };

export type TriageReasonSelectFieldQueryVariables = Exact<{
  storeId: Scalars['ID'];
}>;


export type TriageReasonSelectFieldQuery = { __typename?: 'Query', store?: { __typename?: 'Store', id: string, triageReasons: Array<{ __typename?: 'TriageReason', id: string, reasonText: string }> } | null };

export type UserRoleTemplateSelectFieldQueryVariables = Exact<{ [key: string]: never; }>;


export type UserRoleTemplateSelectFieldQuery = { __typename?: 'Query', userRoleTemplates: { __typename?: 'UserRoleTemplatePage', nodes: Array<{ __typename?: 'UserRoleTemplate', id: string, displayName: string, visibilityScope: { __typename?: 'VisibilityScope', id: string, name: VisibilityScopeName, displayName: string } }> } };

export type UserStatusSelectFieldQueryVariables = Exact<{ [key: string]: never; }>;


export type UserStatusSelectFieldQuery = { __typename?: 'Query', userStatuses: Array<{ __typename?: 'UserStatus', id: string, name: UserStatusName, displayName: string }> };

export type AcceptReturnAuthorizationMutationVariables = Exact<{
  returnAuthorizationId: Scalars['ID'];
  approvalTypeName: ApprovalTypeName;
}>;


export type AcceptReturnAuthorizationMutation = { __typename?: 'Mutation', acceptReturnAuthorization?: { __typename?: 'ReturnAuthorization', id: string, acceptance?: { __typename?: 'ReturnAuthorizationAcceptance', id: string, approvalType: { __typename?: 'ApprovalType', id: string, name: ApprovalTypeName, displayName: string } } | null } | null };

export type ReverseReturnAuthorizationAcceptanceDecisionMutationVariables = Exact<{
  returnAuthorizationId: Scalars['ID'];
}>;


export type ReverseReturnAuthorizationAcceptanceDecisionMutation = { __typename?: 'Mutation', reverseReturnAuthorizationAcceptanceDecision?: { __typename?: 'ReturnAuthorization', id: string, acceptance?: { __typename?: 'ReturnAuthorizationAcceptance', id: string } | null } | null };

export type AcceptReturnAuthorizationModalQueryVariables = Exact<{
  returnAuthorizationId: Scalars['ID'];
}>;


export type AcceptReturnAuthorizationModalQuery = { __typename?: 'Query', returnAuthorization?: { __typename?: 'ReturnAuthorization', id: string, returnNumber: string, store: { __typename?: 'Store', id: string }, netSuiteWriteRequest?: { __typename?: 'NetSuiteWriteRequest', id: string, validationErrors: Array<string> } | null, netSuiteRecord?: { __typename?: 'NetSuiteRecord', id: string, createdAt: string, netSuiteInternalId: string, recordUrl: string, transactionId: string } | null, lineItems: Array<{ __typename?: 'ReturnAuthorizationLineItem', id: string, serialNumber: string, quantity: number, reasonForReturn: string, product: { __typename?: 'Product', id: string, sku: string, name: string } }>, customer: { __typename?: 'Customer', id: string, firstName: string, lastName: string, netSuiteWriteRequest?: { __typename?: 'NetSuiteWriteRequest', id: string, validationErrors: Array<string> } | null, netSuiteRecord?: { __typename?: 'NetSuiteRecord', id: string, createdAt: string, netSuiteInternalId: string, recordUrl: string, transactionId: string } | null }, order: { __typename?: 'Order', id: string, orderNumber: string, orderDate: string, netSuiteWriteRequest?: { __typename?: 'NetSuiteWriteRequest', id: string, validationErrors: Array<string> } | null, netSuiteRecord?: { __typename?: 'NetSuiteRecord', id: string, createdAt: string, netSuiteInternalId: string, recordUrl: string, transactionId: string } | null } } | null };

export type ApproveReturnAuthorizationMutationVariables = Exact<{
  returnAuthorizationId: Scalars['ID'];
  approvalTypeName: ApprovalTypeName;
}>;


export type ApproveReturnAuthorizationMutation = { __typename?: 'Mutation', approveReturnAuthorization?: { __typename?: 'ReturnAuthorization', id: string, approval?: { __typename?: 'ReturnAuthorizationApproval', id: string, approvalType: { __typename?: 'ApprovalType', id: string, name: ApprovalTypeName, displayName: string } } | null } | null };

export type ReverseReturnAuthorizationApprovalDecisionMutationVariables = Exact<{
  returnAuthorizationId: Scalars['ID'];
}>;


export type ReverseReturnAuthorizationApprovalDecisionMutation = { __typename?: 'Mutation', reverseReturnAuthorizationApprovalDecision?: { __typename?: 'ReturnAuthorization', id: string, approval?: { __typename?: 'ReturnAuthorizationApproval', id: string } | null } | null };

export type ApproveReturnAuthorizationModalQueryVariables = Exact<{
  returnAuthorizationId: Scalars['ID'];
}>;


export type ApproveReturnAuthorizationModalQuery = { __typename?: 'Query', returnAuthorization?: { __typename?: 'ReturnAuthorization', id: string, returnNumber: string, netSuiteWriteRequest?: { __typename?: 'NetSuiteWriteRequest', id: string, validationErrors: Array<string> } | null, netSuiteRecord?: { __typename?: 'NetSuiteRecord', id: string, createdAt: string, netSuiteInternalId: string, recordUrl: string, transactionId: string } | null, store: { __typename?: 'Store', id: string }, lineItems: Array<{ __typename?: 'ReturnAuthorizationLineItem', id: string, serialNumber: string, quantity: number, reasonForReturn: string, product: { __typename?: 'Product', id: string, sku: string, name: string } }>, customer: { __typename?: 'Customer', id: string, firstName: string, lastName: string, netSuiteWriteRequest?: { __typename?: 'NetSuiteWriteRequest', id: string, validationErrors: Array<string> } | null, netSuiteRecord?: { __typename?: 'NetSuiteRecord', id: string, createdAt: string, netSuiteInternalId: string, recordUrl: string, transactionId: string } | null }, order: { __typename?: 'Order', id: string, orderNumber: string, orderDate: string, netSuiteWriteRequest?: { __typename?: 'NetSuiteWriteRequest', id: string, validationErrors: Array<string> } | null, netSuiteRecord?: { __typename?: 'NetSuiteRecord', id: string, createdAt: string, netSuiteInternalId: string, recordUrl: string, transactionId: string } | null } } | null };

export type InitiateReturnAuthorizationMutationVariables = Exact<{
  input: InitiateReturnAuthorizationInput;
}>;


export type InitiateReturnAuthorizationMutation = { __typename?: 'Mutation', initiateReturnAuthorization?: { __typename?: 'ReturnAuthorization', id: string } | null };

export type InitiateReturnAuthorizationAsCustomerMutationVariables = Exact<{
  input: InitiateReturnAuthorizationInput;
}>;


export type InitiateReturnAuthorizationAsCustomerMutation = { __typename?: 'Mutation', initiateReturnAuthorizationAsCustomer?: { __typename?: 'ReturnAuthorizationLite', id: string, returnNumber: string } | null };

export type InitiateReturnModalQueryVariables = Exact<{
  orderId: Scalars['ID'];
  asCustomer: Scalars['Boolean'];
}>;


export type InitiateReturnModalQuery = { __typename?: 'Query', order?: { __typename?: 'Order', id: string, orderDate: string, orderNumber: string, netSuiteWriteRequest?: { __typename?: 'NetSuiteWriteRequest', id: string, validationErrors: Array<string> } | null, netSuiteRecord?: { __typename?: 'NetSuiteRecord', id: string, createdAt: string, netSuiteInternalId: string, recordUrl: string, transactionId: string } | null, customer: { __typename?: 'Customer', id: string, fullName: string, netSuiteWriteRequest?: { __typename?: 'NetSuiteWriteRequest', id: string, validationErrors: Array<string> } | null, netSuiteRecord?: { __typename?: 'NetSuiteRecord', id: string, createdAt: string, netSuiteInternalId: string, recordUrl: string, transactionId: string } | null }, store: { __typename?: 'Store', id: string }, paymentMethod: { __typename?: 'PaymentMethod', id: string, name: PaymentMethodName, displayName: string }, lineItems: Array<{ __typename?: 'LineItem', id: string, discountTotalCents: string, feeTotalCents: string, itemTotalCents: string, taxTotalCents: string, quantity: number, product: { __typename?: 'Product', id: string, name: string, sku: string } }>, itemFulfillment?: { __typename?: 'ItemFulfillment', id: string, netSuiteRecord?: { __typename?: 'NetSuiteRecord', id: string, createdAt: string, netSuiteInternalId: string, recordUrl: string, transactionId: string } | null, lineItems: Array<{ __typename?: 'ItemFulfillmentLineItem', id: string, item: { __typename?: 'Item', id: string, sku: string }, assignments: Array<{ __typename?: 'InventoryNumberAssignment', id: string, inventoryNumber: string }> }> } | null, returnAuthorizations: { __typename?: 'ReturnAuthorizationPage', pageInfo: { __typename?: 'PageInfo', nextPage?: any | null, pages: Array<any>, previousPage?: any | null, totalRows: number }, nodes: Array<{ __typename?: 'ReturnAuthorization', id: string, itemReceipt?: { __typename?: 'ItemReceipt', id: string, lineItems: Array<{ __typename?: 'ItemReceiptLineItem', id: string, inventoryNumber: string, product: { __typename?: 'Product', id: string, sku: string } }> } | null }> } } | null, orderLite?: { __typename?: 'OrderLite', id: string, orderDate: string, orderNumber: string, customerFullName: string, paymentMethod: { __typename?: 'PaymentMethod', id: string, name: PaymentMethodName, displayName: string }, lineItems: Array<{ __typename?: 'LineItemLite', id: string, discountTotalCents: string, feeTotalCents: string, itemTotalCents: string, taxTotalCents: string, quantity: number, productName: string, sku: string }>, itemFulfillment?: { __typename?: 'ItemFulfillment', id: string, lineItems: Array<{ __typename?: 'ItemFulfillmentLineItem', id: string, item: { __typename?: 'Item', id: string, sku: string }, assignments: Array<{ __typename?: 'InventoryNumberAssignment', id: string, inventoryNumber: string }> }> } | null, returnAuthorizations: Array<{ __typename?: 'ReturnAuthorizationLite', id: string, receivedInventoryNumbers: Array<string> }> } | null };

export type OrderChatMessagesWidgetQueryVariables = Exact<{
  orderId: Scalars['ID'];
}>;


export type OrderChatMessagesWidgetQuery = { __typename?: 'Query', order?: { __typename?: 'Order', id: string, messages: { __typename?: 'ChatMessagePage', pageInfo: { __typename?: 'PageInfo', nextPage?: any | null, pages: Array<any>, previousPage?: any | null, totalRows: number }, nodes: Array<{ __typename?: 'ChatMessage', id: string, metaCreated: string, content: string, senderName: string }> } } | null };

export type Partner_ReturnAuthorizationChatMessagesWidgetQueryVariables = Exact<{
  returnAuthorizationId: Scalars['ID'];
}>;


export type Partner_ReturnAuthorizationChatMessagesWidgetQuery = { __typename?: 'Query', returnAuthorization?: { __typename?: 'ReturnAuthorization', id: string, messages: { __typename?: 'ChatMessagePage', pageInfo: { __typename?: 'PageInfo', nextPage?: any | null, pages: Array<any>, previousPage?: any | null, totalRows: number }, nodes: Array<{ __typename?: 'ChatMessage', id: string, metaCreated: string, content: string, senderName: string }> } } | null };

export type GenerateSkuSwapMutationVariables = Exact<{
  input: GenerateSkuSwapInput;
}>;


export type GenerateSkuSwapMutation = { __typename?: 'Mutation', generateSkuSwap: boolean };

export type SkuSwapModalQueryVariables = Exact<{
  orderId: Scalars['ID'];
}>;


export type SkuSwapModalQuery = { __typename?: 'Query', order?: { __typename?: 'Order', id: string, lineItems: Array<{ __typename?: 'LineItem', id: string, quantity: number, product: { __typename?: 'Product', id: string, name: string, sku: string } }>, itemFulfillment?: { __typename?: 'ItemFulfillment', id: string, lineItems: Array<{ __typename?: 'ItemFulfillmentLineItem', id: string, item: { __typename?: 'Item', id: string, sku: string }, assignments: Array<{ __typename?: 'InventoryNumberAssignment', id: string, inventoryNumber: string }> }> } | null } | null };

export type AuditLogWidgetQueryVariables = Exact<{
  id: Scalars['ID'];
  isQueryingOrder: Scalars['Boolean'];
}>;


export type AuditLogWidgetQuery = { __typename?: 'Query', loggedInUser?: { __typename?: 'SiteUserFull', id: string, isSuperAdmin: boolean } | null, order?: { __typename?: 'Order', id: string, auditLog: { __typename?: 'AuditLogEventPage', pageInfo: { __typename?: 'PageInfo', nextPage?: any | null, pages: Array<any>, previousPage?: any | null, totalRows: number }, nodes: Array<{ __typename?: 'AuditLogEvent', id: string, metaCreated: string, title: string, content: string, triggeringSiteUser?: { __typename?: 'SiteUserFull', id: string, fullName: string } | null }> } } | null, returnAuthorization?: { __typename?: 'ReturnAuthorization', id: string, auditLog: { __typename?: 'AuditLogEventPage', pageInfo: { __typename?: 'PageInfo', nextPage?: any | null, pages: Array<any>, previousPage?: any | null, totalRows: number }, nodes: Array<{ __typename?: 'AuditLogEvent', id: string, metaCreated: string, title: string, content: string, triggeringSiteUser?: { __typename?: 'SiteUserFull', id: string, fullName: string } | null }> } } | null };

export type SendGridEmailLogWidgetQueryVariables = Exact<{
  options: QuerySendGridEmailRequestsOptionsInput;
}>;


export type SendGridEmailLogWidgetQuery = { __typename?: 'Query', sendGridEmailRequests: { __typename?: 'SendGridEmailRequestPage', nodes: Array<{ __typename?: 'SendGridEmailRequest', id: string, orderId?: string | null, returnAuthorizationId?: string | null, createdAt: string, errorReason?: string | null, recipientEmails: Array<string>, appEvent?: { __typename?: 'AppEvent', name: AppEventName, displayName: string } | null, status: { __typename?: 'SendGridEmailStatus', id: string, name: SendGridEmailStatusName, displayName: string } }>, pageInfo: { __typename?: 'PageInfo', nextPage?: any | null, pages: Array<any>, previousPage?: any | null, totalRows: number } } };

export type AppleCareWidgetQueryVariables = Exact<{
  orderId: Scalars['ID'];
}>;


export type AppleCareWidgetQuery = { __typename?: 'Query', order?: { __typename?: 'Order', id: string, lineItems: Array<{ __typename?: 'LineItem', id: string, appleCareAgreement?: { __typename?: 'AppleCareAgreement', id: string, expiresAt?: string | null, agreementNumber: string, serialNumber: string } | null }> } | null };

export type CustomerInformationWidgetQueryVariables = Exact<{
  orderId: Scalars['ID'];
}>;


export type CustomerInformationWidgetQuery = { __typename?: 'Query', order?: { __typename?: 'Order', id: string, customer: { __typename?: 'Customer', id: string, email: string, firstName: string, lastName: string, phoneNumber: string }, billingAddress: { __typename?: 'Address', addressee?: string | null, street1: string, street2: string, city: string, usState: string, postalCode: string, countryCode: string, company: string, phone: string }, shippingAddress: { __typename?: 'Address', addressee?: string | null, street1: string, street2: string, city: string, usState: string, postalCode: string, countryCode: string, company: string, phone: string } } | null };

export type EditOrderModalQueryVariables = Exact<{
  orderId: Scalars['ID'];
}>;


export type EditOrderModalQuery = { __typename?: 'Query', order?: { __typename?: 'Order', id: string, orderNumber: string, customer: { __typename?: 'Customer', id: string }, billingAddress: { __typename?: 'Address', addressee?: string | null, street1: string, street2: string, city: string, usState: string, postalCode: string, countryCode: string, company: string, phone: string }, shippingAddress: { __typename?: 'Address', addressee?: string | null, street1: string, street2: string, city: string, usState: string, postalCode: string, countryCode: string, company: string, phone: string } } | null };

export type SaveOrderMutationVariables = Exact<{
  input: SaveSalesOrderInput;
}>;


export type SaveOrderMutation = { __typename?: 'Mutation', saveOrder?: { __typename?: 'Order', id: string, billingAddress: { __typename?: 'Address', addressee?: string | null, street1: string, street2: string, city: string, usState: string, postalCode: string, countryCode: string, company: string, phone: string }, shippingAddress: { __typename?: 'Address', addressee?: string | null, street1: string, street2: string, city: string, usState: string, postalCode: string, countryCode: string, company: string, phone: string } } | null };

export type ApiRequestModalQueryVariables = Exact<{
  orderId: Scalars['ID'];
}>;


export type ApiRequestModalQuery = { __typename?: 'Query', order?: { __typename?: 'Order', id: string, fulfillment?: { __typename?: 'BaseFulfillment', id: string } | null } | null };

export type Customer_FulfillmentStatusWidgetQueryVariables = Exact<{
  orderId: Scalars['ID'];
}>;


export type Customer_FulfillmentStatusWidgetQuery = { __typename?: 'Query', orderLite?: { __typename?: 'OrderLite', id: string, lifeCycle: Array<{ __typename?: 'LifeCycleStep', label: string, approvalType: ApprovalTypeName, completedOn?: string | null }> } | null };

export type Partner_FulfillmentStatusWidgetQueryVariables = Exact<{
  orderId: Scalars['ID'];
}>;


export type Partner_FulfillmentStatusWidgetQuery = { __typename?: 'Query', order?: { __typename?: 'Order', id: string, lifeCycle: Array<{ __typename?: 'LifeCycleStep', label: string, approvalType: ApprovalTypeName, completedOn?: string | null }> } | null };

export type ItemFulfillmentWidgetQueryVariables = Exact<{
  orderId: Scalars['ID'];
}>;


export type ItemFulfillmentWidgetQuery = { __typename?: 'Query', order?: { __typename?: 'Order', id: string, lineItems: Array<{ __typename?: 'LineItem', id: string, product: { __typename?: 'Product', id: string, sku: string }, swaps: Array<{ __typename?: 'SkuSwap', id: string, quantity: number, product: { __typename?: 'Product', id: string, sku: string } }> }>, itemFulfillment?: { __typename?: 'ItemFulfillment', id: string, lineItems: Array<{ __typename?: 'ItemFulfillmentLineItem', id: string, quantity: number, item: { __typename?: 'Item', id: string, sku: string }, assignments: Array<{ __typename?: 'InventoryNumberAssignment', id: string, inventoryNumber: string }> }> } | null } | null };

export type NetSuiteEligibilityDetailsQueryVariables = Exact<{
  orderId: Scalars['ID'];
}>;


export type NetSuiteEligibilityDetailsQuery = { __typename?: 'Query', netSuiteEligibilityDetails?: { __typename?: 'NetSuiteEligibilityDetails', orderId: string, orderNumber: string, customerInNetSuite: boolean, customerEmail?: string | null, customerMissingReason?: string | null, allProductsInNetSuite: boolean, hasShippingService: boolean, requestedShippingService?: string | null, shippingServiceMissingReason?: string | null, storeHasDepartment: boolean, storeHasLocation: boolean, storeHasTaxItem: boolean, storeMissingReason?: string | null, hasMappedPaymentMethod: boolean, rawPaymentMethod?: string | null, paymentMethodMissingReason?: string | null, discountItemsSynced: boolean, writeRequestGenerated: boolean, orderInNetSuite: boolean, missingProducts: Array<{ __typename?: 'MissingProduct', sku: string, name: string, productId: string }>, missingDiscountItems: Array<{ __typename?: 'MissingDiscountItem', discountItemId: string, discountType: string, rate: string }> } | null, order?: { __typename?: 'Order', id: string, netSuiteWriteRequest?: { __typename?: 'NetSuiteWriteRequest', id: string, validationErrors: Array<string> } | null, customer: { __typename?: 'Customer', id: string, netSuiteWriteRequest?: { __typename?: 'NetSuiteWriteRequest', id: string, validationErrors: Array<string> } | null } } | null };

export type SyncOrderToNetSuiteMutationVariables = Exact<{
  orderId: Scalars['ID'];
}>;


export type SyncOrderToNetSuiteMutation = { __typename?: 'Mutation', syncOrderToNetSuite: boolean };

export type CloseOrderMutationVariables = Exact<{
  orderId: Scalars['ID'];
}>;


export type CloseOrderMutation = { __typename?: 'Mutation', closeOrder?: { __typename?: 'Order', id: string, status: { __typename?: 'OrderStatus', id: string, name: OrderStatusName, displayName: string } } | null };

export type OrderSourceInformationWidgetQueryVariables = Exact<{
  orderId: Scalars['ID'];
}>;


export type OrderSourceInformationWidgetQuery = { __typename?: 'Query', loggedInUser?: { __typename?: 'SiteUserFull', id: string, isSuperAdmin: boolean } | null, order?: { __typename?: 'Order', id: string, urlToStoreRecord: string, orderNumber: string, customer: { __typename?: 'Customer', id: string, email: string }, netSuiteRecord?: { __typename?: 'NetSuiteRecord', recordUrl: string } | null, overallOrderStatus: { __typename?: 'OverallOrderStatus', id: string, name: OverallOrderStatusName, displayName: string }, status: { __typename?: 'OrderStatus', id: string, name: OrderStatusName, displayName: string }, e1DocumentIndex?: { __typename?: 'E1DocumentIndex', id: string, urlToE1Record: string } | null, store: { __typename?: 'Store', id: string, type: { __typename?: 'StoreType', id: string, name: StoreTypeName, displayName: string } } } | null };

export type CloseOrderAsCustomerMutationVariables = Exact<{
  orderId: Scalars['ID'];
}>;


export type CloseOrderAsCustomerMutation = { __typename?: 'Mutation', closeOrderAsCustomer?: { __typename?: 'OrderLite', id: string } | null };

export type PartnerActionsWidgetQueryVariables = Exact<{
  orderId: Scalars['ID'];
}>;


export type PartnerActionsWidgetQuery = { __typename?: 'Query', canInitiateReturnAuthorization: boolean, canCloseOrder: boolean, loggedInUser?: { __typename?: 'SiteUserFull', id: string, isSuperAdmin: boolean } | null, order?: { __typename?: 'Order', id: string, status: { __typename?: 'OrderStatus', id: string, name: OrderStatusName, displayName: string }, returnAuthorizations: { __typename?: 'ReturnAuthorizationPage', pageInfo: { __typename?: 'PageInfo', nextPage?: any | null, pages: Array<any>, previousPage?: any | null, totalRows: number }, nodes: Array<{ __typename?: 'ReturnAuthorization', id: string }> } } | null };

export type PaymentInformationWidgetQueryVariables = Exact<{
  orderId: Scalars['ID'];
}>;


export type PaymentInformationWidgetQuery = { __typename?: 'Query', orderLite?: { __typename?: 'OrderLite', id: string, shippingTotalCents: string, taxTotalCents: string, totalCents: string, feeTotalCents: string, discountTotalCents: string, lineItems: Array<{ __typename?: 'LineItemLite', id: string, quantity: number, itemTotalCents: string, taxTotalCents: string }>, paymentMethod: { __typename?: 'PaymentMethod', id: string, name: PaymentMethodName, displayName: string } } | null };

export type ProductInformationWidgetQueryVariables = Exact<{
  orderId: Scalars['ID'];
}>;


export type ProductInformationWidgetQuery = { __typename?: 'Query', order?: { __typename?: 'Order', id: string, totalCents: string, feeLines: Array<{ __typename?: 'ChargeLine', id: string, name: string, subtotalCents: string, taxTotalCents: string }>, shippingLines: Array<{ __typename?: 'ChargeLine', id: string, name: string, subtotalCents: string, taxTotalCents: string }>, lineItems: Array<{ __typename?: 'LineItem', id: string, itemTotalCents: string, taxTotalCents: string, feeTotalCents: string, discountTotalCents: string, refundAmountCents: string, quantity: number, product: { __typename?: 'Product', id: string, name: string, sku: string } }> } | null };

export type ShippingInformationWidgetQueryVariables = Exact<{
  orderId: Scalars['ID'];
}>;


export type ShippingInformationWidgetQuery = { __typename?: 'Query', orderLite?: { __typename?: 'OrderLite', id: string, shippingAddress: { __typename?: 'Address', street1: string, street2: string, city: string, usState: string, postalCode: string }, shipment?: Array<{ __typename?: 'Shipment', id: string, serviceCode: string, carrierCode: string, trackingNumber: string, trackingUrl: string } | null> | null } | null };

export type DeleteReturnAuthorizationMutationVariables = Exact<{
  returnAuthorizationId: Scalars['ID'];
}>;


export type DeleteReturnAuthorizationMutation = { __typename?: 'Mutation', deleteReturnAuthorization: boolean };

export type GenerateReturnLabelMutationVariables = Exact<{
  input: GenerateReturnLabelInput;
}>;


export type GenerateReturnLabelMutation = { __typename?: 'Mutation', generateReturnLabel?: { __typename?: 'ReturnAuthorization', id: string, shipment?: { __typename?: 'Shipment', id: string } | null } | null };

export type InitiateRefundMutationVariables = Exact<{
  input: InitiateRefundInput;
}>;


export type InitiateRefundMutation = { __typename?: 'Mutation', initiateRefund?: { __typename?: 'Refund', id: string } | null };

export type ReverseReturnAuthorizationRefundDenialDecisionMutationVariables = Exact<{
  returnAuthorizationId: Scalars['ID'];
}>;


export type ReverseReturnAuthorizationRefundDenialDecisionMutation = { __typename?: 'Mutation', reverseReturnAuthorizationRefundDenialDecision?: { __typename?: 'ReturnAuthorization', id: string, refund?: { __typename?: 'Refund', id: string } | null } | null };

export type Partner_ReturnAuthorizationActionsWidgetQueryVariables = Exact<{
  returnAuthorizationId: Scalars['ID'];
}>;


export type Partner_ReturnAuthorizationActionsWidgetQuery = { __typename?: 'Query', canDeleteReturnAuthorization: boolean, loggedInUser?: { __typename?: 'SiteUserFull', id: string } | null, returnAuthorization?: { __typename?: 'ReturnAuthorization', id: string, order: { __typename?: 'Order', id: string }, store: { __typename?: 'Store', id: string, type: { __typename?: 'StoreType', id: string, name: StoreTypeName, displayName: string } }, itemReceipt?: { __typename?: 'ItemReceipt', id: string } | null, approval?: { __typename?: 'ReturnAuthorizationApproval', id: string, approvalType: { __typename?: 'ApprovalType', id: string, name: ApprovalTypeName, displayName: string } } | null, acceptance?: { __typename?: 'ReturnAuthorizationAcceptance', id: string, approvalType: { __typename?: 'ApprovalType', id: string, name: ApprovalTypeName, displayName: string } } | null, refund?: { __typename?: 'Refund', id: string, approvalType: { __typename?: 'ApprovalType', id: string, name: ApprovalTypeName, displayName: string } } | null, shipment?: { __typename?: 'Shipment', id: string, labelUrl: string } | null } | null };

export type CustomerReturnShippingWidgetQueryVariables = Exact<{
  returnAuthorizationId: Scalars['ID'];
}>;


export type CustomerReturnShippingWidgetQuery = { __typename?: 'Query', returnAuthorizationLite?: { __typename?: 'ReturnAuthorizationLite', id: string, shipment?: { __typename?: 'Shipment', id: string, trackingNumber: string, trackingUrl: string, labelUrl: string } | null } | null };

export type ItemReceiptWidgetQueryVariables = Exact<{
  returnAuthorizationId: Scalars['ID'];
}>;


export type ItemReceiptWidgetQuery = { __typename?: 'Query', returnAuthorization?: { __typename?: 'ReturnAuthorization', id: string, itemReceipt?: { __typename?: 'ItemReceipt', id: string, lineItems: Array<{ __typename?: 'ItemReceiptLineItem', id: string, inventoryNumber: string, refundAmountCents: string, product: { __typename?: 'Product', id: string, name: string, sku: string } }> } | null } | null };

export type Partner_ReturnAuthorizationLifeCycleWidgetQueryVariables = Exact<{
  returnAuthorizationId: Scalars['ID'];
  queryAsCustomer: Scalars['Boolean'];
}>;


export type Partner_ReturnAuthorizationLifeCycleWidgetQuery = { __typename?: 'Query', returnAuthorization?: { __typename?: 'ReturnAuthorization', id: string, lifeCycle: Array<{ __typename?: 'LifeCycleStep', label: string, approvalType: ApprovalTypeName, completedOn?: string | null }>, refund?: { __typename?: 'Refund', id: string, approvalType: { __typename?: 'ApprovalType', id: string, name: ApprovalTypeName, displayName: string } } | null } | null, returnAuthorizationLite?: { __typename?: 'ReturnAuthorizationLite', id: string, lifeCycle: Array<{ __typename?: 'LifeCycleStep', label: string, approvalType: ApprovalTypeName, completedOn?: string | null }> } | null };

export type Partner_ReturnShippingWidgetQueryVariables = Exact<{
  returnAuthorizationId: Scalars['ID'];
}>;


export type Partner_ReturnShippingWidgetQuery = { __typename?: 'Query', returnAuthorization?: { __typename?: 'ReturnAuthorization', id: string, order: { __typename?: 'Order', id: string, customer: { __typename?: 'Customer', id: string, firstName: string, lastName: string }, shippingAddress: { __typename?: 'Address', street1: string, street2: string, city: string, usState: string, postalCode: string } }, shipment?: { __typename?: 'Shipment', id: string, createdAt: string, carrierCode: string, trackingNumber: string, trackingUrl: string } | null } | null };

export type ReturnedProductsWidgetQueryVariables = Exact<{
  returnAuthorizationId: Scalars['ID'];
  queryAsCustomer: Scalars['Boolean'];
}>;


export type ReturnedProductsWidgetQuery = { __typename?: 'Query', returnAuthorizationLite?: { __typename?: 'ReturnAuthorizationLite', id: string, lineItems: Array<{ __typename?: 'ReturnAuthorizationLineItemLite', id: string, quantity: number, productName: string, sku: string, reasonForReturn: string }> } | null, returnAuthorization?: { __typename?: 'ReturnAuthorization', id: string, lineItems: Array<{ __typename?: 'ReturnAuthorizationLineItem', id: string, quantity: number, reasonForReturn: string, refundAmountCents: string, serialNumber: string, product: { __typename?: 'Product', id: string, name: string, sku: string } }>, itemReceipt?: { __typename?: 'ItemReceipt', id: string, lineItems: Array<{ __typename?: 'ItemReceiptLineItem', id: string, refundAmountCents: string, product: { __typename?: 'Product', id: string, sku: string } }> } | null } | null };

export type ReturnAuthorizationSummaryWidgetQueryVariables = Exact<{
  returnAuthorizationId: Scalars['ID'];
  asCustomer: Scalars['Boolean'];
}>;


export type ReturnAuthorizationSummaryWidgetQuery = { __typename?: 'Query', returnAuthorizationLite?: { __typename?: 'ReturnAuthorizationLite', id: string, returnNumber: string, order: { __typename?: 'OrderLite', id: string, orderNumber: string, storeName: string } } | null, returnAuthorization?: { __typename?: 'ReturnAuthorization', id: string, returnNumber: string, order: { __typename?: 'Order', id: string, orderNumber: string }, store: { __typename?: 'Store', id: string, type: { __typename?: 'StoreType', id: string, name: StoreTypeName, displayName: string } } } | null };

export type AsnSettingsWidgetQueryVariables = Exact<{
  storeId: Scalars['ID'];
}>;


export type AsnSettingsWidgetQuery = { __typename?: 'Query', orderProperties: Array<{ __typename?: 'OrderProperty', id: string, name: OrderPropertyName, displayName: string }>, asnFormat: Array<{ __typename?: 'AsnFormatProperty', id: string, customColumnHeader: string, defaultValue: string, property: { __typename?: 'OrderProperty', id: string, name: OrderPropertyName, displayName: string } }> };

export type SaveAsnFormatMutationVariables = Exact<{
  input: SaveAsnFormatInput;
}>;


export type SaveAsnFormatMutation = { __typename?: 'Mutation', saveAsnFormat: Array<{ __typename?: 'AsnFormatProperty', id: string, customColumnHeader: string, property: { __typename?: 'OrderProperty', id: string, name: OrderPropertyName, displayName: string } }> };

export type AutomatedEmailReportSettingsWidgetQueryVariables = Exact<{
  storeId: Scalars['ID'];
}>;


export type AutomatedEmailReportSettingsWidgetQuery = { __typename?: 'Query', store?: { __typename?: 'Store', id: string, automatedReportEmailRecipient: string } | null };

export type SaveAutomatedEmailReportRecipientMutationVariables = Exact<{
  storeId: Scalars['ID'];
  email: Scalars['String'];
}>;


export type SaveAutomatedEmailReportRecipientMutation = { __typename?: 'Mutation', saveStore?: { __typename?: 'Store', id: string, automatedReportEmailRecipient: string } | null };

export type BrandSettingsWidgetQueryVariables = Exact<{
  storeId: Scalars['ID'];
}>;


export type BrandSettingsWidgetQuery = { __typename?: 'Query', store?: { __typename?: 'Store', id: string, name: string, primaryColorHex: string, secondaryColorHex: string, buttonColorHex: string, logoUrl: string } | null };

export type SaveBrandMutationVariables = Exact<{
  storeId: Scalars['ID'];
  storeName: Scalars['String'];
  primaryColorHex: Scalars['String'];
  secondaryColorHex: Scalars['String'];
  buttonColorHex: Scalars['String'];
  logo?: InputMaybe<Scalars['EncodedFileInput']>;
}>;


export type SaveBrandMutation = { __typename?: 'Mutation', saveStore?: { __typename?: 'Store', id: string, name: string, primaryColorHex: string, secondaryColorHex: string, buttonColorHex: string, logoUrl: string } | null };

export type CsvOrderFormatSettingsWidgetQueryVariables = Exact<{
  storeId: Scalars['ID'];
}>;


export type CsvOrderFormatSettingsWidgetQuery = { __typename?: 'Query', orderProperties: Array<{ __typename?: 'OrderProperty', id: string, name: OrderPropertyName, displayName: string }>, store?: { __typename?: 'Store', id: string, type: { __typename?: 'StoreType', id: string, name: StoreTypeName, displayName: string }, storeSettings: { __typename?: 'StoreSettings', prefixNewOrders: boolean }, customOrderFormatFlow?: { __typename?: 'CustomOrderFormatFlow', id: string, propertyMapping: Array<{ __typename?: 'CustomOrderFormatPropertyMapping', id: string, sourceDataLabel: string, defaultValueOnEmpty: string, mapToProperty: { __typename?: 'OrderProperty', id: string, name: OrderPropertyName, displayName: string } }> } | null } | null };

export type SaveCustomOrderFormatFlowMutationVariables = Exact<{
  input: SaveCustomOrderFormatFlowInput;
  storeId: Scalars['ID'];
  prefixNewOrders: Scalars['Boolean'];
}>;


export type SaveCustomOrderFormatFlowMutation = { __typename?: 'Mutation', saveStore?: { __typename?: 'Store', id: string, storeSettings: { __typename?: 'StoreSettings', prefixNewOrders: boolean } } | null, saveCustomOrderFormatFlow?: { __typename?: 'CustomOrderFormatFlow', id: string } | null };

export type CustomFieldsWidgetQueryVariables = Exact<{
  storeId: Scalars['ID'];
}>;


export type CustomFieldsWidgetQuery = { __typename?: 'Query', store?: { __typename?: 'Store', id: string, creditCardDynamicDescriptor: string, zenDeskUrl: string, additionalSupportText: string } | null };

export type SaveCustomFieldsMutationVariables = Exact<{
  storeId: Scalars['ID'];
  creditCardDynamicDescriptor: Scalars['String'];
  zenDeskUrl: Scalars['String'];
  additionalSupportText: Scalars['String'];
}>;


export type SaveCustomFieldsMutation = { __typename?: 'Mutation', saveStore?: { __typename?: 'Store', id: string, creditCardDynamicDescriptor: string, zenDeskUrl: string, additionalSupportText: string } | null };

export type DynamicDataExampleWidgetQueryVariables = Exact<{
  id: Scalars['ID'];
  queryOrder: Scalars['Boolean'];
}>;


export type DynamicDataExampleWidgetQuery = { __typename?: 'Query', sendGridOrder?: any | null, sendGridReturnAuthorization?: any | null };

export type E1SettingsWidgetQueryVariables = Exact<{
  storeId: Scalars['ID'];
}>;


export type E1SettingsWidgetQuery = { __typename?: 'Query', store?: { __typename?: 'Store', id: string, partner: { __typename?: 'Partner', id: string } } | null };

export type SaveE1SettingsMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type SaveE1SettingsMutation = { __typename?: 'Mutation', saveStore?: { __typename?: 'Store', id: string, partner: { __typename?: 'Partner', id: string } } | null };

export type EmailSettingsWidgetQueryVariables = Exact<{
  storeId: Scalars['ID'];
}>;


export type EmailSettingsWidgetQuery = { __typename?: 'Query', appEvents: Array<{ __typename?: 'AppEvent', id: string, name: AppEventName, displayName: string }>, store?: { __typename?: 'Store', id: string, sendGridFromEmail: string, sendGridFromName: string, emailSettings: Array<{ __typename?: 'StoreEmailSetting', id: string, templateId: string, isActive: boolean, appEvent: { __typename?: 'AppEvent', id: string, name: AppEventName, displayName: string } }> } | null };

export type SaveStoreEmailSettingsMutationVariables = Exact<{
  input: SaveStoreEmailSettingsInput;
}>;


export type SaveStoreEmailSettingsMutation = { __typename?: 'Mutation', saveStoreEmailSettings: Array<{ __typename?: 'StoreEmailSetting', id: string, isActive: boolean, templateId: string, appEvent: { __typename?: 'AppEvent', id: string, name: AppEventName, displayName: string } }> };

export type LineItemUnbundlerWidgetQueryVariables = Exact<{
  storeId: Scalars['ID'];
}>;


export type LineItemUnbundlerWidgetQuery = { __typename?: 'Query', lineItemUnbundlingRules: { __typename?: 'LineItemUnbundlerPage', pageInfo: { __typename?: 'PageInfo', nextPage?: any | null, pages: Array<any>, previousPage?: any | null, totalRows: number }, nodes: Array<{ __typename?: 'LineItemUnbundler', id: string, priceCents: string, productName: string, sku: string, value: string, comparisonOperator: { __typename?: 'ComparisonOperator', id: string, name: ComparisonOperatorName, displayName: string } }> } };

export type NetSuiteSettingsWidgetQueryVariables = Exact<{
  storeId: Scalars['ID'];
}>;


export type NetSuiteSettingsWidgetQuery = { __typename?: 'Query', store?: { __typename?: 'Store', id: string, packingSlipInformation: string, netSuiteClientInternalId: string, type: { __typename?: 'StoreType', id: string, name: StoreTypeName, displayName: string }, salesChannel: { __typename?: 'SalesChannel', id: string, name: SalesChannelName, displayName: string }, department?: { __typename?: 'NetSuiteDepartment', id: string } | null, inventoryLocation?: { __typename?: 'NetSuiteInventoryLocation', id: string } | null, brand?: { __typename?: 'NetSuiteBrand', id: string } | null, subsidiary?: { __typename?: 'NetSuiteSubsidiary', id: string } | null, taxItem?: { __typename?: 'NetSuiteTaxItem', id: string } | null, salesRepresentativeEmployee?: { __typename?: 'Employee', id: string, fullName: string } | null } | null };

export type SaveNetSuiteSettingsMutationVariables = Exact<{
  storeId: Scalars['ID'];
  salesChannel: SalesChannelName;
  departmentId: Scalars['ID'];
  subsidiaryId: Scalars['ID'];
  inventoryLocationId: Scalars['ID'];
  brandId: Scalars['ID'];
  taxItemId: Scalars['ID'];
  packingSlipInformation: Scalars['String'];
  netSuiteClientInternalId: Scalars['String'];
  salesRepresentativeEmployeeId?: InputMaybe<Scalars['ID']>;
}>;


export type SaveNetSuiteSettingsMutation = { __typename?: 'Mutation', saveStore?: { __typename?: 'Store', id: string, department?: { __typename?: 'NetSuiteDepartment', id: string } | null, inventoryLocation?: { __typename?: 'NetSuiteInventoryLocation', id: string } | null, subsidiary?: { __typename?: 'NetSuiteSubsidiary', id: string } | null } | null };

export type PaymentMethodWidgetQueryVariables = Exact<{
  storeId: Scalars['ID'];
}>;


export type PaymentMethodWidgetQuery = { __typename?: 'Query', allRawPaymentMethods: Array<string>, store?: { __typename?: 'Store', id: string, subsidiary?: { __typename?: 'NetSuiteSubsidiary', id: string } | null, paymentMethodMappings: Array<{ __typename?: 'PaymentMethodMapping', id: string, isTaxable: boolean, paymentMethodText: string, paymentMethod: { __typename?: 'NetSuitePaymentMethod', id: string, name: string, internalId: string } }> } | null };

export type SavePaymentMethodMappingsMutationVariables = Exact<{
  input: SavePaymentMethodMappingsInput;
}>;


export type SavePaymentMethodMappingsMutation = { __typename?: 'Mutation', savePaymentMethodMappings: boolean };

export type RepairCodesWidgetQueryVariables = Exact<{
  storeId: Scalars['ID'];
}>;


export type RepairCodesWidgetQuery = { __typename?: 'Query', store?: { __typename?: 'Store', id: string, repairCodes: Array<{ __typename?: 'RepairCode', id: string, repairCode: string }> } | null };

export type SaveRepairCodesMutationVariables = Exact<{
  input: SaveRepairCodesInput;
}>;


export type SaveRepairCodesMutation = { __typename?: 'Mutation', saveRepairCodes: Array<{ __typename?: 'RepairCode', id: string, repairCode: string }> };

export type ReturnLabelSettingsWidgetQueryVariables = Exact<{
  storeId: Scalars['ID'];
}>;


export type ReturnLabelSettingsWidgetQuery = { __typename?: 'Query', store?: { __typename?: 'Store', id: string, tier1PrintRequestLabelType: string, printRequestFunctionInternalId: string, printRequestLabelInternalId: string, printRequestPrinterInternalId: string } | null };

export type SaveTier1PrintRequestLabelTypeMutationVariables = Exact<{
  storeId: Scalars['ID'];
  tier1PrintRequestLabelType: Scalars['String'];
  printRequestFunctionInternalId: Scalars['String'];
  printRequestLabelInternalId: Scalars['String'];
  printRequestPrinterInternalId: Scalars['String'];
}>;


export type SaveTier1PrintRequestLabelTypeMutation = { __typename?: 'Mutation', saveStore?: { __typename?: 'Store', id: string, tier1PrintRequestLabelType: string } | null };

export type SaveShippingServicesMutationVariables = Exact<{
  input: SaveShippingServicesInput;
}>;


export type SaveShippingServicesMutation = { __typename?: 'Mutation', saveShippingServices: boolean };

export type ShippingServiceWidgetQueryVariables = Exact<{
  storeId: Scalars['ID'];
}>;


export type ShippingServiceWidgetQuery = { __typename?: 'Query', notMappedRequestedShippingServices: Array<string>, store?: { __typename?: 'Store', id: string, subsidiary?: { __typename?: 'NetSuiteSubsidiary', id: string } | null, shippingServices: Array<{ __typename?: 'ShippingService', id: string, requestedShippingService: string, shipItem?: { __typename?: 'ShipItem', id: string } | null, thirdPartyAccount?: { __typename?: 'ThirdPartyAccount', id: string } | null }> } | null };

export type SaveSoftwareVersionsMutationVariables = Exact<{
  input: SaveSoftwareVersionsInput;
}>;


export type SaveSoftwareVersionsMutation = { __typename?: 'Mutation', saveSoftwareVersions: Array<{ __typename?: 'SoftwareVersion', id: string, name: string }> };

export type SoftwareVersionsWidgetQueryVariables = Exact<{
  storeId: Scalars['ID'];
}>;


export type SoftwareVersionsWidgetQuery = { __typename?: 'Query', store?: { __typename?: 'Store', id: string, softwareVersions: Array<{ __typename?: 'SoftwareVersion', id: string, name: string }> } | null };

export type SaveTriageReasonsMutationVariables = Exact<{
  input: SaveTriageReasonsInput;
}>;


export type SaveTriageReasonsMutation = { __typename?: 'Mutation', saveTriageReasons: Array<{ __typename?: 'TriageReason', id: string, reasonText: string }> };

export type TriageReasonsWidgetQueryVariables = Exact<{
  storeId: Scalars['ID'];
}>;


export type TriageReasonsWidgetQuery = { __typename?: 'Query', store?: { __typename?: 'Store', id: string, triageReasons: Array<{ __typename?: 'TriageReason', id: string, reasonText: string }> } | null };

export type SaveTriageWorkflowsMutationVariables = Exact<{
  input: SaveTriageWorkflowsInput;
}>;


export type SaveTriageWorkflowsMutation = { __typename?: 'Mutation', saveTriageWorkflows?: Array<{ __typename?: 'TriageWorkflow', id: string, name: string, netSuiteBinInternalId: string, isEnabled: boolean, type: { __typename?: 'TriageWorkflowType', id: string, name: TriageWorkflowTypeName, displayName: string } } | null> | null };

export type TriageWorkflowsWidgetQueryVariables = Exact<{
  storeId: Scalars['ID'];
}>;


export type TriageWorkflowsWidgetQuery = { __typename?: 'Query', store?: { __typename?: 'Store', id: string, triageWorkflows: Array<{ __typename?: 'TriageWorkflow', id: string, name: string, isEnabled: boolean, netSuiteBinInternalId: string, type: { __typename?: 'TriageWorkflowType', id: string, name: TriageWorkflowTypeName, displayName: string } }> } | null };

export type BeginTriageModalQueryVariables = Exact<{
  returnAuthorizationId: Scalars['ID'];
}>;


export type BeginTriageModalQuery = { __typename?: 'Query', tier1ReturnAuthorization?: { __typename?: 'Tier1ReturnAuthorization', id: string, returnNumber: string, problemStatements: Array<string>, customerComment: string, itemReceipt?: { __typename?: 'Tier1ItemReceipt', id: string, serialNumber: string, item: { __typename?: 'Item', id: string, sku: string, name: string } } | null, group: { __typename?: 'Tier1ReturnAuthorizationGroup', id: string, referenceNumber: string, store: { __typename?: 'Store', id: string } } } | null };

export type SaveTriageObservationMutationVariables = Exact<{
  input: SaveTriageObservationInput;
}>;


export type SaveTriageObservationMutation = { __typename?: 'Mutation', saveTriageObservation?: { __typename?: 'Tier1ReturnAuthorization', id: string, observation?: { __typename?: 'TriageObservation', id: string, createdTimestamp: string, reasonText: string, createdBy: { __typename?: 'SiteUserFull', id: string, fullName: string, email: string } } | null } | null };

export type CreditReturnAuthorizationModalQueryVariables = Exact<{
  returnAuthorizationId: Scalars['ID'];
}>;


export type CreditReturnAuthorizationModalQuery = { __typename?: 'Query', tier1ReturnAuthorization?: { __typename?: 'Tier1ReturnAuthorization', id: string, itemReceipt?: { __typename?: 'Tier1ItemReceipt', id: string, serialNumber: string } | null, group: { __typename?: 'Tier1ReturnAuthorizationGroup', id: string, store: { __typename?: 'Store', id: string, triageWorkflows: Array<{ __typename?: 'TriageWorkflow', id: string, type: { __typename?: 'TriageWorkflowType', id: string, name: TriageWorkflowTypeName, displayName: string } }> } } } | null };

export type SubmitQualityControlCheckMutationVariables = Exact<{
  input: SubmitQualityControlCheckInput;
}>;


export type SubmitQualityControlCheckMutation = { __typename?: 'Mutation', submitQualityControlCheck?: { __typename?: 'Tier1ReturnAuthorization', id: string, qualityControlCheck?: { __typename?: 'QualityControlCheck', id: string, createdTimestamp: string } | null } | null };

export type ReceiveTier1ReturnAuthorizationMutationVariables = Exact<{
  input: ReceiveTier1ReturnAuthorizationInput;
}>;


export type ReceiveTier1ReturnAuthorizationMutation = { __typename?: 'Mutation', receiveTier1ReturnAuthorization?: { __typename?: 'Tier1ReturnAuthorization', id: string, itemReceipt?: { __typename?: 'Tier1ItemReceipt', id: string, createdTimestamp: string, serialNumber: string, createdBy: { __typename?: 'SiteUserFull', id: string, fullName: string }, item: { __typename?: 'Item', id: string, sku: string, name: string } } | null } | null };

export type ReceiveTier1ReturnAuthorizationModalQueryVariables = Exact<{
  returnAuthorizationId: Scalars['ID'];
}>;


export type ReceiveTier1ReturnAuthorizationModalQuery = { __typename?: 'Query', tier1ReturnAuthorization?: { __typename?: 'Tier1ReturnAuthorization', id: string, expectedSerialNumber: string, item: { __typename?: 'Item', id: string, sku: string, name: string } } | null };

export type ReplaceItemModalQueryVariables = Exact<{
  returnAuthorizationId: Scalars['ID'];
}>;


export type ReplaceItemModalQuery = { __typename?: 'Query', tier1ReturnAuthorization?: { __typename?: 'Tier1ReturnAuthorization', id: string, itemReceipt?: { __typename?: 'Tier1ItemReceipt', id: string, serialNumber: string } | null, group: { __typename?: 'Tier1ReturnAuthorizationGroup', id: string, store: { __typename?: 'Store', id: string, triageWorkflows: Array<{ __typename?: 'TriageWorkflow', id: string, netSuiteBinInternalId: string, type: { __typename?: 'TriageWorkflowType', id: string, name: TriageWorkflowTypeName, displayName: string } }> } } } | null };

export type RestockItemModalQueryVariables = Exact<{
  returnAuthorizationId: Scalars['ID'];
}>;


export type RestockItemModalQuery = { __typename?: 'Query', tier1ReturnAuthorization?: { __typename?: 'Tier1ReturnAuthorization', id: string, group: { __typename?: 'Tier1ReturnAuthorizationGroup', id: string, store: { __typename?: 'Store', id: string, triageWorkflows: Array<{ __typename?: 'TriageWorkflow', id: string, netSuiteBinInternalId: string, type: { __typename?: 'TriageWorkflowType', id: string, name: TriageWorkflowTypeName, displayName: string } }> } }, itemReceipt?: { __typename?: 'Tier1ItemReceipt', id: string, item: { __typename?: 'Item', id: string, name: string, sku: string } } | null, selectedTriage?: { __typename?: 'ReturnAuthorizationTriage', id: string, createdTimestamp: string, workflow: { __typename?: 'TriageWorkflow', id: string, type: { __typename?: 'TriageWorkflowType', id: string, name: TriageWorkflowTypeName, displayName: string } } } | null } | null };

export type ReturnItemModalQueryVariables = Exact<{
  returnAuthorizationId: Scalars['ID'];
}>;


export type ReturnItemModalQuery = { __typename?: 'Query', tier1ReturnAuthorization?: { __typename?: 'Tier1ReturnAuthorization', id: string, itemReceipt?: { __typename?: 'Tier1ItemReceipt', id: string, serialNumber: string } | null, group: { __typename?: 'Tier1ReturnAuthorizationGroup', id: string, store: { __typename?: 'Store', id: string, triageWorkflows: Array<{ __typename?: 'TriageWorkflow', id: string, netSuiteBinInternalId: string, type: { __typename?: 'TriageWorkflowType', id: string, name: TriageWorkflowTypeName, displayName: string } }> } } } | null };

export type ScrapItemModalQueryVariables = Exact<{
  returnAuthorizationId: Scalars['ID'];
}>;


export type ScrapItemModalQuery = { __typename?: 'Query', tier1ReturnAuthorization?: { __typename?: 'Tier1ReturnAuthorization', id: string, itemReceipt?: { __typename?: 'Tier1ItemReceipt', id: string, serialNumber: string } | null, group: { __typename?: 'Tier1ReturnAuthorizationGroup', id: string, store: { __typename?: 'Store', id: string, triageWorkflows: Array<{ __typename?: 'TriageWorkflow', id: string, netSuiteBinInternalId: string, type: { __typename?: 'TriageWorkflowType', id: string, name: TriageWorkflowTypeName, displayName: string } }> } } } | null };

export type TriageTier1ReturnAuthorizationMutationVariables = Exact<{
  input: TriageTier1ReturnAuthorizationInput;
}>;


export type TriageTier1ReturnAuthorizationMutation = { __typename?: 'Mutation', triageTier1ReturnAuthorization?: { __typename?: 'Tier1ReturnAuthorization', id: string, createdTimestamp: string, itemReceipt?: { __typename?: 'Tier1ItemReceipt', id: string, createdTimestamp: string } | null, observation?: { __typename?: 'TriageObservation', id: string, createdTimestamp: string } | null, selectedTriage?: { __typename?: 'ReturnAuthorizationTriage', id: string, createdTimestamp: string, workflow: { __typename?: 'TriageWorkflow', id: string, type: { __typename?: 'TriageWorkflowType', id: string, name: TriageWorkflowTypeName, displayName: string } } } | null, group: { __typename?: 'Tier1ReturnAuthorizationGroup', id: string, referenceNumber: string, store: { __typename?: 'Store', id: string, name: string } } } | null };

export const EnumPermissionFieldsFragmentDoc = gql`
    fragment enumPermissionFields on Permission {
  id
  name
  displayName
  group {
    id
    name
    displayName
  }
}
    `;
export const PageInfoFieldsFragmentDoc = gql`
    fragment pageInfoFields on PageInfo {
  nextPage
  pages
  previousPage
  totalRows
}
    `;
export const ScheduledJobTable_ScheduledJobFieldsFragmentDoc = gql`
    fragment scheduledJobTable_scheduledJobFields on ScheduledJob {
  id
  isActive
  windowStartTime
  windowEndTime
  repeatPeriodSeconds
  isIndependent
  averageRunTimeSeconds
  runParameters
  runs(options: {paginationInput: {first: 10}}) {
    pageInfo {
      ...pageInfoFields
    }
    nodes {
      id
      startTimestamp
      endTimestamp
    }
  }
  daemon {
    id
    name
    displayName
  }
}
    ${PageInfoFieldsFragmentDoc}`;
export const InventoryActivity_ItemTabItemFieldsFragmentDoc = gql`
    fragment inventoryActivity_itemTabItemFields on Item {
  id
  sku
  name
  defaultPriceDollars
  defaultWholesalePriceDollars
  defaultCostDollars
  listingManagementStrategyCount
  currentQuantity
  itemQtyLastModifiedDate
  itemLastModifiedDate
}
    `;
export const NetSuiteRecordFieldsFragmentDoc = gql`
    fragment netSuiteRecordFields on NetSuiteRecord {
  id
  createdAt
  netSuiteInternalId
  recordUrl
  transactionId
}
    `;
export const WriteRequestFieldsFragmentDoc = gql`
    fragment writeRequestFields on NetSuiteWriteRequest {
  id
  validationErrors
}
    `;
export const ReturnAuthorizationTriageFieldsFragmentDoc = gql`
    fragment returnAuthorizationTriageFields on ReturnAuthorizationTriage {
  id
  createdTimestamp
  workflow {
    id
    type {
      id
      name
      displayName
    }
  }
}
    `;
export const AdministratorInvitesWidgetDocument = gql`
    query AdministratorInvitesWidget {
  invites(input: {onlyAdministrators: true}) {
    pageInfo {
      ...pageInfoFields
    }
    nodes {
      id
      recipientEmail
      sentTimestamp
      claimant {
        id
      }
    }
  }
}
    ${PageInfoFieldsFragmentDoc}`;

/**
 * __useAdministratorInvitesWidgetQuery__
 *
 * To run a query within a React component, call `useAdministratorInvitesWidgetQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdministratorInvitesWidgetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdministratorInvitesWidgetQuery({
 *   variables: {
 *   },
 * });
 */
export function useAdministratorInvitesWidgetQuery(baseOptions?: Apollo.QueryHookOptions<AdministratorInvitesWidgetQuery, AdministratorInvitesWidgetQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdministratorInvitesWidgetQuery, AdministratorInvitesWidgetQueryVariables>(AdministratorInvitesWidgetDocument, options);
      }
export function useAdministratorInvitesWidgetLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdministratorInvitesWidgetQuery, AdministratorInvitesWidgetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdministratorInvitesWidgetQuery, AdministratorInvitesWidgetQueryVariables>(AdministratorInvitesWidgetDocument, options);
        }
export type AdministratorInvitesWidgetQueryHookResult = ReturnType<typeof useAdministratorInvitesWidgetQuery>;
export type AdministratorInvitesWidgetLazyQueryHookResult = ReturnType<typeof useAdministratorInvitesWidgetLazyQuery>;
export type AdministratorInvitesWidgetQueryResult = Apollo.QueryResult<AdministratorInvitesWidgetQuery, AdministratorInvitesWidgetQueryVariables>;
export const AdministratorsWidgetDocument = gql`
    query AdministratorsWidget {
  siteUsers(options: {}) {
    pageInfo {
      ...pageInfoFields
    }
    nodes {
      id
      email
      fullName
      status {
        id
        name
        displayName
      }
    }
  }
}
    ${PageInfoFieldsFragmentDoc}`;

/**
 * __useAdministratorsWidgetQuery__
 *
 * To run a query within a React component, call `useAdministratorsWidgetQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdministratorsWidgetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdministratorsWidgetQuery({
 *   variables: {
 *   },
 * });
 */
export function useAdministratorsWidgetQuery(baseOptions?: Apollo.QueryHookOptions<AdministratorsWidgetQuery, AdministratorsWidgetQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdministratorsWidgetQuery, AdministratorsWidgetQueryVariables>(AdministratorsWidgetDocument, options);
      }
export function useAdministratorsWidgetLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdministratorsWidgetQuery, AdministratorsWidgetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdministratorsWidgetQuery, AdministratorsWidgetQueryVariables>(AdministratorsWidgetDocument, options);
        }
export type AdministratorsWidgetQueryHookResult = ReturnType<typeof useAdministratorsWidgetQuery>;
export type AdministratorsWidgetLazyQueryHookResult = ReturnType<typeof useAdministratorsWidgetLazyQuery>;
export type AdministratorsWidgetQueryResult = Apollo.QueryResult<AdministratorsWidgetQuery, AdministratorsWidgetQueryVariables>;
export const SaveUserDocument = gql`
    mutation SaveUser($input: SaveUserInput!) {
  saveUser(input: $input) {
    id
    status {
      id
      name
      displayName
    }
  }
}
    `;
export type SaveUserMutationFn = Apollo.MutationFunction<SaveUserMutation, SaveUserMutationVariables>;

/**
 * __useSaveUserMutation__
 *
 * To run a mutation, you first call `useSaveUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveUserMutation, { data, loading, error }] = useSaveUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveUserMutation(baseOptions?: Apollo.MutationHookOptions<SaveUserMutation, SaveUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveUserMutation, SaveUserMutationVariables>(SaveUserDocument, options);
      }
export type SaveUserMutationHookResult = ReturnType<typeof useSaveUserMutation>;
export type SaveUserMutationResult = Apollo.MutationResult<SaveUserMutation>;
export type SaveUserMutationOptions = Apollo.BaseMutationOptions<SaveUserMutation, SaveUserMutationVariables>;
export const AppSettings_AssignedPermissionsTabDocument = gql`
    query AppSettings_AssignedPermissionsTab {
  siteUsers(options: {}) {
    pageInfo {
      ...pageInfoFields
    }
    nodes {
      id
      email
      fullName
      assignedRoles {
        id
      }
    }
  }
}
    ${PageInfoFieldsFragmentDoc}`;

/**
 * __useAppSettings_AssignedPermissionsTabQuery__
 *
 * To run a query within a React component, call `useAppSettings_AssignedPermissionsTabQuery` and pass it any options that fit your needs.
 * When your component renders, `useAppSettings_AssignedPermissionsTabQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAppSettings_AssignedPermissionsTabQuery({
 *   variables: {
 *   },
 * });
 */
export function useAppSettings_AssignedPermissionsTabQuery(baseOptions?: Apollo.QueryHookOptions<AppSettings_AssignedPermissionsTabQuery, AppSettings_AssignedPermissionsTabQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AppSettings_AssignedPermissionsTabQuery, AppSettings_AssignedPermissionsTabQueryVariables>(AppSettings_AssignedPermissionsTabDocument, options);
      }
export function useAppSettings_AssignedPermissionsTabLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AppSettings_AssignedPermissionsTabQuery, AppSettings_AssignedPermissionsTabQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AppSettings_AssignedPermissionsTabQuery, AppSettings_AssignedPermissionsTabQueryVariables>(AppSettings_AssignedPermissionsTabDocument, options);
        }
export type AppSettings_AssignedPermissionsTabQueryHookResult = ReturnType<typeof useAppSettings_AssignedPermissionsTabQuery>;
export type AppSettings_AssignedPermissionsTabLazyQueryHookResult = ReturnType<typeof useAppSettings_AssignedPermissionsTabLazyQuery>;
export type AppSettings_AssignedPermissionsTabQueryResult = Apollo.QueryResult<AppSettings_AssignedPermissionsTabQuery, AppSettings_AssignedPermissionsTabQueryVariables>;
export const AssignRoleDocument = gql`
    mutation AssignRole($input: AssignRoleInput!) {
  assignRole(input: $input) {
    id
  }
}
    `;
export type AssignRoleMutationFn = Apollo.MutationFunction<AssignRoleMutation, AssignRoleMutationVariables>;

/**
 * __useAssignRoleMutation__
 *
 * To run a mutation, you first call `useAssignRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssignRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assignRoleMutation, { data, loading, error }] = useAssignRoleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAssignRoleMutation(baseOptions?: Apollo.MutationHookOptions<AssignRoleMutation, AssignRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AssignRoleMutation, AssignRoleMutationVariables>(AssignRoleDocument, options);
      }
export type AssignRoleMutationHookResult = ReturnType<typeof useAssignRoleMutation>;
export type AssignRoleMutationResult = Apollo.MutationResult<AssignRoleMutation>;
export type AssignRoleMutationOptions = Apollo.BaseMutationOptions<AssignRoleMutation, AssignRoleMutationVariables>;
export const AssignRoleModalDocument = gql`
    query AssignRoleModal($siteUserId: ID!) {
  siteUser(id: $siteUserId) {
    id
    assignedRoles {
      id
      roleTemplate {
        id
      }
      store {
        id
      }
    }
  }
}
    `;

/**
 * __useAssignRoleModalQuery__
 *
 * To run a query within a React component, call `useAssignRoleModalQuery` and pass it any options that fit your needs.
 * When your component renders, `useAssignRoleModalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAssignRoleModalQuery({
 *   variables: {
 *      siteUserId: // value for 'siteUserId'
 *   },
 * });
 */
export function useAssignRoleModalQuery(baseOptions: Apollo.QueryHookOptions<AssignRoleModalQuery, AssignRoleModalQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AssignRoleModalQuery, AssignRoleModalQueryVariables>(AssignRoleModalDocument, options);
      }
export function useAssignRoleModalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AssignRoleModalQuery, AssignRoleModalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AssignRoleModalQuery, AssignRoleModalQueryVariables>(AssignRoleModalDocument, options);
        }
export type AssignRoleModalQueryHookResult = ReturnType<typeof useAssignRoleModalQuery>;
export type AssignRoleModalLazyQueryHookResult = ReturnType<typeof useAssignRoleModalLazyQuery>;
export type AssignRoleModalQueryResult = Apollo.QueryResult<AssignRoleModalQuery, AssignRoleModalQueryVariables>;
export const UnassignRoleDocument = gql`
    mutation UnassignRole($id: ID!) {
  unassignRole(id: $id)
}
    `;
export type UnassignRoleMutationFn = Apollo.MutationFunction<UnassignRoleMutation, UnassignRoleMutationVariables>;

/**
 * __useUnassignRoleMutation__
 *
 * To run a mutation, you first call `useUnassignRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnassignRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unassignRoleMutation, { data, loading, error }] = useUnassignRoleMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUnassignRoleMutation(baseOptions?: Apollo.MutationHookOptions<UnassignRoleMutation, UnassignRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnassignRoleMutation, UnassignRoleMutationVariables>(UnassignRoleDocument, options);
      }
export type UnassignRoleMutationHookResult = ReturnType<typeof useUnassignRoleMutation>;
export type UnassignRoleMutationResult = Apollo.MutationResult<UnassignRoleMutation>;
export type UnassignRoleMutationOptions = Apollo.BaseMutationOptions<UnassignRoleMutation, UnassignRoleMutationVariables>;
export const AppSettings_AssignedPermissionsTab_UserDetailSectionDocument = gql`
    query AppSettings_AssignedPermissionsTab_UserDetailSection($siteUserId: ID!) {
  siteUser(id: $siteUserId) {
    id
    email
    fullName
    assignedRoles {
      id
      roleTemplate {
        id
        displayName
      }
      store {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useAppSettings_AssignedPermissionsTab_UserDetailSectionQuery__
 *
 * To run a query within a React component, call `useAppSettings_AssignedPermissionsTab_UserDetailSectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useAppSettings_AssignedPermissionsTab_UserDetailSectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAppSettings_AssignedPermissionsTab_UserDetailSectionQuery({
 *   variables: {
 *      siteUserId: // value for 'siteUserId'
 *   },
 * });
 */
export function useAppSettings_AssignedPermissionsTab_UserDetailSectionQuery(baseOptions: Apollo.QueryHookOptions<AppSettings_AssignedPermissionsTab_UserDetailSectionQuery, AppSettings_AssignedPermissionsTab_UserDetailSectionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AppSettings_AssignedPermissionsTab_UserDetailSectionQuery, AppSettings_AssignedPermissionsTab_UserDetailSectionQueryVariables>(AppSettings_AssignedPermissionsTab_UserDetailSectionDocument, options);
      }
export function useAppSettings_AssignedPermissionsTab_UserDetailSectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AppSettings_AssignedPermissionsTab_UserDetailSectionQuery, AppSettings_AssignedPermissionsTab_UserDetailSectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AppSettings_AssignedPermissionsTab_UserDetailSectionQuery, AppSettings_AssignedPermissionsTab_UserDetailSectionQueryVariables>(AppSettings_AssignedPermissionsTab_UserDetailSectionDocument, options);
        }
export type AppSettings_AssignedPermissionsTab_UserDetailSectionQueryHookResult = ReturnType<typeof useAppSettings_AssignedPermissionsTab_UserDetailSectionQuery>;
export type AppSettings_AssignedPermissionsTab_UserDetailSectionLazyQueryHookResult = ReturnType<typeof useAppSettings_AssignedPermissionsTab_UserDetailSectionLazyQuery>;
export type AppSettings_AssignedPermissionsTab_UserDetailSectionQueryResult = Apollo.QueryResult<AppSettings_AssignedPermissionsTab_UserDetailSectionQuery, AppSettings_AssignedPermissionsTab_UserDetailSectionQueryVariables>;
export const AppSettingsActivity_RolesTabDocument = gql`
    query AppSettingsActivity_RolesTab {
  permissionGroups {
    id
    name
    displayName
    permissions {
      ...enumPermissionFields
    }
  }
  userRoleTemplates {
    pageInfo {
      ...pageInfoFields
    }
    nodes {
      id
      displayName
      description
      visibilityScope {
        id
        name
        displayName
      }
      permissions {
        ...enumPermissionFields
      }
    }
  }
}
    ${EnumPermissionFieldsFragmentDoc}
${PageInfoFieldsFragmentDoc}`;

/**
 * __useAppSettingsActivity_RolesTabQuery__
 *
 * To run a query within a React component, call `useAppSettingsActivity_RolesTabQuery` and pass it any options that fit your needs.
 * When your component renders, `useAppSettingsActivity_RolesTabQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAppSettingsActivity_RolesTabQuery({
 *   variables: {
 *   },
 * });
 */
export function useAppSettingsActivity_RolesTabQuery(baseOptions?: Apollo.QueryHookOptions<AppSettingsActivity_RolesTabQuery, AppSettingsActivity_RolesTabQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AppSettingsActivity_RolesTabQuery, AppSettingsActivity_RolesTabQueryVariables>(AppSettingsActivity_RolesTabDocument, options);
      }
export function useAppSettingsActivity_RolesTabLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AppSettingsActivity_RolesTabQuery, AppSettingsActivity_RolesTabQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AppSettingsActivity_RolesTabQuery, AppSettingsActivity_RolesTabQueryVariables>(AppSettingsActivity_RolesTabDocument, options);
        }
export type AppSettingsActivity_RolesTabQueryHookResult = ReturnType<typeof useAppSettingsActivity_RolesTabQuery>;
export type AppSettingsActivity_RolesTabLazyQueryHookResult = ReturnType<typeof useAppSettingsActivity_RolesTabLazyQuery>;
export type AppSettingsActivity_RolesTabQueryResult = Apollo.QueryResult<AppSettingsActivity_RolesTabQuery, AppSettingsActivity_RolesTabQueryVariables>;
export const DeleteUserRoleTemplateDocument = gql`
    mutation DeleteUserRoleTemplate($id: ID!) {
  deleteUserRoleTemplate(id: $id)
}
    `;
export type DeleteUserRoleTemplateMutationFn = Apollo.MutationFunction<DeleteUserRoleTemplateMutation, DeleteUserRoleTemplateMutationVariables>;

/**
 * __useDeleteUserRoleTemplateMutation__
 *
 * To run a mutation, you first call `useDeleteUserRoleTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteUserRoleTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteUserRoleTemplateMutation, { data, loading, error }] = useDeleteUserRoleTemplateMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteUserRoleTemplateMutation(baseOptions?: Apollo.MutationHookOptions<DeleteUserRoleTemplateMutation, DeleteUserRoleTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteUserRoleTemplateMutation, DeleteUserRoleTemplateMutationVariables>(DeleteUserRoleTemplateDocument, options);
      }
export type DeleteUserRoleTemplateMutationHookResult = ReturnType<typeof useDeleteUserRoleTemplateMutation>;
export type DeleteUserRoleTemplateMutationResult = Apollo.MutationResult<DeleteUserRoleTemplateMutation>;
export type DeleteUserRoleTemplateMutationOptions = Apollo.BaseMutationOptions<DeleteUserRoleTemplateMutation, DeleteUserRoleTemplateMutationVariables>;
export const SaveUserRoleTemplateDocument = gql`
    mutation SaveUserRoleTemplate($input: SaveUserRoleTemplateInput!) {
  saveUserRoleTemplate(input: $input) {
    id
    displayName
    description
    permissions {
      id
      name
      displayName
    }
  }
}
    `;
export type SaveUserRoleTemplateMutationFn = Apollo.MutationFunction<SaveUserRoleTemplateMutation, SaveUserRoleTemplateMutationVariables>;

/**
 * __useSaveUserRoleTemplateMutation__
 *
 * To run a mutation, you first call `useSaveUserRoleTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveUserRoleTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveUserRoleTemplateMutation, { data, loading, error }] = useSaveUserRoleTemplateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveUserRoleTemplateMutation(baseOptions?: Apollo.MutationHookOptions<SaveUserRoleTemplateMutation, SaveUserRoleTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveUserRoleTemplateMutation, SaveUserRoleTemplateMutationVariables>(SaveUserRoleTemplateDocument, options);
      }
export type SaveUserRoleTemplateMutationHookResult = ReturnType<typeof useSaveUserRoleTemplateMutation>;
export type SaveUserRoleTemplateMutationResult = Apollo.MutationResult<SaveUserRoleTemplateMutation>;
export type SaveUserRoleTemplateMutationOptions = Apollo.BaseMutationOptions<SaveUserRoleTemplateMutation, SaveUserRoleTemplateMutationVariables>;
export const AppleCareAgreementsActivityDocument = gql`
    query AppleCareAgreementsActivity($cursor: Cursor, $filter: QueryAppleCareAgreementsFilterInput, $sort: QueryAppleCareAgreementsSortInput) {
  appleCareAgreements(
    options: {paginationInput: {after: $cursor, first: 20}, filter: $filter, sort: $sort}
  ) {
    pageInfo {
      ...pageInfoFields
    }
    nodes {
      id
      agreementNumber
      activatedAt
      serialNumber
      lineItem {
        id
        order {
          id
          orderNumber
          orderDate
          store {
            id
          }
        }
        product {
          id
          name
          sku
        }
      }
      apiRequests(options: {}) {
        pageInfo {
          ...pageInfoFields
        }
        nodes {
          id
          metaCreated
          method
          url
          httpStatusCode
          requestBody
          responseBody
        }
      }
    }
  }
}
    ${PageInfoFieldsFragmentDoc}`;

/**
 * __useAppleCareAgreementsActivityQuery__
 *
 * To run a query within a React component, call `useAppleCareAgreementsActivityQuery` and pass it any options that fit your needs.
 * When your component renders, `useAppleCareAgreementsActivityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAppleCareAgreementsActivityQuery({
 *   variables: {
 *      cursor: // value for 'cursor'
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useAppleCareAgreementsActivityQuery(baseOptions?: Apollo.QueryHookOptions<AppleCareAgreementsActivityQuery, AppleCareAgreementsActivityQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AppleCareAgreementsActivityQuery, AppleCareAgreementsActivityQueryVariables>(AppleCareAgreementsActivityDocument, options);
      }
export function useAppleCareAgreementsActivityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AppleCareAgreementsActivityQuery, AppleCareAgreementsActivityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AppleCareAgreementsActivityQuery, AppleCareAgreementsActivityQueryVariables>(AppleCareAgreementsActivityDocument, options);
        }
export type AppleCareAgreementsActivityQueryHookResult = ReturnType<typeof useAppleCareAgreementsActivityQuery>;
export type AppleCareAgreementsActivityLazyQueryHookResult = ReturnType<typeof useAppleCareAgreementsActivityLazyQuery>;
export type AppleCareAgreementsActivityQueryResult = Apollo.QueryResult<AppleCareAgreementsActivityQuery, AppleCareAgreementsActivityQueryVariables>;
export const CustomersActivityDocument = gql`
    query CustomersActivity($page: Cursor, $filter: QueryCustomersFilterInput, $sort: QueryCustomersSortInput) {
  customers(
    options: {paginationInput: {after: $page, first: 20}, filter: $filter, sort: $sort}
  ) {
    pageInfo {
      ...pageInfoFields
    }
    nodes {
      id
      email
      firstName
      lastName
      phoneNumber
      netSuiteRecord {
        ...netSuiteRecordFields
      }
    }
  }
}
    ${PageInfoFieldsFragmentDoc}
${NetSuiteRecordFieldsFragmentDoc}`;

/**
 * __useCustomersActivityQuery__
 *
 * To run a query within a React component, call `useCustomersActivityQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomersActivityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomersActivityQuery({
 *   variables: {
 *      page: // value for 'page'
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useCustomersActivityQuery(baseOptions?: Apollo.QueryHookOptions<CustomersActivityQuery, CustomersActivityQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CustomersActivityQuery, CustomersActivityQueryVariables>(CustomersActivityDocument, options);
      }
export function useCustomersActivityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CustomersActivityQuery, CustomersActivityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CustomersActivityQuery, CustomersActivityQueryVariables>(CustomersActivityDocument, options);
        }
export type CustomersActivityQueryHookResult = ReturnType<typeof useCustomersActivityQuery>;
export type CustomersActivityLazyQueryHookResult = ReturnType<typeof useCustomersActivityLazyQuery>;
export type CustomersActivityQueryResult = Apollo.QueryResult<CustomersActivityQuery, CustomersActivityQueryVariables>;
export const EditCustomerModalDocument = gql`
    query EditCustomerModal($customerId: ID!) {
  customer(id: $customerId) {
    id
    firstName
    lastName
    email
    phoneNumber
    netSuiteRecord {
      ...netSuiteRecordFields
    }
  }
}
    ${NetSuiteRecordFieldsFragmentDoc}`;

/**
 * __useEditCustomerModalQuery__
 *
 * To run a query within a React component, call `useEditCustomerModalQuery` and pass it any options that fit your needs.
 * When your component renders, `useEditCustomerModalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEditCustomerModalQuery({
 *   variables: {
 *      customerId: // value for 'customerId'
 *   },
 * });
 */
export function useEditCustomerModalQuery(baseOptions: Apollo.QueryHookOptions<EditCustomerModalQuery, EditCustomerModalQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EditCustomerModalQuery, EditCustomerModalQueryVariables>(EditCustomerModalDocument, options);
      }
export function useEditCustomerModalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EditCustomerModalQuery, EditCustomerModalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EditCustomerModalQuery, EditCustomerModalQueryVariables>(EditCustomerModalDocument, options);
        }
export type EditCustomerModalQueryHookResult = ReturnType<typeof useEditCustomerModalQuery>;
export type EditCustomerModalLazyQueryHookResult = ReturnType<typeof useEditCustomerModalLazyQuery>;
export type EditCustomerModalQueryResult = Apollo.QueryResult<EditCustomerModalQuery, EditCustomerModalQueryVariables>;
export const SaveCustomerDocument = gql`
    mutation SaveCustomer($input: SaveCustomerInput!) {
  saveCustomer(input: $input) {
    id
    email
    firstName
    lastName
    phoneNumber
  }
}
    `;
export type SaveCustomerMutationFn = Apollo.MutationFunction<SaveCustomerMutation, SaveCustomerMutationVariables>;

/**
 * __useSaveCustomerMutation__
 *
 * To run a mutation, you first call `useSaveCustomerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveCustomerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveCustomerMutation, { data, loading, error }] = useSaveCustomerMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveCustomerMutation(baseOptions?: Apollo.MutationHookOptions<SaveCustomerMutation, SaveCustomerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveCustomerMutation, SaveCustomerMutationVariables>(SaveCustomerDocument, options);
      }
export type SaveCustomerMutationHookResult = ReturnType<typeof useSaveCustomerMutation>;
export type SaveCustomerMutationResult = Apollo.MutationResult<SaveCustomerMutation>;
export type SaveCustomerMutationOptions = Apollo.BaseMutationOptions<SaveCustomerMutation, SaveCustomerMutationVariables>;
export const CacheAndProcessOrdersDocument = gql`
    mutation CacheAndProcessOrders($storeId: ID!, $startTime: Timestamp, $orderId: String) {
  cacheAndProcessOrders(
    storeId: $storeId
    startTime: $startTime
    orderId: $orderId
  )
}
    `;
export type CacheAndProcessOrdersMutationFn = Apollo.MutationFunction<CacheAndProcessOrdersMutation, CacheAndProcessOrdersMutationVariables>;

/**
 * __useCacheAndProcessOrdersMutation__
 *
 * To run a mutation, you first call `useCacheAndProcessOrdersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCacheAndProcessOrdersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cacheAndProcessOrdersMutation, { data, loading, error }] = useCacheAndProcessOrdersMutation({
 *   variables: {
 *      storeId: // value for 'storeId'
 *      startTime: // value for 'startTime'
 *      orderId: // value for 'orderId'
 *   },
 * });
 */
export function useCacheAndProcessOrdersMutation(baseOptions?: Apollo.MutationHookOptions<CacheAndProcessOrdersMutation, CacheAndProcessOrdersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CacheAndProcessOrdersMutation, CacheAndProcessOrdersMutationVariables>(CacheAndProcessOrdersDocument, options);
      }
export type CacheAndProcessOrdersMutationHookResult = ReturnType<typeof useCacheAndProcessOrdersMutation>;
export type CacheAndProcessOrdersMutationResult = Apollo.MutationResult<CacheAndProcessOrdersMutation>;
export type CacheAndProcessOrdersMutationOptions = Apollo.BaseMutationOptions<CacheAndProcessOrdersMutation, CacheAndProcessOrdersMutationVariables>;
export const DataCacheActivityDocument = gql`
    query DataCacheActivity($page: Cursor, $filter: QueryCachedOrdersFilterInput, $sort: QueryCachedOrdersSortInput) {
  cachedOrders(
    options: {filter: $filter, sort: $sort, paginationInput: {after: $page, first: 20}}
  ) {
    pageInfo {
      ...pageInfoFields
    }
    nodes {
      id
      metaCreated
      rawData
      validationErrors
      store {
        id
        type {
          id
          name
          displayName
        }
      }
    }
  }
}
    ${PageInfoFieldsFragmentDoc}`;

/**
 * __useDataCacheActivityQuery__
 *
 * To run a query within a React component, call `useDataCacheActivityQuery` and pass it any options that fit your needs.
 * When your component renders, `useDataCacheActivityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDataCacheActivityQuery({
 *   variables: {
 *      page: // value for 'page'
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useDataCacheActivityQuery(baseOptions?: Apollo.QueryHookOptions<DataCacheActivityQuery, DataCacheActivityQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DataCacheActivityQuery, DataCacheActivityQueryVariables>(DataCacheActivityDocument, options);
      }
export function useDataCacheActivityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DataCacheActivityQuery, DataCacheActivityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DataCacheActivityQuery, DataCacheActivityQueryVariables>(DataCacheActivityDocument, options);
        }
export type DataCacheActivityQueryHookResult = ReturnType<typeof useDataCacheActivityQuery>;
export type DataCacheActivityLazyQueryHookResult = ReturnType<typeof useDataCacheActivityLazyQuery>;
export type DataCacheActivityQueryResult = Apollo.QueryResult<DataCacheActivityQuery, DataCacheActivityQueryVariables>;
export const ToggleDataCacheExternalOrderArchivedDocument = gql`
    mutation ToggleDataCacheExternalOrderArchived($input: ToggleExternalOrderArchivedInput!) {
  toggleExternalOrderArchived(input: $input)
}
    `;
export type ToggleDataCacheExternalOrderArchivedMutationFn = Apollo.MutationFunction<ToggleDataCacheExternalOrderArchivedMutation, ToggleDataCacheExternalOrderArchivedMutationVariables>;

/**
 * __useToggleDataCacheExternalOrderArchivedMutation__
 *
 * To run a mutation, you first call `useToggleDataCacheExternalOrderArchivedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleDataCacheExternalOrderArchivedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleDataCacheExternalOrderArchivedMutation, { data, loading, error }] = useToggleDataCacheExternalOrderArchivedMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useToggleDataCacheExternalOrderArchivedMutation(baseOptions?: Apollo.MutationHookOptions<ToggleDataCacheExternalOrderArchivedMutation, ToggleDataCacheExternalOrderArchivedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ToggleDataCacheExternalOrderArchivedMutation, ToggleDataCacheExternalOrderArchivedMutationVariables>(ToggleDataCacheExternalOrderArchivedDocument, options);
      }
export type ToggleDataCacheExternalOrderArchivedMutationHookResult = ReturnType<typeof useToggleDataCacheExternalOrderArchivedMutation>;
export type ToggleDataCacheExternalOrderArchivedMutationResult = Apollo.MutationResult<ToggleDataCacheExternalOrderArchivedMutation>;
export type ToggleDataCacheExternalOrderArchivedMutationOptions = Apollo.BaseMutationOptions<ToggleDataCacheExternalOrderArchivedMutation, ToggleDataCacheExternalOrderArchivedMutationVariables>;
export const JiraTicketsTabDocument = gql`
    query JiraTicketsTab($page: Cursor, $filter: QueryJiraTicketsFilterInput, $sort: QueryJiraTicketsSortInput) {
  jiraTickets(
    options: {filter: $filter, sort: $sort, paginationInput: {first: 50, after: $page}}
  ) {
    pageInfo {
      ...pageInfoFields
    }
    nodes {
      id
      createdAt
      key
      title
      description
      context
      labels
    }
  }
}
    ${PageInfoFieldsFragmentDoc}`;

/**
 * __useJiraTicketsTabQuery__
 *
 * To run a query within a React component, call `useJiraTicketsTabQuery` and pass it any options that fit your needs.
 * When your component renders, `useJiraTicketsTabQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useJiraTicketsTabQuery({
 *   variables: {
 *      page: // value for 'page'
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useJiraTicketsTabQuery(baseOptions?: Apollo.QueryHookOptions<JiraTicketsTabQuery, JiraTicketsTabQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<JiraTicketsTabQuery, JiraTicketsTabQueryVariables>(JiraTicketsTabDocument, options);
      }
export function useJiraTicketsTabLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<JiraTicketsTabQuery, JiraTicketsTabQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<JiraTicketsTabQuery, JiraTicketsTabQueryVariables>(JiraTicketsTabDocument, options);
        }
export type JiraTicketsTabQueryHookResult = ReturnType<typeof useJiraTicketsTabQuery>;
export type JiraTicketsTabLazyQueryHookResult = ReturnType<typeof useJiraTicketsTabLazyQuery>;
export type JiraTicketsTabQueryResult = Apollo.QueryResult<JiraTicketsTabQuery, JiraTicketsTabQueryVariables>;
export const LoadTabDocument = gql`
    query LoadTab($start: Timestamp!, $end: Timestamp!) {
  orderCountTimeSeries(
    input: {startDate: $start, endDate: $end, intervalSeconds: 3600}
  ) {
    intervalSeconds
    yUnit
    series {
      x
      y
    }
  }
  cacheSalesOrdersTimeSeries: daemonRunTimeSeries(
    input: {startDate: $start, endDate: $end, intervalSeconds: 3600, daemon: cacheSalesOrders}
  ) {
    series {
      x
      y
    }
  }
  processSalesOrderCacheTimeSeries: daemonRunTimeSeries(
    input: {startDate: $start, endDate: $end, intervalSeconds: 3600, daemon: processSalesOrderCache}
  ) {
    series {
      x
      y
    }
  }
  wooCommerceCheckForUpdatesToUnfulfilledOrdersTimeSeries: daemonRunTimeSeries(
    input: {startDate: $start, endDate: $end, intervalSeconds: 3600, daemon: wooCommerceCheckForUpdatesToUnfulfilledOrders}
  ) {
    series {
      x
      y
    }
  }
}
    `;

/**
 * __useLoadTabQuery__
 *
 * To run a query within a React component, call `useLoadTabQuery` and pass it any options that fit your needs.
 * When your component renders, `useLoadTabQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLoadTabQuery({
 *   variables: {
 *      start: // value for 'start'
 *      end: // value for 'end'
 *   },
 * });
 */
export function useLoadTabQuery(baseOptions: Apollo.QueryHookOptions<LoadTabQuery, LoadTabQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LoadTabQuery, LoadTabQueryVariables>(LoadTabDocument, options);
      }
export function useLoadTabLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LoadTabQuery, LoadTabQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LoadTabQuery, LoadTabQueryVariables>(LoadTabDocument, options);
        }
export type LoadTabQueryHookResult = ReturnType<typeof useLoadTabQuery>;
export type LoadTabLazyQueryHookResult = ReturnType<typeof useLoadTabLazyQuery>;
export type LoadTabQueryResult = Apollo.QueryResult<LoadTabQuery, LoadTabQueryVariables>;
export const ImportInventoryItemsDocument = gql`
    mutation ImportInventoryItems($input: [ImportInventoryItemInput!]!) {
  importInventoryItems(input: $input)
}
    `;
export type ImportInventoryItemsMutationFn = Apollo.MutationFunction<ImportInventoryItemsMutation, ImportInventoryItemsMutationVariables>;

/**
 * __useImportInventoryItemsMutation__
 *
 * To run a mutation, you first call `useImportInventoryItemsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useImportInventoryItemsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [importInventoryItemsMutation, { data, loading, error }] = useImportInventoryItemsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useImportInventoryItemsMutation(baseOptions?: Apollo.MutationHookOptions<ImportInventoryItemsMutation, ImportInventoryItemsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ImportInventoryItemsMutation, ImportInventoryItemsMutationVariables>(ImportInventoryItemsDocument, options);
      }
export type ImportInventoryItemsMutationHookResult = ReturnType<typeof useImportInventoryItemsMutation>;
export type ImportInventoryItemsMutationResult = Apollo.MutationResult<ImportInventoryItemsMutation>;
export type ImportInventoryItemsMutationOptions = Apollo.BaseMutationOptions<ImportInventoryItemsMutation, ImportInventoryItemsMutationVariables>;
export const ImportNetSuiteDepartmentsDocument = gql`
    mutation ImportNetSuiteDepartments($input: [ImportDepartmentInput!]!) {
  importNetSuiteDepartments(input: $input)
}
    `;
export type ImportNetSuiteDepartmentsMutationFn = Apollo.MutationFunction<ImportNetSuiteDepartmentsMutation, ImportNetSuiteDepartmentsMutationVariables>;

/**
 * __useImportNetSuiteDepartmentsMutation__
 *
 * To run a mutation, you first call `useImportNetSuiteDepartmentsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useImportNetSuiteDepartmentsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [importNetSuiteDepartmentsMutation, { data, loading, error }] = useImportNetSuiteDepartmentsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useImportNetSuiteDepartmentsMutation(baseOptions?: Apollo.MutationHookOptions<ImportNetSuiteDepartmentsMutation, ImportNetSuiteDepartmentsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ImportNetSuiteDepartmentsMutation, ImportNetSuiteDepartmentsMutationVariables>(ImportNetSuiteDepartmentsDocument, options);
      }
export type ImportNetSuiteDepartmentsMutationHookResult = ReturnType<typeof useImportNetSuiteDepartmentsMutation>;
export type ImportNetSuiteDepartmentsMutationResult = Apollo.MutationResult<ImportNetSuiteDepartmentsMutation>;
export type ImportNetSuiteDepartmentsMutationOptions = Apollo.BaseMutationOptions<ImportNetSuiteDepartmentsMutation, ImportNetSuiteDepartmentsMutationVariables>;
export const ImportNetSuiteEmployeesDocument = gql`
    mutation ImportNetSuiteEmployees($input: [ImportEmployeeInput!]!) {
  importNetSuiteEmployees(input: $input)
}
    `;
export type ImportNetSuiteEmployeesMutationFn = Apollo.MutationFunction<ImportNetSuiteEmployeesMutation, ImportNetSuiteEmployeesMutationVariables>;

/**
 * __useImportNetSuiteEmployeesMutation__
 *
 * To run a mutation, you first call `useImportNetSuiteEmployeesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useImportNetSuiteEmployeesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [importNetSuiteEmployeesMutation, { data, loading, error }] = useImportNetSuiteEmployeesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useImportNetSuiteEmployeesMutation(baseOptions?: Apollo.MutationHookOptions<ImportNetSuiteEmployeesMutation, ImportNetSuiteEmployeesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ImportNetSuiteEmployeesMutation, ImportNetSuiteEmployeesMutationVariables>(ImportNetSuiteEmployeesDocument, options);
      }
export type ImportNetSuiteEmployeesMutationHookResult = ReturnType<typeof useImportNetSuiteEmployeesMutation>;
export type ImportNetSuiteEmployeesMutationResult = Apollo.MutationResult<ImportNetSuiteEmployeesMutation>;
export type ImportNetSuiteEmployeesMutationOptions = Apollo.BaseMutationOptions<ImportNetSuiteEmployeesMutation, ImportNetSuiteEmployeesMutationVariables>;
export const ImportNetSuiteSubsidiariesModalDocument = gql`
    query ImportNetSuiteSubsidiariesModal {
  subsidiaries {
    id
    name
  }
}
    `;

/**
 * __useImportNetSuiteSubsidiariesModalQuery__
 *
 * To run a query within a React component, call `useImportNetSuiteSubsidiariesModalQuery` and pass it any options that fit your needs.
 * When your component renders, `useImportNetSuiteSubsidiariesModalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useImportNetSuiteSubsidiariesModalQuery({
 *   variables: {
 *   },
 * });
 */
export function useImportNetSuiteSubsidiariesModalQuery(baseOptions?: Apollo.QueryHookOptions<ImportNetSuiteSubsidiariesModalQuery, ImportNetSuiteSubsidiariesModalQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ImportNetSuiteSubsidiariesModalQuery, ImportNetSuiteSubsidiariesModalQueryVariables>(ImportNetSuiteSubsidiariesModalDocument, options);
      }
export function useImportNetSuiteSubsidiariesModalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ImportNetSuiteSubsidiariesModalQuery, ImportNetSuiteSubsidiariesModalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ImportNetSuiteSubsidiariesModalQuery, ImportNetSuiteSubsidiariesModalQueryVariables>(ImportNetSuiteSubsidiariesModalDocument, options);
        }
export type ImportNetSuiteSubsidiariesModalQueryHookResult = ReturnType<typeof useImportNetSuiteSubsidiariesModalQuery>;
export type ImportNetSuiteSubsidiariesModalLazyQueryHookResult = ReturnType<typeof useImportNetSuiteSubsidiariesModalLazyQuery>;
export type ImportNetSuiteSubsidiariesModalQueryResult = Apollo.QueryResult<ImportNetSuiteSubsidiariesModalQuery, ImportNetSuiteSubsidiariesModalQueryVariables>;
export const ImportNetSuiteInventoryLocationsDocument = gql`
    mutation ImportNetSuiteInventoryLocations($input: [ImportInventoryLocationInput!]!) {
  importNetSuiteInventoryLocations(input: $input)
}
    `;
export type ImportNetSuiteInventoryLocationsMutationFn = Apollo.MutationFunction<ImportNetSuiteInventoryLocationsMutation, ImportNetSuiteInventoryLocationsMutationVariables>;

/**
 * __useImportNetSuiteInventoryLocationsMutation__
 *
 * To run a mutation, you first call `useImportNetSuiteInventoryLocationsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useImportNetSuiteInventoryLocationsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [importNetSuiteInventoryLocationsMutation, { data, loading, error }] = useImportNetSuiteInventoryLocationsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useImportNetSuiteInventoryLocationsMutation(baseOptions?: Apollo.MutationHookOptions<ImportNetSuiteInventoryLocationsMutation, ImportNetSuiteInventoryLocationsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ImportNetSuiteInventoryLocationsMutation, ImportNetSuiteInventoryLocationsMutationVariables>(ImportNetSuiteInventoryLocationsDocument, options);
      }
export type ImportNetSuiteInventoryLocationsMutationHookResult = ReturnType<typeof useImportNetSuiteInventoryLocationsMutation>;
export type ImportNetSuiteInventoryLocationsMutationResult = Apollo.MutationResult<ImportNetSuiteInventoryLocationsMutation>;
export type ImportNetSuiteInventoryLocationsMutationOptions = Apollo.BaseMutationOptions<ImportNetSuiteInventoryLocationsMutation, ImportNetSuiteInventoryLocationsMutationVariables>;
export const ImportInventoryLocationsModalDocument = gql`
    query ImportInventoryLocationsModal {
  subsidiaries {
    id
    name
  }
}
    `;

/**
 * __useImportInventoryLocationsModalQuery__
 *
 * To run a query within a React component, call `useImportInventoryLocationsModalQuery` and pass it any options that fit your needs.
 * When your component renders, `useImportInventoryLocationsModalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useImportInventoryLocationsModalQuery({
 *   variables: {
 *   },
 * });
 */
export function useImportInventoryLocationsModalQuery(baseOptions?: Apollo.QueryHookOptions<ImportInventoryLocationsModalQuery, ImportInventoryLocationsModalQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ImportInventoryLocationsModalQuery, ImportInventoryLocationsModalQueryVariables>(ImportInventoryLocationsModalDocument, options);
      }
export function useImportInventoryLocationsModalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ImportInventoryLocationsModalQuery, ImportInventoryLocationsModalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ImportInventoryLocationsModalQuery, ImportInventoryLocationsModalQueryVariables>(ImportInventoryLocationsModalDocument, options);
        }
export type ImportInventoryLocationsModalQueryHookResult = ReturnType<typeof useImportInventoryLocationsModalQuery>;
export type ImportInventoryLocationsModalLazyQueryHookResult = ReturnType<typeof useImportInventoryLocationsModalLazyQuery>;
export type ImportInventoryLocationsModalQueryResult = Apollo.QueryResult<ImportInventoryLocationsModalQuery, ImportInventoryLocationsModalQueryVariables>;
export const ImportNetSuiteShipItemsDocument = gql`
    mutation ImportNetSuiteShipItems($input: [ImportShipItemInput!]!) {
  importNetSuiteShipItems(input: $input)
}
    `;
export type ImportNetSuiteShipItemsMutationFn = Apollo.MutationFunction<ImportNetSuiteShipItemsMutation, ImportNetSuiteShipItemsMutationVariables>;

/**
 * __useImportNetSuiteShipItemsMutation__
 *
 * To run a mutation, you first call `useImportNetSuiteShipItemsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useImportNetSuiteShipItemsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [importNetSuiteShipItemsMutation, { data, loading, error }] = useImportNetSuiteShipItemsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useImportNetSuiteShipItemsMutation(baseOptions?: Apollo.MutationHookOptions<ImportNetSuiteShipItemsMutation, ImportNetSuiteShipItemsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ImportNetSuiteShipItemsMutation, ImportNetSuiteShipItemsMutationVariables>(ImportNetSuiteShipItemsDocument, options);
      }
export type ImportNetSuiteShipItemsMutationHookResult = ReturnType<typeof useImportNetSuiteShipItemsMutation>;
export type ImportNetSuiteShipItemsMutationResult = Apollo.MutationResult<ImportNetSuiteShipItemsMutation>;
export type ImportNetSuiteShipItemsMutationOptions = Apollo.BaseMutationOptions<ImportNetSuiteShipItemsMutation, ImportNetSuiteShipItemsMutationVariables>;
export const ImportNetSuiteShipItemsModalDocument = gql`
    query ImportNetSuiteShipItemsModal {
  subsidiaries {
    id
    name
  }
}
    `;

/**
 * __useImportNetSuiteShipItemsModalQuery__
 *
 * To run a query within a React component, call `useImportNetSuiteShipItemsModalQuery` and pass it any options that fit your needs.
 * When your component renders, `useImportNetSuiteShipItemsModalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useImportNetSuiteShipItemsModalQuery({
 *   variables: {
 *   },
 * });
 */
export function useImportNetSuiteShipItemsModalQuery(baseOptions?: Apollo.QueryHookOptions<ImportNetSuiteShipItemsModalQuery, ImportNetSuiteShipItemsModalQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ImportNetSuiteShipItemsModalQuery, ImportNetSuiteShipItemsModalQueryVariables>(ImportNetSuiteShipItemsModalDocument, options);
      }
export function useImportNetSuiteShipItemsModalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ImportNetSuiteShipItemsModalQuery, ImportNetSuiteShipItemsModalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ImportNetSuiteShipItemsModalQuery, ImportNetSuiteShipItemsModalQueryVariables>(ImportNetSuiteShipItemsModalDocument, options);
        }
export type ImportNetSuiteShipItemsModalQueryHookResult = ReturnType<typeof useImportNetSuiteShipItemsModalQuery>;
export type ImportNetSuiteShipItemsModalLazyQueryHookResult = ReturnType<typeof useImportNetSuiteShipItemsModalLazyQuery>;
export type ImportNetSuiteShipItemsModalQueryResult = Apollo.QueryResult<ImportNetSuiteShipItemsModalQuery, ImportNetSuiteShipItemsModalQueryVariables>;
export const ImportNetSuiteSubsidiariesDocument = gql`
    mutation ImportNetSuiteSubsidiaries($input: [ImportSubsidiaryInput!]!) {
  importNetSuiteSubsidiaries(input: $input)
}
    `;
export type ImportNetSuiteSubsidiariesMutationFn = Apollo.MutationFunction<ImportNetSuiteSubsidiariesMutation, ImportNetSuiteSubsidiariesMutationVariables>;

/**
 * __useImportNetSuiteSubsidiariesMutation__
 *
 * To run a mutation, you first call `useImportNetSuiteSubsidiariesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useImportNetSuiteSubsidiariesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [importNetSuiteSubsidiariesMutation, { data, loading, error }] = useImportNetSuiteSubsidiariesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useImportNetSuiteSubsidiariesMutation(baseOptions?: Apollo.MutationHookOptions<ImportNetSuiteSubsidiariesMutation, ImportNetSuiteSubsidiariesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ImportNetSuiteSubsidiariesMutation, ImportNetSuiteSubsidiariesMutationVariables>(ImportNetSuiteSubsidiariesDocument, options);
      }
export type ImportNetSuiteSubsidiariesMutationHookResult = ReturnType<typeof useImportNetSuiteSubsidiariesMutation>;
export type ImportNetSuiteSubsidiariesMutationResult = Apollo.MutationResult<ImportNetSuiteSubsidiariesMutation>;
export type ImportNetSuiteSubsidiariesMutationOptions = Apollo.BaseMutationOptions<ImportNetSuiteSubsidiariesMutation, ImportNetSuiteSubsidiariesMutationVariables>;
export const ImportNetSuitePaymentMethodsDocument = gql`
    mutation ImportNetSuitePaymentMethods($input: [ImportPaymentMethodInput!]!) {
  importNetSuitePaymentMethods(input: $input)
}
    `;
export type ImportNetSuitePaymentMethodsMutationFn = Apollo.MutationFunction<ImportNetSuitePaymentMethodsMutation, ImportNetSuitePaymentMethodsMutationVariables>;

/**
 * __useImportNetSuitePaymentMethodsMutation__
 *
 * To run a mutation, you first call `useImportNetSuitePaymentMethodsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useImportNetSuitePaymentMethodsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [importNetSuitePaymentMethodsMutation, { data, loading, error }] = useImportNetSuitePaymentMethodsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useImportNetSuitePaymentMethodsMutation(baseOptions?: Apollo.MutationHookOptions<ImportNetSuitePaymentMethodsMutation, ImportNetSuitePaymentMethodsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ImportNetSuitePaymentMethodsMutation, ImportNetSuitePaymentMethodsMutationVariables>(ImportNetSuitePaymentMethodsDocument, options);
      }
export type ImportNetSuitePaymentMethodsMutationHookResult = ReturnType<typeof useImportNetSuitePaymentMethodsMutation>;
export type ImportNetSuitePaymentMethodsMutationResult = Apollo.MutationResult<ImportNetSuitePaymentMethodsMutation>;
export type ImportNetSuitePaymentMethodsMutationOptions = Apollo.BaseMutationOptions<ImportNetSuitePaymentMethodsMutation, ImportNetSuitePaymentMethodsMutationVariables>;
export const ImportPaymentMethodsModalDocument = gql`
    query ImportPaymentMethodsModal {
  subsidiaries {
    id
    name
  }
}
    `;

/**
 * __useImportPaymentMethodsModalQuery__
 *
 * To run a query within a React component, call `useImportPaymentMethodsModalQuery` and pass it any options that fit your needs.
 * When your component renders, `useImportPaymentMethodsModalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useImportPaymentMethodsModalQuery({
 *   variables: {
 *   },
 * });
 */
export function useImportPaymentMethodsModalQuery(baseOptions?: Apollo.QueryHookOptions<ImportPaymentMethodsModalQuery, ImportPaymentMethodsModalQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ImportPaymentMethodsModalQuery, ImportPaymentMethodsModalQueryVariables>(ImportPaymentMethodsModalDocument, options);
      }
export function useImportPaymentMethodsModalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ImportPaymentMethodsModalQuery, ImportPaymentMethodsModalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ImportPaymentMethodsModalQuery, ImportPaymentMethodsModalQueryVariables>(ImportPaymentMethodsModalDocument, options);
        }
export type ImportPaymentMethodsModalQueryHookResult = ReturnType<typeof useImportPaymentMethodsModalQuery>;
export type ImportPaymentMethodsModalLazyQueryHookResult = ReturnType<typeof useImportPaymentMethodsModalLazyQuery>;
export type ImportPaymentMethodsModalQueryResult = Apollo.QueryResult<ImportPaymentMethodsModalQuery, ImportPaymentMethodsModalQueryVariables>;
export const DebugActivity_NetSuiteRecordsTabDocument = gql`
    query DebugActivity_NetSuiteRecordsTab {
  shipItems {
    nodes {
      id
      name
      internalId
    }
  }
  subsidiaries {
    id
    name
    internalId
  }
  departments {
    id
    name
    internalId
  }
  employees {
    id
    fullName
    internalId
  }
  items {
    nodes {
      id
      sku
      name
      description
      netSuiteInternalId
    }
  }
  netSuitePaymentMethods {
    id
    name
    internalId
  }
  inventoryLocations {
    id
    name
    internalId
  }
}
    `;

/**
 * __useDebugActivity_NetSuiteRecordsTabQuery__
 *
 * To run a query within a React component, call `useDebugActivity_NetSuiteRecordsTabQuery` and pass it any options that fit your needs.
 * When your component renders, `useDebugActivity_NetSuiteRecordsTabQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDebugActivity_NetSuiteRecordsTabQuery({
 *   variables: {
 *   },
 * });
 */
export function useDebugActivity_NetSuiteRecordsTabQuery(baseOptions?: Apollo.QueryHookOptions<DebugActivity_NetSuiteRecordsTabQuery, DebugActivity_NetSuiteRecordsTabQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DebugActivity_NetSuiteRecordsTabQuery, DebugActivity_NetSuiteRecordsTabQueryVariables>(DebugActivity_NetSuiteRecordsTabDocument, options);
      }
export function useDebugActivity_NetSuiteRecordsTabLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DebugActivity_NetSuiteRecordsTabQuery, DebugActivity_NetSuiteRecordsTabQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DebugActivity_NetSuiteRecordsTabQuery, DebugActivity_NetSuiteRecordsTabQueryVariables>(DebugActivity_NetSuiteRecordsTabDocument, options);
        }
export type DebugActivity_NetSuiteRecordsTabQueryHookResult = ReturnType<typeof useDebugActivity_NetSuiteRecordsTabQuery>;
export type DebugActivity_NetSuiteRecordsTabLazyQueryHookResult = ReturnType<typeof useDebugActivity_NetSuiteRecordsTabLazyQuery>;
export type DebugActivity_NetSuiteRecordsTabQueryResult = Apollo.QueryResult<DebugActivity_NetSuiteRecordsTabQuery, DebugActivity_NetSuiteRecordsTabQueryVariables>;
export const DebugActivity_RolesTabDocument = gql`
    query DebugActivity_RolesTab {
  permissionGroups {
    id
    name
    displayName
    permissions {
      ...enumPermissionFields
    }
  }
  userRoleTemplates {
    pageInfo {
      ...pageInfoFields
    }
    nodes {
      id
      displayName
      description
      permissions {
        ...enumPermissionFields
      }
    }
  }
}
    ${EnumPermissionFieldsFragmentDoc}
${PageInfoFieldsFragmentDoc}`;

/**
 * __useDebugActivity_RolesTabQuery__
 *
 * To run a query within a React component, call `useDebugActivity_RolesTabQuery` and pass it any options that fit your needs.
 * When your component renders, `useDebugActivity_RolesTabQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDebugActivity_RolesTabQuery({
 *   variables: {
 *   },
 * });
 */
export function useDebugActivity_RolesTabQuery(baseOptions?: Apollo.QueryHookOptions<DebugActivity_RolesTabQuery, DebugActivity_RolesTabQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DebugActivity_RolesTabQuery, DebugActivity_RolesTabQueryVariables>(DebugActivity_RolesTabDocument, options);
      }
export function useDebugActivity_RolesTabLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DebugActivity_RolesTabQuery, DebugActivity_RolesTabQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DebugActivity_RolesTabQuery, DebugActivity_RolesTabQueryVariables>(DebugActivity_RolesTabDocument, options);
        }
export type DebugActivity_RolesTabQueryHookResult = ReturnType<typeof useDebugActivity_RolesTabQuery>;
export type DebugActivity_RolesTabLazyQueryHookResult = ReturnType<typeof useDebugActivity_RolesTabLazyQuery>;
export type DebugActivity_RolesTabQueryResult = Apollo.QueryResult<DebugActivity_RolesTabQuery, DebugActivity_RolesTabQueryVariables>;
export const MockFulfillTelgoo5OrdersDocument = gql`
    mutation MockFulfillTelgoo5Orders {
  mockFulfillTelgoo5Orders
}
    `;
export type MockFulfillTelgoo5OrdersMutationFn = Apollo.MutationFunction<MockFulfillTelgoo5OrdersMutation, MockFulfillTelgoo5OrdersMutationVariables>;

/**
 * __useMockFulfillTelgoo5OrdersMutation__
 *
 * To run a mutation, you first call `useMockFulfillTelgoo5OrdersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMockFulfillTelgoo5OrdersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [mockFulfillTelgoo5OrdersMutation, { data, loading, error }] = useMockFulfillTelgoo5OrdersMutation({
 *   variables: {
 *   },
 * });
 */
export function useMockFulfillTelgoo5OrdersMutation(baseOptions?: Apollo.MutationHookOptions<MockFulfillTelgoo5OrdersMutation, MockFulfillTelgoo5OrdersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MockFulfillTelgoo5OrdersMutation, MockFulfillTelgoo5OrdersMutationVariables>(MockFulfillTelgoo5OrdersDocument, options);
      }
export type MockFulfillTelgoo5OrdersMutationHookResult = ReturnType<typeof useMockFulfillTelgoo5OrdersMutation>;
export type MockFulfillTelgoo5OrdersMutationResult = Apollo.MutationResult<MockFulfillTelgoo5OrdersMutation>;
export type MockFulfillTelgoo5OrdersMutationOptions = Apollo.BaseMutationOptions<MockFulfillTelgoo5OrdersMutation, MockFulfillTelgoo5OrdersMutationVariables>;
export const PingNetSuiteDocument = gql`
    query PingNetSuite {
  testNetSuiteConnection
}
    `;

/**
 * __usePingNetSuiteQuery__
 *
 * To run a query within a React component, call `usePingNetSuiteQuery` and pass it any options that fit your needs.
 * When your component renders, `usePingNetSuiteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePingNetSuiteQuery({
 *   variables: {
 *   },
 * });
 */
export function usePingNetSuiteQuery(baseOptions?: Apollo.QueryHookOptions<PingNetSuiteQuery, PingNetSuiteQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PingNetSuiteQuery, PingNetSuiteQueryVariables>(PingNetSuiteDocument, options);
      }
export function usePingNetSuiteLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PingNetSuiteQuery, PingNetSuiteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PingNetSuiteQuery, PingNetSuiteQueryVariables>(PingNetSuiteDocument, options);
        }
export type PingNetSuiteQueryHookResult = ReturnType<typeof usePingNetSuiteQuery>;
export type PingNetSuiteLazyQueryHookResult = ReturnType<typeof usePingNetSuiteLazyQuery>;
export type PingNetSuiteQueryResult = Apollo.QueryResult<PingNetSuiteQuery, PingNetSuiteQueryVariables>;
export const PingE1Document = gql`
    query PingE1 {
  testE1Connection
}
    `;

/**
 * __usePingE1Query__
 *
 * To run a query within a React component, call `usePingE1Query` and pass it any options that fit your needs.
 * When your component renders, `usePingE1Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePingE1Query({
 *   variables: {
 *   },
 * });
 */
export function usePingE1Query(baseOptions?: Apollo.QueryHookOptions<PingE1Query, PingE1QueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PingE1Query, PingE1QueryVariables>(PingE1Document, options);
      }
export function usePingE1LazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PingE1Query, PingE1QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PingE1Query, PingE1QueryVariables>(PingE1Document, options);
        }
export type PingE1QueryHookResult = ReturnType<typeof usePingE1Query>;
export type PingE1LazyQueryHookResult = ReturnType<typeof usePingE1LazyQuery>;
export type PingE1QueryResult = Apollo.QueryResult<PingE1Query, PingE1QueryVariables>;
export const RunAllJobsDocument = gql`
    mutation RunAllJobs {
  runAllJobs
}
    `;
export type RunAllJobsMutationFn = Apollo.MutationFunction<RunAllJobsMutation, RunAllJobsMutationVariables>;

/**
 * __useRunAllJobsMutation__
 *
 * To run a mutation, you first call `useRunAllJobsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRunAllJobsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [runAllJobsMutation, { data, loading, error }] = useRunAllJobsMutation({
 *   variables: {
 *   },
 * });
 */
export function useRunAllJobsMutation(baseOptions?: Apollo.MutationHookOptions<RunAllJobsMutation, RunAllJobsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RunAllJobsMutation, RunAllJobsMutationVariables>(RunAllJobsDocument, options);
      }
export type RunAllJobsMutationHookResult = ReturnType<typeof useRunAllJobsMutation>;
export type RunAllJobsMutationResult = Apollo.MutationResult<RunAllJobsMutation>;
export type RunAllJobsMutationOptions = Apollo.BaseMutationOptions<RunAllJobsMutation, RunAllJobsMutationVariables>;
export const RunScheduledJobDocument = gql`
    mutation RunScheduledJob($scheduledJobId: ID!) {
  runScheduledJob(scheduledJobId: $scheduledJobId)
}
    `;
export type RunScheduledJobMutationFn = Apollo.MutationFunction<RunScheduledJobMutation, RunScheduledJobMutationVariables>;

/**
 * __useRunScheduledJobMutation__
 *
 * To run a mutation, you first call `useRunScheduledJobMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRunScheduledJobMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [runScheduledJobMutation, { data, loading, error }] = useRunScheduledJobMutation({
 *   variables: {
 *      scheduledJobId: // value for 'scheduledJobId'
 *   },
 * });
 */
export function useRunScheduledJobMutation(baseOptions?: Apollo.MutationHookOptions<RunScheduledJobMutation, RunScheduledJobMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RunScheduledJobMutation, RunScheduledJobMutationVariables>(RunScheduledJobDocument, options);
      }
export type RunScheduledJobMutationHookResult = ReturnType<typeof useRunScheduledJobMutation>;
export type RunScheduledJobMutationResult = Apollo.MutationResult<RunScheduledJobMutation>;
export type RunScheduledJobMutationOptions = Apollo.BaseMutationOptions<RunScheduledJobMutation, RunScheduledJobMutationVariables>;
export const SaveScheduledJobDocument = gql`
    mutation SaveScheduledJob($input: SaveScheduledJobInput!) {
  saveScheduledJob(input: $input) {
    ...scheduledJobTable_scheduledJobFields
  }
}
    ${ScheduledJobTable_ScheduledJobFieldsFragmentDoc}`;
export type SaveScheduledJobMutationFn = Apollo.MutationFunction<SaveScheduledJobMutation, SaveScheduledJobMutationVariables>;

/**
 * __useSaveScheduledJobMutation__
 *
 * To run a mutation, you first call `useSaveScheduledJobMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveScheduledJobMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveScheduledJobMutation, { data, loading, error }] = useSaveScheduledJobMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveScheduledJobMutation(baseOptions?: Apollo.MutationHookOptions<SaveScheduledJobMutation, SaveScheduledJobMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveScheduledJobMutation, SaveScheduledJobMutationVariables>(SaveScheduledJobDocument, options);
      }
export type SaveScheduledJobMutationHookResult = ReturnType<typeof useSaveScheduledJobMutation>;
export type SaveScheduledJobMutationResult = Apollo.MutationResult<SaveScheduledJobMutation>;
export type SaveScheduledJobMutationOptions = Apollo.BaseMutationOptions<SaveScheduledJobMutation, SaveScheduledJobMutationVariables>;
export const ScheduledJobsTabDocument = gql`
    query ScheduledJobsTab($filter: QueryScheduledJobsFilterInput!) {
  scheduledJobs(options: {filter: $filter}) {
    pageInfo {
      ...pageInfoFields
    }
    nodes {
      ...scheduledJobTable_scheduledJobFields
    }
  }
}
    ${PageInfoFieldsFragmentDoc}
${ScheduledJobTable_ScheduledJobFieldsFragmentDoc}`;

/**
 * __useScheduledJobsTabQuery__
 *
 * To run a query within a React component, call `useScheduledJobsTabQuery` and pass it any options that fit your needs.
 * When your component renders, `useScheduledJobsTabQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useScheduledJobsTabQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useScheduledJobsTabQuery(baseOptions: Apollo.QueryHookOptions<ScheduledJobsTabQuery, ScheduledJobsTabQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ScheduledJobsTabQuery, ScheduledJobsTabQueryVariables>(ScheduledJobsTabDocument, options);
      }
export function useScheduledJobsTabLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ScheduledJobsTabQuery, ScheduledJobsTabQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ScheduledJobsTabQuery, ScheduledJobsTabQueryVariables>(ScheduledJobsTabDocument, options);
        }
export type ScheduledJobsTabQueryHookResult = ReturnType<typeof useScheduledJobsTabQuery>;
export type ScheduledJobsTabLazyQueryHookResult = ReturnType<typeof useScheduledJobsTabLazyQuery>;
export type ScheduledJobsTabQueryResult = Apollo.QueryResult<ScheduledJobsTabQuery, ScheduledJobsTabQueryVariables>;
export const TestPingDocument = gql`
    mutation TestPing {
  testPing
}
    `;
export type TestPingMutationFn = Apollo.MutationFunction<TestPingMutation, TestPingMutationVariables>;

/**
 * __useTestPingMutation__
 *
 * To run a mutation, you first call `useTestPingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTestPingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [testPingMutation, { data, loading, error }] = useTestPingMutation({
 *   variables: {
 *   },
 * });
 */
export function useTestPingMutation(baseOptions?: Apollo.MutationHookOptions<TestPingMutation, TestPingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TestPingMutation, TestPingMutationVariables>(TestPingDocument, options);
      }
export type TestPingMutationHookResult = ReturnType<typeof useTestPingMutation>;
export type TestPingMutationResult = Apollo.MutationResult<TestPingMutation>;
export type TestPingMutationOptions = Apollo.BaseMutationOptions<TestPingMutation, TestPingMutationVariables>;
export const ApplyListingManagementStrategyTemplateGroupsDocument = gql`
    mutation ApplyListingManagementStrategyTemplateGroups($input: ApplyListingManagementStrategyTemplateGroupsInput!) {
  applyListingManagementStrategyTemplateGroups(input: $input) {
    id
    listingManagementStrategies {
      id
      isActive
      priceDollars
      store {
        id
        name
        isInventoryManagementDisabled: isFeatureDisabled(
          featureName: reportInventoryLevels
        )
      }
    }
  }
}
    `;
export type ApplyListingManagementStrategyTemplateGroupsMutationFn = Apollo.MutationFunction<ApplyListingManagementStrategyTemplateGroupsMutation, ApplyListingManagementStrategyTemplateGroupsMutationVariables>;

/**
 * __useApplyListingManagementStrategyTemplateGroupsMutation__
 *
 * To run a mutation, you first call `useApplyListingManagementStrategyTemplateGroupsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApplyListingManagementStrategyTemplateGroupsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [applyListingManagementStrategyTemplateGroupsMutation, { data, loading, error }] = useApplyListingManagementStrategyTemplateGroupsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useApplyListingManagementStrategyTemplateGroupsMutation(baseOptions?: Apollo.MutationHookOptions<ApplyListingManagementStrategyTemplateGroupsMutation, ApplyListingManagementStrategyTemplateGroupsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApplyListingManagementStrategyTemplateGroupsMutation, ApplyListingManagementStrategyTemplateGroupsMutationVariables>(ApplyListingManagementStrategyTemplateGroupsDocument, options);
      }
export type ApplyListingManagementStrategyTemplateGroupsMutationHookResult = ReturnType<typeof useApplyListingManagementStrategyTemplateGroupsMutation>;
export type ApplyListingManagementStrategyTemplateGroupsMutationResult = Apollo.MutationResult<ApplyListingManagementStrategyTemplateGroupsMutation>;
export type ApplyListingManagementStrategyTemplateGroupsMutationOptions = Apollo.BaseMutationOptions<ApplyListingManagementStrategyTemplateGroupsMutation, ApplyListingManagementStrategyTemplateGroupsMutationVariables>;
export const ApplyTemplatesToStoreModalDocument = gql`
    query ApplyTemplatesToStoreModal {
  listingManagementStrategyTemplateGroups(options: {}) {
    pageInfo {
      ...pageInfoFields
    }
    nodes {
      id
      name
      templateCount
    }
  }
}
    ${PageInfoFieldsFragmentDoc}`;

/**
 * __useApplyTemplatesToStoreModalQuery__
 *
 * To run a query within a React component, call `useApplyTemplatesToStoreModalQuery` and pass it any options that fit your needs.
 * When your component renders, `useApplyTemplatesToStoreModalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useApplyTemplatesToStoreModalQuery({
 *   variables: {
 *   },
 * });
 */
export function useApplyTemplatesToStoreModalQuery(baseOptions?: Apollo.QueryHookOptions<ApplyTemplatesToStoreModalQuery, ApplyTemplatesToStoreModalQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ApplyTemplatesToStoreModalQuery, ApplyTemplatesToStoreModalQueryVariables>(ApplyTemplatesToStoreModalDocument, options);
      }
export function useApplyTemplatesToStoreModalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ApplyTemplatesToStoreModalQuery, ApplyTemplatesToStoreModalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ApplyTemplatesToStoreModalQuery, ApplyTemplatesToStoreModalQueryVariables>(ApplyTemplatesToStoreModalDocument, options);
        }
export type ApplyTemplatesToStoreModalQueryHookResult = ReturnType<typeof useApplyTemplatesToStoreModalQuery>;
export type ApplyTemplatesToStoreModalLazyQueryHookResult = ReturnType<typeof useApplyTemplatesToStoreModalLazyQuery>;
export type ApplyTemplatesToStoreModalQueryResult = Apollo.QueryResult<ApplyTemplatesToStoreModalQuery, ApplyTemplatesToStoreModalQueryVariables>;
export const ExportItemListDocument = gql`
    query ExportItemList($options: QueryItemsOptionsInput!) {
  exportItemList(options: $options)
}
    `;

/**
 * __useExportItemListQuery__
 *
 * To run a query within a React component, call `useExportItemListQuery` and pass it any options that fit your needs.
 * When your component renders, `useExportItemListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExportItemListQuery({
 *   variables: {
 *      options: // value for 'options'
 *   },
 * });
 */
export function useExportItemListQuery(baseOptions: Apollo.QueryHookOptions<ExportItemListQuery, ExportItemListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExportItemListQuery, ExportItemListQueryVariables>(ExportItemListDocument, options);
      }
export function useExportItemListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExportItemListQuery, ExportItemListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExportItemListQuery, ExportItemListQueryVariables>(ExportItemListDocument, options);
        }
export type ExportItemListQueryHookResult = ReturnType<typeof useExportItemListQuery>;
export type ExportItemListLazyQueryHookResult = ReturnType<typeof useExportItemListLazyQuery>;
export type ExportItemListQueryResult = Apollo.QueryResult<ExportItemListQuery, ExportItemListQueryVariables>;
export const InventoryActivity_ItemTabDocument = gql`
    query InventoryActivity_ItemTab($page: Cursor, $filter: QueryItemsFilterInput, $sort: QueryItemsSortInput) {
  items(
    options: {paginationInput: {after: $page, first: 10000}, filter: $filter, sort: $sort}
  ) {
    pageInfo {
      ...pageInfoFields
    }
    nodes {
      ...inventoryActivity_itemTabItemFields
    }
  }
}
    ${PageInfoFieldsFragmentDoc}
${InventoryActivity_ItemTabItemFieldsFragmentDoc}`;

/**
 * __useInventoryActivity_ItemTabQuery__
 *
 * To run a query within a React component, call `useInventoryActivity_ItemTabQuery` and pass it any options that fit your needs.
 * When your component renders, `useInventoryActivity_ItemTabQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInventoryActivity_ItemTabQuery({
 *   variables: {
 *      page: // value for 'page'
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useInventoryActivity_ItemTabQuery(baseOptions?: Apollo.QueryHookOptions<InventoryActivity_ItemTabQuery, InventoryActivity_ItemTabQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InventoryActivity_ItemTabQuery, InventoryActivity_ItemTabQueryVariables>(InventoryActivity_ItemTabDocument, options);
      }
export function useInventoryActivity_ItemTabLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InventoryActivity_ItemTabQuery, InventoryActivity_ItemTabQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InventoryActivity_ItemTabQuery, InventoryActivity_ItemTabQueryVariables>(InventoryActivity_ItemTabDocument, options);
        }
export type InventoryActivity_ItemTabQueryHookResult = ReturnType<typeof useInventoryActivity_ItemTabQuery>;
export type InventoryActivity_ItemTabLazyQueryHookResult = ReturnType<typeof useInventoryActivity_ItemTabLazyQuery>;
export type InventoryActivity_ItemTabQueryResult = Apollo.QueryResult<InventoryActivity_ItemTabQuery, InventoryActivity_ItemTabQueryVariables>;
export const BulkUpdateListedStoresModalDocument = gql`
    query BulkUpdateListedStoresModal($itemId: ID!) {
  stores(options: {filter: {types: [wooCommerce, wooCommerce_buyWithAmazon]}}) {
    pageInfo {
      ...pageInfoFields
    }
    nodes {
      id
      name
      isInventoryManagementDisabled: isFeatureDisabled(
        featureName: reportInventoryLevels
      )
    }
  }
  item(id: $itemId) {
    id
    defaultPriceDollars
    listings(options: {}) {
      pageInfo {
        ...pageInfoFields
      }
      nodes {
        id
        regularPriceDollars
        store {
          id
        }
      }
    }
    listingManagementStrategies {
      id
      priceDollars
      store {
        id
      }
    }
  }
}
    ${PageInfoFieldsFragmentDoc}`;

/**
 * __useBulkUpdateListedStoresModalQuery__
 *
 * To run a query within a React component, call `useBulkUpdateListedStoresModalQuery` and pass it any options that fit your needs.
 * When your component renders, `useBulkUpdateListedStoresModalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBulkUpdateListedStoresModalQuery({
 *   variables: {
 *      itemId: // value for 'itemId'
 *   },
 * });
 */
export function useBulkUpdateListedStoresModalQuery(baseOptions: Apollo.QueryHookOptions<BulkUpdateListedStoresModalQuery, BulkUpdateListedStoresModalQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BulkUpdateListedStoresModalQuery, BulkUpdateListedStoresModalQueryVariables>(BulkUpdateListedStoresModalDocument, options);
      }
export function useBulkUpdateListedStoresModalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BulkUpdateListedStoresModalQuery, BulkUpdateListedStoresModalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BulkUpdateListedStoresModalQuery, BulkUpdateListedStoresModalQueryVariables>(BulkUpdateListedStoresModalDocument, options);
        }
export type BulkUpdateListedStoresModalQueryHookResult = ReturnType<typeof useBulkUpdateListedStoresModalQuery>;
export type BulkUpdateListedStoresModalLazyQueryHookResult = ReturnType<typeof useBulkUpdateListedStoresModalLazyQuery>;
export type BulkUpdateListedStoresModalQueryResult = Apollo.QueryResult<BulkUpdateListedStoresModalQuery, BulkUpdateListedStoresModalQueryVariables>;
export const SaveListingManagementStrategiesByItemDocument = gql`
    mutation SaveListingManagementStrategiesByItem($input: SaveListingManagementStrategiesByItemInput!) {
  saveListingManagementStrategiesByItem(input: $input) {
    id
    listings(options: {}) {
      pageInfo {
        ...pageInfoFields
      }
      nodes {
        id
        regularPriceDollars
        urlToListing
        store {
          id
          logoUrl
          name
        }
      }
    }
    listingManagementStrategies {
      id
      isActive
      priceDollars
      store {
        id
      }
    }
  }
}
    ${PageInfoFieldsFragmentDoc}`;
export type SaveListingManagementStrategiesByItemMutationFn = Apollo.MutationFunction<SaveListingManagementStrategiesByItemMutation, SaveListingManagementStrategiesByItemMutationVariables>;

/**
 * __useSaveListingManagementStrategiesByItemMutation__
 *
 * To run a mutation, you first call `useSaveListingManagementStrategiesByItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveListingManagementStrategiesByItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveListingManagementStrategiesByItemMutation, { data, loading, error }] = useSaveListingManagementStrategiesByItemMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveListingManagementStrategiesByItemMutation(baseOptions?: Apollo.MutationHookOptions<SaveListingManagementStrategiesByItemMutation, SaveListingManagementStrategiesByItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveListingManagementStrategiesByItemMutation, SaveListingManagementStrategiesByItemMutationVariables>(SaveListingManagementStrategiesByItemDocument, options);
      }
export type SaveListingManagementStrategiesByItemMutationHookResult = ReturnType<typeof useSaveListingManagementStrategiesByItemMutation>;
export type SaveListingManagementStrategiesByItemMutationResult = Apollo.MutationResult<SaveListingManagementStrategiesByItemMutation>;
export type SaveListingManagementStrategiesByItemMutationOptions = Apollo.BaseMutationOptions<SaveListingManagementStrategiesByItemMutation, SaveListingManagementStrategiesByItemMutationVariables>;
export const DeleteListingManagementStrategyDocument = gql`
    mutation DeleteListingManagementStrategy($id: ID!) {
  deleteListingManagementStrategy(id: $id) {
    id
    listingManagementStrategies {
      id
    }
  }
}
    `;
export type DeleteListingManagementStrategyMutationFn = Apollo.MutationFunction<DeleteListingManagementStrategyMutation, DeleteListingManagementStrategyMutationVariables>;

/**
 * __useDeleteListingManagementStrategyMutation__
 *
 * To run a mutation, you first call `useDeleteListingManagementStrategyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteListingManagementStrategyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteListingManagementStrategyMutation, { data, loading, error }] = useDeleteListingManagementStrategyMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteListingManagementStrategyMutation(baseOptions?: Apollo.MutationHookOptions<DeleteListingManagementStrategyMutation, DeleteListingManagementStrategyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteListingManagementStrategyMutation, DeleteListingManagementStrategyMutationVariables>(DeleteListingManagementStrategyDocument, options);
      }
export type DeleteListingManagementStrategyMutationHookResult = ReturnType<typeof useDeleteListingManagementStrategyMutation>;
export type DeleteListingManagementStrategyMutationResult = Apollo.MutationResult<DeleteListingManagementStrategyMutation>;
export type DeleteListingManagementStrategyMutationOptions = Apollo.BaseMutationOptions<DeleteListingManagementStrategyMutation, DeleteListingManagementStrategyMutationVariables>;
export const InventoryActivity_ItemDetailDrawerDocument = gql`
    query InventoryActivity_ItemDetailDrawer($itemId: ID!) {
  item(id: $itemId) {
    id
    sku
    name
    description
    weightValue
    weightUnit
    defaultPriceDollars
    defaultWholesalePriceDollars
    defaultCostDollars
    deviceType
    listingManagementStrategies {
      id
      isActive
      priceDollars
      store {
        id
        name
        isInventoryManagementDisabled: isFeatureDisabled(
          featureName: reportInventoryLevels
        )
      }
    }
    itemBaselineQuantities {
      id
      itemId
      quantity
      locationId
      locationName
    }
  }
}
    `;

/**
 * __useInventoryActivity_ItemDetailDrawerQuery__
 *
 * To run a query within a React component, call `useInventoryActivity_ItemDetailDrawerQuery` and pass it any options that fit your needs.
 * When your component renders, `useInventoryActivity_ItemDetailDrawerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInventoryActivity_ItemDetailDrawerQuery({
 *   variables: {
 *      itemId: // value for 'itemId'
 *   },
 * });
 */
export function useInventoryActivity_ItemDetailDrawerQuery(baseOptions: Apollo.QueryHookOptions<InventoryActivity_ItemDetailDrawerQuery, InventoryActivity_ItemDetailDrawerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InventoryActivity_ItemDetailDrawerQuery, InventoryActivity_ItemDetailDrawerQueryVariables>(InventoryActivity_ItemDetailDrawerDocument, options);
      }
export function useInventoryActivity_ItemDetailDrawerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InventoryActivity_ItemDetailDrawerQuery, InventoryActivity_ItemDetailDrawerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InventoryActivity_ItemDetailDrawerQuery, InventoryActivity_ItemDetailDrawerQueryVariables>(InventoryActivity_ItemDetailDrawerDocument, options);
        }
export type InventoryActivity_ItemDetailDrawerQueryHookResult = ReturnType<typeof useInventoryActivity_ItemDetailDrawerQuery>;
export type InventoryActivity_ItemDetailDrawerLazyQueryHookResult = ReturnType<typeof useInventoryActivity_ItemDetailDrawerLazyQuery>;
export type InventoryActivity_ItemDetailDrawerQueryResult = Apollo.QueryResult<InventoryActivity_ItemDetailDrawerQuery, InventoryActivity_ItemDetailDrawerQueryVariables>;
export const ToggleListingManagementStrategiesForItemDocument = gql`
    mutation ToggleListingManagementStrategiesForItem($input: ToggleListingManagementStrategiesForItemInput!) {
  toggleListingManagementStrategiesForItem(input: $input) {
    id
    listingManagementStrategies {
      id
      isActive
    }
  }
}
    `;
export type ToggleListingManagementStrategiesForItemMutationFn = Apollo.MutationFunction<ToggleListingManagementStrategiesForItemMutation, ToggleListingManagementStrategiesForItemMutationVariables>;

/**
 * __useToggleListingManagementStrategiesForItemMutation__
 *
 * To run a mutation, you first call `useToggleListingManagementStrategiesForItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleListingManagementStrategiesForItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleListingManagementStrategiesForItemMutation, { data, loading, error }] = useToggleListingManagementStrategiesForItemMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useToggleListingManagementStrategiesForItemMutation(baseOptions?: Apollo.MutationHookOptions<ToggleListingManagementStrategiesForItemMutation, ToggleListingManagementStrategiesForItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ToggleListingManagementStrategiesForItemMutation, ToggleListingManagementStrategiesForItemMutationVariables>(ToggleListingManagementStrategiesForItemDocument, options);
      }
export type ToggleListingManagementStrategiesForItemMutationHookResult = ReturnType<typeof useToggleListingManagementStrategiesForItemMutation>;
export type ToggleListingManagementStrategiesForItemMutationResult = Apollo.MutationResult<ToggleListingManagementStrategiesForItemMutation>;
export type ToggleListingManagementStrategiesForItemMutationOptions = Apollo.BaseMutationOptions<ToggleListingManagementStrategiesForItemMutation, ToggleListingManagementStrategiesForItemMutationVariables>;
export const SaveItemPriceDocument = gql`
    mutation SaveItemPrice($input: SaveItemInput!) {
  saveItem(input: $input) {
    id
    defaultPriceDollars
    defaultWholesalePriceDollars
    listings(options: {}) {
      pageInfo {
        ...pageInfoFields
      }
      nodes {
        id
        regularPriceDollars
        urlToListing
        store {
          id
          logoUrl
          name
        }
      }
    }
    listingManagementStrategies {
      id
      isActive
      priceDollars
      store {
        id
      }
    }
  }
}
    ${PageInfoFieldsFragmentDoc}`;
export type SaveItemPriceMutationFn = Apollo.MutationFunction<SaveItemPriceMutation, SaveItemPriceMutationVariables>;

/**
 * __useSaveItemPriceMutation__
 *
 * To run a mutation, you first call `useSaveItemPriceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveItemPriceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveItemPriceMutation, { data, loading, error }] = useSaveItemPriceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveItemPriceMutation(baseOptions?: Apollo.MutationHookOptions<SaveItemPriceMutation, SaveItemPriceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveItemPriceMutation, SaveItemPriceMutationVariables>(SaveItemPriceDocument, options);
      }
export type SaveItemPriceMutationHookResult = ReturnType<typeof useSaveItemPriceMutation>;
export type SaveItemPriceMutationResult = Apollo.MutationResult<SaveItemPriceMutation>;
export type SaveItemPriceMutationOptions = Apollo.BaseMutationOptions<SaveItemPriceMutation, SaveItemPriceMutationVariables>;
export const SaveListingManagementStrategyDocument = gql`
    mutation SaveListingManagementStrategy($input: SaveListingManagementStrategyInput!) {
  saveListingManagementStrategy(input: $input) {
    id
    listingManagementStrategies {
      id
      priceDollars
    }
  }
}
    `;
export type SaveListingManagementStrategyMutationFn = Apollo.MutationFunction<SaveListingManagementStrategyMutation, SaveListingManagementStrategyMutationVariables>;

/**
 * __useSaveListingManagementStrategyMutation__
 *
 * To run a mutation, you first call `useSaveListingManagementStrategyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveListingManagementStrategyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveListingManagementStrategyMutation, { data, loading, error }] = useSaveListingManagementStrategyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveListingManagementStrategyMutation(baseOptions?: Apollo.MutationHookOptions<SaveListingManagementStrategyMutation, SaveListingManagementStrategyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveListingManagementStrategyMutation, SaveListingManagementStrategyMutationVariables>(SaveListingManagementStrategyDocument, options);
      }
export type SaveListingManagementStrategyMutationHookResult = ReturnType<typeof useSaveListingManagementStrategyMutation>;
export type SaveListingManagementStrategyMutationResult = Apollo.MutationResult<SaveListingManagementStrategyMutation>;
export type SaveListingManagementStrategyMutationOptions = Apollo.BaseMutationOptions<SaveListingManagementStrategyMutation, SaveListingManagementStrategyMutationVariables>;
export const ListItemModalDocument = gql`
    query ListItemModal($storeId: ID!) {
  items(options: {filter: {hasListingManagementStrategyForStoreId: $storeId}}) {
    pageInfo {
      ...pageInfoFields
    }
    nodes {
      id
      sku
      name
      defaultPriceDollars
    }
  }
}
    ${PageInfoFieldsFragmentDoc}`;

/**
 * __useListItemModalQuery__
 *
 * To run a query within a React component, call `useListItemModalQuery` and pass it any options that fit your needs.
 * When your component renders, `useListItemModalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListItemModalQuery({
 *   variables: {
 *      storeId: // value for 'storeId'
 *   },
 * });
 */
export function useListItemModalQuery(baseOptions: Apollo.QueryHookOptions<ListItemModalQuery, ListItemModalQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListItemModalQuery, ListItemModalQueryVariables>(ListItemModalDocument, options);
      }
export function useListItemModalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListItemModalQuery, ListItemModalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListItemModalQuery, ListItemModalQueryVariables>(ListItemModalDocument, options);
        }
export type ListItemModalQueryHookResult = ReturnType<typeof useListItemModalQuery>;
export type ListItemModalLazyQueryHookResult = ReturnType<typeof useListItemModalLazyQuery>;
export type ListItemModalQueryResult = Apollo.QueryResult<ListItemModalQuery, ListItemModalQueryVariables>;
export const SaveListingManagementStrategiesByStoreDocument = gql`
    mutation SaveListingManagementStrategiesByStore($input: SaveListingManagementStrategiesByStoreInput!) {
  saveListingManagementStrategiesByStore(input: $input) {
    ...inventoryActivity_itemTabItemFields
    listingManagementStrategies {
      id
      priceDollars
      isActive
    }
  }
}
    ${InventoryActivity_ItemTabItemFieldsFragmentDoc}`;
export type SaveListingManagementStrategiesByStoreMutationFn = Apollo.MutationFunction<SaveListingManagementStrategiesByStoreMutation, SaveListingManagementStrategiesByStoreMutationVariables>;

/**
 * __useSaveListingManagementStrategiesByStoreMutation__
 *
 * To run a mutation, you first call `useSaveListingManagementStrategiesByStoreMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveListingManagementStrategiesByStoreMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveListingManagementStrategiesByStoreMutation, { data, loading, error }] = useSaveListingManagementStrategiesByStoreMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveListingManagementStrategiesByStoreMutation(baseOptions?: Apollo.MutationHookOptions<SaveListingManagementStrategiesByStoreMutation, SaveListingManagementStrategiesByStoreMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveListingManagementStrategiesByStoreMutation, SaveListingManagementStrategiesByStoreMutationVariables>(SaveListingManagementStrategiesByStoreDocument, options);
      }
export type SaveListingManagementStrategiesByStoreMutationHookResult = ReturnType<typeof useSaveListingManagementStrategiesByStoreMutation>;
export type SaveListingManagementStrategiesByStoreMutationResult = Apollo.MutationResult<SaveListingManagementStrategiesByStoreMutation>;
export type SaveListingManagementStrategiesByStoreMutationOptions = Apollo.BaseMutationOptions<SaveListingManagementStrategiesByStoreMutation, SaveListingManagementStrategiesByStoreMutationVariables>;
export const InventoryActivity_TemplateTabDocument = gql`
    query InventoryActivity_TemplateTab {
  listingManagementStrategyTemplateGroups(options: {}) {
    pageInfo {
      ...pageInfoFields
    }
    nodes {
      id
      createdTimestamp
      name
      templateCount
    }
  }
}
    ${PageInfoFieldsFragmentDoc}`;

/**
 * __useInventoryActivity_TemplateTabQuery__
 *
 * To run a query within a React component, call `useInventoryActivity_TemplateTabQuery` and pass it any options that fit your needs.
 * When your component renders, `useInventoryActivity_TemplateTabQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInventoryActivity_TemplateTabQuery({
 *   variables: {
 *   },
 * });
 */
export function useInventoryActivity_TemplateTabQuery(baseOptions?: Apollo.QueryHookOptions<InventoryActivity_TemplateTabQuery, InventoryActivity_TemplateTabQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InventoryActivity_TemplateTabQuery, InventoryActivity_TemplateTabQueryVariables>(InventoryActivity_TemplateTabDocument, options);
      }
export function useInventoryActivity_TemplateTabLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InventoryActivity_TemplateTabQuery, InventoryActivity_TemplateTabQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InventoryActivity_TemplateTabQuery, InventoryActivity_TemplateTabQueryVariables>(InventoryActivity_TemplateTabDocument, options);
        }
export type InventoryActivity_TemplateTabQueryHookResult = ReturnType<typeof useInventoryActivity_TemplateTabQuery>;
export type InventoryActivity_TemplateTabLazyQueryHookResult = ReturnType<typeof useInventoryActivity_TemplateTabLazyQuery>;
export type InventoryActivity_TemplateTabQueryResult = Apollo.QueryResult<InventoryActivity_TemplateTabQuery, InventoryActivity_TemplateTabQueryVariables>;
export const SaveListingManagementStrategyTemplateGroupDocument = gql`
    mutation SaveListingManagementStrategyTemplateGroup($input: SaveListingManagementStrategyTemplateGroupInput!) {
  saveListingManagementStrategyTemplateGroup(input: $input) {
    id
    createdTimestamp
    name
    templateCount
    templates {
      pageInfo {
        ...pageInfoFields
      }
      nodes {
        id
        priceDollars
        item {
          id
          sku
          name
        }
      }
    }
  }
}
    ${PageInfoFieldsFragmentDoc}`;
export type SaveListingManagementStrategyTemplateGroupMutationFn = Apollo.MutationFunction<SaveListingManagementStrategyTemplateGroupMutation, SaveListingManagementStrategyTemplateGroupMutationVariables>;

/**
 * __useSaveListingManagementStrategyTemplateGroupMutation__
 *
 * To run a mutation, you first call `useSaveListingManagementStrategyTemplateGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveListingManagementStrategyTemplateGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveListingManagementStrategyTemplateGroupMutation, { data, loading, error }] = useSaveListingManagementStrategyTemplateGroupMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveListingManagementStrategyTemplateGroupMutation(baseOptions?: Apollo.MutationHookOptions<SaveListingManagementStrategyTemplateGroupMutation, SaveListingManagementStrategyTemplateGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveListingManagementStrategyTemplateGroupMutation, SaveListingManagementStrategyTemplateGroupMutationVariables>(SaveListingManagementStrategyTemplateGroupDocument, options);
      }
export type SaveListingManagementStrategyTemplateGroupMutationHookResult = ReturnType<typeof useSaveListingManagementStrategyTemplateGroupMutation>;
export type SaveListingManagementStrategyTemplateGroupMutationResult = Apollo.MutationResult<SaveListingManagementStrategyTemplateGroupMutation>;
export type SaveListingManagementStrategyTemplateGroupMutationOptions = Apollo.BaseMutationOptions<SaveListingManagementStrategyTemplateGroupMutation, SaveListingManagementStrategyTemplateGroupMutationVariables>;
export const InventoryActivity_TemplateTab_TemplateGroupDrawerDocument = gql`
    query InventoryActivity_TemplateTab_TemplateGroupDrawer($templateId: ID!) {
  listingManagementStrategyTemplateGroup(id: $templateId) {
    id
    name
    templates {
      pageInfo {
        ...pageInfoFields
      }
      nodes {
        id
        priceDollars
        item {
          id
          sku
          name
        }
      }
    }
  }
}
    ${PageInfoFieldsFragmentDoc}`;

/**
 * __useInventoryActivity_TemplateTab_TemplateGroupDrawerQuery__
 *
 * To run a query within a React component, call `useInventoryActivity_TemplateTab_TemplateGroupDrawerQuery` and pass it any options that fit your needs.
 * When your component renders, `useInventoryActivity_TemplateTab_TemplateGroupDrawerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInventoryActivity_TemplateTab_TemplateGroupDrawerQuery({
 *   variables: {
 *      templateId: // value for 'templateId'
 *   },
 * });
 */
export function useInventoryActivity_TemplateTab_TemplateGroupDrawerQuery(baseOptions: Apollo.QueryHookOptions<InventoryActivity_TemplateTab_TemplateGroupDrawerQuery, InventoryActivity_TemplateTab_TemplateGroupDrawerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InventoryActivity_TemplateTab_TemplateGroupDrawerQuery, InventoryActivity_TemplateTab_TemplateGroupDrawerQueryVariables>(InventoryActivity_TemplateTab_TemplateGroupDrawerDocument, options);
      }
export function useInventoryActivity_TemplateTab_TemplateGroupDrawerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InventoryActivity_TemplateTab_TemplateGroupDrawerQuery, InventoryActivity_TemplateTab_TemplateGroupDrawerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InventoryActivity_TemplateTab_TemplateGroupDrawerQuery, InventoryActivity_TemplateTab_TemplateGroupDrawerQueryVariables>(InventoryActivity_TemplateTab_TemplateGroupDrawerDocument, options);
        }
export type InventoryActivity_TemplateTab_TemplateGroupDrawerQueryHookResult = ReturnType<typeof useInventoryActivity_TemplateTab_TemplateGroupDrawerQuery>;
export type InventoryActivity_TemplateTab_TemplateGroupDrawerLazyQueryHookResult = ReturnType<typeof useInventoryActivity_TemplateTab_TemplateGroupDrawerLazyQuery>;
export type InventoryActivity_TemplateTab_TemplateGroupDrawerQueryResult = Apollo.QueryResult<InventoryActivity_TemplateTab_TemplateGroupDrawerQuery, InventoryActivity_TemplateTab_TemplateGroupDrawerQueryVariables>;
export const PendingWritesTabDocument = gql`
    query PendingWritesTab($filter: QueryEligibleOrdersNotInNetSuiteFilterInput) {
  eligibleOrdersNotInNetSuite(options: {filter: $filter}) {
    pageInfo {
      ...pageInfoFields
    }
    nodes {
      id
      order {
        id
        orderNumber
        orderDate
        store {
          id
        }
      }
      criteria {
        status
        code
        description
      }
    }
  }
}
    ${PageInfoFieldsFragmentDoc}`;

/**
 * __usePendingWritesTabQuery__
 *
 * To run a query within a React component, call `usePendingWritesTabQuery` and pass it any options that fit your needs.
 * When your component renders, `usePendingWritesTabQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePendingWritesTabQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function usePendingWritesTabQuery(baseOptions?: Apollo.QueryHookOptions<PendingWritesTabQuery, PendingWritesTabQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PendingWritesTabQuery, PendingWritesTabQueryVariables>(PendingWritesTabDocument, options);
      }
export function usePendingWritesTabLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PendingWritesTabQuery, PendingWritesTabQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PendingWritesTabQuery, PendingWritesTabQueryVariables>(PendingWritesTabDocument, options);
        }
export type PendingWritesTabQueryHookResult = ReturnType<typeof usePendingWritesTabQuery>;
export type PendingWritesTabLazyQueryHookResult = ReturnType<typeof usePendingWritesTabLazyQuery>;
export type PendingWritesTabQueryResult = Apollo.QueryResult<PendingWritesTabQuery, PendingWritesTabQueryVariables>;
export const ExportNetSuiteXmlRequestsDocument = gql`
    query ExportNetSuiteXmlRequests($orderIds: [ID!]!) {
  exportNetSuiteXmlRequests(orderIds: $orderIds)
}
    `;

/**
 * __useExportNetSuiteXmlRequestsQuery__
 *
 * To run a query within a React component, call `useExportNetSuiteXmlRequestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useExportNetSuiteXmlRequestsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExportNetSuiteXmlRequestsQuery({
 *   variables: {
 *      orderIds: // value for 'orderIds'
 *   },
 * });
 */
export function useExportNetSuiteXmlRequestsQuery(baseOptions: Apollo.QueryHookOptions<ExportNetSuiteXmlRequestsQuery, ExportNetSuiteXmlRequestsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExportNetSuiteXmlRequestsQuery, ExportNetSuiteXmlRequestsQueryVariables>(ExportNetSuiteXmlRequestsDocument, options);
      }
export function useExportNetSuiteXmlRequestsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExportNetSuiteXmlRequestsQuery, ExportNetSuiteXmlRequestsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExportNetSuiteXmlRequestsQuery, ExportNetSuiteXmlRequestsQueryVariables>(ExportNetSuiteXmlRequestsDocument, options);
        }
export type ExportNetSuiteXmlRequestsQueryHookResult = ReturnType<typeof useExportNetSuiteXmlRequestsQuery>;
export type ExportNetSuiteXmlRequestsLazyQueryHookResult = ReturnType<typeof useExportNetSuiteXmlRequestsLazyQuery>;
export type ExportNetSuiteXmlRequestsQueryResult = Apollo.QueryResult<ExportNetSuiteXmlRequestsQuery, ExportNetSuiteXmlRequestsQueryVariables>;
export const NetSuiteActivity_SoapRequestTabDocument = gql`
    query NetSuiteActivity_SOAPRequestTab($page: Cursor, $filter: QueryOrdersFilterInput, $sort: QueryOrdersSortInput) {
  orders(
    options: {paginationInput: {after: $page, first: 50}, filter: $filter, sort: $sort}
  ) {
    pageInfo {
      ...pageInfoFields
    }
    nodes {
      id
      orderNumber
      orderDate
      customer {
        id
        email
      }
      store {
        id
        name
        department {
          id
          name
        }
        inventoryLocation {
          id
          name
        }
        subsidiary {
          id
          name
        }
        taxItem {
          id
          name
        }
      }
    }
  }
}
    ${PageInfoFieldsFragmentDoc}`;

/**
 * __useNetSuiteActivity_SoapRequestTabQuery__
 *
 * To run a query within a React component, call `useNetSuiteActivity_SoapRequestTabQuery` and pass it any options that fit your needs.
 * When your component renders, `useNetSuiteActivity_SoapRequestTabQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNetSuiteActivity_SoapRequestTabQuery({
 *   variables: {
 *      page: // value for 'page'
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useNetSuiteActivity_SoapRequestTabQuery(baseOptions?: Apollo.QueryHookOptions<NetSuiteActivity_SoapRequestTabQuery, NetSuiteActivity_SoapRequestTabQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NetSuiteActivity_SoapRequestTabQuery, NetSuiteActivity_SoapRequestTabQueryVariables>(NetSuiteActivity_SoapRequestTabDocument, options);
      }
export function useNetSuiteActivity_SoapRequestTabLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NetSuiteActivity_SoapRequestTabQuery, NetSuiteActivity_SoapRequestTabQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NetSuiteActivity_SoapRequestTabQuery, NetSuiteActivity_SoapRequestTabQueryVariables>(NetSuiteActivity_SoapRequestTabDocument, options);
        }
export type NetSuiteActivity_SoapRequestTabQueryHookResult = ReturnType<typeof useNetSuiteActivity_SoapRequestTabQuery>;
export type NetSuiteActivity_SoapRequestTabLazyQueryHookResult = ReturnType<typeof useNetSuiteActivity_SoapRequestTabLazyQuery>;
export type NetSuiteActivity_SoapRequestTabQueryResult = Apollo.QueryResult<NetSuiteActivity_SoapRequestTabQuery, NetSuiteActivity_SoapRequestTabQueryVariables>;
export const ArchiveValidationErrorsDocument = gql`
    mutation ArchiveValidationErrors($writeRequestId: ID!) {
  archiveWriteRequestValidationErrors(writeRequestId: $writeRequestId)
}
    `;
export type ArchiveValidationErrorsMutationFn = Apollo.MutationFunction<ArchiveValidationErrorsMutation, ArchiveValidationErrorsMutationVariables>;

/**
 * __useArchiveValidationErrorsMutation__
 *
 * To run a mutation, you first call `useArchiveValidationErrorsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveValidationErrorsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveValidationErrorsMutation, { data, loading, error }] = useArchiveValidationErrorsMutation({
 *   variables: {
 *      writeRequestId: // value for 'writeRequestId'
 *   },
 * });
 */
export function useArchiveValidationErrorsMutation(baseOptions?: Apollo.MutationHookOptions<ArchiveValidationErrorsMutation, ArchiveValidationErrorsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ArchiveValidationErrorsMutation, ArchiveValidationErrorsMutationVariables>(ArchiveValidationErrorsDocument, options);
      }
export type ArchiveValidationErrorsMutationHookResult = ReturnType<typeof useArchiveValidationErrorsMutation>;
export type ArchiveValidationErrorsMutationResult = Apollo.MutationResult<ArchiveValidationErrorsMutation>;
export type ArchiveValidationErrorsMutationOptions = Apollo.BaseMutationOptions<ArchiveValidationErrorsMutation, ArchiveValidationErrorsMutationVariables>;
export const ClearValidationErrorsDocument = gql`
    mutation ClearValidationErrors($storeId: ID, $writeRequestId: ID) {
  clearInvalidWriteRequests(storeId: $storeId, writeRequestId: $writeRequestId)
}
    `;
export type ClearValidationErrorsMutationFn = Apollo.MutationFunction<ClearValidationErrorsMutation, ClearValidationErrorsMutationVariables>;

/**
 * __useClearValidationErrorsMutation__
 *
 * To run a mutation, you first call `useClearValidationErrorsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useClearValidationErrorsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [clearValidationErrorsMutation, { data, loading, error }] = useClearValidationErrorsMutation({
 *   variables: {
 *      storeId: // value for 'storeId'
 *      writeRequestId: // value for 'writeRequestId'
 *   },
 * });
 */
export function useClearValidationErrorsMutation(baseOptions?: Apollo.MutationHookOptions<ClearValidationErrorsMutation, ClearValidationErrorsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ClearValidationErrorsMutation, ClearValidationErrorsMutationVariables>(ClearValidationErrorsDocument, options);
      }
export type ClearValidationErrorsMutationHookResult = ReturnType<typeof useClearValidationErrorsMutation>;
export type ClearValidationErrorsMutationResult = Apollo.MutationResult<ClearValidationErrorsMutation>;
export type ClearValidationErrorsMutationOptions = Apollo.BaseMutationOptions<ClearValidationErrorsMutation, ClearValidationErrorsMutationVariables>;
export const EditWriteRequestModalDocument = gql`
    query EditWriteRequestModal($writeRequestId: ID!) {
  netSuiteWriteRequest(id: $writeRequestId) {
    id
    format
    validationErrors
    requestData
  }
}
    `;

/**
 * __useEditWriteRequestModalQuery__
 *
 * To run a query within a React component, call `useEditWriteRequestModalQuery` and pass it any options that fit your needs.
 * When your component renders, `useEditWriteRequestModalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEditWriteRequestModalQuery({
 *   variables: {
 *      writeRequestId: // value for 'writeRequestId'
 *   },
 * });
 */
export function useEditWriteRequestModalQuery(baseOptions: Apollo.QueryHookOptions<EditWriteRequestModalQuery, EditWriteRequestModalQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EditWriteRequestModalQuery, EditWriteRequestModalQueryVariables>(EditWriteRequestModalDocument, options);
      }
export function useEditWriteRequestModalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EditWriteRequestModalQuery, EditWriteRequestModalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EditWriteRequestModalQuery, EditWriteRequestModalQueryVariables>(EditWriteRequestModalDocument, options);
        }
export type EditWriteRequestModalQueryHookResult = ReturnType<typeof useEditWriteRequestModalQuery>;
export type EditWriteRequestModalLazyQueryHookResult = ReturnType<typeof useEditWriteRequestModalLazyQuery>;
export type EditWriteRequestModalQueryResult = Apollo.QueryResult<EditWriteRequestModalQuery, EditWriteRequestModalQueryVariables>;
export const RegenerateWriteRequestDocument = gql`
    mutation RegenerateWriteRequest($id: ID!) {
  regenerateWriteRequest(id: $id) {
    id
    requestData
    validationErrors
    customer {
      id
      email
    }
    order {
      id
      orderNumber
    }
    record {
      id
    }
  }
}
    `;
export type RegenerateWriteRequestMutationFn = Apollo.MutationFunction<RegenerateWriteRequestMutation, RegenerateWriteRequestMutationVariables>;

/**
 * __useRegenerateWriteRequestMutation__
 *
 * To run a mutation, you first call `useRegenerateWriteRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegenerateWriteRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [regenerateWriteRequestMutation, { data, loading, error }] = useRegenerateWriteRequestMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRegenerateWriteRequestMutation(baseOptions?: Apollo.MutationHookOptions<RegenerateWriteRequestMutation, RegenerateWriteRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RegenerateWriteRequestMutation, RegenerateWriteRequestMutationVariables>(RegenerateWriteRequestDocument, options);
      }
export type RegenerateWriteRequestMutationHookResult = ReturnType<typeof useRegenerateWriteRequestMutation>;
export type RegenerateWriteRequestMutationResult = Apollo.MutationResult<RegenerateWriteRequestMutation>;
export type RegenerateWriteRequestMutationOptions = Apollo.BaseMutationOptions<RegenerateWriteRequestMutation, RegenerateWriteRequestMutationVariables>;
export const SaveAndValidateWriteRequestDocument = gql`
    mutation SaveAndValidateWriteRequest($input: SaveAndValidateWriteRequestInput!) {
  saveAndValidateWriteRequest(input: $input) {
    id
    requestData
    validationErrors
    customer {
      id
      email
    }
    order {
      id
      orderNumber
    }
    record {
      id
    }
  }
}
    `;
export type SaveAndValidateWriteRequestMutationFn = Apollo.MutationFunction<SaveAndValidateWriteRequestMutation, SaveAndValidateWriteRequestMutationVariables>;

/**
 * __useSaveAndValidateWriteRequestMutation__
 *
 * To run a mutation, you first call `useSaveAndValidateWriteRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveAndValidateWriteRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveAndValidateWriteRequestMutation, { data, loading, error }] = useSaveAndValidateWriteRequestMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveAndValidateWriteRequestMutation(baseOptions?: Apollo.MutationHookOptions<SaveAndValidateWriteRequestMutation, SaveAndValidateWriteRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveAndValidateWriteRequestMutation, SaveAndValidateWriteRequestMutationVariables>(SaveAndValidateWriteRequestDocument, options);
      }
export type SaveAndValidateWriteRequestMutationHookResult = ReturnType<typeof useSaveAndValidateWriteRequestMutation>;
export type SaveAndValidateWriteRequestMutationResult = Apollo.MutationResult<SaveAndValidateWriteRequestMutation>;
export type SaveAndValidateWriteRequestMutationOptions = Apollo.BaseMutationOptions<SaveAndValidateWriteRequestMutation, SaveAndValidateWriteRequestMutationVariables>;
export const NetSuite_ValidationErrorsTabDocument = gql`
    query NetSuite_ValidationErrorsTab($storeId: ID) {
  netSuiteWriteRequests(
    options: {filter: {storeId: $storeId, hasValidationError: true}}
  ) {
    pageInfo {
      ...pageInfoFields
    }
    nodes {
      id
      format
      requestData
      validationErrors
      customer {
        id
        email
      }
      order {
        id
        orderNumber
      }
      record {
        id
      }
      returnAuthorization {
        id
        returnNumber
      }
    }
  }
}
    ${PageInfoFieldsFragmentDoc}`;

/**
 * __useNetSuite_ValidationErrorsTabQuery__
 *
 * To run a query within a React component, call `useNetSuite_ValidationErrorsTabQuery` and pass it any options that fit your needs.
 * When your component renders, `useNetSuite_ValidationErrorsTabQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNetSuite_ValidationErrorsTabQuery({
 *   variables: {
 *      storeId: // value for 'storeId'
 *   },
 * });
 */
export function useNetSuite_ValidationErrorsTabQuery(baseOptions?: Apollo.QueryHookOptions<NetSuite_ValidationErrorsTabQuery, NetSuite_ValidationErrorsTabQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NetSuite_ValidationErrorsTabQuery, NetSuite_ValidationErrorsTabQueryVariables>(NetSuite_ValidationErrorsTabDocument, options);
      }
export function useNetSuite_ValidationErrorsTabLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NetSuite_ValidationErrorsTabQuery, NetSuite_ValidationErrorsTabQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NetSuite_ValidationErrorsTabQuery, NetSuite_ValidationErrorsTabQueryVariables>(NetSuite_ValidationErrorsTabDocument, options);
        }
export type NetSuite_ValidationErrorsTabQueryHookResult = ReturnType<typeof useNetSuite_ValidationErrorsTabQuery>;
export type NetSuite_ValidationErrorsTabLazyQueryHookResult = ReturnType<typeof useNetSuite_ValidationErrorsTabLazyQuery>;
export type NetSuite_ValidationErrorsTabQueryResult = Apollo.QueryResult<NetSuite_ValidationErrorsTabQuery, NetSuite_ValidationErrorsTabQueryVariables>;
export const OrderDetailActivityDocument = gql`
    query OrderDetailActivity($orderId: ID!) {
  order(id: $orderId) {
    id
    orderNumber
    orderDate
    customer {
      id
      firstName
      lastName
      email
    }
    status {
      id
      name
      displayName
    }
    paymentMethod {
      id
      name
      displayName
    }
    netSuitePaymentMethod {
      id
      name
    }
    smartPayLeaseApplication {
      id
      applicationNumber
      steps {
        id
        name {
          id
          name
          displayName
        }
        status {
          id
          name
          displayName
        }
      }
    }
    shipStationOrder {
      id
      rawData
    }
    shipStationShipment {
      id
      rawData
    }
    shipment {
      id
      carrierCode
      trackingNumber
    }
    billingAddress {
      street1
      street2
      city
      usState
      postalCode
      company
      phone
    }
    shippingAddress {
      street1
      street2
      city
      usState
      postalCode
      company
      phone
    }
    e1Data {
      headerRow {
        columnName
        value
      }
      addressRow {
        columnName
        value
      }
      detailRows {
        columnName
        value
      }
    }
    lineItems {
      id
      itemTotalCents
      taxTotalCents
      quantity
      product {
        id
        sku
        name
      }
    }
    shipStationOrder {
      id
    }
    shipStationShipment {
      id
    }
    rawSourceOrder {
      id
      externalId
      rawData
    }
    e1DeviceLedger {
      sku
      imei
      iccid
    }
  }
}
    `;

/**
 * __useOrderDetailActivityQuery__
 *
 * To run a query within a React component, call `useOrderDetailActivityQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrderDetailActivityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrderDetailActivityQuery({
 *   variables: {
 *      orderId: // value for 'orderId'
 *   },
 * });
 */
export function useOrderDetailActivityQuery(baseOptions: Apollo.QueryHookOptions<OrderDetailActivityQuery, OrderDetailActivityQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrderDetailActivityQuery, OrderDetailActivityQueryVariables>(OrderDetailActivityDocument, options);
      }
export function useOrderDetailActivityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrderDetailActivityQuery, OrderDetailActivityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrderDetailActivityQuery, OrderDetailActivityQueryVariables>(OrderDetailActivityDocument, options);
        }
export type OrderDetailActivityQueryHookResult = ReturnType<typeof useOrderDetailActivityQuery>;
export type OrderDetailActivityLazyQueryHookResult = ReturnType<typeof useOrderDetailActivityLazyQuery>;
export type OrderDetailActivityQueryResult = Apollo.QueryResult<OrderDetailActivityQuery, OrderDetailActivityQueryVariables>;
export const OverrideLeaseApplicationDocument = gql`
    mutation OverrideLeaseApplication($input: OverrideLeaseApplicationInput!) {
  overrideLeaseApplication(input: $input)
}
    `;
export type OverrideLeaseApplicationMutationFn = Apollo.MutationFunction<OverrideLeaseApplicationMutation, OverrideLeaseApplicationMutationVariables>;

/**
 * __useOverrideLeaseApplicationMutation__
 *
 * To run a mutation, you first call `useOverrideLeaseApplicationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOverrideLeaseApplicationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [overrideLeaseApplicationMutation, { data, loading, error }] = useOverrideLeaseApplicationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useOverrideLeaseApplicationMutation(baseOptions?: Apollo.MutationHookOptions<OverrideLeaseApplicationMutation, OverrideLeaseApplicationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OverrideLeaseApplicationMutation, OverrideLeaseApplicationMutationVariables>(OverrideLeaseApplicationDocument, options);
      }
export type OverrideLeaseApplicationMutationHookResult = ReturnType<typeof useOverrideLeaseApplicationMutation>;
export type OverrideLeaseApplicationMutationResult = Apollo.MutationResult<OverrideLeaseApplicationMutation>;
export type OverrideLeaseApplicationMutationOptions = Apollo.BaseMutationOptions<OverrideLeaseApplicationMutation, OverrideLeaseApplicationMutationVariables>;
export const OverrideLeaseApplicationModalDocument = gql`
    query OverrideLeaseApplicationModal($orderId: ID!) {
  order(id: $orderId) {
    id
    lineItems {
      id
      itemTotalCents
      taxTotalCents
      product {
        id
        sku
      }
    }
    e1DeviceLedger {
      iccid
      imei
      sku
    }
    smartPayLeaseApplication {
      id
      applicationNumber
    }
  }
}
    `;

/**
 * __useOverrideLeaseApplicationModalQuery__
 *
 * To run a query within a React component, call `useOverrideLeaseApplicationModalQuery` and pass it any options that fit your needs.
 * When your component renders, `useOverrideLeaseApplicationModalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOverrideLeaseApplicationModalQuery({
 *   variables: {
 *      orderId: // value for 'orderId'
 *   },
 * });
 */
export function useOverrideLeaseApplicationModalQuery(baseOptions: Apollo.QueryHookOptions<OverrideLeaseApplicationModalQuery, OverrideLeaseApplicationModalQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OverrideLeaseApplicationModalQuery, OverrideLeaseApplicationModalQueryVariables>(OverrideLeaseApplicationModalDocument, options);
      }
export function useOverrideLeaseApplicationModalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OverrideLeaseApplicationModalQuery, OverrideLeaseApplicationModalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OverrideLeaseApplicationModalQuery, OverrideLeaseApplicationModalQueryVariables>(OverrideLeaseApplicationModalDocument, options);
        }
export type OverrideLeaseApplicationModalQueryHookResult = ReturnType<typeof useOverrideLeaseApplicationModalQuery>;
export type OverrideLeaseApplicationModalLazyQueryHookResult = ReturnType<typeof useOverrideLeaseApplicationModalLazyQuery>;
export type OverrideLeaseApplicationModalQueryResult = Apollo.QueryResult<OverrideLeaseApplicationModalQuery, OverrideLeaseApplicationModalQueryVariables>;
export const SmartPayLeaseApplicationSectionDocument = gql`
    query SmartPayLeaseApplicationSection($orderId: ID!) {
  order(id: $orderId) {
    id
    smartPayLeaseApplication {
      id
      applicationNumber
      apiRequests(options: {}) {
        nodes {
          id
          metaCreated
          method
          httpStatusCode
          url
          requestBody
          responseBody
        }
      }
      steps {
        id
        name {
          id
          name
          displayName
        }
        status {
          id
          name
          displayName
        }
      }
    }
  }
}
    `;

/**
 * __useSmartPayLeaseApplicationSectionQuery__
 *
 * To run a query within a React component, call `useSmartPayLeaseApplicationSectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useSmartPayLeaseApplicationSectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSmartPayLeaseApplicationSectionQuery({
 *   variables: {
 *      orderId: // value for 'orderId'
 *   },
 * });
 */
export function useSmartPayLeaseApplicationSectionQuery(baseOptions: Apollo.QueryHookOptions<SmartPayLeaseApplicationSectionQuery, SmartPayLeaseApplicationSectionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SmartPayLeaseApplicationSectionQuery, SmartPayLeaseApplicationSectionQueryVariables>(SmartPayLeaseApplicationSectionDocument, options);
      }
export function useSmartPayLeaseApplicationSectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SmartPayLeaseApplicationSectionQuery, SmartPayLeaseApplicationSectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SmartPayLeaseApplicationSectionQuery, SmartPayLeaseApplicationSectionQueryVariables>(SmartPayLeaseApplicationSectionDocument, options);
        }
export type SmartPayLeaseApplicationSectionQueryHookResult = ReturnType<typeof useSmartPayLeaseApplicationSectionQuery>;
export type SmartPayLeaseApplicationSectionLazyQueryHookResult = ReturnType<typeof useSmartPayLeaseApplicationSectionLazyQuery>;
export type SmartPayLeaseApplicationSectionQueryResult = Apollo.QueryResult<SmartPayLeaseApplicationSectionQuery, SmartPayLeaseApplicationSectionQueryVariables>;
export const ExportOrdersDocument = gql`
    query ExportOrders($options: QueryOrdersAsCsvOptionsInput!) {
  ordersAsCsv(options: $options)
}
    `;

/**
 * __useExportOrdersQuery__
 *
 * To run a query within a React component, call `useExportOrdersQuery` and pass it any options that fit your needs.
 * When your component renders, `useExportOrdersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExportOrdersQuery({
 *   variables: {
 *      options: // value for 'options'
 *   },
 * });
 */
export function useExportOrdersQuery(baseOptions: Apollo.QueryHookOptions<ExportOrdersQuery, ExportOrdersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExportOrdersQuery, ExportOrdersQueryVariables>(ExportOrdersDocument, options);
      }
export function useExportOrdersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExportOrdersQuery, ExportOrdersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExportOrdersQuery, ExportOrdersQueryVariables>(ExportOrdersDocument, options);
        }
export type ExportOrdersQueryHookResult = ReturnType<typeof useExportOrdersQuery>;
export type ExportOrdersLazyQueryHookResult = ReturnType<typeof useExportOrdersLazyQuery>;
export type ExportOrdersQueryResult = Apollo.QueryResult<ExportOrdersQuery, ExportOrdersQueryVariables>;
export const MockFulfillOrderDocument = gql`
    mutation MockFulfillOrder($orderId: ID!) {
  mockFulfillOrder(orderId: $orderId) {
    id
  }
}
    `;
export type MockFulfillOrderMutationFn = Apollo.MutationFunction<MockFulfillOrderMutation, MockFulfillOrderMutationVariables>;

/**
 * __useMockFulfillOrderMutation__
 *
 * To run a mutation, you first call `useMockFulfillOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMockFulfillOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [mockFulfillOrderMutation, { data, loading, error }] = useMockFulfillOrderMutation({
 *   variables: {
 *      orderId: // value for 'orderId'
 *   },
 * });
 */
export function useMockFulfillOrderMutation(baseOptions?: Apollo.MutationHookOptions<MockFulfillOrderMutation, MockFulfillOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MockFulfillOrderMutation, MockFulfillOrderMutationVariables>(MockFulfillOrderDocument, options);
      }
export type MockFulfillOrderMutationHookResult = ReturnType<typeof useMockFulfillOrderMutation>;
export type MockFulfillOrderMutationResult = Apollo.MutationResult<MockFulfillOrderMutation>;
export type MockFulfillOrderMutationOptions = Apollo.BaseMutationOptions<MockFulfillOrderMutation, MockFulfillOrderMutationVariables>;
export const ReconciliationReportActivityDocument = gql`
    query ReconciliationReportActivity($page: Cursor, $filter: QueryOrdersFilterInput, $sort: QueryOrdersSortInput) {
  orders(
    options: {paginationInput: {after: $page, first: 20}, filter: $filter, sort: $sort}
  ) {
    pageInfo {
      ...pageInfoFields
    }
    nodes {
      id
      orderNumber
      metaCreated
      cacheLastUpdatedTimestamp
      orderDate
      totalCents
      paymentMethod {
        id
        name
        displayName
      }
      rawSourceOrder {
        id
        externalId
        url
      }
      store {
        id
        metaData {
          ... on WooCommerceStoreMetaData {
            id
            baseUrl
          }
          ... on ShopifyStoreMetaData {
            id
            baseUrl
          }
        }
      }
      status {
        id
        name
        displayName
      }
      lineItems {
        id
      }
      shipStationOrder {
        id
        rawData
      }
      shipment {
        id
      }
      e1Data {
        detailRows {
          columnName
          value
        }
      }
      e1Data42File {
        detailRows {
          columnName
          value
        }
      }
      smartPayLeaseApplication {
        id
        applicationNumber
        steps {
          id
          name {
            id
            name
            displayName
          }
          status {
            id
            name
            displayName
          }
        }
      }
      shipStationShipment {
        id
        rawData
      }
      e1DeviceLedger {
        sku
      }
    }
  }
}
    ${PageInfoFieldsFragmentDoc}`;

/**
 * __useReconciliationReportActivityQuery__
 *
 * To run a query within a React component, call `useReconciliationReportActivityQuery` and pass it any options that fit your needs.
 * When your component renders, `useReconciliationReportActivityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReconciliationReportActivityQuery({
 *   variables: {
 *      page: // value for 'page'
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useReconciliationReportActivityQuery(baseOptions?: Apollo.QueryHookOptions<ReconciliationReportActivityQuery, ReconciliationReportActivityQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReconciliationReportActivityQuery, ReconciliationReportActivityQueryVariables>(ReconciliationReportActivityDocument, options);
      }
export function useReconciliationReportActivityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReconciliationReportActivityQuery, ReconciliationReportActivityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReconciliationReportActivityQuery, ReconciliationReportActivityQueryVariables>(ReconciliationReportActivityDocument, options);
        }
export type ReconciliationReportActivityQueryHookResult = ReturnType<typeof useReconciliationReportActivityQuery>;
export type ReconciliationReportActivityLazyQueryHookResult = ReturnType<typeof useReconciliationReportActivityLazyQuery>;
export type ReconciliationReportActivityQueryResult = Apollo.QueryResult<ReconciliationReportActivityQuery, ReconciliationReportActivityQueryVariables>;
export const ReconciliationReportActivity_FiltersDocument = gql`
    query ReconciliationReportActivity_Filters {
  orderStatuses {
    id
    name
    displayName
  }
}
    `;

/**
 * __useReconciliationReportActivity_FiltersQuery__
 *
 * To run a query within a React component, call `useReconciliationReportActivity_FiltersQuery` and pass it any options that fit your needs.
 * When your component renders, `useReconciliationReportActivity_FiltersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReconciliationReportActivity_FiltersQuery({
 *   variables: {
 *   },
 * });
 */
export function useReconciliationReportActivity_FiltersQuery(baseOptions?: Apollo.QueryHookOptions<ReconciliationReportActivity_FiltersQuery, ReconciliationReportActivity_FiltersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReconciliationReportActivity_FiltersQuery, ReconciliationReportActivity_FiltersQueryVariables>(ReconciliationReportActivity_FiltersDocument, options);
      }
export function useReconciliationReportActivity_FiltersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReconciliationReportActivity_FiltersQuery, ReconciliationReportActivity_FiltersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReconciliationReportActivity_FiltersQuery, ReconciliationReportActivity_FiltersQueryVariables>(ReconciliationReportActivity_FiltersDocument, options);
        }
export type ReconciliationReportActivity_FiltersQueryHookResult = ReturnType<typeof useReconciliationReportActivity_FiltersQuery>;
export type ReconciliationReportActivity_FiltersLazyQueryHookResult = ReturnType<typeof useReconciliationReportActivity_FiltersLazyQuery>;
export type ReconciliationReportActivity_FiltersQueryResult = Apollo.QueryResult<ReconciliationReportActivity_FiltersQuery, ReconciliationReportActivity_FiltersQueryVariables>;
export const WriteOrderToE1Document = gql`
    mutation WriteOrderToE1($orderId: ID!) {
  writeOrderToE1(orderId: $orderId)
}
    `;
export type WriteOrderToE1MutationFn = Apollo.MutationFunction<WriteOrderToE1Mutation, WriteOrderToE1MutationVariables>;

/**
 * __useWriteOrderToE1Mutation__
 *
 * To run a mutation, you first call `useWriteOrderToE1Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useWriteOrderToE1Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [writeOrderToE1Mutation, { data, loading, error }] = useWriteOrderToE1Mutation({
 *   variables: {
 *      orderId: // value for 'orderId'
 *   },
 * });
 */
export function useWriteOrderToE1Mutation(baseOptions?: Apollo.MutationHookOptions<WriteOrderToE1Mutation, WriteOrderToE1MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<WriteOrderToE1Mutation, WriteOrderToE1MutationVariables>(WriteOrderToE1Document, options);
      }
export type WriteOrderToE1MutationHookResult = ReturnType<typeof useWriteOrderToE1Mutation>;
export type WriteOrderToE1MutationResult = Apollo.MutationResult<WriteOrderToE1Mutation>;
export type WriteOrderToE1MutationOptions = Apollo.BaseMutationOptions<WriteOrderToE1Mutation, WriteOrderToE1MutationVariables>;
export const ReturnAuthorizationDetailActivityDocument = gql`
    query ReturnAuthorizationDetailActivity($returnAuthorizationId: ID!) {
  returnAuthorization(id: $returnAuthorizationId) {
    id
    store {
      id
      name
    }
    order {
      id
    }
    customer {
      id
      fullName
      email
      phoneNumber
    }
  }
}
    `;

/**
 * __useReturnAuthorizationDetailActivityQuery__
 *
 * To run a query within a React component, call `useReturnAuthorizationDetailActivityQuery` and pass it any options that fit your needs.
 * When your component renders, `useReturnAuthorizationDetailActivityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReturnAuthorizationDetailActivityQuery({
 *   variables: {
 *      returnAuthorizationId: // value for 'returnAuthorizationId'
 *   },
 * });
 */
export function useReturnAuthorizationDetailActivityQuery(baseOptions: Apollo.QueryHookOptions<ReturnAuthorizationDetailActivityQuery, ReturnAuthorizationDetailActivityQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReturnAuthorizationDetailActivityQuery, ReturnAuthorizationDetailActivityQueryVariables>(ReturnAuthorizationDetailActivityDocument, options);
      }
export function useReturnAuthorizationDetailActivityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReturnAuthorizationDetailActivityQuery, ReturnAuthorizationDetailActivityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReturnAuthorizationDetailActivityQuery, ReturnAuthorizationDetailActivityQueryVariables>(ReturnAuthorizationDetailActivityDocument, options);
        }
export type ReturnAuthorizationDetailActivityQueryHookResult = ReturnType<typeof useReturnAuthorizationDetailActivityQuery>;
export type ReturnAuthorizationDetailActivityLazyQueryHookResult = ReturnType<typeof useReturnAuthorizationDetailActivityLazyQuery>;
export type ReturnAuthorizationDetailActivityQueryResult = Apollo.QueryResult<ReturnAuthorizationDetailActivityQuery, ReturnAuthorizationDetailActivityQueryVariables>;
export const LookUpReturnAuthorizationDocument = gql`
    query LookUpReturnAuthorization($searchText: String!) {
  returnAuthorizations(
    options: {paginationInput: {first: 2}, filter: {omniFreeText: $searchText, isReceived: false, authorizationApprovalStatus: approved}}
  ) {
    nodes {
      id
      returnNumber
      order {
        id
        orderNumber
      }
    }
  }
}
    `;

/**
 * __useLookUpReturnAuthorizationQuery__
 *
 * To run a query within a React component, call `useLookUpReturnAuthorizationQuery` and pass it any options that fit your needs.
 * When your component renders, `useLookUpReturnAuthorizationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLookUpReturnAuthorizationQuery({
 *   variables: {
 *      searchText: // value for 'searchText'
 *   },
 * });
 */
export function useLookUpReturnAuthorizationQuery(baseOptions: Apollo.QueryHookOptions<LookUpReturnAuthorizationQuery, LookUpReturnAuthorizationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LookUpReturnAuthorizationQuery, LookUpReturnAuthorizationQueryVariables>(LookUpReturnAuthorizationDocument, options);
      }
export function useLookUpReturnAuthorizationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LookUpReturnAuthorizationQuery, LookUpReturnAuthorizationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LookUpReturnAuthorizationQuery, LookUpReturnAuthorizationQueryVariables>(LookUpReturnAuthorizationDocument, options);
        }
export type LookUpReturnAuthorizationQueryHookResult = ReturnType<typeof useLookUpReturnAuthorizationQuery>;
export type LookUpReturnAuthorizationLazyQueryHookResult = ReturnType<typeof useLookUpReturnAuthorizationLazyQuery>;
export type LookUpReturnAuthorizationQueryResult = Apollo.QueryResult<LookUpReturnAuthorizationQuery, LookUpReturnAuthorizationQueryVariables>;
export const ReturnAuthorizationsActivity_ReturnAuthorizationTableDocument = gql`
    query ReturnAuthorizationsActivity_ReturnAuthorizationTable($page: Cursor, $filter: QueryReturnAuthorizationsFilterInput, $sort: QueryReturnAuthorizationsSortInput) {
  returnAuthorizations(
    options: {paginationInput: {after: $page, first: 20}, filter: $filter, sort: $sort}
  ) {
    pageInfo {
      ...pageInfoFields
    }
    nodes {
      id
      returnDate
      returnNumber
      lineItems {
        id
        quantity
      }
      customer {
        id
        firstName
        lastName
        phoneNumber
        email
        netSuiteWriteRequest {
          ...writeRequestFields
        }
        netSuiteRecord {
          ...netSuiteRecordFields
        }
      }
      store {
        id
        name
      }
      shipment {
        id
        labelUrl
        shippedScanEvent: scanEvent(type: shipped) {
          id
        }
        deliveredScanEvent: scanEvent(type: delivered) {
          id
        }
      }
      order {
        id
        orderDate
        orderNumber
        totalCents
        netSuiteWriteRequest {
          ...writeRequestFields
        }
        netSuiteRecord {
          ...netSuiteRecordFields
        }
        rawSourceOrder {
          id
          externalId
          url
        }
        itemFulfillment {
          id
          lineItems {
            id
            quantity
          }
        }
      }
      approval {
        id
        metaCreated
        approvalType {
          id
          name
          displayName
        }
      }
      itemReceipt {
        id
        metaCreated
        lineItems {
          id
        }
      }
      acceptance {
        id
        metaCreated
        approvalType {
          id
          name
          displayName
        }
      }
      netSuiteWriteRequest {
        ...writeRequestFields
      }
      netSuiteRecord {
        ...netSuiteRecordFields
      }
    }
  }
}
    ${PageInfoFieldsFragmentDoc}
${WriteRequestFieldsFragmentDoc}
${NetSuiteRecordFieldsFragmentDoc}`;

/**
 * __useReturnAuthorizationsActivity_ReturnAuthorizationTableQuery__
 *
 * To run a query within a React component, call `useReturnAuthorizationsActivity_ReturnAuthorizationTableQuery` and pass it any options that fit your needs.
 * When your component renders, `useReturnAuthorizationsActivity_ReturnAuthorizationTableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReturnAuthorizationsActivity_ReturnAuthorizationTableQuery({
 *   variables: {
 *      page: // value for 'page'
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useReturnAuthorizationsActivity_ReturnAuthorizationTableQuery(baseOptions?: Apollo.QueryHookOptions<ReturnAuthorizationsActivity_ReturnAuthorizationTableQuery, ReturnAuthorizationsActivity_ReturnAuthorizationTableQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReturnAuthorizationsActivity_ReturnAuthorizationTableQuery, ReturnAuthorizationsActivity_ReturnAuthorizationTableQueryVariables>(ReturnAuthorizationsActivity_ReturnAuthorizationTableDocument, options);
      }
export function useReturnAuthorizationsActivity_ReturnAuthorizationTableLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReturnAuthorizationsActivity_ReturnAuthorizationTableQuery, ReturnAuthorizationsActivity_ReturnAuthorizationTableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReturnAuthorizationsActivity_ReturnAuthorizationTableQuery, ReturnAuthorizationsActivity_ReturnAuthorizationTableQueryVariables>(ReturnAuthorizationsActivity_ReturnAuthorizationTableDocument, options);
        }
export type ReturnAuthorizationsActivity_ReturnAuthorizationTableQueryHookResult = ReturnType<typeof useReturnAuthorizationsActivity_ReturnAuthorizationTableQuery>;
export type ReturnAuthorizationsActivity_ReturnAuthorizationTableLazyQueryHookResult = ReturnType<typeof useReturnAuthorizationsActivity_ReturnAuthorizationTableLazyQuery>;
export type ReturnAuthorizationsActivity_ReturnAuthorizationTableQueryResult = Apollo.QueryResult<ReturnAuthorizationsActivity_ReturnAuthorizationTableQuery, ReturnAuthorizationsActivity_ReturnAuthorizationTableQueryVariables>;
export const ReturnAuthorizationsActivity_TabBarDocument = gql`
    query ReturnAuthorizationsActivity_TabBar($storeId: ID) {
  pendingApproval: returnAuthorizations(
    options: {filter: {authorizationApprovalStatus: pending, storeId: $storeId}, paginationInput: {first: 1}}
  ) {
    pageInfo {
      ...pageInfoFields
    }
  }
  pendingShippingLabel: returnAuthorizations(
    options: {filter: {authorizationApprovalStatus: approved, isReceived: false, storeId: $storeId, shippingLabelPrinted: false}, paginationInput: {first: 1}}
  ) {
    pageInfo {
      ...pageInfoFields
    }
  }
  pendingReceipt: returnAuthorizations(
    options: {filter: {authorizationApprovalStatus: approved, isReceived: false, storeId: $storeId}, paginationInput: {first: 1}}
  ) {
    pageInfo {
      ...pageInfoFields
    }
  }
  pendingAcceptance: returnAuthorizations(
    options: {filter: {authorizationApprovalStatus: approved, isReceived: true, acceptanceApprovalStatus: pending, storeId: $storeId}, paginationInput: {first: 1}}
  ) {
    pageInfo {
      ...pageInfoFields
    }
  }
  pendingRefund: returnAuthorizations(
    options: {filter: {authorizationApprovalStatus: approved, isReceived: true, acceptanceApprovalStatus: approved, refundApprovalStatus: pending, storeId: $storeId}, paginationInput: {first: 1}}
  ) {
    pageInfo {
      ...pageInfoFields
    }
  }
}
    ${PageInfoFieldsFragmentDoc}`;

/**
 * __useReturnAuthorizationsActivity_TabBarQuery__
 *
 * To run a query within a React component, call `useReturnAuthorizationsActivity_TabBarQuery` and pass it any options that fit your needs.
 * When your component renders, `useReturnAuthorizationsActivity_TabBarQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReturnAuthorizationsActivity_TabBarQuery({
 *   variables: {
 *      storeId: // value for 'storeId'
 *   },
 * });
 */
export function useReturnAuthorizationsActivity_TabBarQuery(baseOptions?: Apollo.QueryHookOptions<ReturnAuthorizationsActivity_TabBarQuery, ReturnAuthorizationsActivity_TabBarQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReturnAuthorizationsActivity_TabBarQuery, ReturnAuthorizationsActivity_TabBarQueryVariables>(ReturnAuthorizationsActivity_TabBarDocument, options);
      }
export function useReturnAuthorizationsActivity_TabBarLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReturnAuthorizationsActivity_TabBarQuery, ReturnAuthorizationsActivity_TabBarQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReturnAuthorizationsActivity_TabBarQuery, ReturnAuthorizationsActivity_TabBarQueryVariables>(ReturnAuthorizationsActivity_TabBarDocument, options);
        }
export type ReturnAuthorizationsActivity_TabBarQueryHookResult = ReturnType<typeof useReturnAuthorizationsActivity_TabBarQuery>;
export type ReturnAuthorizationsActivity_TabBarLazyQueryHookResult = ReturnType<typeof useReturnAuthorizationsActivity_TabBarLazyQuery>;
export type ReturnAuthorizationsActivity_TabBarQueryResult = Apollo.QueryResult<ReturnAuthorizationsActivity_TabBarQuery, ReturnAuthorizationsActivity_TabBarQueryVariables>;
export const ReturnAuthorizationsActivity_DeprecatedDocument = gql`
    query ReturnAuthorizationsActivity_Deprecated($page: Cursor, $filter: QueryReturnAuthorizationsFilterInput, $sort: QueryReturnAuthorizationsSortInput) {
  returnAuthorizations(
    options: {paginationInput: {after: $page, first: 20}, filter: $filter, sort: $sort}
  ) {
    pageInfo {
      ...pageInfoFields
    }
    nodes {
      id
      returnNumber
      returnDate
      customer {
        id
        email
      }
      store {
        id
      }
      order {
        id
      }
      shipment {
        id
        departureScanEvent: scanEvent(type: shipped) {
          id
          scannedAt
        }
        deliveryScanEvent: scanEvent(type: delivered) {
          id
          scannedAt
        }
        labelUrl
        trackingNumber
      }
      approval {
        id
        approvalType {
          id
          name
          displayName
        }
      }
      acceptance {
        id
        approvalType {
          id
          name
          displayName
        }
      }
      itemReceipt {
        id
      }
      refund {
        id
        approvalType {
          id
          name
          displayName
        }
      }
      lineItems {
        id
        quantity
        refundAmountCents
        product {
          id
          sku
          name
        }
      }
    }
  }
}
    ${PageInfoFieldsFragmentDoc}`;

/**
 * __useReturnAuthorizationsActivity_DeprecatedQuery__
 *
 * To run a query within a React component, call `useReturnAuthorizationsActivity_DeprecatedQuery` and pass it any options that fit your needs.
 * When your component renders, `useReturnAuthorizationsActivity_DeprecatedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReturnAuthorizationsActivity_DeprecatedQuery({
 *   variables: {
 *      page: // value for 'page'
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useReturnAuthorizationsActivity_DeprecatedQuery(baseOptions?: Apollo.QueryHookOptions<ReturnAuthorizationsActivity_DeprecatedQuery, ReturnAuthorizationsActivity_DeprecatedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReturnAuthorizationsActivity_DeprecatedQuery, ReturnAuthorizationsActivity_DeprecatedQueryVariables>(ReturnAuthorizationsActivity_DeprecatedDocument, options);
      }
export function useReturnAuthorizationsActivity_DeprecatedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReturnAuthorizationsActivity_DeprecatedQuery, ReturnAuthorizationsActivity_DeprecatedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReturnAuthorizationsActivity_DeprecatedQuery, ReturnAuthorizationsActivity_DeprecatedQueryVariables>(ReturnAuthorizationsActivity_DeprecatedDocument, options);
        }
export type ReturnAuthorizationsActivity_DeprecatedQueryHookResult = ReturnType<typeof useReturnAuthorizationsActivity_DeprecatedQuery>;
export type ReturnAuthorizationsActivity_DeprecatedLazyQueryHookResult = ReturnType<typeof useReturnAuthorizationsActivity_DeprecatedLazyQuery>;
export type ReturnAuthorizationsActivity_DeprecatedQueryResult = Apollo.QueryResult<ReturnAuthorizationsActivity_DeprecatedQuery, ReturnAuthorizationsActivity_DeprecatedQueryVariables>;
export const AppleCareAgreementsWidgetDocument = gql`
    query AppleCareAgreementsWidget {
  appleCareAgreements(
    options: {paginationInput: {first: 10}, sort: {direction: descending, field: orderDate}}
  ) {
    pageInfo {
      ...pageInfoFields
    }
    nodes {
      id
      agreementNumber
      activatedAt
      serialNumber
      lineItem {
        id
        order {
          id
          orderNumber
          orderDate
        }
        product {
          id
          name
          sku
        }
      }
    }
  }
}
    ${PageInfoFieldsFragmentDoc}`;

/**
 * __useAppleCareAgreementsWidgetQuery__
 *
 * To run a query within a React component, call `useAppleCareAgreementsWidgetQuery` and pass it any options that fit your needs.
 * When your component renders, `useAppleCareAgreementsWidgetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAppleCareAgreementsWidgetQuery({
 *   variables: {
 *   },
 * });
 */
export function useAppleCareAgreementsWidgetQuery(baseOptions?: Apollo.QueryHookOptions<AppleCareAgreementsWidgetQuery, AppleCareAgreementsWidgetQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AppleCareAgreementsWidgetQuery, AppleCareAgreementsWidgetQueryVariables>(AppleCareAgreementsWidgetDocument, options);
      }
export function useAppleCareAgreementsWidgetLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AppleCareAgreementsWidgetQuery, AppleCareAgreementsWidgetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AppleCareAgreementsWidgetQuery, AppleCareAgreementsWidgetQueryVariables>(AppleCareAgreementsWidgetDocument, options);
        }
export type AppleCareAgreementsWidgetQueryHookResult = ReturnType<typeof useAppleCareAgreementsWidgetQuery>;
export type AppleCareAgreementsWidgetLazyQueryHookResult = ReturnType<typeof useAppleCareAgreementsWidgetLazyQuery>;
export type AppleCareAgreementsWidgetQueryResult = Apollo.QueryResult<AppleCareAgreementsWidgetQuery, AppleCareAgreementsWidgetQueryVariables>;
export const CurrentDevelopmentWorkWidgetDocument = gql`
    query CurrentDevelopmentWorkWidget($page: Cursor, $filter: QueryJiraTicketsFilterInput, $sort: QueryJiraTicketsSortInput) {
  jiraTickets(
    options: {useJiraAsSource: true, filter: $filter, sort: $sort, paginationInput: {first: 20, after: $page}}
  ) {
    pageInfo {
      ...pageInfoFields
    }
    nodes {
      id
      createdAt
      key
      title
      status
    }
  }
}
    ${PageInfoFieldsFragmentDoc}`;

/**
 * __useCurrentDevelopmentWorkWidgetQuery__
 *
 * To run a query within a React component, call `useCurrentDevelopmentWorkWidgetQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentDevelopmentWorkWidgetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentDevelopmentWorkWidgetQuery({
 *   variables: {
 *      page: // value for 'page'
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useCurrentDevelopmentWorkWidgetQuery(baseOptions?: Apollo.QueryHookOptions<CurrentDevelopmentWorkWidgetQuery, CurrentDevelopmentWorkWidgetQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CurrentDevelopmentWorkWidgetQuery, CurrentDevelopmentWorkWidgetQueryVariables>(CurrentDevelopmentWorkWidgetDocument, options);
      }
export function useCurrentDevelopmentWorkWidgetLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CurrentDevelopmentWorkWidgetQuery, CurrentDevelopmentWorkWidgetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CurrentDevelopmentWorkWidgetQuery, CurrentDevelopmentWorkWidgetQueryVariables>(CurrentDevelopmentWorkWidgetDocument, options);
        }
export type CurrentDevelopmentWorkWidgetQueryHookResult = ReturnType<typeof useCurrentDevelopmentWorkWidgetQuery>;
export type CurrentDevelopmentWorkWidgetLazyQueryHookResult = ReturnType<typeof useCurrentDevelopmentWorkWidgetLazyQuery>;
export type CurrentDevelopmentWorkWidgetQueryResult = Apollo.QueryResult<CurrentDevelopmentWorkWidgetQuery, CurrentDevelopmentWorkWidgetQueryVariables>;
export const OrderListWidgetDocument = gql`
    query OrderListWidget($salesChannel: SalesChannelName) {
  orders(
    options: {filter: {salesChannel: $salesChannel}, paginationInput: {first: 10}, sort: {field: orderDate, direction: descending}}
  ) {
    pageInfo {
      ...pageInfoFields
    }
    nodes {
      id
      orderNumber
      orderDate
    }
  }
}
    ${PageInfoFieldsFragmentDoc}`;

/**
 * __useOrderListWidgetQuery__
 *
 * To run a query within a React component, call `useOrderListWidgetQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrderListWidgetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrderListWidgetQuery({
 *   variables: {
 *      salesChannel: // value for 'salesChannel'
 *   },
 * });
 */
export function useOrderListWidgetQuery(baseOptions?: Apollo.QueryHookOptions<OrderListWidgetQuery, OrderListWidgetQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrderListWidgetQuery, OrderListWidgetQueryVariables>(OrderListWidgetDocument, options);
      }
export function useOrderListWidgetLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrderListWidgetQuery, OrderListWidgetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrderListWidgetQuery, OrderListWidgetQueryVariables>(OrderListWidgetDocument, options);
        }
export type OrderListWidgetQueryHookResult = ReturnType<typeof useOrderListWidgetQuery>;
export type OrderListWidgetLazyQueryHookResult = ReturnType<typeof useOrderListWidgetLazyQuery>;
export type OrderListWidgetQueryResult = Apollo.QueryResult<OrderListWidgetQuery, OrderListWidgetQueryVariables>;
export const RecentReturnAuthorizationListWidgetDocument = gql`
    query RecentReturnAuthorizationListWidget {
  returnAuthorizations(
    options: {paginationInput: {first: 10}, sort: {field: returnDate, direction: descending}}
  ) {
    pageInfo {
      ...pageInfoFields
    }
    nodes {
      id
      returnDate
      returnNumber
      store {
        id
        name
      }
    }
  }
}
    ${PageInfoFieldsFragmentDoc}`;

/**
 * __useRecentReturnAuthorizationListWidgetQuery__
 *
 * To run a query within a React component, call `useRecentReturnAuthorizationListWidgetQuery` and pass it any options that fit your needs.
 * When your component renders, `useRecentReturnAuthorizationListWidgetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRecentReturnAuthorizationListWidgetQuery({
 *   variables: {
 *   },
 * });
 */
export function useRecentReturnAuthorizationListWidgetQuery(baseOptions?: Apollo.QueryHookOptions<RecentReturnAuthorizationListWidgetQuery, RecentReturnAuthorizationListWidgetQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RecentReturnAuthorizationListWidgetQuery, RecentReturnAuthorizationListWidgetQueryVariables>(RecentReturnAuthorizationListWidgetDocument, options);
      }
export function useRecentReturnAuthorizationListWidgetLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RecentReturnAuthorizationListWidgetQuery, RecentReturnAuthorizationListWidgetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RecentReturnAuthorizationListWidgetQuery, RecentReturnAuthorizationListWidgetQueryVariables>(RecentReturnAuthorizationListWidgetDocument, options);
        }
export type RecentReturnAuthorizationListWidgetQueryHookResult = ReturnType<typeof useRecentReturnAuthorizationListWidgetQuery>;
export type RecentReturnAuthorizationListWidgetLazyQueryHookResult = ReturnType<typeof useRecentReturnAuthorizationListWidgetLazyQuery>;
export type RecentReturnAuthorizationListWidgetQueryResult = Apollo.QueryResult<RecentReturnAuthorizationListWidgetQuery, RecentReturnAuthorizationListWidgetQueryVariables>;
export const SkuSwapWidgetDocument = gql`
    query SkuSwapWidget($page: Cursor, $filter: QueryOrdersFilterInput, $sort: QueryOrdersSortInput) {
  orders(
    options: {paginationInput: {after: $page, first: 20}, filter: $filter, sort: $sort}
  ) {
    pageInfo {
      ...pageInfoFields
    }
    nodes {
      id
      orderNumber
      orderDate
    }
  }
}
    ${PageInfoFieldsFragmentDoc}`;

/**
 * __useSkuSwapWidgetQuery__
 *
 * To run a query within a React component, call `useSkuSwapWidgetQuery` and pass it any options that fit your needs.
 * When your component renders, `useSkuSwapWidgetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSkuSwapWidgetQuery({
 *   variables: {
 *      page: // value for 'page'
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useSkuSwapWidgetQuery(baseOptions?: Apollo.QueryHookOptions<SkuSwapWidgetQuery, SkuSwapWidgetQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SkuSwapWidgetQuery, SkuSwapWidgetQueryVariables>(SkuSwapWidgetDocument, options);
      }
export function useSkuSwapWidgetLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SkuSwapWidgetQuery, SkuSwapWidgetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SkuSwapWidgetQuery, SkuSwapWidgetQueryVariables>(SkuSwapWidgetDocument, options);
        }
export type SkuSwapWidgetQueryHookResult = ReturnType<typeof useSkuSwapWidgetQuery>;
export type SkuSwapWidgetLazyQueryHookResult = ReturnType<typeof useSkuSwapWidgetLazyQuery>;
export type SkuSwapWidgetQueryResult = Apollo.QueryResult<SkuSwapWidgetQuery, SkuSwapWidgetQueryVariables>;
export const SaveStoreDocument = gql`
    mutation SaveStore($input: SaveStoreInput!) {
  saveStore(input: $input) {
    id
    name
    orderPrefix
    partner {
      id
    }
    metaData {
      ... on WooCommerceStoreMetaData {
        id
        baseUrl
        consumerKey
        consumerSecret
      }
      ... on ShopifyStoreMetaData {
        id
        baseUrl
        adminToken
      }
      ... on SftpStoreMetaData {
        id
        baseUrl
        username
        password
        orderFileDirectory
        ackFileDirectory
        shipFileDirectory
      }
    }
  }
}
    `;
export type SaveStoreMutationFn = Apollo.MutationFunction<SaveStoreMutation, SaveStoreMutationVariables>;

/**
 * __useSaveStoreMutation__
 *
 * To run a mutation, you first call `useSaveStoreMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveStoreMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveStoreMutation, { data, loading, error }] = useSaveStoreMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveStoreMutation(baseOptions?: Apollo.MutationHookOptions<SaveStoreMutation, SaveStoreMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveStoreMutation, SaveStoreMutationVariables>(SaveStoreDocument, options);
      }
export type SaveStoreMutationHookResult = ReturnType<typeof useSaveStoreMutation>;
export type SaveStoreMutationResult = Apollo.MutationResult<SaveStoreMutation>;
export type SaveStoreMutationOptions = Apollo.BaseMutationOptions<SaveStoreMutation, SaveStoreMutationVariables>;
export const StoreListWidgetDocument = gql`
    query StoreListWidget {
  stores(options: {}) {
    pageInfo {
      ...pageInfoFields
    }
    nodes {
      id
      orderPrefix
      name
      logoUrl
      primaryColorHex
      secondaryColorHex
      buttonColorHex
      type {
        id
        name
        displayName
      }
      metaData {
        ... on ShopifyStoreMetaData {
          id
          baseUrl
        }
        ... on WooCommerceStoreMetaData {
          id
          baseUrl
        }
        ... on Telgoo5StoreMetaData {
          id
          apiUrl
        }
        ... on SftpStoreMetaData {
          id
          baseUrl
          orderFileDirectory
          ackFileDirectory
          shipFileDirectory
        }
      }
    }
  }
}
    ${PageInfoFieldsFragmentDoc}`;

/**
 * __useStoreListWidgetQuery__
 *
 * To run a query within a React component, call `useStoreListWidgetQuery` and pass it any options that fit your needs.
 * When your component renders, `useStoreListWidgetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStoreListWidgetQuery({
 *   variables: {
 *   },
 * });
 */
export function useStoreListWidgetQuery(baseOptions?: Apollo.QueryHookOptions<StoreListWidgetQuery, StoreListWidgetQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StoreListWidgetQuery, StoreListWidgetQueryVariables>(StoreListWidgetDocument, options);
      }
export function useStoreListWidgetLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StoreListWidgetQuery, StoreListWidgetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StoreListWidgetQuery, StoreListWidgetQueryVariables>(StoreListWidgetDocument, options);
        }
export type StoreListWidgetQueryHookResult = ReturnType<typeof useStoreListWidgetQuery>;
export type StoreListWidgetLazyQueryHookResult = ReturnType<typeof useStoreListWidgetLazyQuery>;
export type StoreListWidgetQueryResult = Apollo.QueryResult<StoreListWidgetQuery, StoreListWidgetQueryVariables>;
export const TestStoreConnectionDocument = gql`
    query TestStoreConnection($storeId: ID!) {
  testStoreConnection(storeId: $storeId)
}
    `;

/**
 * __useTestStoreConnectionQuery__
 *
 * To run a query within a React component, call `useTestStoreConnectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useTestStoreConnectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTestStoreConnectionQuery({
 *   variables: {
 *      storeId: // value for 'storeId'
 *   },
 * });
 */
export function useTestStoreConnectionQuery(baseOptions: Apollo.QueryHookOptions<TestStoreConnectionQuery, TestStoreConnectionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TestStoreConnectionQuery, TestStoreConnectionQueryVariables>(TestStoreConnectionDocument, options);
      }
export function useTestStoreConnectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TestStoreConnectionQuery, TestStoreConnectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TestStoreConnectionQuery, TestStoreConnectionQueryVariables>(TestStoreConnectionDocument, options);
        }
export type TestStoreConnectionQueryHookResult = ReturnType<typeof useTestStoreConnectionQuery>;
export type TestStoreConnectionLazyQueryHookResult = ReturnType<typeof useTestStoreConnectionLazyQuery>;
export type TestStoreConnectionQueryResult = Apollo.QueryResult<TestStoreConnectionQuery, TestStoreConnectionQueryVariables>;
export const EditCachedOrderModalDocument = gql`
    query EditCachedOrderModal($externalOrderId: ID!) {
  cachedOrder(id: $externalOrderId) {
    id
    metaCreated
    rawData
    validationErrors
    store {
      id
      salesOrderValidator
      type {
        id
        name
        displayName
      }
    }
  }
}
    `;

/**
 * __useEditCachedOrderModalQuery__
 *
 * To run a query within a React component, call `useEditCachedOrderModalQuery` and pass it any options that fit your needs.
 * When your component renders, `useEditCachedOrderModalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEditCachedOrderModalQuery({
 *   variables: {
 *      externalOrderId: // value for 'externalOrderId'
 *   },
 * });
 */
export function useEditCachedOrderModalQuery(baseOptions: Apollo.QueryHookOptions<EditCachedOrderModalQuery, EditCachedOrderModalQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EditCachedOrderModalQuery, EditCachedOrderModalQueryVariables>(EditCachedOrderModalDocument, options);
      }
export function useEditCachedOrderModalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EditCachedOrderModalQuery, EditCachedOrderModalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EditCachedOrderModalQuery, EditCachedOrderModalQueryVariables>(EditCachedOrderModalDocument, options);
        }
export type EditCachedOrderModalQueryHookResult = ReturnType<typeof useEditCachedOrderModalQuery>;
export type EditCachedOrderModalLazyQueryHookResult = ReturnType<typeof useEditCachedOrderModalLazyQuery>;
export type EditCachedOrderModalQueryResult = Apollo.QueryResult<EditCachedOrderModalQuery, EditCachedOrderModalQueryVariables>;
export const SalesOrdersActivity_NewOrderTableDocument = gql`
    query SalesOrdersActivity_NewOrderTable($page: Cursor, $filter: QueryCachedOrdersFilterInput, $sort: QueryCachedOrdersSortInput) {
  cachedOrders(
    options: {paginationInput: {after: $page, first: 20}, filter: $filter, sort: $sort}
  ) {
    pageInfo {
      ...pageInfoFields
    }
    nodes {
      id
      metaCreated
      rawOrderNumber
      validationErrors
      store {
        id
        name
      }
    }
  }
}
    ${PageInfoFieldsFragmentDoc}`;

/**
 * __useSalesOrdersActivity_NewOrderTableQuery__
 *
 * To run a query within a React component, call `useSalesOrdersActivity_NewOrderTableQuery` and pass it any options that fit your needs.
 * When your component renders, `useSalesOrdersActivity_NewOrderTableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSalesOrdersActivity_NewOrderTableQuery({
 *   variables: {
 *      page: // value for 'page'
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useSalesOrdersActivity_NewOrderTableQuery(baseOptions?: Apollo.QueryHookOptions<SalesOrdersActivity_NewOrderTableQuery, SalesOrdersActivity_NewOrderTableQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SalesOrdersActivity_NewOrderTableQuery, SalesOrdersActivity_NewOrderTableQueryVariables>(SalesOrdersActivity_NewOrderTableDocument, options);
      }
export function useSalesOrdersActivity_NewOrderTableLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SalesOrdersActivity_NewOrderTableQuery, SalesOrdersActivity_NewOrderTableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SalesOrdersActivity_NewOrderTableQuery, SalesOrdersActivity_NewOrderTableQueryVariables>(SalesOrdersActivity_NewOrderTableDocument, options);
        }
export type SalesOrdersActivity_NewOrderTableQueryHookResult = ReturnType<typeof useSalesOrdersActivity_NewOrderTableQuery>;
export type SalesOrdersActivity_NewOrderTableLazyQueryHookResult = ReturnType<typeof useSalesOrdersActivity_NewOrderTableLazyQuery>;
export type SalesOrdersActivity_NewOrderTableQueryResult = Apollo.QueryResult<SalesOrdersActivity_NewOrderTableQuery, SalesOrdersActivity_NewOrderTableQueryVariables>;
export const ReviewCachedOrdersDocument = gql`
    mutation ReviewCachedOrders($ids: [ID!]!) {
  reviewCachedOrders(ids: $ids)
}
    `;
export type ReviewCachedOrdersMutationFn = Apollo.MutationFunction<ReviewCachedOrdersMutation, ReviewCachedOrdersMutationVariables>;

/**
 * __useReviewCachedOrdersMutation__
 *
 * To run a mutation, you first call `useReviewCachedOrdersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReviewCachedOrdersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reviewCachedOrdersMutation, { data, loading, error }] = useReviewCachedOrdersMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useReviewCachedOrdersMutation(baseOptions?: Apollo.MutationHookOptions<ReviewCachedOrdersMutation, ReviewCachedOrdersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReviewCachedOrdersMutation, ReviewCachedOrdersMutationVariables>(ReviewCachedOrdersDocument, options);
      }
export type ReviewCachedOrdersMutationHookResult = ReturnType<typeof useReviewCachedOrdersMutation>;
export type ReviewCachedOrdersMutationResult = Apollo.MutationResult<ReviewCachedOrdersMutation>;
export type ReviewCachedOrdersMutationOptions = Apollo.BaseMutationOptions<ReviewCachedOrdersMutation, ReviewCachedOrdersMutationVariables>;
export const SalesOrdersActivity_TabBarDocument = gql`
    query SalesOrdersActivity_TabBar($salesChannelName: SalesChannelName!, $storeId: ID, $searchText: String, $after: Timestamp) {
  newOrders: cachedOrderCount(
    options: {filter: {salesChannel: $salesChannelName, storeId: $storeId, isProcessed: false, orderNumber: $searchText, after: $after}}
  )
  awaitingPayment: orderCount(
    options: {filter: {salesChannel: $salesChannelName, storeId: $storeId, inState: awaitingPayment, omniFreeText: $searchText, after: $after}}
  )
  awaitingApproval: orderCount(
    options: {filter: {salesChannel: $salesChannelName, storeId: $storeId, inState: awaitingApproval, omniFreeText: $searchText, after: $after}}
  )
  awaitingFulfillment: orderCount(
    options: {filter: {salesChannel: $salesChannelName, storeId: $storeId, inState: awaitingFulfillment, omniFreeText: $searchText, after: $after}}
  )
  inTransit: orderCount(
    options: {filter: {salesChannel: $salesChannelName, storeId: $storeId, inState: inTransit, omniFreeText: $searchText, after: $after}}
  )
}
    `;

/**
 * __useSalesOrdersActivity_TabBarQuery__
 *
 * To run a query within a React component, call `useSalesOrdersActivity_TabBarQuery` and pass it any options that fit your needs.
 * When your component renders, `useSalesOrdersActivity_TabBarQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSalesOrdersActivity_TabBarQuery({
 *   variables: {
 *      salesChannelName: // value for 'salesChannelName'
 *      storeId: // value for 'storeId'
 *      searchText: // value for 'searchText'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useSalesOrdersActivity_TabBarQuery(baseOptions: Apollo.QueryHookOptions<SalesOrdersActivity_TabBarQuery, SalesOrdersActivity_TabBarQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SalesOrdersActivity_TabBarQuery, SalesOrdersActivity_TabBarQueryVariables>(SalesOrdersActivity_TabBarDocument, options);
      }
export function useSalesOrdersActivity_TabBarLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SalesOrdersActivity_TabBarQuery, SalesOrdersActivity_TabBarQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SalesOrdersActivity_TabBarQuery, SalesOrdersActivity_TabBarQueryVariables>(SalesOrdersActivity_TabBarDocument, options);
        }
export type SalesOrdersActivity_TabBarQueryHookResult = ReturnType<typeof useSalesOrdersActivity_TabBarQuery>;
export type SalesOrdersActivity_TabBarLazyQueryHookResult = ReturnType<typeof useSalesOrdersActivity_TabBarLazyQuery>;
export type SalesOrdersActivity_TabBarQueryResult = Apollo.QueryResult<SalesOrdersActivity_TabBarQuery, SalesOrdersActivity_TabBarQueryVariables>;
export const SalesOrderActivity_TableDocument = gql`
    query SalesOrderActivity_Table($page: Cursor, $filter: QueryOrdersFilterInput, $sort: QueryOrdersSortInput) {
  orders(
    options: {filter: $filter, sort: $sort, paginationInput: {first: 20, after: $page}}
  ) {
    pageInfo {
      ...pageInfoFields
    }
    nodes {
      id
      orderNumber
      orderDate
      totalCents
      customer {
        id
        email
        netSuiteRecord {
          ...netSuiteRecordFields
        }
        netSuiteWriteRequest {
          ...writeRequestFields
        }
      }
      e1DocumentIndex {
        id
        urlToE1Record
      }
      netSuiteRecord {
        ...netSuiteRecordFields
      }
      netSuiteWriteRequest {
        ...writeRequestFields
      }
      netSuitePaymentMethod {
        id
        name
      }
      shipment {
        id
        trackingNumber
        trackingUrl
      }
      store {
        id
        name
      }
      lineItems {
        id
        quantity
      }
      itemFulfillment {
        id
        netSuiteRecord {
          ...netSuiteRecordFields
        }
      }
      paymentMethod {
        id
        name
        displayName
      }
    }
  }
}
    ${PageInfoFieldsFragmentDoc}
${NetSuiteRecordFieldsFragmentDoc}
${WriteRequestFieldsFragmentDoc}`;

/**
 * __useSalesOrderActivity_TableQuery__
 *
 * To run a query within a React component, call `useSalesOrderActivity_TableQuery` and pass it any options that fit your needs.
 * When your component renders, `useSalesOrderActivity_TableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSalesOrderActivity_TableQuery({
 *   variables: {
 *      page: // value for 'page'
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useSalesOrderActivity_TableQuery(baseOptions?: Apollo.QueryHookOptions<SalesOrderActivity_TableQuery, SalesOrderActivity_TableQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SalesOrderActivity_TableQuery, SalesOrderActivity_TableQueryVariables>(SalesOrderActivity_TableDocument, options);
      }
export function useSalesOrderActivity_TableLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SalesOrderActivity_TableQuery, SalesOrderActivity_TableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SalesOrderActivity_TableQuery, SalesOrderActivity_TableQueryVariables>(SalesOrderActivity_TableDocument, options);
        }
export type SalesOrderActivity_TableQueryHookResult = ReturnType<typeof useSalesOrderActivity_TableQuery>;
export type SalesOrderActivity_TableLazyQueryHookResult = ReturnType<typeof useSalesOrderActivity_TableLazyQuery>;
export type SalesOrderActivity_TableQueryResult = Apollo.QueryResult<SalesOrderActivity_TableQuery, SalesOrderActivity_TableQueryVariables>;
export const AdminStoreSettingsActivityDocument = gql`
    query AdminStoreSettingsActivity($storeId: ID!) {
  store(id: $storeId) {
    id
    type {
      name
    }
  }
}
    `;

/**
 * __useAdminStoreSettingsActivityQuery__
 *
 * To run a query within a React component, call `useAdminStoreSettingsActivityQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminStoreSettingsActivityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminStoreSettingsActivityQuery({
 *   variables: {
 *      storeId: // value for 'storeId'
 *   },
 * });
 */
export function useAdminStoreSettingsActivityQuery(baseOptions: Apollo.QueryHookOptions<AdminStoreSettingsActivityQuery, AdminStoreSettingsActivityQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminStoreSettingsActivityQuery, AdminStoreSettingsActivityQueryVariables>(AdminStoreSettingsActivityDocument, options);
      }
export function useAdminStoreSettingsActivityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminStoreSettingsActivityQuery, AdminStoreSettingsActivityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminStoreSettingsActivityQuery, AdminStoreSettingsActivityQueryVariables>(AdminStoreSettingsActivityDocument, options);
        }
export type AdminStoreSettingsActivityQueryHookResult = ReturnType<typeof useAdminStoreSettingsActivityQuery>;
export type AdminStoreSettingsActivityLazyQueryHookResult = ReturnType<typeof useAdminStoreSettingsActivityLazyQuery>;
export type AdminStoreSettingsActivityQueryResult = Apollo.QueryResult<AdminStoreSettingsActivityQuery, AdminStoreSettingsActivityQueryVariables>;
export const ArchiveStoreDocument = gql`
    mutation ArchiveStore($storeId: ID!) {
  archiveStore(storeId: $storeId)
}
    `;
export type ArchiveStoreMutationFn = Apollo.MutationFunction<ArchiveStoreMutation, ArchiveStoreMutationVariables>;

/**
 * __useArchiveStoreMutation__
 *
 * To run a mutation, you first call `useArchiveStoreMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveStoreMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveStoreMutation, { data, loading, error }] = useArchiveStoreMutation({
 *   variables: {
 *      storeId: // value for 'storeId'
 *   },
 * });
 */
export function useArchiveStoreMutation(baseOptions?: Apollo.MutationHookOptions<ArchiveStoreMutation, ArchiveStoreMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ArchiveStoreMutation, ArchiveStoreMutationVariables>(ArchiveStoreDocument, options);
      }
export type ArchiveStoreMutationHookResult = ReturnType<typeof useArchiveStoreMutation>;
export type ArchiveStoreMutationResult = Apollo.MutationResult<ArchiveStoreMutation>;
export type ArchiveStoreMutationOptions = Apollo.BaseMutationOptions<ArchiveStoreMutation, ArchiveStoreMutationVariables>;
export const DeleteThirdPartyAccountDocument = gql`
    mutation DeleteThirdPartyAccount($id: ID!) {
  deleteThirdPartyAccount(id: $id)
}
    `;
export type DeleteThirdPartyAccountMutationFn = Apollo.MutationFunction<DeleteThirdPartyAccountMutation, DeleteThirdPartyAccountMutationVariables>;

/**
 * __useDeleteThirdPartyAccountMutation__
 *
 * To run a mutation, you first call `useDeleteThirdPartyAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteThirdPartyAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteThirdPartyAccountMutation, { data, loading, error }] = useDeleteThirdPartyAccountMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteThirdPartyAccountMutation(baseOptions?: Apollo.MutationHookOptions<DeleteThirdPartyAccountMutation, DeleteThirdPartyAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteThirdPartyAccountMutation, DeleteThirdPartyAccountMutationVariables>(DeleteThirdPartyAccountDocument, options);
      }
export type DeleteThirdPartyAccountMutationHookResult = ReturnType<typeof useDeleteThirdPartyAccountMutation>;
export type DeleteThirdPartyAccountMutationResult = Apollo.MutationResult<DeleteThirdPartyAccountMutation>;
export type DeleteThirdPartyAccountMutationOptions = Apollo.BaseMutationOptions<DeleteThirdPartyAccountMutation, DeleteThirdPartyAccountMutationVariables>;
export const SaveThirdPartyAccountDocument = gql`
    mutation SaveThirdPartyAccount($input: SaveThirdPartyAccountInput!) {
  saveThirdPartyAccount(input: $input) {
    id
    name
    accountNumber
    address {
      street1
      street2
      city
      usState
      postalCode
    }
  }
}
    `;
export type SaveThirdPartyAccountMutationFn = Apollo.MutationFunction<SaveThirdPartyAccountMutation, SaveThirdPartyAccountMutationVariables>;

/**
 * __useSaveThirdPartyAccountMutation__
 *
 * To run a mutation, you first call `useSaveThirdPartyAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveThirdPartyAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveThirdPartyAccountMutation, { data, loading, error }] = useSaveThirdPartyAccountMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveThirdPartyAccountMutation(baseOptions?: Apollo.MutationHookOptions<SaveThirdPartyAccountMutation, SaveThirdPartyAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveThirdPartyAccountMutation, SaveThirdPartyAccountMutationVariables>(SaveThirdPartyAccountDocument, options);
      }
export type SaveThirdPartyAccountMutationHookResult = ReturnType<typeof useSaveThirdPartyAccountMutation>;
export type SaveThirdPartyAccountMutationResult = Apollo.MutationResult<SaveThirdPartyAccountMutation>;
export type SaveThirdPartyAccountMutationOptions = Apollo.BaseMutationOptions<SaveThirdPartyAccountMutation, SaveThirdPartyAccountMutationVariables>;
export const SaveThirdPartyAccountModalDocument = gql`
    query SaveThirdPartyAccountModal($id: ID!) {
  thirdPartyAccount(id: $id) {
    id
    name
    accountNumber
    carrierType
    attention
    addressee
    address {
      phone
      street1
      street2
      street3
      city
      usState
      postalCode
      countryCode
    }
  }
}
    `;

/**
 * __useSaveThirdPartyAccountModalQuery__
 *
 * To run a query within a React component, call `useSaveThirdPartyAccountModalQuery` and pass it any options that fit your needs.
 * When your component renders, `useSaveThirdPartyAccountModalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSaveThirdPartyAccountModalQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSaveThirdPartyAccountModalQuery(baseOptions: Apollo.QueryHookOptions<SaveThirdPartyAccountModalQuery, SaveThirdPartyAccountModalQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SaveThirdPartyAccountModalQuery, SaveThirdPartyAccountModalQueryVariables>(SaveThirdPartyAccountModalDocument, options);
      }
export function useSaveThirdPartyAccountModalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SaveThirdPartyAccountModalQuery, SaveThirdPartyAccountModalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SaveThirdPartyAccountModalQuery, SaveThirdPartyAccountModalQueryVariables>(SaveThirdPartyAccountModalDocument, options);
        }
export type SaveThirdPartyAccountModalQueryHookResult = ReturnType<typeof useSaveThirdPartyAccountModalQuery>;
export type SaveThirdPartyAccountModalLazyQueryHookResult = ReturnType<typeof useSaveThirdPartyAccountModalLazyQuery>;
export type SaveThirdPartyAccountModalQueryResult = Apollo.QueryResult<SaveThirdPartyAccountModalQuery, SaveThirdPartyAccountModalQueryVariables>;
export const ThirdPartyAccountActivityDocument = gql`
    query ThirdPartyAccountActivity($page: Cursor, $filter: QueryThirdPartyAccountsFilterInput, $sort: QueryThirdPartyAccountsSortInput) {
  thirdPartyAccounts(
    options: {paginationInput: {after: $page, first: 20}, filter: $filter, sort: $sort}
  ) {
    pageInfo {
      ...pageInfoFields
    }
    nodes {
      id
      name
      accountNumber
      carrierType
      addressee
      attention
      address {
        street1
        street2
        city
        usState
        postalCode
      }
    }
  }
}
    ${PageInfoFieldsFragmentDoc}`;

/**
 * __useThirdPartyAccountActivityQuery__
 *
 * To run a query within a React component, call `useThirdPartyAccountActivityQuery` and pass it any options that fit your needs.
 * When your component renders, `useThirdPartyAccountActivityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useThirdPartyAccountActivityQuery({
 *   variables: {
 *      page: // value for 'page'
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useThirdPartyAccountActivityQuery(baseOptions?: Apollo.QueryHookOptions<ThirdPartyAccountActivityQuery, ThirdPartyAccountActivityQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ThirdPartyAccountActivityQuery, ThirdPartyAccountActivityQueryVariables>(ThirdPartyAccountActivityDocument, options);
      }
export function useThirdPartyAccountActivityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ThirdPartyAccountActivityQuery, ThirdPartyAccountActivityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ThirdPartyAccountActivityQuery, ThirdPartyAccountActivityQueryVariables>(ThirdPartyAccountActivityDocument, options);
        }
export type ThirdPartyAccountActivityQueryHookResult = ReturnType<typeof useThirdPartyAccountActivityQuery>;
export type ThirdPartyAccountActivityLazyQueryHookResult = ReturnType<typeof useThirdPartyAccountActivityLazyQuery>;
export type ThirdPartyAccountActivityQueryResult = Apollo.QueryResult<ThirdPartyAccountActivityQuery, ThirdPartyAccountActivityQueryVariables>;
export const ThirdPartyLogisticsActivityDocument = gql`
    query ThirdPartyLogisticsActivity($storeTypes: [StoreTypeName!]!) {
  stores(options: {filter: {types: $storeTypes}}) {
    pageInfo {
      ...pageInfoFields
    }
    nodes {
      id
      orderPrefix
      name
    }
  }
}
    ${PageInfoFieldsFragmentDoc}`;

/**
 * __useThirdPartyLogisticsActivityQuery__
 *
 * To run a query within a React component, call `useThirdPartyLogisticsActivityQuery` and pass it any options that fit your needs.
 * When your component renders, `useThirdPartyLogisticsActivityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useThirdPartyLogisticsActivityQuery({
 *   variables: {
 *      storeTypes: // value for 'storeTypes'
 *   },
 * });
 */
export function useThirdPartyLogisticsActivityQuery(baseOptions: Apollo.QueryHookOptions<ThirdPartyLogisticsActivityQuery, ThirdPartyLogisticsActivityQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ThirdPartyLogisticsActivityQuery, ThirdPartyLogisticsActivityQueryVariables>(ThirdPartyLogisticsActivityDocument, options);
      }
export function useThirdPartyLogisticsActivityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ThirdPartyLogisticsActivityQuery, ThirdPartyLogisticsActivityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ThirdPartyLogisticsActivityQuery, ThirdPartyLogisticsActivityQueryVariables>(ThirdPartyLogisticsActivityDocument, options);
        }
export type ThirdPartyLogisticsActivityQueryHookResult = ReturnType<typeof useThirdPartyLogisticsActivityQuery>;
export type ThirdPartyLogisticsActivityLazyQueryHookResult = ReturnType<typeof useThirdPartyLogisticsActivityLazyQuery>;
export type ThirdPartyLogisticsActivityQueryResult = Apollo.QueryResult<ThirdPartyLogisticsActivityQuery, ThirdPartyLogisticsActivityQueryVariables>;
export const Tier1ReturnAuthorizationDetailActivity_ActionBarDocument = gql`
    query Tier1ReturnAuthorizationDetailActivity_ActionBar($returnAuthorizationId: ID!) {
  tier1ReturnAuthorization(id: $returnAuthorizationId) {
    id
    expectedSerialNumber
    group {
      id
      referenceNumber
      store {
        id
        triageWorkflows {
          id
          type {
            id
            name
            displayName
          }
          isEnabled
        }
      }
    }
    netSuiteRecord {
      ...netSuiteRecordFields
    }
    itemReceipt {
      id
      serialNumber
    }
    observation {
      id
    }
    selectedTriage {
      id
      workflow {
        id
        type {
          id
          name
          displayName
        }
      }
    }
    qualityControlCheck {
      id
    }
    carton {
      id
    }
  }
}
    ${NetSuiteRecordFieldsFragmentDoc}`;

/**
 * __useTier1ReturnAuthorizationDetailActivity_ActionBarQuery__
 *
 * To run a query within a React component, call `useTier1ReturnAuthorizationDetailActivity_ActionBarQuery` and pass it any options that fit your needs.
 * When your component renders, `useTier1ReturnAuthorizationDetailActivity_ActionBarQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTier1ReturnAuthorizationDetailActivity_ActionBarQuery({
 *   variables: {
 *      returnAuthorizationId: // value for 'returnAuthorizationId'
 *   },
 * });
 */
export function useTier1ReturnAuthorizationDetailActivity_ActionBarQuery(baseOptions: Apollo.QueryHookOptions<Tier1ReturnAuthorizationDetailActivity_ActionBarQuery, Tier1ReturnAuthorizationDetailActivity_ActionBarQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Tier1ReturnAuthorizationDetailActivity_ActionBarQuery, Tier1ReturnAuthorizationDetailActivity_ActionBarQueryVariables>(Tier1ReturnAuthorizationDetailActivity_ActionBarDocument, options);
      }
export function useTier1ReturnAuthorizationDetailActivity_ActionBarLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Tier1ReturnAuthorizationDetailActivity_ActionBarQuery, Tier1ReturnAuthorizationDetailActivity_ActionBarQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Tier1ReturnAuthorizationDetailActivity_ActionBarQuery, Tier1ReturnAuthorizationDetailActivity_ActionBarQueryVariables>(Tier1ReturnAuthorizationDetailActivity_ActionBarDocument, options);
        }
export type Tier1ReturnAuthorizationDetailActivity_ActionBarQueryHookResult = ReturnType<typeof useTier1ReturnAuthorizationDetailActivity_ActionBarQuery>;
export type Tier1ReturnAuthorizationDetailActivity_ActionBarLazyQueryHookResult = ReturnType<typeof useTier1ReturnAuthorizationDetailActivity_ActionBarLazyQuery>;
export type Tier1ReturnAuthorizationDetailActivity_ActionBarQueryResult = Apollo.QueryResult<Tier1ReturnAuthorizationDetailActivity_ActionBarQuery, Tier1ReturnAuthorizationDetailActivity_ActionBarQueryVariables>;
export const DeviceInformationWidgetDocument = gql`
    query DeviceInformationWidget($returnAuthorizationId: ID!) {
  tier1ReturnAuthorization(id: $returnAuthorizationId) {
    id
    expectedSerialNumber
    item {
      id
      name
      sku
    }
    itemReceipt {
      id
      serialNumber
      item {
        id
        sku
        name
      }
    }
    qualityControlCheck {
      id
      softwareVersion {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useDeviceInformationWidgetQuery__
 *
 * To run a query within a React component, call `useDeviceInformationWidgetQuery` and pass it any options that fit your needs.
 * When your component renders, `useDeviceInformationWidgetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDeviceInformationWidgetQuery({
 *   variables: {
 *      returnAuthorizationId: // value for 'returnAuthorizationId'
 *   },
 * });
 */
export function useDeviceInformationWidgetQuery(baseOptions: Apollo.QueryHookOptions<DeviceInformationWidgetQuery, DeviceInformationWidgetQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DeviceInformationWidgetQuery, DeviceInformationWidgetQueryVariables>(DeviceInformationWidgetDocument, options);
      }
export function useDeviceInformationWidgetLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DeviceInformationWidgetQuery, DeviceInformationWidgetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DeviceInformationWidgetQuery, DeviceInformationWidgetQueryVariables>(DeviceInformationWidgetDocument, options);
        }
export type DeviceInformationWidgetQueryHookResult = ReturnType<typeof useDeviceInformationWidgetQuery>;
export type DeviceInformationWidgetLazyQueryHookResult = ReturnType<typeof useDeviceInformationWidgetLazyQuery>;
export type DeviceInformationWidgetQueryResult = Apollo.QueryResult<DeviceInformationWidgetQuery, DeviceInformationWidgetQueryVariables>;
export const ObservedFailureWidgetDocument = gql`
    query ObservedFailureWidget($returnAuthorizationId: ID!) {
  tier1ReturnAuthorization(id: $returnAuthorizationId) {
    id
    observation {
      id
      createdTimestamp
      reasonText
      createdBy {
        id
        email
        fullName
      }
    }
  }
}
    `;

/**
 * __useObservedFailureWidgetQuery__
 *
 * To run a query within a React component, call `useObservedFailureWidgetQuery` and pass it any options that fit your needs.
 * When your component renders, `useObservedFailureWidgetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useObservedFailureWidgetQuery({
 *   variables: {
 *      returnAuthorizationId: // value for 'returnAuthorizationId'
 *   },
 * });
 */
export function useObservedFailureWidgetQuery(baseOptions: Apollo.QueryHookOptions<ObservedFailureWidgetQuery, ObservedFailureWidgetQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ObservedFailureWidgetQuery, ObservedFailureWidgetQueryVariables>(ObservedFailureWidgetDocument, options);
      }
export function useObservedFailureWidgetLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ObservedFailureWidgetQuery, ObservedFailureWidgetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ObservedFailureWidgetQuery, ObservedFailureWidgetQueryVariables>(ObservedFailureWidgetDocument, options);
        }
export type ObservedFailureWidgetQueryHookResult = ReturnType<typeof useObservedFailureWidgetQuery>;
export type ObservedFailureWidgetLazyQueryHookResult = ReturnType<typeof useObservedFailureWidgetLazyQuery>;
export type ObservedFailureWidgetQueryResult = Apollo.QueryResult<ObservedFailureWidgetQuery, ObservedFailureWidgetQueryVariables>;
export const RmaSourceInformationWidgetDocument = gql`
    query RMASourceInformationWidget($returnAuthorizationId: ID!) {
  tier1ReturnAuthorization(id: $returnAuthorizationId) {
    id
    createdTimestamp
    inboundTrackingNumber
    netSuiteRecord {
      ...netSuiteRecordFields
    }
    netSuiteWriteRequest {
      ...writeRequestFields
    }
    group {
      id
      referenceNumber
      store {
        id
        name
      }
    }
    returnNumber
    itemReceipt {
      id
      createdTimestamp
    }
  }
}
    ${NetSuiteRecordFieldsFragmentDoc}
${WriteRequestFieldsFragmentDoc}`;

/**
 * __useRmaSourceInformationWidgetQuery__
 *
 * To run a query within a React component, call `useRmaSourceInformationWidgetQuery` and pass it any options that fit your needs.
 * When your component renders, `useRmaSourceInformationWidgetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRmaSourceInformationWidgetQuery({
 *   variables: {
 *      returnAuthorizationId: // value for 'returnAuthorizationId'
 *   },
 * });
 */
export function useRmaSourceInformationWidgetQuery(baseOptions: Apollo.QueryHookOptions<RmaSourceInformationWidgetQuery, RmaSourceInformationWidgetQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RmaSourceInformationWidgetQuery, RmaSourceInformationWidgetQueryVariables>(RmaSourceInformationWidgetDocument, options);
      }
export function useRmaSourceInformationWidgetLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RmaSourceInformationWidgetQuery, RmaSourceInformationWidgetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RmaSourceInformationWidgetQuery, RmaSourceInformationWidgetQueryVariables>(RmaSourceInformationWidgetDocument, options);
        }
export type RmaSourceInformationWidgetQueryHookResult = ReturnType<typeof useRmaSourceInformationWidgetQuery>;
export type RmaSourceInformationWidgetLazyQueryHookResult = ReturnType<typeof useRmaSourceInformationWidgetLazyQuery>;
export type RmaSourceInformationWidgetQueryResult = Apollo.QueryResult<RmaSourceInformationWidgetQuery, RmaSourceInformationWidgetQueryVariables>;
export const ReportedDeviceIssueWidgetDocument = gql`
    query ReportedDeviceIssueWidget($returnAuthorizationId: ID!) {
  tier1ReturnAuthorization(id: $returnAuthorizationId) {
    id
    problemStatements
    customerComment
  }
}
    `;

/**
 * __useReportedDeviceIssueWidgetQuery__
 *
 * To run a query within a React component, call `useReportedDeviceIssueWidgetQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportedDeviceIssueWidgetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportedDeviceIssueWidgetQuery({
 *   variables: {
 *      returnAuthorizationId: // value for 'returnAuthorizationId'
 *   },
 * });
 */
export function useReportedDeviceIssueWidgetQuery(baseOptions: Apollo.QueryHookOptions<ReportedDeviceIssueWidgetQuery, ReportedDeviceIssueWidgetQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReportedDeviceIssueWidgetQuery, ReportedDeviceIssueWidgetQueryVariables>(ReportedDeviceIssueWidgetDocument, options);
      }
export function useReportedDeviceIssueWidgetLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReportedDeviceIssueWidgetQuery, ReportedDeviceIssueWidgetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReportedDeviceIssueWidgetQuery, ReportedDeviceIssueWidgetQueryVariables>(ReportedDeviceIssueWidgetDocument, options);
        }
export type ReportedDeviceIssueWidgetQueryHookResult = ReturnType<typeof useReportedDeviceIssueWidgetQuery>;
export type ReportedDeviceIssueWidgetLazyQueryHookResult = ReturnType<typeof useReportedDeviceIssueWidgetLazyQuery>;
export type ReportedDeviceIssueWidgetQueryResult = Apollo.QueryResult<ReportedDeviceIssueWidgetQuery, ReportedDeviceIssueWidgetQueryVariables>;
export const Tier1ReturnAuthorizationLifeCycleWidgetDocument = gql`
    query Tier1ReturnAuthorizationLifeCycleWidget($returnAuthorizationId: ID!) {
  tier1ReturnAuthorization(id: $returnAuthorizationId) {
    id
    createdTimestamp
    itemReceipt {
      id
      serialNumber
      createdTimestamp
    }
    observation {
      id
      createdTimestamp
    }
    selectedTriage {
      id
      createdTimestamp
      replacementSerialNumber
      workflow {
        id
        type {
          id
          name
          displayName
        }
      }
    }
    qualityControlCheck {
      id
      createdTimestamp
    }
    carton {
      id
      createdTimestamp
    }
    group {
      id
      referenceNumber
      store {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useTier1ReturnAuthorizationLifeCycleWidgetQuery__
 *
 * To run a query within a React component, call `useTier1ReturnAuthorizationLifeCycleWidgetQuery` and pass it any options that fit your needs.
 * When your component renders, `useTier1ReturnAuthorizationLifeCycleWidgetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTier1ReturnAuthorizationLifeCycleWidgetQuery({
 *   variables: {
 *      returnAuthorizationId: // value for 'returnAuthorizationId'
 *   },
 * });
 */
export function useTier1ReturnAuthorizationLifeCycleWidgetQuery(baseOptions: Apollo.QueryHookOptions<Tier1ReturnAuthorizationLifeCycleWidgetQuery, Tier1ReturnAuthorizationLifeCycleWidgetQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Tier1ReturnAuthorizationLifeCycleWidgetQuery, Tier1ReturnAuthorizationLifeCycleWidgetQueryVariables>(Tier1ReturnAuthorizationLifeCycleWidgetDocument, options);
      }
export function useTier1ReturnAuthorizationLifeCycleWidgetLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Tier1ReturnAuthorizationLifeCycleWidgetQuery, Tier1ReturnAuthorizationLifeCycleWidgetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Tier1ReturnAuthorizationLifeCycleWidgetQuery, Tier1ReturnAuthorizationLifeCycleWidgetQueryVariables>(Tier1ReturnAuthorizationLifeCycleWidgetDocument, options);
        }
export type Tier1ReturnAuthorizationLifeCycleWidgetQueryHookResult = ReturnType<typeof useTier1ReturnAuthorizationLifeCycleWidgetQuery>;
export type Tier1ReturnAuthorizationLifeCycleWidgetLazyQueryHookResult = ReturnType<typeof useTier1ReturnAuthorizationLifeCycleWidgetLazyQuery>;
export type Tier1ReturnAuthorizationLifeCycleWidgetQueryResult = Apollo.QueryResult<Tier1ReturnAuthorizationLifeCycleWidgetQuery, Tier1ReturnAuthorizationLifeCycleWidgetQueryVariables>;
export const TriageDecisionWidgetDocument = gql`
    query TriageDecisionWidget($returnAuthorizationId: ID!) {
  tier1ReturnAuthorization(id: $returnAuthorizationId) {
    id
    selectedTriage {
      id
      createdTimestamp
      createdBy {
        id
        fullName
      }
      workflow {
        id
        type {
          id
          name
          displayName
        }
      }
      repairCode
      replacementSerialNumber
      technicianComment
    }
  }
}
    `;

/**
 * __useTriageDecisionWidgetQuery__
 *
 * To run a query within a React component, call `useTriageDecisionWidgetQuery` and pass it any options that fit your needs.
 * When your component renders, `useTriageDecisionWidgetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTriageDecisionWidgetQuery({
 *   variables: {
 *      returnAuthorizationId: // value for 'returnAuthorizationId'
 *   },
 * });
 */
export function useTriageDecisionWidgetQuery(baseOptions: Apollo.QueryHookOptions<TriageDecisionWidgetQuery, TriageDecisionWidgetQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TriageDecisionWidgetQuery, TriageDecisionWidgetQueryVariables>(TriageDecisionWidgetDocument, options);
      }
export function useTriageDecisionWidgetLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TriageDecisionWidgetQuery, TriageDecisionWidgetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TriageDecisionWidgetQuery, TriageDecisionWidgetQueryVariables>(TriageDecisionWidgetDocument, options);
        }
export type TriageDecisionWidgetQueryHookResult = ReturnType<typeof useTriageDecisionWidgetQuery>;
export type TriageDecisionWidgetLazyQueryHookResult = ReturnType<typeof useTriageDecisionWidgetLazyQuery>;
export type TriageDecisionWidgetQueryResult = Apollo.QueryResult<TriageDecisionWidgetQuery, TriageDecisionWidgetQueryVariables>;
export const LookUpTier1ReturnAuthorizationModalDocument = gql`
    query LookUpTier1ReturnAuthorizationModal($searchText: String!) {
  tier1ReturnAuthorizations(options: {filter: {omniFreeText: $searchText}}) {
    pageInfo {
      ...pageInfoFields
    }
    nodes {
      id
      item {
        id
        name
      }
      group {
        id
        referenceNumber
        store {
          id
          name
        }
        returnAuthorizations {
          pageInfo {
            ...pageInfoFields
          }
          nodes {
            id
            itemReceipt {
              id
            }
            expectedSerialNumber
            item {
              id
              sku
              name
            }
          }
        }
      }
    }
  }
}
    ${PageInfoFieldsFragmentDoc}`;

/**
 * __useLookUpTier1ReturnAuthorizationModalQuery__
 *
 * To run a query within a React component, call `useLookUpTier1ReturnAuthorizationModalQuery` and pass it any options that fit your needs.
 * When your component renders, `useLookUpTier1ReturnAuthorizationModalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLookUpTier1ReturnAuthorizationModalQuery({
 *   variables: {
 *      searchText: // value for 'searchText'
 *   },
 * });
 */
export function useLookUpTier1ReturnAuthorizationModalQuery(baseOptions: Apollo.QueryHookOptions<LookUpTier1ReturnAuthorizationModalQuery, LookUpTier1ReturnAuthorizationModalQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LookUpTier1ReturnAuthorizationModalQuery, LookUpTier1ReturnAuthorizationModalQueryVariables>(LookUpTier1ReturnAuthorizationModalDocument, options);
      }
export function useLookUpTier1ReturnAuthorizationModalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LookUpTier1ReturnAuthorizationModalQuery, LookUpTier1ReturnAuthorizationModalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LookUpTier1ReturnAuthorizationModalQuery, LookUpTier1ReturnAuthorizationModalQueryVariables>(LookUpTier1ReturnAuthorizationModalDocument, options);
        }
export type LookUpTier1ReturnAuthorizationModalQueryHookResult = ReturnType<typeof useLookUpTier1ReturnAuthorizationModalQuery>;
export type LookUpTier1ReturnAuthorizationModalLazyQueryHookResult = ReturnType<typeof useLookUpTier1ReturnAuthorizationModalLazyQuery>;
export type LookUpTier1ReturnAuthorizationModalQueryResult = Apollo.QueryResult<LookUpTier1ReturnAuthorizationModalQuery, LookUpTier1ReturnAuthorizationModalQueryVariables>;
export const GenerateShippingLabelForTier1ReturnAuthorizationsDocument = gql`
    mutation GenerateShippingLabelForTier1ReturnAuthorizations($input: GenerateShippingLabelForTier1ReturnAuthorizationsInput!) {
  generateShippingLabelForTier1ReturnAuthorizations(input: $input) {
    id
    shipment {
      id
      labelUrl
    }
  }
}
    `;
export type GenerateShippingLabelForTier1ReturnAuthorizationsMutationFn = Apollo.MutationFunction<GenerateShippingLabelForTier1ReturnAuthorizationsMutation, GenerateShippingLabelForTier1ReturnAuthorizationsMutationVariables>;

/**
 * __useGenerateShippingLabelForTier1ReturnAuthorizationsMutation__
 *
 * To run a mutation, you first call `useGenerateShippingLabelForTier1ReturnAuthorizationsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateShippingLabelForTier1ReturnAuthorizationsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateShippingLabelForTier1ReturnAuthorizationsMutation, { data, loading, error }] = useGenerateShippingLabelForTier1ReturnAuthorizationsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGenerateShippingLabelForTier1ReturnAuthorizationsMutation(baseOptions?: Apollo.MutationHookOptions<GenerateShippingLabelForTier1ReturnAuthorizationsMutation, GenerateShippingLabelForTier1ReturnAuthorizationsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateShippingLabelForTier1ReturnAuthorizationsMutation, GenerateShippingLabelForTier1ReturnAuthorizationsMutationVariables>(GenerateShippingLabelForTier1ReturnAuthorizationsDocument, options);
      }
export type GenerateShippingLabelForTier1ReturnAuthorizationsMutationHookResult = ReturnType<typeof useGenerateShippingLabelForTier1ReturnAuthorizationsMutation>;
export type GenerateShippingLabelForTier1ReturnAuthorizationsMutationResult = Apollo.MutationResult<GenerateShippingLabelForTier1ReturnAuthorizationsMutation>;
export type GenerateShippingLabelForTier1ReturnAuthorizationsMutationOptions = Apollo.BaseMutationOptions<GenerateShippingLabelForTier1ReturnAuthorizationsMutation, GenerateShippingLabelForTier1ReturnAuthorizationsMutationVariables>;
export const PrintLabelModalDocument = gql`
    query PrintLabelModal($returnAuthorizationGroupId: ID!) {
  tier1ReturnAuthorizationGroup(id: $returnAuthorizationGroupId) {
    id
    referenceNumber
    returnAuthorizations(options: {filter: {inState: readyForLabel}}) {
      pageInfo {
        ...pageInfoFields
      }
      nodes {
        id
        createdTimestamp
        netSuiteRecord {
          id
          transactionId
        }
        returnNumber
        itemReceipt {
          id
          serialNumber
          item {
            id
            sku
            name
            weightValue
            weightUnit
          }
        }
      }
    }
  }
}
    ${PageInfoFieldsFragmentDoc}`;

/**
 * __usePrintLabelModalQuery__
 *
 * To run a query within a React component, call `usePrintLabelModalQuery` and pass it any options that fit your needs.
 * When your component renders, `usePrintLabelModalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePrintLabelModalQuery({
 *   variables: {
 *      returnAuthorizationGroupId: // value for 'returnAuthorizationGroupId'
 *   },
 * });
 */
export function usePrintLabelModalQuery(baseOptions: Apollo.QueryHookOptions<PrintLabelModalQuery, PrintLabelModalQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PrintLabelModalQuery, PrintLabelModalQueryVariables>(PrintLabelModalDocument, options);
      }
export function usePrintLabelModalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PrintLabelModalQuery, PrintLabelModalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PrintLabelModalQuery, PrintLabelModalQueryVariables>(PrintLabelModalDocument, options);
        }
export type PrintLabelModalQueryHookResult = ReturnType<typeof usePrintLabelModalQuery>;
export type PrintLabelModalLazyQueryHookResult = ReturnType<typeof usePrintLabelModalLazyQuery>;
export type PrintLabelModalQueryResult = Apollo.QueryResult<PrintLabelModalQuery, PrintLabelModalQueryVariables>;
export const PrintLabelTableDocument = gql`
    query PrintLabelTable($page: Cursor, $filter: QueryTier1ReturnAuthorizationGroupsFilterInput) {
  tier1ReturnAuthorizationGroups(
    options: {paginationInput: {after: $page, first: 20}, filter: $filter}
  ) {
    pageInfo {
      ...pageInfoFields
    }
    nodes {
      id
      createdTimestamp
      referenceNumber
      readyForLabel: returnAuthorizations(options: {filter: {inState: readyForLabel}}) {
        pageInfo {
          ...pageInfoFields
        }
        nodes {
          id
          createdTimestamp
        }
      }
      totalReturnCount
    }
  }
}
    ${PageInfoFieldsFragmentDoc}`;

/**
 * __usePrintLabelTableQuery__
 *
 * To run a query within a React component, call `usePrintLabelTableQuery` and pass it any options that fit your needs.
 * When your component renders, `usePrintLabelTableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePrintLabelTableQuery({
 *   variables: {
 *      page: // value for 'page'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function usePrintLabelTableQuery(baseOptions?: Apollo.QueryHookOptions<PrintLabelTableQuery, PrintLabelTableQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PrintLabelTableQuery, PrintLabelTableQueryVariables>(PrintLabelTableDocument, options);
      }
export function usePrintLabelTableLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PrintLabelTableQuery, PrintLabelTableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PrintLabelTableQuery, PrintLabelTableQueryVariables>(PrintLabelTableDocument, options);
        }
export type PrintLabelTableQueryHookResult = ReturnType<typeof usePrintLabelTableQuery>;
export type PrintLabelTableLazyQueryHookResult = ReturnType<typeof usePrintLabelTableLazyQuery>;
export type PrintLabelTableQueryResult = Apollo.QueryResult<PrintLabelTableQuery, PrintLabelTableQueryVariables>;
export const LookUpTier1ReturnAuthorizationByDetailsDocument = gql`
    query LookUpTier1ReturnAuthorizationByDetails($storeId: ID!, $itemId: ID!, $inState: Tier1ReturnAuthorizationState!) {
  tier1ReturnAuthorizations(
    options: {filter: {storeId: $storeId, itemId: $itemId, inState: $inState, excludeWithSerialNumber: true}, sort: {field: createdTimestamp, direction: descending}}
  ) {
    pageInfo {
      ...pageInfoFields
    }
    nodes {
      id
      createdTimestamp
      group {
        id
        referenceNumber
      }
      item {
        id
        sku
        name
      }
    }
  }
}
    ${PageInfoFieldsFragmentDoc}`;

/**
 * __useLookUpTier1ReturnAuthorizationByDetailsQuery__
 *
 * To run a query within a React component, call `useLookUpTier1ReturnAuthorizationByDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useLookUpTier1ReturnAuthorizationByDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLookUpTier1ReturnAuthorizationByDetailsQuery({
 *   variables: {
 *      storeId: // value for 'storeId'
 *      itemId: // value for 'itemId'
 *      inState: // value for 'inState'
 *   },
 * });
 */
export function useLookUpTier1ReturnAuthorizationByDetailsQuery(baseOptions: Apollo.QueryHookOptions<LookUpTier1ReturnAuthorizationByDetailsQuery, LookUpTier1ReturnAuthorizationByDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LookUpTier1ReturnAuthorizationByDetailsQuery, LookUpTier1ReturnAuthorizationByDetailsQueryVariables>(LookUpTier1ReturnAuthorizationByDetailsDocument, options);
      }
export function useLookUpTier1ReturnAuthorizationByDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LookUpTier1ReturnAuthorizationByDetailsQuery, LookUpTier1ReturnAuthorizationByDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LookUpTier1ReturnAuthorizationByDetailsQuery, LookUpTier1ReturnAuthorizationByDetailsQueryVariables>(LookUpTier1ReturnAuthorizationByDetailsDocument, options);
        }
export type LookUpTier1ReturnAuthorizationByDetailsQueryHookResult = ReturnType<typeof useLookUpTier1ReturnAuthorizationByDetailsQuery>;
export type LookUpTier1ReturnAuthorizationByDetailsLazyQueryHookResult = ReturnType<typeof useLookUpTier1ReturnAuthorizationByDetailsLazyQuery>;
export type LookUpTier1ReturnAuthorizationByDetailsQueryResult = Apollo.QueryResult<LookUpTier1ReturnAuthorizationByDetailsQuery, LookUpTier1ReturnAuthorizationByDetailsQueryVariables>;
export const ReturnAuthorizationGroupTableDocument = gql`
    query ReturnAuthorizationGroupTable($filter: QueryTier1ReturnAuthorizationsFilterInput) {
  tier1ReturnAuthorizations(options: {filter: $filter}) {
    pageInfo {
      ...pageInfoFields
    }
    nodes {
      id
      expectedSerialNumber
      netSuiteRecord {
        ...netSuiteRecordFields
      }
      netSuiteWriteRequest {
        ...writeRequestFields
      }
      item {
        id
        name
        sku
      }
      group {
        id
        createdTimestamp
        referenceNumber
        totalReturnCount
        store {
          id
          name
        }
      }
    }
  }
}
    ${PageInfoFieldsFragmentDoc}
${NetSuiteRecordFieldsFragmentDoc}
${WriteRequestFieldsFragmentDoc}`;

/**
 * __useReturnAuthorizationGroupTableQuery__
 *
 * To run a query within a React component, call `useReturnAuthorizationGroupTableQuery` and pass it any options that fit your needs.
 * When your component renders, `useReturnAuthorizationGroupTableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReturnAuthorizationGroupTableQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useReturnAuthorizationGroupTableQuery(baseOptions?: Apollo.QueryHookOptions<ReturnAuthorizationGroupTableQuery, ReturnAuthorizationGroupTableQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReturnAuthorizationGroupTableQuery, ReturnAuthorizationGroupTableQueryVariables>(ReturnAuthorizationGroupTableDocument, options);
      }
export function useReturnAuthorizationGroupTableLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReturnAuthorizationGroupTableQuery, ReturnAuthorizationGroupTableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReturnAuthorizationGroupTableQuery, ReturnAuthorizationGroupTableQueryVariables>(ReturnAuthorizationGroupTableDocument, options);
        }
export type ReturnAuthorizationGroupTableQueryHookResult = ReturnType<typeof useReturnAuthorizationGroupTableQuery>;
export type ReturnAuthorizationGroupTableLazyQueryHookResult = ReturnType<typeof useReturnAuthorizationGroupTableLazyQuery>;
export type ReturnAuthorizationGroupTableQueryResult = Apollo.QueryResult<ReturnAuthorizationGroupTableQuery, ReturnAuthorizationGroupTableQueryVariables>;
export const Tier1ReturnAuthorizationsActivity_TabBarDocument = gql`
    query Tier1ReturnAuthorizationsActivity_TabBar($storeId: ID, $searchText: String!) {
  preAlert: tier1ReturnAuthorizations(
    options: {filter: {storeId: $storeId, inState: preAlert, omniFreeText: $searchText}, paginationInput: {first: 1}}
  ) {
    pageInfo {
      ...pageInfoFields
    }
  }
  awaitingTriageObservation: tier1ReturnAuthorizations(
    options: {filter: {storeId: $storeId, inState: awaitingTriageObservation, omniFreeText: $searchText}, paginationInput: {first: 1}}
  ) {
    pageInfo {
      ...pageInfoFields
    }
  }
  awaitingTriage: tier1ReturnAuthorizations(
    options: {filter: {storeId: $storeId, inState: awaitingTriage, omniFreeText: $searchText}, paginationInput: {first: 1}}
  ) {
    pageInfo {
      ...pageInfoFields
    }
  }
  awaitingQualityControl: tier1ReturnAuthorizations(
    options: {filter: {storeId: $storeId, inState: awaitingQualityControl}, paginationInput: {first: 1}}
  ) {
    pageInfo {
      ...pageInfoFields
    }
  }
  readyForLabel: tier1ReturnAuthorizations(
    options: {filter: {storeId: $storeId, inState: readyForLabel, omniFreeText: $searchText}, paginationInput: {first: 1}}
  ) {
    pageInfo {
      ...pageInfoFields
    }
  }
}
    ${PageInfoFieldsFragmentDoc}`;

/**
 * __useTier1ReturnAuthorizationsActivity_TabBarQuery__
 *
 * To run a query within a React component, call `useTier1ReturnAuthorizationsActivity_TabBarQuery` and pass it any options that fit your needs.
 * When your component renders, `useTier1ReturnAuthorizationsActivity_TabBarQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTier1ReturnAuthorizationsActivity_TabBarQuery({
 *   variables: {
 *      storeId: // value for 'storeId'
 *      searchText: // value for 'searchText'
 *   },
 * });
 */
export function useTier1ReturnAuthorizationsActivity_TabBarQuery(baseOptions: Apollo.QueryHookOptions<Tier1ReturnAuthorizationsActivity_TabBarQuery, Tier1ReturnAuthorizationsActivity_TabBarQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Tier1ReturnAuthorizationsActivity_TabBarQuery, Tier1ReturnAuthorizationsActivity_TabBarQueryVariables>(Tier1ReturnAuthorizationsActivity_TabBarDocument, options);
      }
export function useTier1ReturnAuthorizationsActivity_TabBarLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Tier1ReturnAuthorizationsActivity_TabBarQuery, Tier1ReturnAuthorizationsActivity_TabBarQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Tier1ReturnAuthorizationsActivity_TabBarQuery, Tier1ReturnAuthorizationsActivity_TabBarQueryVariables>(Tier1ReturnAuthorizationsActivity_TabBarDocument, options);
        }
export type Tier1ReturnAuthorizationsActivity_TabBarQueryHookResult = ReturnType<typeof useTier1ReturnAuthorizationsActivity_TabBarQuery>;
export type Tier1ReturnAuthorizationsActivity_TabBarLazyQueryHookResult = ReturnType<typeof useTier1ReturnAuthorizationsActivity_TabBarLazyQuery>;
export type Tier1ReturnAuthorizationsActivity_TabBarQueryResult = Apollo.QueryResult<Tier1ReturnAuthorizationsActivity_TabBarQuery, Tier1ReturnAuthorizationsActivity_TabBarQueryVariables>;
export const Tier1ReturnAuthorizationsActivity_TableDocument = gql`
    query Tier1ReturnAuthorizationsActivity_Table($page: Cursor, $filter: QueryTier1ReturnAuthorizationsFilterInput, $sort: QueryTier1ReturnAuthorizationsSortInput) {
  tier1ReturnAuthorizations(
    options: {paginationInput: {after: $page, first: 20}, filter: $filter, sort: $sort}
  ) {
    pageInfo {
      ...pageInfoFields
    }
    nodes {
      id
      createdTimestamp
      returnNumber
      expectedSerialNumber
      observation {
        id
        reasonText
      }
      item {
        id
        name
        sku
      }
      itemReceipt {
        id
        createdTimestamp
        netSuiteWriteRequest {
          ...writeRequestFields
        }
        netSuiteRecord {
          ...netSuiteRecordFields
        }
      }
      carton {
        id
        shipment {
          id
          labelUrl
        }
      }
      netSuiteWriteRequest {
        ...writeRequestFields
      }
      netSuiteRecord {
        ...netSuiteRecordFields
      }
      group {
        id
        referenceNumber
        store {
          id
          name
        }
      }
    }
  }
}
    ${PageInfoFieldsFragmentDoc}
${WriteRequestFieldsFragmentDoc}
${NetSuiteRecordFieldsFragmentDoc}`;

/**
 * __useTier1ReturnAuthorizationsActivity_TableQuery__
 *
 * To run a query within a React component, call `useTier1ReturnAuthorizationsActivity_TableQuery` and pass it any options that fit your needs.
 * When your component renders, `useTier1ReturnAuthorizationsActivity_TableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTier1ReturnAuthorizationsActivity_TableQuery({
 *   variables: {
 *      page: // value for 'page'
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useTier1ReturnAuthorizationsActivity_TableQuery(baseOptions?: Apollo.QueryHookOptions<Tier1ReturnAuthorizationsActivity_TableQuery, Tier1ReturnAuthorizationsActivity_TableQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Tier1ReturnAuthorizationsActivity_TableQuery, Tier1ReturnAuthorizationsActivity_TableQueryVariables>(Tier1ReturnAuthorizationsActivity_TableDocument, options);
      }
export function useTier1ReturnAuthorizationsActivity_TableLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Tier1ReturnAuthorizationsActivity_TableQuery, Tier1ReturnAuthorizationsActivity_TableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Tier1ReturnAuthorizationsActivity_TableQuery, Tier1ReturnAuthorizationsActivity_TableQueryVariables>(Tier1ReturnAuthorizationsActivity_TableDocument, options);
        }
export type Tier1ReturnAuthorizationsActivity_TableQueryHookResult = ReturnType<typeof useTier1ReturnAuthorizationsActivity_TableQuery>;
export type Tier1ReturnAuthorizationsActivity_TableLazyQueryHookResult = ReturnType<typeof useTier1ReturnAuthorizationsActivity_TableLazyQuery>;
export type Tier1ReturnAuthorizationsActivity_TableQueryResult = Apollo.QueryResult<Tier1ReturnAuthorizationsActivity_TableQuery, Tier1ReturnAuthorizationsActivity_TableQueryVariables>;
export const OverrideCachedOrderDocument = gql`
    mutation OverrideCachedOrder($input: OverrideCachedOrderInput!) {
  overrideCachedOrder(input: $input)
}
    `;
export type OverrideCachedOrderMutationFn = Apollo.MutationFunction<OverrideCachedOrderMutation, OverrideCachedOrderMutationVariables>;

/**
 * __useOverrideCachedOrderMutation__
 *
 * To run a mutation, you first call `useOverrideCachedOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOverrideCachedOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [overrideCachedOrderMutation, { data, loading, error }] = useOverrideCachedOrderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useOverrideCachedOrderMutation(baseOptions?: Apollo.MutationHookOptions<OverrideCachedOrderMutation, OverrideCachedOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OverrideCachedOrderMutation, OverrideCachedOrderMutationVariables>(OverrideCachedOrderDocument, options);
      }
export type OverrideCachedOrderMutationHookResult = ReturnType<typeof useOverrideCachedOrderMutation>;
export type OverrideCachedOrderMutationResult = Apollo.MutationResult<OverrideCachedOrderMutation>;
export type OverrideCachedOrderMutationOptions = Apollo.BaseMutationOptions<OverrideCachedOrderMutation, OverrideCachedOrderMutationVariables>;
export const ValidateCachedOrderDocument = gql`
    query ValidateCachedOrder($input: OverrideCachedOrderInput!) {
  validateCachedOrder(input: $input)
}
    `;

/**
 * __useValidateCachedOrderQuery__
 *
 * To run a query within a React component, call `useValidateCachedOrderQuery` and pass it any options that fit your needs.
 * When your component renders, `useValidateCachedOrderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useValidateCachedOrderQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useValidateCachedOrderQuery(baseOptions: Apollo.QueryHookOptions<ValidateCachedOrderQuery, ValidateCachedOrderQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ValidateCachedOrderQuery, ValidateCachedOrderQueryVariables>(ValidateCachedOrderDocument, options);
      }
export function useValidateCachedOrderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ValidateCachedOrderQuery, ValidateCachedOrderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ValidateCachedOrderQuery, ValidateCachedOrderQueryVariables>(ValidateCachedOrderDocument, options);
        }
export type ValidateCachedOrderQueryHookResult = ReturnType<typeof useValidateCachedOrderQuery>;
export type ValidateCachedOrderLazyQueryHookResult = ReturnType<typeof useValidateCachedOrderLazyQuery>;
export type ValidateCachedOrderQueryResult = Apollo.QueryResult<ValidateCachedOrderQuery, ValidateCachedOrderQueryVariables>;
export const ValidateOrderActivityDocument = gql`
    query ValidateOrderActivity($externalOrderId: ID!) {
  cachedOrder(id: $externalOrderId) {
    id
    metaCreated
    rawData
    validationErrors
    store {
      id
      salesOrderValidator
      type {
        id
        name
        displayName
      }
    }
  }
}
    `;

/**
 * __useValidateOrderActivityQuery__
 *
 * To run a query within a React component, call `useValidateOrderActivityQuery` and pass it any options that fit your needs.
 * When your component renders, `useValidateOrderActivityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useValidateOrderActivityQuery({
 *   variables: {
 *      externalOrderId: // value for 'externalOrderId'
 *   },
 * });
 */
export function useValidateOrderActivityQuery(baseOptions: Apollo.QueryHookOptions<ValidateOrderActivityQuery, ValidateOrderActivityQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ValidateOrderActivityQuery, ValidateOrderActivityQueryVariables>(ValidateOrderActivityDocument, options);
      }
export function useValidateOrderActivityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ValidateOrderActivityQuery, ValidateOrderActivityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ValidateOrderActivityQuery, ValidateOrderActivityQueryVariables>(ValidateOrderActivityDocument, options);
        }
export type ValidateOrderActivityQueryHookResult = ReturnType<typeof useValidateOrderActivityQuery>;
export type ValidateOrderActivityLazyQueryHookResult = ReturnType<typeof useValidateOrderActivityLazyQuery>;
export type ValidateOrderActivityQueryResult = Apollo.QueryResult<ValidateOrderActivityQuery, ValidateOrderActivityQueryVariables>;
export const RegisterActivityDocument = gql`
    query RegisterActivity($code: String!) {
  invite(input: {code: $code}) {
    id
    isClaimed
  }
}
    `;

/**
 * __useRegisterActivityQuery__
 *
 * To run a query within a React component, call `useRegisterActivityQuery` and pass it any options that fit your needs.
 * When your component renders, `useRegisterActivityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRegisterActivityQuery({
 *   variables: {
 *      code: // value for 'code'
 *   },
 * });
 */
export function useRegisterActivityQuery(baseOptions: Apollo.QueryHookOptions<RegisterActivityQuery, RegisterActivityQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RegisterActivityQuery, RegisterActivityQueryVariables>(RegisterActivityDocument, options);
      }
export function useRegisterActivityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RegisterActivityQuery, RegisterActivityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RegisterActivityQuery, RegisterActivityQueryVariables>(RegisterActivityDocument, options);
        }
export type RegisterActivityQueryHookResult = ReturnType<typeof useRegisterActivityQuery>;
export type RegisterActivityLazyQueryHookResult = ReturnType<typeof useRegisterActivityLazyQuery>;
export type RegisterActivityQueryResult = Apollo.QueryResult<RegisterActivityQuery, RegisterActivityQueryVariables>;
export const RootActivityDocument = gql`
    query RootActivity {
  loggedInUser {
    id
    isSuperAdmin
    permissions {
      id
      name
    }
  }
  stores(options: {}) {
    pageInfo {
      ...pageInfoFields
    }
    nodes {
      id
      name
    }
  }
}
    ${PageInfoFieldsFragmentDoc}`;

/**
 * __useRootActivityQuery__
 *
 * To run a query within a React component, call `useRootActivityQuery` and pass it any options that fit your needs.
 * When your component renders, `useRootActivityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRootActivityQuery({
 *   variables: {
 *   },
 * });
 */
export function useRootActivityQuery(baseOptions?: Apollo.QueryHookOptions<RootActivityQuery, RootActivityQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RootActivityQuery, RootActivityQueryVariables>(RootActivityDocument, options);
      }
export function useRootActivityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RootActivityQuery, RootActivityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RootActivityQuery, RootActivityQueryVariables>(RootActivityDocument, options);
        }
export type RootActivityQueryHookResult = ReturnType<typeof useRootActivityQuery>;
export type RootActivityLazyQueryHookResult = ReturnType<typeof useRootActivityLazyQuery>;
export type RootActivityQueryResult = Apollo.QueryResult<RootActivityQuery, RootActivityQueryVariables>;
export const CustomerChatWidgetDocument = gql`
    query CustomerChatWidget($id: ID!, $queryOrder: Boolean!) {
  returnAuthorizationLite(id: $id) @skip(if: $queryOrder) {
    id
    messages {
      nodes {
        id
        metaCreated
        content
        senderName
      }
    }
  }
  orderLite(input: {id: $id}) @include(if: $queryOrder) {
    id
    messages {
      nodes {
        id
        metaCreated
        content
        senderName
      }
    }
  }
}
    `;

/**
 * __useCustomerChatWidgetQuery__
 *
 * To run a query within a React component, call `useCustomerChatWidgetQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomerChatWidgetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomerChatWidgetQuery({
 *   variables: {
 *      id: // value for 'id'
 *      queryOrder: // value for 'queryOrder'
 *   },
 * });
 */
export function useCustomerChatWidgetQuery(baseOptions: Apollo.QueryHookOptions<CustomerChatWidgetQuery, CustomerChatWidgetQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CustomerChatWidgetQuery, CustomerChatWidgetQueryVariables>(CustomerChatWidgetDocument, options);
      }
export function useCustomerChatWidgetLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CustomerChatWidgetQuery, CustomerChatWidgetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CustomerChatWidgetQuery, CustomerChatWidgetQueryVariables>(CustomerChatWidgetDocument, options);
        }
export type CustomerChatWidgetQueryHookResult = ReturnType<typeof useCustomerChatWidgetQuery>;
export type CustomerChatWidgetLazyQueryHookResult = ReturnType<typeof useCustomerChatWidgetLazyQuery>;
export type CustomerChatWidgetQueryResult = Apollo.QueryResult<CustomerChatWidgetQuery, CustomerChatWidgetQueryVariables>;
export const CustomerOrderActionsWidgetDocument = gql`
    query CustomerOrderActionsWidget($orderId: ID!) {
  canInitiateReturnAuthorization(orderId: $orderId)
  canCloseOrder(orderId: $orderId)
  orderLite(input: {id: $orderId}) {
    id
    overallOrderStatus {
      id
      name
      displayName
    }
    returnAuthorizations {
      id
    }
  }
}
    `;

/**
 * __useCustomerOrderActionsWidgetQuery__
 *
 * To run a query within a React component, call `useCustomerOrderActionsWidgetQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomerOrderActionsWidgetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomerOrderActionsWidgetQuery({
 *   variables: {
 *      orderId: // value for 'orderId'
 *   },
 * });
 */
export function useCustomerOrderActionsWidgetQuery(baseOptions: Apollo.QueryHookOptions<CustomerOrderActionsWidgetQuery, CustomerOrderActionsWidgetQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CustomerOrderActionsWidgetQuery, CustomerOrderActionsWidgetQueryVariables>(CustomerOrderActionsWidgetDocument, options);
      }
export function useCustomerOrderActionsWidgetLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CustomerOrderActionsWidgetQuery, CustomerOrderActionsWidgetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CustomerOrderActionsWidgetQuery, CustomerOrderActionsWidgetQueryVariables>(CustomerOrderActionsWidgetDocument, options);
        }
export type CustomerOrderActionsWidgetQueryHookResult = ReturnType<typeof useCustomerOrderActionsWidgetQuery>;
export type CustomerOrderActionsWidgetLazyQueryHookResult = ReturnType<typeof useCustomerOrderActionsWidgetLazyQuery>;
export type CustomerOrderActionsWidgetQueryResult = Apollo.QueryResult<CustomerOrderActionsWidgetQuery, CustomerOrderActionsWidgetQueryVariables>;
export const LineItemsWidgetDocument = gql`
    query LineItemsWidget($orderId: ID!) {
  orderLite(input: {id: $orderId}) {
    id
    lineItems {
      id
      productName
      sku
      quantity
      itemTotalCents
      taxTotalCents
      feeTotalCents
      refundAmountCents
    }
  }
}
    `;

/**
 * __useLineItemsWidgetQuery__
 *
 * To run a query within a React component, call `useLineItemsWidgetQuery` and pass it any options that fit your needs.
 * When your component renders, `useLineItemsWidgetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLineItemsWidgetQuery({
 *   variables: {
 *      orderId: // value for 'orderId'
 *   },
 * });
 */
export function useLineItemsWidgetQuery(baseOptions: Apollo.QueryHookOptions<LineItemsWidgetQuery, LineItemsWidgetQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LineItemsWidgetQuery, LineItemsWidgetQueryVariables>(LineItemsWidgetDocument, options);
      }
export function useLineItemsWidgetLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LineItemsWidgetQuery, LineItemsWidgetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LineItemsWidgetQuery, LineItemsWidgetQueryVariables>(LineItemsWidgetDocument, options);
        }
export type LineItemsWidgetQueryHookResult = ReturnType<typeof useLineItemsWidgetQuery>;
export type LineItemsWidgetLazyQueryHookResult = ReturnType<typeof useLineItemsWidgetLazyQuery>;
export type LineItemsWidgetQueryResult = Apollo.QueryResult<LineItemsWidgetQuery, LineItemsWidgetQueryVariables>;
export const SummaryInformationWidgetDocument = gql`
    query SummaryInformationWidget($orderId: ID!) {
  orderLite(input: {id: $orderId}) {
    id
    orderNumber
    orderDate
    overallOrderStatus {
      id
      name
      displayName
    }
  }
}
    `;

/**
 * __useSummaryInformationWidgetQuery__
 *
 * To run a query within a React component, call `useSummaryInformationWidgetQuery` and pass it any options that fit your needs.
 * When your component renders, `useSummaryInformationWidgetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSummaryInformationWidgetQuery({
 *   variables: {
 *      orderId: // value for 'orderId'
 *   },
 * });
 */
export function useSummaryInformationWidgetQuery(baseOptions: Apollo.QueryHookOptions<SummaryInformationWidgetQuery, SummaryInformationWidgetQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SummaryInformationWidgetQuery, SummaryInformationWidgetQueryVariables>(SummaryInformationWidgetDocument, options);
      }
export function useSummaryInformationWidgetLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SummaryInformationWidgetQuery, SummaryInformationWidgetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SummaryInformationWidgetQuery, SummaryInformationWidgetQueryVariables>(SummaryInformationWidgetDocument, options);
        }
export type SummaryInformationWidgetQueryHookResult = ReturnType<typeof useSummaryInformationWidgetQuery>;
export type SummaryInformationWidgetLazyQueryHookResult = ReturnType<typeof useSummaryInformationWidgetLazyQuery>;
export type SummaryInformationWidgetQueryResult = Apollo.QueryResult<SummaryInformationWidgetQuery, SummaryInformationWidgetQueryVariables>;
export const LookupOrderDocument = gql`
    query LookupOrder($email: String!, $orderNumber: String!) {
  orderLite(input: {email: $email, orderNumber: $orderNumber}) {
    id
    orderNumber
    orderDate
    customerEmail
    customerFullName
    lineItems {
      id
      productName
      quantity
      sku
    }
  }
}
    `;

/**
 * __useLookupOrderQuery__
 *
 * To run a query within a React component, call `useLookupOrderQuery` and pass it any options that fit your needs.
 * When your component renders, `useLookupOrderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLookupOrderQuery({
 *   variables: {
 *      email: // value for 'email'
 *      orderNumber: // value for 'orderNumber'
 *   },
 * });
 */
export function useLookupOrderQuery(baseOptions: Apollo.QueryHookOptions<LookupOrderQuery, LookupOrderQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LookupOrderQuery, LookupOrderQueryVariables>(LookupOrderDocument, options);
      }
export function useLookupOrderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LookupOrderQuery, LookupOrderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LookupOrderQuery, LookupOrderQueryVariables>(LookupOrderDocument, options);
        }
export type LookupOrderQueryHookResult = ReturnType<typeof useLookupOrderQuery>;
export type LookupOrderLazyQueryHookResult = ReturnType<typeof useLookupOrderLazyQuery>;
export type LookupOrderQueryResult = Apollo.QueryResult<LookupOrderQuery, LookupOrderQueryVariables>;
export const OrderLookupActivityDocument = gql`
    query OrderLookupActivity($storeId: ID!) {
  storeBrand(storeId: $storeId) {
    id
    logoUrl
  }
}
    `;

/**
 * __useOrderLookupActivityQuery__
 *
 * To run a query within a React component, call `useOrderLookupActivityQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrderLookupActivityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrderLookupActivityQuery({
 *   variables: {
 *      storeId: // value for 'storeId'
 *   },
 * });
 */
export function useOrderLookupActivityQuery(baseOptions: Apollo.QueryHookOptions<OrderLookupActivityQuery, OrderLookupActivityQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrderLookupActivityQuery, OrderLookupActivityQueryVariables>(OrderLookupActivityDocument, options);
      }
export function useOrderLookupActivityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrderLookupActivityQuery, OrderLookupActivityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrderLookupActivityQuery, OrderLookupActivityQueryVariables>(OrderLookupActivityDocument, options);
        }
export type OrderLookupActivityQueryHookResult = ReturnType<typeof useOrderLookupActivityQuery>;
export type OrderLookupActivityLazyQueryHookResult = ReturnType<typeof useOrderLookupActivityLazyQuery>;
export type OrderLookupActivityQueryResult = Apollo.QueryResult<OrderLookupActivityQuery, OrderLookupActivityQueryVariables>;
export const StoreReferralActivityDocument = gql`
    query StoreReferralActivity($email: String!, $orderNumber: String!) {
  orderLite(input: {email: $email, orderNumber: $orderNumber}) {
    id
  }
}
    `;

/**
 * __useStoreReferralActivityQuery__
 *
 * To run a query within a React component, call `useStoreReferralActivityQuery` and pass it any options that fit your needs.
 * When your component renders, `useStoreReferralActivityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStoreReferralActivityQuery({
 *   variables: {
 *      email: // value for 'email'
 *      orderNumber: // value for 'orderNumber'
 *   },
 * });
 */
export function useStoreReferralActivityQuery(baseOptions: Apollo.QueryHookOptions<StoreReferralActivityQuery, StoreReferralActivityQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StoreReferralActivityQuery, StoreReferralActivityQueryVariables>(StoreReferralActivityDocument, options);
      }
export function useStoreReferralActivityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StoreReferralActivityQuery, StoreReferralActivityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StoreReferralActivityQuery, StoreReferralActivityQueryVariables>(StoreReferralActivityDocument, options);
        }
export type StoreReferralActivityQueryHookResult = ReturnType<typeof useStoreReferralActivityQuery>;
export type StoreReferralActivityLazyQueryHookResult = ReturnType<typeof useStoreReferralActivityLazyQuery>;
export type StoreReferralActivityQueryResult = Apollo.QueryResult<StoreReferralActivityQuery, StoreReferralActivityQueryVariables>;
export const ExportReportDocument = gql`
    query ExportReport($reportId: ID!, $storeId: ID!) {
  exportReport(input: {reportId: $reportId, storeId: $storeId})
}
    `;

/**
 * __useExportReportQuery__
 *
 * To run a query within a React component, call `useExportReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useExportReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExportReportQuery({
 *   variables: {
 *      reportId: // value for 'reportId'
 *      storeId: // value for 'storeId'
 *   },
 * });
 */
export function useExportReportQuery(baseOptions: Apollo.QueryHookOptions<ExportReportQuery, ExportReportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExportReportQuery, ExportReportQueryVariables>(ExportReportDocument, options);
      }
export function useExportReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExportReportQuery, ExportReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExportReportQuery, ExportReportQueryVariables>(ExportReportDocument, options);
        }
export type ExportReportQueryHookResult = ReturnType<typeof useExportReportQuery>;
export type ExportReportLazyQueryHookResult = ReturnType<typeof useExportReportLazyQuery>;
export type ExportReportQueryResult = Apollo.QueryResult<ExportReportQuery, ExportReportQueryVariables>;
export const StoreDetailActivity_OrderListPaneDocument = gql`
    query StoreDetailActivity_OrderListPane($storeId: ID!, $omniFreeText: String!) {
  orders(
    options: {paginationInput: {first: 50}, filter: {storeId: $storeId, omniFreeText: $omniFreeText}}
  ) {
    pageInfo {
      ...pageInfoFields
    }
    nodes {
      id
      orderNumber
      orderDate
      customer {
        id
        firstName
        lastName
        email
      }
    }
  }
}
    ${PageInfoFieldsFragmentDoc}`;

/**
 * __useStoreDetailActivity_OrderListPaneQuery__
 *
 * To run a query within a React component, call `useStoreDetailActivity_OrderListPaneQuery` and pass it any options that fit your needs.
 * When your component renders, `useStoreDetailActivity_OrderListPaneQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStoreDetailActivity_OrderListPaneQuery({
 *   variables: {
 *      storeId: // value for 'storeId'
 *      omniFreeText: // value for 'omniFreeText'
 *   },
 * });
 */
export function useStoreDetailActivity_OrderListPaneQuery(baseOptions: Apollo.QueryHookOptions<StoreDetailActivity_OrderListPaneQuery, StoreDetailActivity_OrderListPaneQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StoreDetailActivity_OrderListPaneQuery, StoreDetailActivity_OrderListPaneQueryVariables>(StoreDetailActivity_OrderListPaneDocument, options);
      }
export function useStoreDetailActivity_OrderListPaneLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StoreDetailActivity_OrderListPaneQuery, StoreDetailActivity_OrderListPaneQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StoreDetailActivity_OrderListPaneQuery, StoreDetailActivity_OrderListPaneQueryVariables>(StoreDetailActivity_OrderListPaneDocument, options);
        }
export type StoreDetailActivity_OrderListPaneQueryHookResult = ReturnType<typeof useStoreDetailActivity_OrderListPaneQuery>;
export type StoreDetailActivity_OrderListPaneLazyQueryHookResult = ReturnType<typeof useStoreDetailActivity_OrderListPaneLazyQuery>;
export type StoreDetailActivity_OrderListPaneQueryResult = Apollo.QueryResult<StoreDetailActivity_OrderListPaneQuery, StoreDetailActivity_OrderListPaneQueryVariables>;
export const StoreDetailActivityDocument = gql`
    query StoreDetailActivity {
  loggedInUser {
    id
    isSuperAdmin
    permissions {
      id
      name
    }
  }
  databaseReports {
    id
    name
  }
}
    `;

/**
 * __useStoreDetailActivityQuery__
 *
 * To run a query within a React component, call `useStoreDetailActivityQuery` and pass it any options that fit your needs.
 * When your component renders, `useStoreDetailActivityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStoreDetailActivityQuery({
 *   variables: {
 *   },
 * });
 */
export function useStoreDetailActivityQuery(baseOptions?: Apollo.QueryHookOptions<StoreDetailActivityQuery, StoreDetailActivityQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StoreDetailActivityQuery, StoreDetailActivityQueryVariables>(StoreDetailActivityDocument, options);
      }
export function useStoreDetailActivityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StoreDetailActivityQuery, StoreDetailActivityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StoreDetailActivityQuery, StoreDetailActivityQueryVariables>(StoreDetailActivityDocument, options);
        }
export type StoreDetailActivityQueryHookResult = ReturnType<typeof useStoreDetailActivityQuery>;
export type StoreDetailActivityLazyQueryHookResult = ReturnType<typeof useStoreDetailActivityLazyQuery>;
export type StoreDetailActivityQueryResult = Apollo.QueryResult<StoreDetailActivityQuery, StoreDetailActivityQueryVariables>;
export const StoreListActivityDocument = gql`
    query StoreListActivity {
  loggedInUser {
    id
    isSuperAdmin
    permissions {
      id
      name
    }
  }
  stores(options: {}) {
    pageInfo {
      ...pageInfoFields
    }
    nodes {
      id
      name
      logoUrl
    }
  }
}
    ${PageInfoFieldsFragmentDoc}`;

/**
 * __useStoreListActivityQuery__
 *
 * To run a query within a React component, call `useStoreListActivityQuery` and pass it any options that fit your needs.
 * When your component renders, `useStoreListActivityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStoreListActivityQuery({
 *   variables: {
 *   },
 * });
 */
export function useStoreListActivityQuery(baseOptions?: Apollo.QueryHookOptions<StoreListActivityQuery, StoreListActivityQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StoreListActivityQuery, StoreListActivityQueryVariables>(StoreListActivityDocument, options);
      }
export function useStoreListActivityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StoreListActivityQuery, StoreListActivityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StoreListActivityQuery, StoreListActivityQueryVariables>(StoreListActivityDocument, options);
        }
export type StoreListActivityQueryHookResult = ReturnType<typeof useStoreListActivityQuery>;
export type StoreListActivityLazyQueryHookResult = ReturnType<typeof useStoreListActivityLazyQuery>;
export type StoreListActivityQueryResult = Apollo.QueryResult<StoreListActivityQuery, StoreListActivityQueryVariables>;
export const StoreSettingsActivity_UsersTabDocument = gql`
    query StoreSettingsActivity_UsersTab($storeId: ID!) {
  store(id: $storeId) {
    id
    invites {
      pageInfo {
        ...pageInfoFields
      }
      nodes {
        id
        isClaimed
        sentTimestamp
        recipientEmail
        claimant {
          id
          fullName
        }
      }
    }
    users {
      pageInfo {
        ...pageInfoFields
      }
      nodes {
        id
        fullName
        email
        status {
          id
          name
          displayName
        }
      }
    }
  }
}
    ${PageInfoFieldsFragmentDoc}`;

/**
 * __useStoreSettingsActivity_UsersTabQuery__
 *
 * To run a query within a React component, call `useStoreSettingsActivity_UsersTabQuery` and pass it any options that fit your needs.
 * When your component renders, `useStoreSettingsActivity_UsersTabQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStoreSettingsActivity_UsersTabQuery({
 *   variables: {
 *      storeId: // value for 'storeId'
 *   },
 * });
 */
export function useStoreSettingsActivity_UsersTabQuery(baseOptions: Apollo.QueryHookOptions<StoreSettingsActivity_UsersTabQuery, StoreSettingsActivity_UsersTabQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StoreSettingsActivity_UsersTabQuery, StoreSettingsActivity_UsersTabQueryVariables>(StoreSettingsActivity_UsersTabDocument, options);
      }
export function useStoreSettingsActivity_UsersTabLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StoreSettingsActivity_UsersTabQuery, StoreSettingsActivity_UsersTabQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StoreSettingsActivity_UsersTabQuery, StoreSettingsActivity_UsersTabQueryVariables>(StoreSettingsActivity_UsersTabDocument, options);
        }
export type StoreSettingsActivity_UsersTabQueryHookResult = ReturnType<typeof useStoreSettingsActivity_UsersTabQuery>;
export type StoreSettingsActivity_UsersTabLazyQueryHookResult = ReturnType<typeof useStoreSettingsActivity_UsersTabLazyQuery>;
export type StoreSettingsActivity_UsersTabQueryResult = Apollo.QueryResult<StoreSettingsActivity_UsersTabQuery, StoreSettingsActivity_UsersTabQueryVariables>;
export const TransactionListActivity_OrderListTabDocument = gql`
    query TransactionListActivity_OrderListTab($page: Cursor, $filter: QueryOrdersFilterInput, $sort: QueryOrdersSortInput) {
  orders(
    options: {paginationInput: {after: $page, first: 20}, filter: $filter, sort: $sort}
  ) {
    pageInfo {
      ...pageInfoFields
    }
    nodes {
      id
      orderDate
      orderNumber
      totalCents
      requestedShippingService
      overallOrderStatus {
        id
        name
        displayName
      }
      customer {
        id
        firstName
        lastName
        email
      }
      paymentMethod {
        id
        name
        displayName
      }
      shipment {
        id
        createdAt
        trackingNumber
      }
    }
  }
}
    ${PageInfoFieldsFragmentDoc}`;

/**
 * __useTransactionListActivity_OrderListTabQuery__
 *
 * To run a query within a React component, call `useTransactionListActivity_OrderListTabQuery` and pass it any options that fit your needs.
 * When your component renders, `useTransactionListActivity_OrderListTabQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTransactionListActivity_OrderListTabQuery({
 *   variables: {
 *      page: // value for 'page'
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useTransactionListActivity_OrderListTabQuery(baseOptions?: Apollo.QueryHookOptions<TransactionListActivity_OrderListTabQuery, TransactionListActivity_OrderListTabQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TransactionListActivity_OrderListTabQuery, TransactionListActivity_OrderListTabQueryVariables>(TransactionListActivity_OrderListTabDocument, options);
      }
export function useTransactionListActivity_OrderListTabLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TransactionListActivity_OrderListTabQuery, TransactionListActivity_OrderListTabQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TransactionListActivity_OrderListTabQuery, TransactionListActivity_OrderListTabQueryVariables>(TransactionListActivity_OrderListTabDocument, options);
        }
export type TransactionListActivity_OrderListTabQueryHookResult = ReturnType<typeof useTransactionListActivity_OrderListTabQuery>;
export type TransactionListActivity_OrderListTabLazyQueryHookResult = ReturnType<typeof useTransactionListActivity_OrderListTabLazyQuery>;
export type TransactionListActivity_OrderListTabQueryResult = Apollo.QueryResult<TransactionListActivity_OrderListTabQuery, TransactionListActivity_OrderListTabQueryVariables>;
export const TransactionListActivity_ReturnAuthorizationListTabDocument = gql`
    query TransactionListActivity_ReturnAuthorizationListTab($page: Cursor, $filter: QueryReturnAuthorizationsFilterInput, $sort: QueryReturnAuthorizationsSortInput) {
  returnAuthorizations(
    options: {paginationInput: {after: $page, first: 20}, filter: $filter, sort: $sort}
  ) {
    pageInfo {
      ...pageInfoFields
    }
    nodes {
      id
      returnNumber
      returnDate
      order {
        id
      }
      customer {
        id
        email
      }
      approval {
        id
        approvalType {
          id
          name
          displayName
        }
      }
      acceptance {
        id
        approvalType {
          id
          name
          displayName
        }
      }
      itemReceipt {
        id
        metaCreated
        lineItems {
          id
        }
      }
      refund {
        id
        approvalType {
          id
          name
          displayName
        }
      }
      lineItems {
        id
        quantity
        reasonForReturn
        product {
          id
          sku
          name
        }
      }
    }
  }
}
    ${PageInfoFieldsFragmentDoc}`;

/**
 * __useTransactionListActivity_ReturnAuthorizationListTabQuery__
 *
 * To run a query within a React component, call `useTransactionListActivity_ReturnAuthorizationListTabQuery` and pass it any options that fit your needs.
 * When your component renders, `useTransactionListActivity_ReturnAuthorizationListTabQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTransactionListActivity_ReturnAuthorizationListTabQuery({
 *   variables: {
 *      page: // value for 'page'
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useTransactionListActivity_ReturnAuthorizationListTabQuery(baseOptions?: Apollo.QueryHookOptions<TransactionListActivity_ReturnAuthorizationListTabQuery, TransactionListActivity_ReturnAuthorizationListTabQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TransactionListActivity_ReturnAuthorizationListTabQuery, TransactionListActivity_ReturnAuthorizationListTabQueryVariables>(TransactionListActivity_ReturnAuthorizationListTabDocument, options);
      }
export function useTransactionListActivity_ReturnAuthorizationListTabLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TransactionListActivity_ReturnAuthorizationListTabQuery, TransactionListActivity_ReturnAuthorizationListTabQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TransactionListActivity_ReturnAuthorizationListTabQuery, TransactionListActivity_ReturnAuthorizationListTabQueryVariables>(TransactionListActivity_ReturnAuthorizationListTabDocument, options);
        }
export type TransactionListActivity_ReturnAuthorizationListTabQueryHookResult = ReturnType<typeof useTransactionListActivity_ReturnAuthorizationListTabQuery>;
export type TransactionListActivity_ReturnAuthorizationListTabLazyQueryHookResult = ReturnType<typeof useTransactionListActivity_ReturnAuthorizationListTabLazyQuery>;
export type TransactionListActivity_ReturnAuthorizationListTabQueryResult = Apollo.QueryResult<TransactionListActivity_ReturnAuthorizationListTabQuery, TransactionListActivity_ReturnAuthorizationListTabQueryVariables>;
export const AuthRedirectorDocument = gql`
    query AuthRedirector {
  loggedInUser {
    id
    isSuperAdmin
    status {
      id
      name
      displayName
    }
  }
}
    `;

/**
 * __useAuthRedirectorQuery__
 *
 * To run a query within a React component, call `useAuthRedirectorQuery` and pass it any options that fit your needs.
 * When your component renders, `useAuthRedirectorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAuthRedirectorQuery({
 *   variables: {
 *   },
 * });
 */
export function useAuthRedirectorQuery(baseOptions?: Apollo.QueryHookOptions<AuthRedirectorQuery, AuthRedirectorQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AuthRedirectorQuery, AuthRedirectorQueryVariables>(AuthRedirectorDocument, options);
      }
export function useAuthRedirectorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AuthRedirectorQuery, AuthRedirectorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AuthRedirectorQuery, AuthRedirectorQueryVariables>(AuthRedirectorDocument, options);
        }
export type AuthRedirectorQueryHookResult = ReturnType<typeof useAuthRedirectorQuery>;
export type AuthRedirectorLazyQueryHookResult = ReturnType<typeof useAuthRedirectorLazyQuery>;
export type AuthRedirectorQueryResult = Apollo.QueryResult<AuthRedirectorQuery, AuthRedirectorQueryVariables>;
export const ExportAsnDocument = gql`
    query ExportAsn($input: ExportAsnInput!) {
  exportAsn(input: $input)
}
    `;

/**
 * __useExportAsnQuery__
 *
 * To run a query within a React component, call `useExportAsnQuery` and pass it any options that fit your needs.
 * When your component renders, `useExportAsnQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExportAsnQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useExportAsnQuery(baseOptions: Apollo.QueryHookOptions<ExportAsnQuery, ExportAsnQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExportAsnQuery, ExportAsnQueryVariables>(ExportAsnDocument, options);
      }
export function useExportAsnLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExportAsnQuery, ExportAsnQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExportAsnQuery, ExportAsnQueryVariables>(ExportAsnDocument, options);
        }
export type ExportAsnQueryHookResult = ReturnType<typeof useExportAsnQuery>;
export type ExportAsnLazyQueryHookResult = ReturnType<typeof useExportAsnLazyQuery>;
export type ExportAsnQueryResult = Apollo.QueryResult<ExportAsnQuery, ExportAsnQueryVariables>;
export const ImportOrdersFromCsvDocument = gql`
    mutation ImportOrdersFromCsv($input: ImportOrdersFromCsvInput!) {
  importOrdersFromCsv(input: $input)
}
    `;
export type ImportOrdersFromCsvMutationFn = Apollo.MutationFunction<ImportOrdersFromCsvMutation, ImportOrdersFromCsvMutationVariables>;

/**
 * __useImportOrdersFromCsvMutation__
 *
 * To run a mutation, you first call `useImportOrdersFromCsvMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useImportOrdersFromCsvMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [importOrdersFromCsvMutation, { data, loading, error }] = useImportOrdersFromCsvMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useImportOrdersFromCsvMutation(baseOptions?: Apollo.MutationHookOptions<ImportOrdersFromCsvMutation, ImportOrdersFromCsvMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ImportOrdersFromCsvMutation, ImportOrdersFromCsvMutationVariables>(ImportOrdersFromCsvDocument, options);
      }
export type ImportOrdersFromCsvMutationHookResult = ReturnType<typeof useImportOrdersFromCsvMutation>;
export type ImportOrdersFromCsvMutationResult = Apollo.MutationResult<ImportOrdersFromCsvMutation>;
export type ImportOrdersFromCsvMutationOptions = Apollo.BaseMutationOptions<ImportOrdersFromCsvMutation, ImportOrdersFromCsvMutationVariables>;
export const ImportOrdersModalDocument = gql`
    query ImportOrdersModal($storeId: ID!) {
  store(id: $storeId) {
    id
    orderPrefix
    storeSettings {
      prefixNewOrders
    }
    customOrderFormatFlow {
      id
      propertyMapping {
        id
        defaultValueOnEmpty
        sourceDataLabel
        mapToProperty {
          id
          name
          displayName
        }
      }
    }
  }
}
    `;

/**
 * __useImportOrdersModalQuery__
 *
 * To run a query within a React component, call `useImportOrdersModalQuery` and pass it any options that fit your needs.
 * When your component renders, `useImportOrdersModalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useImportOrdersModalQuery({
 *   variables: {
 *      storeId: // value for 'storeId'
 *   },
 * });
 */
export function useImportOrdersModalQuery(baseOptions: Apollo.QueryHookOptions<ImportOrdersModalQuery, ImportOrdersModalQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ImportOrdersModalQuery, ImportOrdersModalQueryVariables>(ImportOrdersModalDocument, options);
      }
export function useImportOrdersModalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ImportOrdersModalQuery, ImportOrdersModalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ImportOrdersModalQuery, ImportOrdersModalQueryVariables>(ImportOrdersModalDocument, options);
        }
export type ImportOrdersModalQueryHookResult = ReturnType<typeof useImportOrdersModalQuery>;
export type ImportOrdersModalLazyQueryHookResult = ReturnType<typeof useImportOrdersModalLazyQuery>;
export type ImportOrdersModalQueryResult = Apollo.QueryResult<ImportOrdersModalQuery, ImportOrdersModalQueryVariables>;
export const PreValidateCsvImportDocument = gql`
    query PreValidateCsvImport($input: ImportOrdersFromCsvInput!) {
  preValidateCsvImport(input: $input)
}
    `;

/**
 * __usePreValidateCsvImportQuery__
 *
 * To run a query within a React component, call `usePreValidateCsvImportQuery` and pass it any options that fit your needs.
 * When your component renders, `usePreValidateCsvImportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePreValidateCsvImportQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePreValidateCsvImportQuery(baseOptions: Apollo.QueryHookOptions<PreValidateCsvImportQuery, PreValidateCsvImportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PreValidateCsvImportQuery, PreValidateCsvImportQueryVariables>(PreValidateCsvImportDocument, options);
      }
export function usePreValidateCsvImportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PreValidateCsvImportQuery, PreValidateCsvImportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PreValidateCsvImportQuery, PreValidateCsvImportQueryVariables>(PreValidateCsvImportDocument, options);
        }
export type PreValidateCsvImportQueryHookResult = ReturnType<typeof usePreValidateCsvImportQuery>;
export type PreValidateCsvImportLazyQueryHookResult = ReturnType<typeof usePreValidateCsvImportLazyQuery>;
export type PreValidateCsvImportQueryResult = Apollo.QueryResult<PreValidateCsvImportQuery, PreValidateCsvImportQueryVariables>;
export const InviteUserDocument = gql`
    mutation InviteUser($input: InviteUserInput!) {
  inviteUser(input: $input) {
    id
    sentTimestamp
    recipientEmail
  }
}
    `;
export type InviteUserMutationFn = Apollo.MutationFunction<InviteUserMutation, InviteUserMutationVariables>;

/**
 * __useInviteUserMutation__
 *
 * To run a mutation, you first call `useInviteUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInviteUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [inviteUserMutation, { data, loading, error }] = useInviteUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useInviteUserMutation(baseOptions?: Apollo.MutationHookOptions<InviteUserMutation, InviteUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InviteUserMutation, InviteUserMutationVariables>(InviteUserDocument, options);
      }
export type InviteUserMutationHookResult = ReturnType<typeof useInviteUserMutation>;
export type InviteUserMutationResult = Apollo.MutationResult<InviteUserMutation>;
export type InviteUserMutationOptions = Apollo.BaseMutationOptions<InviteUserMutation, InviteUserMutationVariables>;
export const SelectItemsModalDocument = gql`
    query SelectItemsModal($storeId: ID!, $checkInventoryManagement: Boolean!) {
  items {
    pageInfo {
      ...pageInfoFields
    }
    nodes {
      id
      sku
      name
      defaultPriceDollars
      canManageInventory(storeId: $storeId) @include(if: $checkInventoryManagement)
    }
  }
}
    ${PageInfoFieldsFragmentDoc}`;

/**
 * __useSelectItemsModalQuery__
 *
 * To run a query within a React component, call `useSelectItemsModalQuery` and pass it any options that fit your needs.
 * When your component renders, `useSelectItemsModalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSelectItemsModalQuery({
 *   variables: {
 *      storeId: // value for 'storeId'
 *      checkInventoryManagement: // value for 'checkInventoryManagement'
 *   },
 * });
 */
export function useSelectItemsModalQuery(baseOptions: Apollo.QueryHookOptions<SelectItemsModalQuery, SelectItemsModalQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SelectItemsModalQuery, SelectItemsModalQueryVariables>(SelectItemsModalDocument, options);
      }
export function useSelectItemsModalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SelectItemsModalQuery, SelectItemsModalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SelectItemsModalQuery, SelectItemsModalQueryVariables>(SelectItemsModalDocument, options);
        }
export type SelectItemsModalQueryHookResult = ReturnType<typeof useSelectItemsModalQuery>;
export type SelectItemsModalLazyQueryHookResult = ReturnType<typeof useSelectItemsModalLazyQuery>;
export type SelectItemsModalQueryResult = Apollo.QueryResult<SelectItemsModalQuery, SelectItemsModalQueryVariables>;
export const SingleOrderRecordNavigatorDocument = gql`
    query SingleOrderRecordNavigator($orderId: ID!) {
  orderLite(input: {id: $orderId}) {
    id
    orderNumber
    returnAuthorizations {
      id
      returnNumber
    }
  }
}
    `;

/**
 * __useSingleOrderRecordNavigatorQuery__
 *
 * To run a query within a React component, call `useSingleOrderRecordNavigatorQuery` and pass it any options that fit your needs.
 * When your component renders, `useSingleOrderRecordNavigatorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSingleOrderRecordNavigatorQuery({
 *   variables: {
 *      orderId: // value for 'orderId'
 *   },
 * });
 */
export function useSingleOrderRecordNavigatorQuery(baseOptions: Apollo.QueryHookOptions<SingleOrderRecordNavigatorQuery, SingleOrderRecordNavigatorQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SingleOrderRecordNavigatorQuery, SingleOrderRecordNavigatorQueryVariables>(SingleOrderRecordNavigatorDocument, options);
      }
export function useSingleOrderRecordNavigatorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SingleOrderRecordNavigatorQuery, SingleOrderRecordNavigatorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SingleOrderRecordNavigatorQuery, SingleOrderRecordNavigatorQueryVariables>(SingleOrderRecordNavigatorDocument, options);
        }
export type SingleOrderRecordNavigatorQueryHookResult = ReturnType<typeof useSingleOrderRecordNavigatorQuery>;
export type SingleOrderRecordNavigatorLazyQueryHookResult = ReturnType<typeof useSingleOrderRecordNavigatorLazyQuery>;
export type SingleOrderRecordNavigatorQueryResult = Apollo.QueryResult<SingleOrderRecordNavigatorQuery, SingleOrderRecordNavigatorQueryVariables>;
export const StoreFeatureToggleDocument = gql`
    query StoreFeatureToggle($storeId: ID!, $featureName: FeatureName!) {
  store(id: $storeId) {
    id
    isFeatureDisabled(featureName: $featureName)
  }
}
    `;

/**
 * __useStoreFeatureToggleQuery__
 *
 * To run a query within a React component, call `useStoreFeatureToggleQuery` and pass it any options that fit your needs.
 * When your component renders, `useStoreFeatureToggleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStoreFeatureToggleQuery({
 *   variables: {
 *      storeId: // value for 'storeId'
 *      featureName: // value for 'featureName'
 *   },
 * });
 */
export function useStoreFeatureToggleQuery(baseOptions: Apollo.QueryHookOptions<StoreFeatureToggleQuery, StoreFeatureToggleQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StoreFeatureToggleQuery, StoreFeatureToggleQueryVariables>(StoreFeatureToggleDocument, options);
      }
export function useStoreFeatureToggleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StoreFeatureToggleQuery, StoreFeatureToggleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StoreFeatureToggleQuery, StoreFeatureToggleQueryVariables>(StoreFeatureToggleDocument, options);
        }
export type StoreFeatureToggleQueryHookResult = ReturnType<typeof useStoreFeatureToggleQuery>;
export type StoreFeatureToggleLazyQueryHookResult = ReturnType<typeof useStoreFeatureToggleLazyQuery>;
export type StoreFeatureToggleQueryResult = Apollo.QueryResult<StoreFeatureToggleQuery, StoreFeatureToggleQueryVariables>;
export const ToggleFeatureForStoreDocument = gql`
    mutation ToggleFeatureForStore($storeId: ID!, $featureName: FeatureName!, $enabled: Boolean!) {
  toggleFeatureForStore(
    input: {storeId: $storeId, featureName: $featureName, enabled: $enabled}
  )
}
    `;
export type ToggleFeatureForStoreMutationFn = Apollo.MutationFunction<ToggleFeatureForStoreMutation, ToggleFeatureForStoreMutationVariables>;

/**
 * __useToggleFeatureForStoreMutation__
 *
 * To run a mutation, you first call `useToggleFeatureForStoreMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleFeatureForStoreMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleFeatureForStoreMutation, { data, loading, error }] = useToggleFeatureForStoreMutation({
 *   variables: {
 *      storeId: // value for 'storeId'
 *      featureName: // value for 'featureName'
 *      enabled: // value for 'enabled'
 *   },
 * });
 */
export function useToggleFeatureForStoreMutation(baseOptions?: Apollo.MutationHookOptions<ToggleFeatureForStoreMutation, ToggleFeatureForStoreMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ToggleFeatureForStoreMutation, ToggleFeatureForStoreMutationVariables>(ToggleFeatureForStoreDocument, options);
      }
export type ToggleFeatureForStoreMutationHookResult = ReturnType<typeof useToggleFeatureForStoreMutation>;
export type ToggleFeatureForStoreMutationResult = Apollo.MutationResult<ToggleFeatureForStoreMutation>;
export type ToggleFeatureForStoreMutationOptions = Apollo.BaseMutationOptions<ToggleFeatureForStoreMutation, ToggleFeatureForStoreMutationVariables>;
export const StoreThemeProviderDocument = gql`
    query StoreThemeProvider($storeId: ID!) {
  storeBrand(storeId: $storeId) {
    id
    primaryColorHex
    secondaryColorHex
    buttonColorHex
  }
}
    `;

/**
 * __useStoreThemeProviderQuery__
 *
 * To run a query within a React component, call `useStoreThemeProviderQuery` and pass it any options that fit your needs.
 * When your component renders, `useStoreThemeProviderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStoreThemeProviderQuery({
 *   variables: {
 *      storeId: // value for 'storeId'
 *   },
 * });
 */
export function useStoreThemeProviderQuery(baseOptions: Apollo.QueryHookOptions<StoreThemeProviderQuery, StoreThemeProviderQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StoreThemeProviderQuery, StoreThemeProviderQueryVariables>(StoreThemeProviderDocument, options);
      }
export function useStoreThemeProviderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StoreThemeProviderQuery, StoreThemeProviderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StoreThemeProviderQuery, StoreThemeProviderQueryVariables>(StoreThemeProviderDocument, options);
        }
export type StoreThemeProviderQueryHookResult = ReturnType<typeof useStoreThemeProviderQuery>;
export type StoreThemeProviderLazyQueryHookResult = ReturnType<typeof useStoreThemeProviderLazyQuery>;
export type StoreThemeProviderQueryResult = Apollo.QueryResult<StoreThemeProviderQuery, StoreThemeProviderQueryVariables>;
export const LoggedInUserPermissionsDocument = gql`
    query LoggedInUserPermissions($storeId: ID) {
  loggedInUser {
    id
    permissions(storeId: $storeId) {
      id
      name
      displayName
    }
  }
}
    `;

/**
 * __useLoggedInUserPermissionsQuery__
 *
 * To run a query within a React component, call `useLoggedInUserPermissionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useLoggedInUserPermissionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLoggedInUserPermissionsQuery({
 *   variables: {
 *      storeId: // value for 'storeId'
 *   },
 * });
 */
export function useLoggedInUserPermissionsQuery(baseOptions?: Apollo.QueryHookOptions<LoggedInUserPermissionsQuery, LoggedInUserPermissionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LoggedInUserPermissionsQuery, LoggedInUserPermissionsQueryVariables>(LoggedInUserPermissionsDocument, options);
      }
export function useLoggedInUserPermissionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LoggedInUserPermissionsQuery, LoggedInUserPermissionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LoggedInUserPermissionsQuery, LoggedInUserPermissionsQueryVariables>(LoggedInUserPermissionsDocument, options);
        }
export type LoggedInUserPermissionsQueryHookResult = ReturnType<typeof useLoggedInUserPermissionsQuery>;
export type LoggedInUserPermissionsLazyQueryHookResult = ReturnType<typeof useLoggedInUserPermissionsLazyQuery>;
export type LoggedInUserPermissionsQueryResult = Apollo.QueryResult<LoggedInUserPermissionsQuery, LoggedInUserPermissionsQueryVariables>;
export const CustomerActivityTemplateDocument = gql`
    query CustomerActivityTemplate($storeId: ID!) {
  storeBrand(storeId: $storeId) {
    id
    logoUrl
  }
}
    `;

/**
 * __useCustomerActivityTemplateQuery__
 *
 * To run a query within a React component, call `useCustomerActivityTemplateQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomerActivityTemplateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomerActivityTemplateQuery({
 *   variables: {
 *      storeId: // value for 'storeId'
 *   },
 * });
 */
export function useCustomerActivityTemplateQuery(baseOptions: Apollo.QueryHookOptions<CustomerActivityTemplateQuery, CustomerActivityTemplateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CustomerActivityTemplateQuery, CustomerActivityTemplateQueryVariables>(CustomerActivityTemplateDocument, options);
      }
export function useCustomerActivityTemplateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CustomerActivityTemplateQuery, CustomerActivityTemplateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CustomerActivityTemplateQuery, CustomerActivityTemplateQueryVariables>(CustomerActivityTemplateDocument, options);
        }
export type CustomerActivityTemplateQueryHookResult = ReturnType<typeof useCustomerActivityTemplateQuery>;
export type CustomerActivityTemplateLazyQueryHookResult = ReturnType<typeof useCustomerActivityTemplateLazyQuery>;
export type CustomerActivityTemplateQueryResult = Apollo.QueryResult<CustomerActivityTemplateQuery, CustomerActivityTemplateQueryVariables>;
export const PartnerActivityTemplateDocument = gql`
    query PartnerActivityTemplate($storeId: ID!) {
  store(id: $storeId) {
    id
    logoUrl
  }
}
    `;

/**
 * __usePartnerActivityTemplateQuery__
 *
 * To run a query within a React component, call `usePartnerActivityTemplateQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerActivityTemplateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerActivityTemplateQuery({
 *   variables: {
 *      storeId: // value for 'storeId'
 *   },
 * });
 */
export function usePartnerActivityTemplateQuery(baseOptions: Apollo.QueryHookOptions<PartnerActivityTemplateQuery, PartnerActivityTemplateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PartnerActivityTemplateQuery, PartnerActivityTemplateQueryVariables>(PartnerActivityTemplateDocument, options);
      }
export function usePartnerActivityTemplateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PartnerActivityTemplateQuery, PartnerActivityTemplateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PartnerActivityTemplateQuery, PartnerActivityTemplateQueryVariables>(PartnerActivityTemplateDocument, options);
        }
export type PartnerActivityTemplateQueryHookResult = ReturnType<typeof usePartnerActivityTemplateQuery>;
export type PartnerActivityTemplateLazyQueryHookResult = ReturnType<typeof usePartnerActivityTemplateLazyQuery>;
export type PartnerActivityTemplateQueryResult = Apollo.QueryResult<PartnerActivityTemplateQuery, PartnerActivityTemplateQueryVariables>;
export const SaveAuditLogEventDocument = gql`
    mutation SaveAuditLogEvent($input: SaveAuditLogEventInput!) {
  saveAuditLogEvent(input: $input) {
    id
    metaCreated
    title
    content
    triggeringSiteUser {
      id
      fullName
    }
  }
}
    `;
export type SaveAuditLogEventMutationFn = Apollo.MutationFunction<SaveAuditLogEventMutation, SaveAuditLogEventMutationVariables>;

/**
 * __useSaveAuditLogEventMutation__
 *
 * To run a mutation, you first call `useSaveAuditLogEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveAuditLogEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveAuditLogEventMutation, { data, loading, error }] = useSaveAuditLogEventMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveAuditLogEventMutation(baseOptions?: Apollo.MutationHookOptions<SaveAuditLogEventMutation, SaveAuditLogEventMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveAuditLogEventMutation, SaveAuditLogEventMutationVariables>(SaveAuditLogEventDocument, options);
      }
export type SaveAuditLogEventMutationHookResult = ReturnType<typeof useSaveAuditLogEventMutation>;
export type SaveAuditLogEventMutationResult = Apollo.MutationResult<SaveAuditLogEventMutation>;
export type SaveAuditLogEventMutationOptions = Apollo.BaseMutationOptions<SaveAuditLogEventMutation, SaveAuditLogEventMutationVariables>;
export const ReceiveReturnAuthorizationDocument = gql`
    mutation ReceiveReturnAuthorization($input: ReceiveReturnAuthorizationInput!) {
  receiveReturnAuthorization(input: $input) {
    id
    itemReceipt {
      id
      lineItems {
        id
        refundAmountCents
        product {
          id
          sku
          name
        }
      }
    }
  }
}
    `;
export type ReceiveReturnAuthorizationMutationFn = Apollo.MutationFunction<ReceiveReturnAuthorizationMutation, ReceiveReturnAuthorizationMutationVariables>;

/**
 * __useReceiveReturnAuthorizationMutation__
 *
 * To run a mutation, you first call `useReceiveReturnAuthorizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReceiveReturnAuthorizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [receiveReturnAuthorizationMutation, { data, loading, error }] = useReceiveReturnAuthorizationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useReceiveReturnAuthorizationMutation(baseOptions?: Apollo.MutationHookOptions<ReceiveReturnAuthorizationMutation, ReceiveReturnAuthorizationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReceiveReturnAuthorizationMutation, ReceiveReturnAuthorizationMutationVariables>(ReceiveReturnAuthorizationDocument, options);
      }
export type ReceiveReturnAuthorizationMutationHookResult = ReturnType<typeof useReceiveReturnAuthorizationMutation>;
export type ReceiveReturnAuthorizationMutationResult = Apollo.MutationResult<ReceiveReturnAuthorizationMutation>;
export type ReceiveReturnAuthorizationMutationOptions = Apollo.BaseMutationOptions<ReceiveReturnAuthorizationMutation, ReceiveReturnAuthorizationMutationVariables>;
export const ReceiveReturnAuthorizationModalDocument = gql`
    query ReceiveReturnAuthorizationModal($returnAuthorizationId: ID!) {
  returnAuthorization(id: $returnAuthorizationId) {
    id
    store {
      id
    }
    returnNumber
    netSuiteWriteRequest {
      ...writeRequestFields
    }
    netSuiteRecord {
      ...netSuiteRecordFields
    }
    store {
      id
    }
    itemReceipt {
      id
      lineItems {
        id
        inventoryNumber
        refundAmountCents
        inventoryNumber
        product {
          id
          name
          sku
        }
      }
    }
    lineItems {
      id
      quantity
      refundAmountCents
      serialNumber
      product {
        id
        sku
        name
      }
    }
  }
}
    ${WriteRequestFieldsFragmentDoc}
${NetSuiteRecordFieldsFragmentDoc}`;

/**
 * __useReceiveReturnAuthorizationModalQuery__
 *
 * To run a query within a React component, call `useReceiveReturnAuthorizationModalQuery` and pass it any options that fit your needs.
 * When your component renders, `useReceiveReturnAuthorizationModalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReceiveReturnAuthorizationModalQuery({
 *   variables: {
 *      returnAuthorizationId: // value for 'returnAuthorizationId'
 *   },
 * });
 */
export function useReceiveReturnAuthorizationModalQuery(baseOptions: Apollo.QueryHookOptions<ReceiveReturnAuthorizationModalQuery, ReceiveReturnAuthorizationModalQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReceiveReturnAuthorizationModalQuery, ReceiveReturnAuthorizationModalQueryVariables>(ReceiveReturnAuthorizationModalDocument, options);
      }
export function useReceiveReturnAuthorizationModalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReceiveReturnAuthorizationModalQuery, ReceiveReturnAuthorizationModalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReceiveReturnAuthorizationModalQuery, ReceiveReturnAuthorizationModalQueryVariables>(ReceiveReturnAuthorizationModalDocument, options);
        }
export type ReceiveReturnAuthorizationModalQueryHookResult = ReturnType<typeof useReceiveReturnAuthorizationModalQuery>;
export type ReceiveReturnAuthorizationModalLazyQueryHookResult = ReturnType<typeof useReceiveReturnAuthorizationModalLazyQuery>;
export type ReceiveReturnAuthorizationModalQueryResult = Apollo.QueryResult<ReceiveReturnAuthorizationModalQuery, ReceiveReturnAuthorizationModalQueryVariables>;
export const SaveItemReceiptDocument = gql`
    mutation SaveItemReceipt($input: SaveItemReceiptInput!) {
  saveItemReceipt(input: $input) {
    id
    lineItems {
      id
      inventoryNumber
      product {
        id
        sku
        name
      }
    }
  }
}
    `;
export type SaveItemReceiptMutationFn = Apollo.MutationFunction<SaveItemReceiptMutation, SaveItemReceiptMutationVariables>;

/**
 * __useSaveItemReceiptMutation__
 *
 * To run a mutation, you first call `useSaveItemReceiptMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveItemReceiptMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveItemReceiptMutation, { data, loading, error }] = useSaveItemReceiptMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveItemReceiptMutation(baseOptions?: Apollo.MutationHookOptions<SaveItemReceiptMutation, SaveItemReceiptMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveItemReceiptMutation, SaveItemReceiptMutationVariables>(SaveItemReceiptDocument, options);
      }
export type SaveItemReceiptMutationHookResult = ReturnType<typeof useSaveItemReceiptMutation>;
export type SaveItemReceiptMutationResult = Apollo.MutationResult<SaveItemReceiptMutation>;
export type SaveItemReceiptMutationOptions = Apollo.BaseMutationOptions<SaveItemReceiptMutation, SaveItemReceiptMutationVariables>;
export const RefundDetailModalDocument = gql`
    query RefundDetailModal($refundId: ID!) {
  refund(id: $refundId) {
    id
    metaCreated
    apiRequests(options: {}) {
      pageInfo {
        ...pageInfoFields
      }
      nodes {
        id
        metaCreated
        httpStatusCode
        requestBody
        responseBody
        url
        method
      }
    }
  }
}
    ${PageInfoFieldsFragmentDoc}`;

/**
 * __useRefundDetailModalQuery__
 *
 * To run a query within a React component, call `useRefundDetailModalQuery` and pass it any options that fit your needs.
 * When your component renders, `useRefundDetailModalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRefundDetailModalQuery({
 *   variables: {
 *      refundId: // value for 'refundId'
 *   },
 * });
 */
export function useRefundDetailModalQuery(baseOptions: Apollo.QueryHookOptions<RefundDetailModalQuery, RefundDetailModalQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RefundDetailModalQuery, RefundDetailModalQueryVariables>(RefundDetailModalDocument, options);
      }
export function useRefundDetailModalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RefundDetailModalQuery, RefundDetailModalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RefundDetailModalQuery, RefundDetailModalQueryVariables>(RefundDetailModalDocument, options);
        }
export type RefundDetailModalQueryHookResult = ReturnType<typeof useRefundDetailModalQuery>;
export type RefundDetailModalLazyQueryHookResult = ReturnType<typeof useRefundDetailModalLazyQuery>;
export type RefundDetailModalQueryResult = Apollo.QueryResult<RefundDetailModalQuery, RefundDetailModalQueryVariables>;
export const ResendEmailDocument = gql`
    mutation ResendEmail($input: ResendEmailInput!) {
  resendEmail(input: $input)
}
    `;
export type ResendEmailMutationFn = Apollo.MutationFunction<ResendEmailMutation, ResendEmailMutationVariables>;

/**
 * __useResendEmailMutation__
 *
 * To run a mutation, you first call `useResendEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResendEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resendEmailMutation, { data, loading, error }] = useResendEmailMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useResendEmailMutation(baseOptions?: Apollo.MutationHookOptions<ResendEmailMutation, ResendEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResendEmailMutation, ResendEmailMutationVariables>(ResendEmailDocument, options);
      }
export type ResendEmailMutationHookResult = ReturnType<typeof useResendEmailMutation>;
export type ResendEmailMutationResult = Apollo.MutationResult<ResendEmailMutation>;
export type ResendEmailMutationOptions = Apollo.BaseMutationOptions<ResendEmailMutation, ResendEmailMutationVariables>;
export const ReturnAuthorizationSummarySectionDocument = gql`
    query ReturnAuthorizationSummarySection($returnAuthorizationId: ID!) {
  returnAuthorization(id: $returnAuthorizationId) {
    id
    returnNumber
    netSuiteWriteRequest {
      ...writeRequestFields
    }
    netSuiteRecord {
      ...netSuiteRecordFields
    }
    store {
      id
    }
    lineItems {
      id
      serialNumber
      quantity
      reasonForReturn
      product {
        id
        sku
        name
      }
    }
    customer {
      id
      firstName
      lastName
      netSuiteWriteRequest {
        ...writeRequestFields
      }
      netSuiteRecord {
        ...netSuiteRecordFields
      }
    }
    order {
      id
      orderNumber
      orderDate
      netSuiteWriteRequest {
        ...writeRequestFields
      }
      netSuiteRecord {
        ...netSuiteRecordFields
      }
    }
  }
}
    ${WriteRequestFieldsFragmentDoc}
${NetSuiteRecordFieldsFragmentDoc}`;

/**
 * __useReturnAuthorizationSummarySectionQuery__
 *
 * To run a query within a React component, call `useReturnAuthorizationSummarySectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useReturnAuthorizationSummarySectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReturnAuthorizationSummarySectionQuery({
 *   variables: {
 *      returnAuthorizationId: // value for 'returnAuthorizationId'
 *   },
 * });
 */
export function useReturnAuthorizationSummarySectionQuery(baseOptions: Apollo.QueryHookOptions<ReturnAuthorizationSummarySectionQuery, ReturnAuthorizationSummarySectionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReturnAuthorizationSummarySectionQuery, ReturnAuthorizationSummarySectionQueryVariables>(ReturnAuthorizationSummarySectionDocument, options);
      }
export function useReturnAuthorizationSummarySectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReturnAuthorizationSummarySectionQuery, ReturnAuthorizationSummarySectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReturnAuthorizationSummarySectionQuery, ReturnAuthorizationSummarySectionQueryVariables>(ReturnAuthorizationSummarySectionDocument, options);
        }
export type ReturnAuthorizationSummarySectionQueryHookResult = ReturnType<typeof useReturnAuthorizationSummarySectionQuery>;
export type ReturnAuthorizationSummarySectionLazyQueryHookResult = ReturnType<typeof useReturnAuthorizationSummarySectionLazyQuery>;
export type ReturnAuthorizationSummarySectionQueryResult = Apollo.QueryResult<ReturnAuthorizationSummarySectionQuery, ReturnAuthorizationSummarySectionQueryVariables>;
export const SendChatMessageDocument = gql`
    mutation SendChatMessage($input: SendChatMessageInput!) {
  sendChatMessage(input: $input) {
    id
    content
    senderName
  }
}
    `;
export type SendChatMessageMutationFn = Apollo.MutationFunction<SendChatMessageMutation, SendChatMessageMutationVariables>;

/**
 * __useSendChatMessageMutation__
 *
 * To run a mutation, you first call `useSendChatMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendChatMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendChatMessageMutation, { data, loading, error }] = useSendChatMessageMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSendChatMessageMutation(baseOptions?: Apollo.MutationHookOptions<SendChatMessageMutation, SendChatMessageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendChatMessageMutation, SendChatMessageMutationVariables>(SendChatMessageDocument, options);
      }
export type SendChatMessageMutationHookResult = ReturnType<typeof useSendChatMessageMutation>;
export type SendChatMessageMutationResult = Apollo.MutationResult<SendChatMessageMutation>;
export type SendChatMessageMutationOptions = Apollo.BaseMutationOptions<SendChatMessageMutation, SendChatMessageMutationVariables>;
export const SendChatMessageAsCustomerDocument = gql`
    mutation SendChatMessageAsCustomer($content: String!, $orderId: ID, $returnAuthorizationId: ID) {
  sendChatMessageAsCustomer(
    input: {content: $content, orderId: $orderId, returnAuthorizationId: $returnAuthorizationId}
  ) {
    id
    content
    metaCreated
  }
}
    `;
export type SendChatMessageAsCustomerMutationFn = Apollo.MutationFunction<SendChatMessageAsCustomerMutation, SendChatMessageAsCustomerMutationVariables>;

/**
 * __useSendChatMessageAsCustomerMutation__
 *
 * To run a mutation, you first call `useSendChatMessageAsCustomerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendChatMessageAsCustomerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendChatMessageAsCustomerMutation, { data, loading, error }] = useSendChatMessageAsCustomerMutation({
 *   variables: {
 *      content: // value for 'content'
 *      orderId: // value for 'orderId'
 *      returnAuthorizationId: // value for 'returnAuthorizationId'
 *   },
 * });
 */
export function useSendChatMessageAsCustomerMutation(baseOptions?: Apollo.MutationHookOptions<SendChatMessageAsCustomerMutation, SendChatMessageAsCustomerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendChatMessageAsCustomerMutation, SendChatMessageAsCustomerMutationVariables>(SendChatMessageAsCustomerDocument, options);
      }
export type SendChatMessageAsCustomerMutationHookResult = ReturnType<typeof useSendChatMessageAsCustomerMutation>;
export type SendChatMessageAsCustomerMutationResult = Apollo.MutationResult<SendChatMessageAsCustomerMutation>;
export type SendChatMessageAsCustomerMutationOptions = Apollo.BaseMutationOptions<SendChatMessageAsCustomerMutation, SendChatMessageAsCustomerMutationVariables>;
export const AppEventSelectFieldDocument = gql`
    query AppEventSelectField($options: QueryAppEventsOptionsInput!) {
  appEvents(options: $options) {
    id
    name
    displayName
  }
}
    `;

/**
 * __useAppEventSelectFieldQuery__
 *
 * To run a query within a React component, call `useAppEventSelectFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useAppEventSelectFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAppEventSelectFieldQuery({
 *   variables: {
 *      options: // value for 'options'
 *   },
 * });
 */
export function useAppEventSelectFieldQuery(baseOptions: Apollo.QueryHookOptions<AppEventSelectFieldQuery, AppEventSelectFieldQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AppEventSelectFieldQuery, AppEventSelectFieldQueryVariables>(AppEventSelectFieldDocument, options);
      }
export function useAppEventSelectFieldLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AppEventSelectFieldQuery, AppEventSelectFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AppEventSelectFieldQuery, AppEventSelectFieldQueryVariables>(AppEventSelectFieldDocument, options);
        }
export type AppEventSelectFieldQueryHookResult = ReturnType<typeof useAppEventSelectFieldQuery>;
export type AppEventSelectFieldLazyQueryHookResult = ReturnType<typeof useAppEventSelectFieldLazyQuery>;
export type AppEventSelectFieldQueryResult = Apollo.QueryResult<AppEventSelectFieldQuery, AppEventSelectFieldQueryVariables>;
export const ItemSelectFieldDocument = gql`
    query ItemSelectField($options: QueryItemsOptionsInput!) {
  items(options: $options) {
    pageInfo {
      ...pageInfoFields
    }
    nodes {
      id
      name
      sku
    }
  }
}
    ${PageInfoFieldsFragmentDoc}`;

/**
 * __useItemSelectFieldQuery__
 *
 * To run a query within a React component, call `useItemSelectFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useItemSelectFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useItemSelectFieldQuery({
 *   variables: {
 *      options: // value for 'options'
 *   },
 * });
 */
export function useItemSelectFieldQuery(baseOptions: Apollo.QueryHookOptions<ItemSelectFieldQuery, ItemSelectFieldQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ItemSelectFieldQuery, ItemSelectFieldQueryVariables>(ItemSelectFieldDocument, options);
      }
export function useItemSelectFieldLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ItemSelectFieldQuery, ItemSelectFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ItemSelectFieldQuery, ItemSelectFieldQueryVariables>(ItemSelectFieldDocument, options);
        }
export type ItemSelectFieldQueryHookResult = ReturnType<typeof useItemSelectFieldQuery>;
export type ItemSelectFieldLazyQueryHookResult = ReturnType<typeof useItemSelectFieldLazyQuery>;
export type ItemSelectFieldQueryResult = Apollo.QueryResult<ItemSelectFieldQuery, ItemSelectFieldQueryVariables>;
export const LeaseApplicationStepNameSelectFieldDocument = gql`
    query LeaseApplicationStepNameSelectField {
  smartPayLeaseApplicationStepNames {
    id
    name
    displayName
  }
}
    `;

/**
 * __useLeaseApplicationStepNameSelectFieldQuery__
 *
 * To run a query within a React component, call `useLeaseApplicationStepNameSelectFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useLeaseApplicationStepNameSelectFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLeaseApplicationStepNameSelectFieldQuery({
 *   variables: {
 *   },
 * });
 */
export function useLeaseApplicationStepNameSelectFieldQuery(baseOptions?: Apollo.QueryHookOptions<LeaseApplicationStepNameSelectFieldQuery, LeaseApplicationStepNameSelectFieldQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LeaseApplicationStepNameSelectFieldQuery, LeaseApplicationStepNameSelectFieldQueryVariables>(LeaseApplicationStepNameSelectFieldDocument, options);
      }
export function useLeaseApplicationStepNameSelectFieldLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LeaseApplicationStepNameSelectFieldQuery, LeaseApplicationStepNameSelectFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LeaseApplicationStepNameSelectFieldQuery, LeaseApplicationStepNameSelectFieldQueryVariables>(LeaseApplicationStepNameSelectFieldDocument, options);
        }
export type LeaseApplicationStepNameSelectFieldQueryHookResult = ReturnType<typeof useLeaseApplicationStepNameSelectFieldQuery>;
export type LeaseApplicationStepNameSelectFieldLazyQueryHookResult = ReturnType<typeof useLeaseApplicationStepNameSelectFieldLazyQuery>;
export type LeaseApplicationStepNameSelectFieldQueryResult = Apollo.QueryResult<LeaseApplicationStepNameSelectFieldQuery, LeaseApplicationStepNameSelectFieldQueryVariables>;
export const NetSuiteBrandSelectFieldDocument = gql`
    query NetSuiteBrandSelectField {
  netSuiteBrands {
    id
    name
  }
}
    `;

/**
 * __useNetSuiteBrandSelectFieldQuery__
 *
 * To run a query within a React component, call `useNetSuiteBrandSelectFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useNetSuiteBrandSelectFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNetSuiteBrandSelectFieldQuery({
 *   variables: {
 *   },
 * });
 */
export function useNetSuiteBrandSelectFieldQuery(baseOptions?: Apollo.QueryHookOptions<NetSuiteBrandSelectFieldQuery, NetSuiteBrandSelectFieldQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NetSuiteBrandSelectFieldQuery, NetSuiteBrandSelectFieldQueryVariables>(NetSuiteBrandSelectFieldDocument, options);
      }
export function useNetSuiteBrandSelectFieldLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NetSuiteBrandSelectFieldQuery, NetSuiteBrandSelectFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NetSuiteBrandSelectFieldQuery, NetSuiteBrandSelectFieldQueryVariables>(NetSuiteBrandSelectFieldDocument, options);
        }
export type NetSuiteBrandSelectFieldQueryHookResult = ReturnType<typeof useNetSuiteBrandSelectFieldQuery>;
export type NetSuiteBrandSelectFieldLazyQueryHookResult = ReturnType<typeof useNetSuiteBrandSelectFieldLazyQuery>;
export type NetSuiteBrandSelectFieldQueryResult = Apollo.QueryResult<NetSuiteBrandSelectFieldQuery, NetSuiteBrandSelectFieldQueryVariables>;
export const NetSuiteDepartmentSelectFieldDocument = gql`
    query NetSuiteDepartmentSelectField {
  departments {
    id
    name
  }
}
    `;

/**
 * __useNetSuiteDepartmentSelectFieldQuery__
 *
 * To run a query within a React component, call `useNetSuiteDepartmentSelectFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useNetSuiteDepartmentSelectFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNetSuiteDepartmentSelectFieldQuery({
 *   variables: {
 *   },
 * });
 */
export function useNetSuiteDepartmentSelectFieldQuery(baseOptions?: Apollo.QueryHookOptions<NetSuiteDepartmentSelectFieldQuery, NetSuiteDepartmentSelectFieldQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NetSuiteDepartmentSelectFieldQuery, NetSuiteDepartmentSelectFieldQueryVariables>(NetSuiteDepartmentSelectFieldDocument, options);
      }
export function useNetSuiteDepartmentSelectFieldLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NetSuiteDepartmentSelectFieldQuery, NetSuiteDepartmentSelectFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NetSuiteDepartmentSelectFieldQuery, NetSuiteDepartmentSelectFieldQueryVariables>(NetSuiteDepartmentSelectFieldDocument, options);
        }
export type NetSuiteDepartmentSelectFieldQueryHookResult = ReturnType<typeof useNetSuiteDepartmentSelectFieldQuery>;
export type NetSuiteDepartmentSelectFieldLazyQueryHookResult = ReturnType<typeof useNetSuiteDepartmentSelectFieldLazyQuery>;
export type NetSuiteDepartmentSelectFieldQueryResult = Apollo.QueryResult<NetSuiteDepartmentSelectFieldQuery, NetSuiteDepartmentSelectFieldQueryVariables>;
export const NetSuiteEmployeeSelectFieldDocument = gql`
    query NetSuiteEmployeeSelectField {
  employees {
    id
    fullName
  }
}
    `;

/**
 * __useNetSuiteEmployeeSelectFieldQuery__
 *
 * To run a query within a React component, call `useNetSuiteEmployeeSelectFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useNetSuiteEmployeeSelectFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNetSuiteEmployeeSelectFieldQuery({
 *   variables: {
 *   },
 * });
 */
export function useNetSuiteEmployeeSelectFieldQuery(baseOptions?: Apollo.QueryHookOptions<NetSuiteEmployeeSelectFieldQuery, NetSuiteEmployeeSelectFieldQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NetSuiteEmployeeSelectFieldQuery, NetSuiteEmployeeSelectFieldQueryVariables>(NetSuiteEmployeeSelectFieldDocument, options);
      }
export function useNetSuiteEmployeeSelectFieldLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NetSuiteEmployeeSelectFieldQuery, NetSuiteEmployeeSelectFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NetSuiteEmployeeSelectFieldQuery, NetSuiteEmployeeSelectFieldQueryVariables>(NetSuiteEmployeeSelectFieldDocument, options);
        }
export type NetSuiteEmployeeSelectFieldQueryHookResult = ReturnType<typeof useNetSuiteEmployeeSelectFieldQuery>;
export type NetSuiteEmployeeSelectFieldLazyQueryHookResult = ReturnType<typeof useNetSuiteEmployeeSelectFieldLazyQuery>;
export type NetSuiteEmployeeSelectFieldQueryResult = Apollo.QueryResult<NetSuiteEmployeeSelectFieldQuery, NetSuiteEmployeeSelectFieldQueryVariables>;
export const NetSuiteLocationSelectFieldDocument = gql`
    query NetSuiteLocationSelectField {
  inventoryLocations {
    id
    name
  }
}
    `;

/**
 * __useNetSuiteLocationSelectFieldQuery__
 *
 * To run a query within a React component, call `useNetSuiteLocationSelectFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useNetSuiteLocationSelectFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNetSuiteLocationSelectFieldQuery({
 *   variables: {
 *   },
 * });
 */
export function useNetSuiteLocationSelectFieldQuery(baseOptions?: Apollo.QueryHookOptions<NetSuiteLocationSelectFieldQuery, NetSuiteLocationSelectFieldQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NetSuiteLocationSelectFieldQuery, NetSuiteLocationSelectFieldQueryVariables>(NetSuiteLocationSelectFieldDocument, options);
      }
export function useNetSuiteLocationSelectFieldLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NetSuiteLocationSelectFieldQuery, NetSuiteLocationSelectFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NetSuiteLocationSelectFieldQuery, NetSuiteLocationSelectFieldQueryVariables>(NetSuiteLocationSelectFieldDocument, options);
        }
export type NetSuiteLocationSelectFieldQueryHookResult = ReturnType<typeof useNetSuiteLocationSelectFieldQuery>;
export type NetSuiteLocationSelectFieldLazyQueryHookResult = ReturnType<typeof useNetSuiteLocationSelectFieldLazyQuery>;
export type NetSuiteLocationSelectFieldQueryResult = Apollo.QueryResult<NetSuiteLocationSelectFieldQuery, NetSuiteLocationSelectFieldQueryVariables>;
export const NetSuitePaymentMethodSelectFieldDocument = gql`
    query NetSuitePaymentMethodSelectField {
  netSuitePaymentMethods {
    id
    name
    internalId
  }
}
    `;

/**
 * __useNetSuitePaymentMethodSelectFieldQuery__
 *
 * To run a query within a React component, call `useNetSuitePaymentMethodSelectFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useNetSuitePaymentMethodSelectFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNetSuitePaymentMethodSelectFieldQuery({
 *   variables: {
 *   },
 * });
 */
export function useNetSuitePaymentMethodSelectFieldQuery(baseOptions?: Apollo.QueryHookOptions<NetSuitePaymentMethodSelectFieldQuery, NetSuitePaymentMethodSelectFieldQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NetSuitePaymentMethodSelectFieldQuery, NetSuitePaymentMethodSelectFieldQueryVariables>(NetSuitePaymentMethodSelectFieldDocument, options);
      }
export function useNetSuitePaymentMethodSelectFieldLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NetSuitePaymentMethodSelectFieldQuery, NetSuitePaymentMethodSelectFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NetSuitePaymentMethodSelectFieldQuery, NetSuitePaymentMethodSelectFieldQueryVariables>(NetSuitePaymentMethodSelectFieldDocument, options);
        }
export type NetSuitePaymentMethodSelectFieldQueryHookResult = ReturnType<typeof useNetSuitePaymentMethodSelectFieldQuery>;
export type NetSuitePaymentMethodSelectFieldLazyQueryHookResult = ReturnType<typeof useNetSuitePaymentMethodSelectFieldLazyQuery>;
export type NetSuitePaymentMethodSelectFieldQueryResult = Apollo.QueryResult<NetSuitePaymentMethodSelectFieldQuery, NetSuitePaymentMethodSelectFieldQueryVariables>;
export const NetSuiteSubsidiarySelectFieldDocument = gql`
    query NetSuiteSubsidiarySelectField {
  subsidiaries {
    id
    name
  }
}
    `;

/**
 * __useNetSuiteSubsidiarySelectFieldQuery__
 *
 * To run a query within a React component, call `useNetSuiteSubsidiarySelectFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useNetSuiteSubsidiarySelectFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNetSuiteSubsidiarySelectFieldQuery({
 *   variables: {
 *   },
 * });
 */
export function useNetSuiteSubsidiarySelectFieldQuery(baseOptions?: Apollo.QueryHookOptions<NetSuiteSubsidiarySelectFieldQuery, NetSuiteSubsidiarySelectFieldQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NetSuiteSubsidiarySelectFieldQuery, NetSuiteSubsidiarySelectFieldQueryVariables>(NetSuiteSubsidiarySelectFieldDocument, options);
      }
export function useNetSuiteSubsidiarySelectFieldLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NetSuiteSubsidiarySelectFieldQuery, NetSuiteSubsidiarySelectFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NetSuiteSubsidiarySelectFieldQuery, NetSuiteSubsidiarySelectFieldQueryVariables>(NetSuiteSubsidiarySelectFieldDocument, options);
        }
export type NetSuiteSubsidiarySelectFieldQueryHookResult = ReturnType<typeof useNetSuiteSubsidiarySelectFieldQuery>;
export type NetSuiteSubsidiarySelectFieldLazyQueryHookResult = ReturnType<typeof useNetSuiteSubsidiarySelectFieldLazyQuery>;
export type NetSuiteSubsidiarySelectFieldQueryResult = Apollo.QueryResult<NetSuiteSubsidiarySelectFieldQuery, NetSuiteSubsidiarySelectFieldQueryVariables>;
export const NetSuiteTaxItemSelectFieldDocument = gql`
    query NetSuiteTaxItemSelectField {
  taxItems {
    id
    name
  }
}
    `;

/**
 * __useNetSuiteTaxItemSelectFieldQuery__
 *
 * To run a query within a React component, call `useNetSuiteTaxItemSelectFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useNetSuiteTaxItemSelectFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNetSuiteTaxItemSelectFieldQuery({
 *   variables: {
 *   },
 * });
 */
export function useNetSuiteTaxItemSelectFieldQuery(baseOptions?: Apollo.QueryHookOptions<NetSuiteTaxItemSelectFieldQuery, NetSuiteTaxItemSelectFieldQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NetSuiteTaxItemSelectFieldQuery, NetSuiteTaxItemSelectFieldQueryVariables>(NetSuiteTaxItemSelectFieldDocument, options);
      }
export function useNetSuiteTaxItemSelectFieldLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NetSuiteTaxItemSelectFieldQuery, NetSuiteTaxItemSelectFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NetSuiteTaxItemSelectFieldQuery, NetSuiteTaxItemSelectFieldQueryVariables>(NetSuiteTaxItemSelectFieldDocument, options);
        }
export type NetSuiteTaxItemSelectFieldQueryHookResult = ReturnType<typeof useNetSuiteTaxItemSelectFieldQuery>;
export type NetSuiteTaxItemSelectFieldLazyQueryHookResult = ReturnType<typeof useNetSuiteTaxItemSelectFieldLazyQuery>;
export type NetSuiteTaxItemSelectFieldQueryResult = Apollo.QueryResult<NetSuiteTaxItemSelectFieldQuery, NetSuiteTaxItemSelectFieldQueryVariables>;
export const OrderPropertySelectFieldDocument = gql`
    query OrderPropertySelectField {
  orderProperties {
    id
    name
    displayName
  }
}
    `;

/**
 * __useOrderPropertySelectFieldQuery__
 *
 * To run a query within a React component, call `useOrderPropertySelectFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrderPropertySelectFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrderPropertySelectFieldQuery({
 *   variables: {
 *   },
 * });
 */
export function useOrderPropertySelectFieldQuery(baseOptions?: Apollo.QueryHookOptions<OrderPropertySelectFieldQuery, OrderPropertySelectFieldQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrderPropertySelectFieldQuery, OrderPropertySelectFieldQueryVariables>(OrderPropertySelectFieldDocument, options);
      }
export function useOrderPropertySelectFieldLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrderPropertySelectFieldQuery, OrderPropertySelectFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrderPropertySelectFieldQuery, OrderPropertySelectFieldQueryVariables>(OrderPropertySelectFieldDocument, options);
        }
export type OrderPropertySelectFieldQueryHookResult = ReturnType<typeof useOrderPropertySelectFieldQuery>;
export type OrderPropertySelectFieldLazyQueryHookResult = ReturnType<typeof useOrderPropertySelectFieldLazyQuery>;
export type OrderPropertySelectFieldQueryResult = Apollo.QueryResult<OrderPropertySelectFieldQuery, OrderPropertySelectFieldQueryVariables>;
export const PaymentMethodSelectFieldDocument = gql`
    query PaymentMethodSelectField {
  paymentMethods {
    id
    name
    displayName
  }
}
    `;

/**
 * __usePaymentMethodSelectFieldQuery__
 *
 * To run a query within a React component, call `usePaymentMethodSelectFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaymentMethodSelectFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaymentMethodSelectFieldQuery({
 *   variables: {
 *   },
 * });
 */
export function usePaymentMethodSelectFieldQuery(baseOptions?: Apollo.QueryHookOptions<PaymentMethodSelectFieldQuery, PaymentMethodSelectFieldQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PaymentMethodSelectFieldQuery, PaymentMethodSelectFieldQueryVariables>(PaymentMethodSelectFieldDocument, options);
      }
export function usePaymentMethodSelectFieldLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PaymentMethodSelectFieldQuery, PaymentMethodSelectFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PaymentMethodSelectFieldQuery, PaymentMethodSelectFieldQueryVariables>(PaymentMethodSelectFieldDocument, options);
        }
export type PaymentMethodSelectFieldQueryHookResult = ReturnType<typeof usePaymentMethodSelectFieldQuery>;
export type PaymentMethodSelectFieldLazyQueryHookResult = ReturnType<typeof usePaymentMethodSelectFieldLazyQuery>;
export type PaymentMethodSelectFieldQueryResult = Apollo.QueryResult<PaymentMethodSelectFieldQuery, PaymentMethodSelectFieldQueryVariables>;
export const ProductSelectFieldDocument = gql`
    query ProductSelectField($options: QueryProductsOptionsInput!) {
  products(options: $options) {
    pageInfo {
      ...pageInfoFields
    }
    nodes {
      id
      name
      sku
    }
  }
}
    ${PageInfoFieldsFragmentDoc}`;

/**
 * __useProductSelectFieldQuery__
 *
 * To run a query within a React component, call `useProductSelectFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductSelectFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductSelectFieldQuery({
 *   variables: {
 *      options: // value for 'options'
 *   },
 * });
 */
export function useProductSelectFieldQuery(baseOptions: Apollo.QueryHookOptions<ProductSelectFieldQuery, ProductSelectFieldQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductSelectFieldQuery, ProductSelectFieldQueryVariables>(ProductSelectFieldDocument, options);
      }
export function useProductSelectFieldLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductSelectFieldQuery, ProductSelectFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductSelectFieldQuery, ProductSelectFieldQueryVariables>(ProductSelectFieldDocument, options);
        }
export type ProductSelectFieldQueryHookResult = ReturnType<typeof useProductSelectFieldQuery>;
export type ProductSelectFieldLazyQueryHookResult = ReturnType<typeof useProductSelectFieldLazyQuery>;
export type ProductSelectFieldQueryResult = Apollo.QueryResult<ProductSelectFieldQuery, ProductSelectFieldQueryVariables>;
export const RepairCodeSelectFieldDocument = gql`
    query RepairCodeSelectField($storeId: ID!) {
  store(id: $storeId) {
    id
    repairCodes {
      id
      repairCode
    }
  }
}
    `;

/**
 * __useRepairCodeSelectFieldQuery__
 *
 * To run a query within a React component, call `useRepairCodeSelectFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useRepairCodeSelectFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRepairCodeSelectFieldQuery({
 *   variables: {
 *      storeId: // value for 'storeId'
 *   },
 * });
 */
export function useRepairCodeSelectFieldQuery(baseOptions: Apollo.QueryHookOptions<RepairCodeSelectFieldQuery, RepairCodeSelectFieldQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RepairCodeSelectFieldQuery, RepairCodeSelectFieldQueryVariables>(RepairCodeSelectFieldDocument, options);
      }
export function useRepairCodeSelectFieldLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RepairCodeSelectFieldQuery, RepairCodeSelectFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RepairCodeSelectFieldQuery, RepairCodeSelectFieldQueryVariables>(RepairCodeSelectFieldDocument, options);
        }
export type RepairCodeSelectFieldQueryHookResult = ReturnType<typeof useRepairCodeSelectFieldQuery>;
export type RepairCodeSelectFieldLazyQueryHookResult = ReturnType<typeof useRepairCodeSelectFieldLazyQuery>;
export type RepairCodeSelectFieldQueryResult = Apollo.QueryResult<RepairCodeSelectFieldQuery, RepairCodeSelectFieldQueryVariables>;
export const ReturnAuthorizationSelectFieldDocument = gql`
    query ReturnAuthorizationSelectField($storeId: ID!) {
  returnAuthorizations(options: {filter: {storeId: $storeId}}) {
    nodes {
      id
      returnNumber
    }
  }
}
    `;

/**
 * __useReturnAuthorizationSelectFieldQuery__
 *
 * To run a query within a React component, call `useReturnAuthorizationSelectFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useReturnAuthorizationSelectFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReturnAuthorizationSelectFieldQuery({
 *   variables: {
 *      storeId: // value for 'storeId'
 *   },
 * });
 */
export function useReturnAuthorizationSelectFieldQuery(baseOptions: Apollo.QueryHookOptions<ReturnAuthorizationSelectFieldQuery, ReturnAuthorizationSelectFieldQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReturnAuthorizationSelectFieldQuery, ReturnAuthorizationSelectFieldQueryVariables>(ReturnAuthorizationSelectFieldDocument, options);
      }
export function useReturnAuthorizationSelectFieldLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReturnAuthorizationSelectFieldQuery, ReturnAuthorizationSelectFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReturnAuthorizationSelectFieldQuery, ReturnAuthorizationSelectFieldQueryVariables>(ReturnAuthorizationSelectFieldDocument, options);
        }
export type ReturnAuthorizationSelectFieldQueryHookResult = ReturnType<typeof useReturnAuthorizationSelectFieldQuery>;
export type ReturnAuthorizationSelectFieldLazyQueryHookResult = ReturnType<typeof useReturnAuthorizationSelectFieldLazyQuery>;
export type ReturnAuthorizationSelectFieldQueryResult = Apollo.QueryResult<ReturnAuthorizationSelectFieldQuery, ReturnAuthorizationSelectFieldQueryVariables>;
export const SalesChannelSelectFieldDocument = gql`
    query SalesChannelSelectField {
  salesChannels {
    id
    name
    displayName
  }
}
    `;

/**
 * __useSalesChannelSelectFieldQuery__
 *
 * To run a query within a React component, call `useSalesChannelSelectFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useSalesChannelSelectFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSalesChannelSelectFieldQuery({
 *   variables: {
 *   },
 * });
 */
export function useSalesChannelSelectFieldQuery(baseOptions?: Apollo.QueryHookOptions<SalesChannelSelectFieldQuery, SalesChannelSelectFieldQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SalesChannelSelectFieldQuery, SalesChannelSelectFieldQueryVariables>(SalesChannelSelectFieldDocument, options);
      }
export function useSalesChannelSelectFieldLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SalesChannelSelectFieldQuery, SalesChannelSelectFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SalesChannelSelectFieldQuery, SalesChannelSelectFieldQueryVariables>(SalesChannelSelectFieldDocument, options);
        }
export type SalesChannelSelectFieldQueryHookResult = ReturnType<typeof useSalesChannelSelectFieldQuery>;
export type SalesChannelSelectFieldLazyQueryHookResult = ReturnType<typeof useSalesChannelSelectFieldLazyQuery>;
export type SalesChannelSelectFieldQueryResult = Apollo.QueryResult<SalesChannelSelectFieldQuery, SalesChannelSelectFieldQueryVariables>;
export const SalesOrderSelectFieldDocument = gql`
    query SalesOrderSelectField($storeId: ID!) {
  orders(options: {filter: {storeId: $storeId}}) {
    nodes {
      id
      orderNumber
    }
  }
}
    `;

/**
 * __useSalesOrderSelectFieldQuery__
 *
 * To run a query within a React component, call `useSalesOrderSelectFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useSalesOrderSelectFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSalesOrderSelectFieldQuery({
 *   variables: {
 *      storeId: // value for 'storeId'
 *   },
 * });
 */
export function useSalesOrderSelectFieldQuery(baseOptions: Apollo.QueryHookOptions<SalesOrderSelectFieldQuery, SalesOrderSelectFieldQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SalesOrderSelectFieldQuery, SalesOrderSelectFieldQueryVariables>(SalesOrderSelectFieldDocument, options);
      }
export function useSalesOrderSelectFieldLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SalesOrderSelectFieldQuery, SalesOrderSelectFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SalesOrderSelectFieldQuery, SalesOrderSelectFieldQueryVariables>(SalesOrderSelectFieldDocument, options);
        }
export type SalesOrderSelectFieldQueryHookResult = ReturnType<typeof useSalesOrderSelectFieldQuery>;
export type SalesOrderSelectFieldLazyQueryHookResult = ReturnType<typeof useSalesOrderSelectFieldLazyQuery>;
export type SalesOrderSelectFieldQueryResult = Apollo.QueryResult<SalesOrderSelectFieldQuery, SalesOrderSelectFieldQueryVariables>;
export const ShipItemFieldDocument = gql`
    query ShipItemField($subsidiaryId: ID!) {
  shipItems(options: {filter: {subsidiaryId: $subsidiaryId}}) {
    pageInfo {
      ...pageInfoFields
    }
    nodes {
      id
      name
    }
  }
}
    ${PageInfoFieldsFragmentDoc}`;

/**
 * __useShipItemFieldQuery__
 *
 * To run a query within a React component, call `useShipItemFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useShipItemFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useShipItemFieldQuery({
 *   variables: {
 *      subsidiaryId: // value for 'subsidiaryId'
 *   },
 * });
 */
export function useShipItemFieldQuery(baseOptions: Apollo.QueryHookOptions<ShipItemFieldQuery, ShipItemFieldQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ShipItemFieldQuery, ShipItemFieldQueryVariables>(ShipItemFieldDocument, options);
      }
export function useShipItemFieldLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ShipItemFieldQuery, ShipItemFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ShipItemFieldQuery, ShipItemFieldQueryVariables>(ShipItemFieldDocument, options);
        }
export type ShipItemFieldQueryHookResult = ReturnType<typeof useShipItemFieldQuery>;
export type ShipItemFieldLazyQueryHookResult = ReturnType<typeof useShipItemFieldLazyQuery>;
export type ShipItemFieldQueryResult = Apollo.QueryResult<ShipItemFieldQuery, ShipItemFieldQueryVariables>;
export const ShipStationStoreSelectFieldDocument = gql`
    query ShipStationStoreSelectField {
  shipStationStores {
    id
    name
  }
}
    `;

/**
 * __useShipStationStoreSelectFieldQuery__
 *
 * To run a query within a React component, call `useShipStationStoreSelectFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useShipStationStoreSelectFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useShipStationStoreSelectFieldQuery({
 *   variables: {
 *   },
 * });
 */
export function useShipStationStoreSelectFieldQuery(baseOptions?: Apollo.QueryHookOptions<ShipStationStoreSelectFieldQuery, ShipStationStoreSelectFieldQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ShipStationStoreSelectFieldQuery, ShipStationStoreSelectFieldQueryVariables>(ShipStationStoreSelectFieldDocument, options);
      }
export function useShipStationStoreSelectFieldLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ShipStationStoreSelectFieldQuery, ShipStationStoreSelectFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ShipStationStoreSelectFieldQuery, ShipStationStoreSelectFieldQueryVariables>(ShipStationStoreSelectFieldDocument, options);
        }
export type ShipStationStoreSelectFieldQueryHookResult = ReturnType<typeof useShipStationStoreSelectFieldQuery>;
export type ShipStationStoreSelectFieldLazyQueryHookResult = ReturnType<typeof useShipStationStoreSelectFieldLazyQuery>;
export type ShipStationStoreSelectFieldQueryResult = Apollo.QueryResult<ShipStationStoreSelectFieldQuery, ShipStationStoreSelectFieldQueryVariables>;
export const SoftwareVersionSelectFieldDocument = gql`
    query SoftwareVersionSelectField($storeId: ID!) {
  store(id: $storeId) {
    id
    softwareVersions {
      id
      name
    }
  }
}
    `;

/**
 * __useSoftwareVersionSelectFieldQuery__
 *
 * To run a query within a React component, call `useSoftwareVersionSelectFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useSoftwareVersionSelectFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSoftwareVersionSelectFieldQuery({
 *   variables: {
 *      storeId: // value for 'storeId'
 *   },
 * });
 */
export function useSoftwareVersionSelectFieldQuery(baseOptions: Apollo.QueryHookOptions<SoftwareVersionSelectFieldQuery, SoftwareVersionSelectFieldQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SoftwareVersionSelectFieldQuery, SoftwareVersionSelectFieldQueryVariables>(SoftwareVersionSelectFieldDocument, options);
      }
export function useSoftwareVersionSelectFieldLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SoftwareVersionSelectFieldQuery, SoftwareVersionSelectFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SoftwareVersionSelectFieldQuery, SoftwareVersionSelectFieldQueryVariables>(SoftwareVersionSelectFieldDocument, options);
        }
export type SoftwareVersionSelectFieldQueryHookResult = ReturnType<typeof useSoftwareVersionSelectFieldQuery>;
export type SoftwareVersionSelectFieldLazyQueryHookResult = ReturnType<typeof useSoftwareVersionSelectFieldLazyQuery>;
export type SoftwareVersionSelectFieldQueryResult = Apollo.QueryResult<SoftwareVersionSelectFieldQuery, SoftwareVersionSelectFieldQueryVariables>;
export const StoreSelectFieldDocument = gql`
    query StoreSelectField($featuresEnabled: [FeatureName!], $salesChannel: SalesChannelName, $types: [StoreTypeName!]) {
  stores(
    options: {filter: {featuresEnabled: $featuresEnabled, salesChannel: $salesChannel, types: $types}}
  ) {
    pageInfo {
      ...pageInfoFields
    }
    nodes {
      id
      name
    }
  }
}
    ${PageInfoFieldsFragmentDoc}`;

/**
 * __useStoreSelectFieldQuery__
 *
 * To run a query within a React component, call `useStoreSelectFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useStoreSelectFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStoreSelectFieldQuery({
 *   variables: {
 *      featuresEnabled: // value for 'featuresEnabled'
 *      salesChannel: // value for 'salesChannel'
 *      types: // value for 'types'
 *   },
 * });
 */
export function useStoreSelectFieldQuery(baseOptions?: Apollo.QueryHookOptions<StoreSelectFieldQuery, StoreSelectFieldQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StoreSelectFieldQuery, StoreSelectFieldQueryVariables>(StoreSelectFieldDocument, options);
      }
export function useStoreSelectFieldLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StoreSelectFieldQuery, StoreSelectFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StoreSelectFieldQuery, StoreSelectFieldQueryVariables>(StoreSelectFieldDocument, options);
        }
export type StoreSelectFieldQueryHookResult = ReturnType<typeof useStoreSelectFieldQuery>;
export type StoreSelectFieldLazyQueryHookResult = ReturnType<typeof useStoreSelectFieldLazyQuery>;
export type StoreSelectFieldQueryResult = Apollo.QueryResult<StoreSelectFieldQuery, StoreSelectFieldQueryVariables>;
export const ThirdPartyAccountSelectFieldDocument = gql`
    query ThirdPartyAccountSelectField {
  thirdPartyAccounts {
    nodes {
      id
      name
      accountNumber
    }
  }
}
    `;

/**
 * __useThirdPartyAccountSelectFieldQuery__
 *
 * To run a query within a React component, call `useThirdPartyAccountSelectFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useThirdPartyAccountSelectFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useThirdPartyAccountSelectFieldQuery({
 *   variables: {
 *   },
 * });
 */
export function useThirdPartyAccountSelectFieldQuery(baseOptions?: Apollo.QueryHookOptions<ThirdPartyAccountSelectFieldQuery, ThirdPartyAccountSelectFieldQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ThirdPartyAccountSelectFieldQuery, ThirdPartyAccountSelectFieldQueryVariables>(ThirdPartyAccountSelectFieldDocument, options);
      }
export function useThirdPartyAccountSelectFieldLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ThirdPartyAccountSelectFieldQuery, ThirdPartyAccountSelectFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ThirdPartyAccountSelectFieldQuery, ThirdPartyAccountSelectFieldQueryVariables>(ThirdPartyAccountSelectFieldDocument, options);
        }
export type ThirdPartyAccountSelectFieldQueryHookResult = ReturnType<typeof useThirdPartyAccountSelectFieldQuery>;
export type ThirdPartyAccountSelectFieldLazyQueryHookResult = ReturnType<typeof useThirdPartyAccountSelectFieldLazyQuery>;
export type ThirdPartyAccountSelectFieldQueryResult = Apollo.QueryResult<ThirdPartyAccountSelectFieldQuery, ThirdPartyAccountSelectFieldQueryVariables>;
export const TriageReasonSelectFieldDocument = gql`
    query TriageReasonSelectField($storeId: ID!) {
  store(id: $storeId) {
    id
    triageReasons {
      id
      reasonText
    }
  }
}
    `;

/**
 * __useTriageReasonSelectFieldQuery__
 *
 * To run a query within a React component, call `useTriageReasonSelectFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useTriageReasonSelectFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTriageReasonSelectFieldQuery({
 *   variables: {
 *      storeId: // value for 'storeId'
 *   },
 * });
 */
export function useTriageReasonSelectFieldQuery(baseOptions: Apollo.QueryHookOptions<TriageReasonSelectFieldQuery, TriageReasonSelectFieldQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TriageReasonSelectFieldQuery, TriageReasonSelectFieldQueryVariables>(TriageReasonSelectFieldDocument, options);
      }
export function useTriageReasonSelectFieldLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TriageReasonSelectFieldQuery, TriageReasonSelectFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TriageReasonSelectFieldQuery, TriageReasonSelectFieldQueryVariables>(TriageReasonSelectFieldDocument, options);
        }
export type TriageReasonSelectFieldQueryHookResult = ReturnType<typeof useTriageReasonSelectFieldQuery>;
export type TriageReasonSelectFieldLazyQueryHookResult = ReturnType<typeof useTriageReasonSelectFieldLazyQuery>;
export type TriageReasonSelectFieldQueryResult = Apollo.QueryResult<TriageReasonSelectFieldQuery, TriageReasonSelectFieldQueryVariables>;
export const UserRoleTemplateSelectFieldDocument = gql`
    query UserRoleTemplateSelectField {
  userRoleTemplates {
    nodes {
      id
      displayName
      visibilityScope {
        id
        name
        displayName
      }
    }
  }
}
    `;

/**
 * __useUserRoleTemplateSelectFieldQuery__
 *
 * To run a query within a React component, call `useUserRoleTemplateSelectFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserRoleTemplateSelectFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserRoleTemplateSelectFieldQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserRoleTemplateSelectFieldQuery(baseOptions?: Apollo.QueryHookOptions<UserRoleTemplateSelectFieldQuery, UserRoleTemplateSelectFieldQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserRoleTemplateSelectFieldQuery, UserRoleTemplateSelectFieldQueryVariables>(UserRoleTemplateSelectFieldDocument, options);
      }
export function useUserRoleTemplateSelectFieldLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserRoleTemplateSelectFieldQuery, UserRoleTemplateSelectFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserRoleTemplateSelectFieldQuery, UserRoleTemplateSelectFieldQueryVariables>(UserRoleTemplateSelectFieldDocument, options);
        }
export type UserRoleTemplateSelectFieldQueryHookResult = ReturnType<typeof useUserRoleTemplateSelectFieldQuery>;
export type UserRoleTemplateSelectFieldLazyQueryHookResult = ReturnType<typeof useUserRoleTemplateSelectFieldLazyQuery>;
export type UserRoleTemplateSelectFieldQueryResult = Apollo.QueryResult<UserRoleTemplateSelectFieldQuery, UserRoleTemplateSelectFieldQueryVariables>;
export const UserStatusSelectFieldDocument = gql`
    query UserStatusSelectField {
  userStatuses {
    id
    name
    displayName
  }
}
    `;

/**
 * __useUserStatusSelectFieldQuery__
 *
 * To run a query within a React component, call `useUserStatusSelectFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserStatusSelectFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserStatusSelectFieldQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserStatusSelectFieldQuery(baseOptions?: Apollo.QueryHookOptions<UserStatusSelectFieldQuery, UserStatusSelectFieldQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserStatusSelectFieldQuery, UserStatusSelectFieldQueryVariables>(UserStatusSelectFieldDocument, options);
      }
export function useUserStatusSelectFieldLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserStatusSelectFieldQuery, UserStatusSelectFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserStatusSelectFieldQuery, UserStatusSelectFieldQueryVariables>(UserStatusSelectFieldDocument, options);
        }
export type UserStatusSelectFieldQueryHookResult = ReturnType<typeof useUserStatusSelectFieldQuery>;
export type UserStatusSelectFieldLazyQueryHookResult = ReturnType<typeof useUserStatusSelectFieldLazyQuery>;
export type UserStatusSelectFieldQueryResult = Apollo.QueryResult<UserStatusSelectFieldQuery, UserStatusSelectFieldQueryVariables>;
export const AcceptReturnAuthorizationDocument = gql`
    mutation AcceptReturnAuthorization($returnAuthorizationId: ID!, $approvalTypeName: ApprovalTypeName!) {
  acceptReturnAuthorization(
    input: {returnAuthorizationId: $returnAuthorizationId, approvalTypeName: $approvalTypeName}
  ) {
    id
    acceptance {
      id
      approvalType {
        id
        name
        displayName
      }
    }
  }
}
    `;
export type AcceptReturnAuthorizationMutationFn = Apollo.MutationFunction<AcceptReturnAuthorizationMutation, AcceptReturnAuthorizationMutationVariables>;

/**
 * __useAcceptReturnAuthorizationMutation__
 *
 * To run a mutation, you first call `useAcceptReturnAuthorizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcceptReturnAuthorizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acceptReturnAuthorizationMutation, { data, loading, error }] = useAcceptReturnAuthorizationMutation({
 *   variables: {
 *      returnAuthorizationId: // value for 'returnAuthorizationId'
 *      approvalTypeName: // value for 'approvalTypeName'
 *   },
 * });
 */
export function useAcceptReturnAuthorizationMutation(baseOptions?: Apollo.MutationHookOptions<AcceptReturnAuthorizationMutation, AcceptReturnAuthorizationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AcceptReturnAuthorizationMutation, AcceptReturnAuthorizationMutationVariables>(AcceptReturnAuthorizationDocument, options);
      }
export type AcceptReturnAuthorizationMutationHookResult = ReturnType<typeof useAcceptReturnAuthorizationMutation>;
export type AcceptReturnAuthorizationMutationResult = Apollo.MutationResult<AcceptReturnAuthorizationMutation>;
export type AcceptReturnAuthorizationMutationOptions = Apollo.BaseMutationOptions<AcceptReturnAuthorizationMutation, AcceptReturnAuthorizationMutationVariables>;
export const ReverseReturnAuthorizationAcceptanceDecisionDocument = gql`
    mutation ReverseReturnAuthorizationAcceptanceDecision($returnAuthorizationId: ID!) {
  reverseReturnAuthorizationAcceptanceDecision(
    returnAuthorizationId: $returnAuthorizationId
  ) {
    id
    acceptance {
      id
    }
  }
}
    `;
export type ReverseReturnAuthorizationAcceptanceDecisionMutationFn = Apollo.MutationFunction<ReverseReturnAuthorizationAcceptanceDecisionMutation, ReverseReturnAuthorizationAcceptanceDecisionMutationVariables>;

/**
 * __useReverseReturnAuthorizationAcceptanceDecisionMutation__
 *
 * To run a mutation, you first call `useReverseReturnAuthorizationAcceptanceDecisionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReverseReturnAuthorizationAcceptanceDecisionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reverseReturnAuthorizationAcceptanceDecisionMutation, { data, loading, error }] = useReverseReturnAuthorizationAcceptanceDecisionMutation({
 *   variables: {
 *      returnAuthorizationId: // value for 'returnAuthorizationId'
 *   },
 * });
 */
export function useReverseReturnAuthorizationAcceptanceDecisionMutation(baseOptions?: Apollo.MutationHookOptions<ReverseReturnAuthorizationAcceptanceDecisionMutation, ReverseReturnAuthorizationAcceptanceDecisionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReverseReturnAuthorizationAcceptanceDecisionMutation, ReverseReturnAuthorizationAcceptanceDecisionMutationVariables>(ReverseReturnAuthorizationAcceptanceDecisionDocument, options);
      }
export type ReverseReturnAuthorizationAcceptanceDecisionMutationHookResult = ReturnType<typeof useReverseReturnAuthorizationAcceptanceDecisionMutation>;
export type ReverseReturnAuthorizationAcceptanceDecisionMutationResult = Apollo.MutationResult<ReverseReturnAuthorizationAcceptanceDecisionMutation>;
export type ReverseReturnAuthorizationAcceptanceDecisionMutationOptions = Apollo.BaseMutationOptions<ReverseReturnAuthorizationAcceptanceDecisionMutation, ReverseReturnAuthorizationAcceptanceDecisionMutationVariables>;
export const AcceptReturnAuthorizationModalDocument = gql`
    query AcceptReturnAuthorizationModal($returnAuthorizationId: ID!) {
  returnAuthorization(id: $returnAuthorizationId) {
    id
    returnNumber
    store {
      id
    }
    netSuiteWriteRequest {
      ...writeRequestFields
    }
    netSuiteRecord {
      ...netSuiteRecordFields
    }
    lineItems {
      id
      serialNumber
      quantity
      reasonForReturn
      product {
        id
        sku
        name
      }
    }
    customer {
      id
      firstName
      lastName
      netSuiteWriteRequest {
        ...writeRequestFields
      }
      netSuiteRecord {
        ...netSuiteRecordFields
      }
    }
    order {
      id
      orderNumber
      orderDate
      netSuiteWriteRequest {
        ...writeRequestFields
      }
      netSuiteRecord {
        ...netSuiteRecordFields
      }
    }
  }
}
    ${WriteRequestFieldsFragmentDoc}
${NetSuiteRecordFieldsFragmentDoc}`;

/**
 * __useAcceptReturnAuthorizationModalQuery__
 *
 * To run a query within a React component, call `useAcceptReturnAuthorizationModalQuery` and pass it any options that fit your needs.
 * When your component renders, `useAcceptReturnAuthorizationModalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAcceptReturnAuthorizationModalQuery({
 *   variables: {
 *      returnAuthorizationId: // value for 'returnAuthorizationId'
 *   },
 * });
 */
export function useAcceptReturnAuthorizationModalQuery(baseOptions: Apollo.QueryHookOptions<AcceptReturnAuthorizationModalQuery, AcceptReturnAuthorizationModalQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AcceptReturnAuthorizationModalQuery, AcceptReturnAuthorizationModalQueryVariables>(AcceptReturnAuthorizationModalDocument, options);
      }
export function useAcceptReturnAuthorizationModalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AcceptReturnAuthorizationModalQuery, AcceptReturnAuthorizationModalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AcceptReturnAuthorizationModalQuery, AcceptReturnAuthorizationModalQueryVariables>(AcceptReturnAuthorizationModalDocument, options);
        }
export type AcceptReturnAuthorizationModalQueryHookResult = ReturnType<typeof useAcceptReturnAuthorizationModalQuery>;
export type AcceptReturnAuthorizationModalLazyQueryHookResult = ReturnType<typeof useAcceptReturnAuthorizationModalLazyQuery>;
export type AcceptReturnAuthorizationModalQueryResult = Apollo.QueryResult<AcceptReturnAuthorizationModalQuery, AcceptReturnAuthorizationModalQueryVariables>;
export const ApproveReturnAuthorizationDocument = gql`
    mutation ApproveReturnAuthorization($returnAuthorizationId: ID!, $approvalTypeName: ApprovalTypeName!) {
  approveReturnAuthorization(
    input: {returnAuthorizationId: $returnAuthorizationId, approvalTypeName: $approvalTypeName}
  ) {
    id
    approval {
      id
      approvalType {
        id
        name
        displayName
      }
    }
  }
}
    `;
export type ApproveReturnAuthorizationMutationFn = Apollo.MutationFunction<ApproveReturnAuthorizationMutation, ApproveReturnAuthorizationMutationVariables>;

/**
 * __useApproveReturnAuthorizationMutation__
 *
 * To run a mutation, you first call `useApproveReturnAuthorizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApproveReturnAuthorizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [approveReturnAuthorizationMutation, { data, loading, error }] = useApproveReturnAuthorizationMutation({
 *   variables: {
 *      returnAuthorizationId: // value for 'returnAuthorizationId'
 *      approvalTypeName: // value for 'approvalTypeName'
 *   },
 * });
 */
export function useApproveReturnAuthorizationMutation(baseOptions?: Apollo.MutationHookOptions<ApproveReturnAuthorizationMutation, ApproveReturnAuthorizationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApproveReturnAuthorizationMutation, ApproveReturnAuthorizationMutationVariables>(ApproveReturnAuthorizationDocument, options);
      }
export type ApproveReturnAuthorizationMutationHookResult = ReturnType<typeof useApproveReturnAuthorizationMutation>;
export type ApproveReturnAuthorizationMutationResult = Apollo.MutationResult<ApproveReturnAuthorizationMutation>;
export type ApproveReturnAuthorizationMutationOptions = Apollo.BaseMutationOptions<ApproveReturnAuthorizationMutation, ApproveReturnAuthorizationMutationVariables>;
export const ReverseReturnAuthorizationApprovalDecisionDocument = gql`
    mutation ReverseReturnAuthorizationApprovalDecision($returnAuthorizationId: ID!) {
  reverseReturnAuthorizationApprovalDecision(
    returnAuthorizationId: $returnAuthorizationId
  ) {
    id
    approval {
      id
    }
  }
}
    `;
export type ReverseReturnAuthorizationApprovalDecisionMutationFn = Apollo.MutationFunction<ReverseReturnAuthorizationApprovalDecisionMutation, ReverseReturnAuthorizationApprovalDecisionMutationVariables>;

/**
 * __useReverseReturnAuthorizationApprovalDecisionMutation__
 *
 * To run a mutation, you first call `useReverseReturnAuthorizationApprovalDecisionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReverseReturnAuthorizationApprovalDecisionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reverseReturnAuthorizationApprovalDecisionMutation, { data, loading, error }] = useReverseReturnAuthorizationApprovalDecisionMutation({
 *   variables: {
 *      returnAuthorizationId: // value for 'returnAuthorizationId'
 *   },
 * });
 */
export function useReverseReturnAuthorizationApprovalDecisionMutation(baseOptions?: Apollo.MutationHookOptions<ReverseReturnAuthorizationApprovalDecisionMutation, ReverseReturnAuthorizationApprovalDecisionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReverseReturnAuthorizationApprovalDecisionMutation, ReverseReturnAuthorizationApprovalDecisionMutationVariables>(ReverseReturnAuthorizationApprovalDecisionDocument, options);
      }
export type ReverseReturnAuthorizationApprovalDecisionMutationHookResult = ReturnType<typeof useReverseReturnAuthorizationApprovalDecisionMutation>;
export type ReverseReturnAuthorizationApprovalDecisionMutationResult = Apollo.MutationResult<ReverseReturnAuthorizationApprovalDecisionMutation>;
export type ReverseReturnAuthorizationApprovalDecisionMutationOptions = Apollo.BaseMutationOptions<ReverseReturnAuthorizationApprovalDecisionMutation, ReverseReturnAuthorizationApprovalDecisionMutationVariables>;
export const ApproveReturnAuthorizationModalDocument = gql`
    query ApproveReturnAuthorizationModal($returnAuthorizationId: ID!) {
  returnAuthorization(id: $returnAuthorizationId) {
    id
    returnNumber
    netSuiteWriteRequest {
      ...writeRequestFields
    }
    netSuiteRecord {
      ...netSuiteRecordFields
    }
    store {
      id
    }
    lineItems {
      id
      serialNumber
      quantity
      reasonForReturn
      product {
        id
        sku
        name
      }
    }
    customer {
      id
      firstName
      lastName
      netSuiteWriteRequest {
        ...writeRequestFields
      }
      netSuiteRecord {
        ...netSuiteRecordFields
      }
    }
    order {
      id
      orderNumber
      orderDate
      netSuiteWriteRequest {
        ...writeRequestFields
      }
      netSuiteRecord {
        ...netSuiteRecordFields
      }
    }
  }
}
    ${WriteRequestFieldsFragmentDoc}
${NetSuiteRecordFieldsFragmentDoc}`;

/**
 * __useApproveReturnAuthorizationModalQuery__
 *
 * To run a query within a React component, call `useApproveReturnAuthorizationModalQuery` and pass it any options that fit your needs.
 * When your component renders, `useApproveReturnAuthorizationModalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useApproveReturnAuthorizationModalQuery({
 *   variables: {
 *      returnAuthorizationId: // value for 'returnAuthorizationId'
 *   },
 * });
 */
export function useApproveReturnAuthorizationModalQuery(baseOptions: Apollo.QueryHookOptions<ApproveReturnAuthorizationModalQuery, ApproveReturnAuthorizationModalQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ApproveReturnAuthorizationModalQuery, ApproveReturnAuthorizationModalQueryVariables>(ApproveReturnAuthorizationModalDocument, options);
      }
export function useApproveReturnAuthorizationModalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ApproveReturnAuthorizationModalQuery, ApproveReturnAuthorizationModalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ApproveReturnAuthorizationModalQuery, ApproveReturnAuthorizationModalQueryVariables>(ApproveReturnAuthorizationModalDocument, options);
        }
export type ApproveReturnAuthorizationModalQueryHookResult = ReturnType<typeof useApproveReturnAuthorizationModalQuery>;
export type ApproveReturnAuthorizationModalLazyQueryHookResult = ReturnType<typeof useApproveReturnAuthorizationModalLazyQuery>;
export type ApproveReturnAuthorizationModalQueryResult = Apollo.QueryResult<ApproveReturnAuthorizationModalQuery, ApproveReturnAuthorizationModalQueryVariables>;
export const InitiateReturnAuthorizationDocument = gql`
    mutation InitiateReturnAuthorization($input: InitiateReturnAuthorizationInput!) {
  initiateReturnAuthorization(input: $input) {
    id
  }
}
    `;
export type InitiateReturnAuthorizationMutationFn = Apollo.MutationFunction<InitiateReturnAuthorizationMutation, InitiateReturnAuthorizationMutationVariables>;

/**
 * __useInitiateReturnAuthorizationMutation__
 *
 * To run a mutation, you first call `useInitiateReturnAuthorizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInitiateReturnAuthorizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [initiateReturnAuthorizationMutation, { data, loading, error }] = useInitiateReturnAuthorizationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useInitiateReturnAuthorizationMutation(baseOptions?: Apollo.MutationHookOptions<InitiateReturnAuthorizationMutation, InitiateReturnAuthorizationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InitiateReturnAuthorizationMutation, InitiateReturnAuthorizationMutationVariables>(InitiateReturnAuthorizationDocument, options);
      }
export type InitiateReturnAuthorizationMutationHookResult = ReturnType<typeof useInitiateReturnAuthorizationMutation>;
export type InitiateReturnAuthorizationMutationResult = Apollo.MutationResult<InitiateReturnAuthorizationMutation>;
export type InitiateReturnAuthorizationMutationOptions = Apollo.BaseMutationOptions<InitiateReturnAuthorizationMutation, InitiateReturnAuthorizationMutationVariables>;
export const InitiateReturnAuthorizationAsCustomerDocument = gql`
    mutation InitiateReturnAuthorizationAsCustomer($input: InitiateReturnAuthorizationInput!) {
  initiateReturnAuthorizationAsCustomer(input: $input) {
    id
    returnNumber
  }
}
    `;
export type InitiateReturnAuthorizationAsCustomerMutationFn = Apollo.MutationFunction<InitiateReturnAuthorizationAsCustomerMutation, InitiateReturnAuthorizationAsCustomerMutationVariables>;

/**
 * __useInitiateReturnAuthorizationAsCustomerMutation__
 *
 * To run a mutation, you first call `useInitiateReturnAuthorizationAsCustomerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInitiateReturnAuthorizationAsCustomerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [initiateReturnAuthorizationAsCustomerMutation, { data, loading, error }] = useInitiateReturnAuthorizationAsCustomerMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useInitiateReturnAuthorizationAsCustomerMutation(baseOptions?: Apollo.MutationHookOptions<InitiateReturnAuthorizationAsCustomerMutation, InitiateReturnAuthorizationAsCustomerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InitiateReturnAuthorizationAsCustomerMutation, InitiateReturnAuthorizationAsCustomerMutationVariables>(InitiateReturnAuthorizationAsCustomerDocument, options);
      }
export type InitiateReturnAuthorizationAsCustomerMutationHookResult = ReturnType<typeof useInitiateReturnAuthorizationAsCustomerMutation>;
export type InitiateReturnAuthorizationAsCustomerMutationResult = Apollo.MutationResult<InitiateReturnAuthorizationAsCustomerMutation>;
export type InitiateReturnAuthorizationAsCustomerMutationOptions = Apollo.BaseMutationOptions<InitiateReturnAuthorizationAsCustomerMutation, InitiateReturnAuthorizationAsCustomerMutationVariables>;
export const InitiateReturnModalDocument = gql`
    query InitiateReturnModal($orderId: ID!, $asCustomer: Boolean!) {
  order(id: $orderId) @skip(if: $asCustomer) {
    id
    orderDate
    orderNumber
    netSuiteWriteRequest {
      ...writeRequestFields
    }
    netSuiteRecord {
      ...netSuiteRecordFields
    }
    customer {
      id
      fullName
      netSuiteWriteRequest {
        ...writeRequestFields
      }
      netSuiteRecord {
        ...netSuiteRecordFields
      }
    }
    store {
      id
    }
    paymentMethod {
      id
      name
      displayName
    }
    lineItems {
      id
      discountTotalCents
      feeTotalCents
      itemTotalCents
      taxTotalCents
      quantity
      product {
        id
        name
        sku
      }
    }
    itemFulfillment {
      id
      netSuiteRecord {
        ...netSuiteRecordFields
      }
      lineItems {
        id
        item {
          id
          sku
        }
        assignments {
          id
          inventoryNumber
        }
      }
    }
    returnAuthorizations {
      pageInfo {
        ...pageInfoFields
      }
      nodes {
        id
        itemReceipt {
          id
          lineItems {
            id
            inventoryNumber
            product {
              id
              sku
            }
          }
        }
      }
    }
  }
  orderLite(input: {id: $orderId}) @include(if: $asCustomer) {
    id
    orderDate
    orderNumber
    customerFullName
    paymentMethod {
      id
      name
      displayName
    }
    lineItems {
      id
      discountTotalCents
      feeTotalCents
      itemTotalCents
      taxTotalCents
      quantity
      productName
      sku
    }
    itemFulfillment {
      id
      lineItems {
        id
        item {
          id
          sku
        }
        assignments {
          id
          inventoryNumber
        }
      }
    }
    returnAuthorizations {
      id
      receivedInventoryNumbers
    }
  }
}
    ${WriteRequestFieldsFragmentDoc}
${NetSuiteRecordFieldsFragmentDoc}
${PageInfoFieldsFragmentDoc}`;

/**
 * __useInitiateReturnModalQuery__
 *
 * To run a query within a React component, call `useInitiateReturnModalQuery` and pass it any options that fit your needs.
 * When your component renders, `useInitiateReturnModalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInitiateReturnModalQuery({
 *   variables: {
 *      orderId: // value for 'orderId'
 *      asCustomer: // value for 'asCustomer'
 *   },
 * });
 */
export function useInitiateReturnModalQuery(baseOptions: Apollo.QueryHookOptions<InitiateReturnModalQuery, InitiateReturnModalQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InitiateReturnModalQuery, InitiateReturnModalQueryVariables>(InitiateReturnModalDocument, options);
      }
export function useInitiateReturnModalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InitiateReturnModalQuery, InitiateReturnModalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InitiateReturnModalQuery, InitiateReturnModalQueryVariables>(InitiateReturnModalDocument, options);
        }
export type InitiateReturnModalQueryHookResult = ReturnType<typeof useInitiateReturnModalQuery>;
export type InitiateReturnModalLazyQueryHookResult = ReturnType<typeof useInitiateReturnModalLazyQuery>;
export type InitiateReturnModalQueryResult = Apollo.QueryResult<InitiateReturnModalQuery, InitiateReturnModalQueryVariables>;
export const OrderChatMessagesWidgetDocument = gql`
    query OrderChatMessagesWidget($orderId: ID!) {
  order(id: $orderId) {
    id
    messages {
      pageInfo {
        ...pageInfoFields
      }
      nodes {
        id
        metaCreated
        content
        senderName
      }
    }
  }
}
    ${PageInfoFieldsFragmentDoc}`;

/**
 * __useOrderChatMessagesWidgetQuery__
 *
 * To run a query within a React component, call `useOrderChatMessagesWidgetQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrderChatMessagesWidgetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrderChatMessagesWidgetQuery({
 *   variables: {
 *      orderId: // value for 'orderId'
 *   },
 * });
 */
export function useOrderChatMessagesWidgetQuery(baseOptions: Apollo.QueryHookOptions<OrderChatMessagesWidgetQuery, OrderChatMessagesWidgetQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrderChatMessagesWidgetQuery, OrderChatMessagesWidgetQueryVariables>(OrderChatMessagesWidgetDocument, options);
      }
export function useOrderChatMessagesWidgetLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrderChatMessagesWidgetQuery, OrderChatMessagesWidgetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrderChatMessagesWidgetQuery, OrderChatMessagesWidgetQueryVariables>(OrderChatMessagesWidgetDocument, options);
        }
export type OrderChatMessagesWidgetQueryHookResult = ReturnType<typeof useOrderChatMessagesWidgetQuery>;
export type OrderChatMessagesWidgetLazyQueryHookResult = ReturnType<typeof useOrderChatMessagesWidgetLazyQuery>;
export type OrderChatMessagesWidgetQueryResult = Apollo.QueryResult<OrderChatMessagesWidgetQuery, OrderChatMessagesWidgetQueryVariables>;
export const Partner_ReturnAuthorizationChatMessagesWidgetDocument = gql`
    query Partner_ReturnAuthorizationChatMessagesWidget($returnAuthorizationId: ID!) {
  returnAuthorization(id: $returnAuthorizationId) {
    id
    messages {
      pageInfo {
        ...pageInfoFields
      }
      nodes {
        id
        metaCreated
        content
        senderName
      }
    }
  }
}
    ${PageInfoFieldsFragmentDoc}`;

/**
 * __usePartner_ReturnAuthorizationChatMessagesWidgetQuery__
 *
 * To run a query within a React component, call `usePartner_ReturnAuthorizationChatMessagesWidgetQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartner_ReturnAuthorizationChatMessagesWidgetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartner_ReturnAuthorizationChatMessagesWidgetQuery({
 *   variables: {
 *      returnAuthorizationId: // value for 'returnAuthorizationId'
 *   },
 * });
 */
export function usePartner_ReturnAuthorizationChatMessagesWidgetQuery(baseOptions: Apollo.QueryHookOptions<Partner_ReturnAuthorizationChatMessagesWidgetQuery, Partner_ReturnAuthorizationChatMessagesWidgetQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Partner_ReturnAuthorizationChatMessagesWidgetQuery, Partner_ReturnAuthorizationChatMessagesWidgetQueryVariables>(Partner_ReturnAuthorizationChatMessagesWidgetDocument, options);
      }
export function usePartner_ReturnAuthorizationChatMessagesWidgetLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Partner_ReturnAuthorizationChatMessagesWidgetQuery, Partner_ReturnAuthorizationChatMessagesWidgetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Partner_ReturnAuthorizationChatMessagesWidgetQuery, Partner_ReturnAuthorizationChatMessagesWidgetQueryVariables>(Partner_ReturnAuthorizationChatMessagesWidgetDocument, options);
        }
export type Partner_ReturnAuthorizationChatMessagesWidgetQueryHookResult = ReturnType<typeof usePartner_ReturnAuthorizationChatMessagesWidgetQuery>;
export type Partner_ReturnAuthorizationChatMessagesWidgetLazyQueryHookResult = ReturnType<typeof usePartner_ReturnAuthorizationChatMessagesWidgetLazyQuery>;
export type Partner_ReturnAuthorizationChatMessagesWidgetQueryResult = Apollo.QueryResult<Partner_ReturnAuthorizationChatMessagesWidgetQuery, Partner_ReturnAuthorizationChatMessagesWidgetQueryVariables>;
export const GenerateSkuSwapDocument = gql`
    mutation GenerateSkuSwap($input: GenerateSkuSwapInput!) {
  generateSkuSwap(input: $input)
}
    `;
export type GenerateSkuSwapMutationFn = Apollo.MutationFunction<GenerateSkuSwapMutation, GenerateSkuSwapMutationVariables>;

/**
 * __useGenerateSkuSwapMutation__
 *
 * To run a mutation, you first call `useGenerateSkuSwapMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateSkuSwapMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateSkuSwapMutation, { data, loading, error }] = useGenerateSkuSwapMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGenerateSkuSwapMutation(baseOptions?: Apollo.MutationHookOptions<GenerateSkuSwapMutation, GenerateSkuSwapMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateSkuSwapMutation, GenerateSkuSwapMutationVariables>(GenerateSkuSwapDocument, options);
      }
export type GenerateSkuSwapMutationHookResult = ReturnType<typeof useGenerateSkuSwapMutation>;
export type GenerateSkuSwapMutationResult = Apollo.MutationResult<GenerateSkuSwapMutation>;
export type GenerateSkuSwapMutationOptions = Apollo.BaseMutationOptions<GenerateSkuSwapMutation, GenerateSkuSwapMutationVariables>;
export const SkuSwapModalDocument = gql`
    query SkuSwapModal($orderId: ID!) {
  order(id: $orderId) {
    id
    lineItems {
      id
      quantity
      product {
        id
        name
        sku
      }
    }
    itemFulfillment {
      id
      lineItems {
        id
        item {
          id
          sku
        }
        assignments {
          id
          inventoryNumber
        }
      }
    }
  }
}
    `;

/**
 * __useSkuSwapModalQuery__
 *
 * To run a query within a React component, call `useSkuSwapModalQuery` and pass it any options that fit your needs.
 * When your component renders, `useSkuSwapModalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSkuSwapModalQuery({
 *   variables: {
 *      orderId: // value for 'orderId'
 *   },
 * });
 */
export function useSkuSwapModalQuery(baseOptions: Apollo.QueryHookOptions<SkuSwapModalQuery, SkuSwapModalQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SkuSwapModalQuery, SkuSwapModalQueryVariables>(SkuSwapModalDocument, options);
      }
export function useSkuSwapModalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SkuSwapModalQuery, SkuSwapModalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SkuSwapModalQuery, SkuSwapModalQueryVariables>(SkuSwapModalDocument, options);
        }
export type SkuSwapModalQueryHookResult = ReturnType<typeof useSkuSwapModalQuery>;
export type SkuSwapModalLazyQueryHookResult = ReturnType<typeof useSkuSwapModalLazyQuery>;
export type SkuSwapModalQueryResult = Apollo.QueryResult<SkuSwapModalQuery, SkuSwapModalQueryVariables>;
export const AuditLogWidgetDocument = gql`
    query AuditLogWidget($id: ID!, $isQueryingOrder: Boolean!) {
  loggedInUser {
    id
    isSuperAdmin
  }
  order(id: $id) @include(if: $isQueryingOrder) {
    id
    auditLog {
      pageInfo {
        ...pageInfoFields
      }
      nodes {
        id
        metaCreated
        title
        content
        triggeringSiteUser {
          id
          fullName
        }
      }
    }
  }
  returnAuthorization(id: $id) @skip(if: $isQueryingOrder) {
    id
    auditLog {
      pageInfo {
        ...pageInfoFields
      }
      nodes {
        id
        metaCreated
        title
        content
        triggeringSiteUser {
          id
          fullName
        }
      }
    }
  }
}
    ${PageInfoFieldsFragmentDoc}`;

/**
 * __useAuditLogWidgetQuery__
 *
 * To run a query within a React component, call `useAuditLogWidgetQuery` and pass it any options that fit your needs.
 * When your component renders, `useAuditLogWidgetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAuditLogWidgetQuery({
 *   variables: {
 *      id: // value for 'id'
 *      isQueryingOrder: // value for 'isQueryingOrder'
 *   },
 * });
 */
export function useAuditLogWidgetQuery(baseOptions: Apollo.QueryHookOptions<AuditLogWidgetQuery, AuditLogWidgetQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AuditLogWidgetQuery, AuditLogWidgetQueryVariables>(AuditLogWidgetDocument, options);
      }
export function useAuditLogWidgetLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AuditLogWidgetQuery, AuditLogWidgetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AuditLogWidgetQuery, AuditLogWidgetQueryVariables>(AuditLogWidgetDocument, options);
        }
export type AuditLogWidgetQueryHookResult = ReturnType<typeof useAuditLogWidgetQuery>;
export type AuditLogWidgetLazyQueryHookResult = ReturnType<typeof useAuditLogWidgetLazyQuery>;
export type AuditLogWidgetQueryResult = Apollo.QueryResult<AuditLogWidgetQuery, AuditLogWidgetQueryVariables>;
export const SendGridEmailLogWidgetDocument = gql`
    query SendGridEmailLogWidget($options: QuerySendGridEmailRequestsOptionsInput!) {
  sendGridEmailRequests(options: $options) {
    nodes {
      id
      orderId
      returnAuthorizationId
      createdAt
      errorReason
      appEvent {
        name
        displayName
      }
      recipientEmails
      status {
        id
        name
        displayName
      }
    }
    pageInfo {
      ...pageInfoFields
    }
  }
}
    ${PageInfoFieldsFragmentDoc}`;

/**
 * __useSendGridEmailLogWidgetQuery__
 *
 * To run a query within a React component, call `useSendGridEmailLogWidgetQuery` and pass it any options that fit your needs.
 * When your component renders, `useSendGridEmailLogWidgetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSendGridEmailLogWidgetQuery({
 *   variables: {
 *      options: // value for 'options'
 *   },
 * });
 */
export function useSendGridEmailLogWidgetQuery(baseOptions: Apollo.QueryHookOptions<SendGridEmailLogWidgetQuery, SendGridEmailLogWidgetQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SendGridEmailLogWidgetQuery, SendGridEmailLogWidgetQueryVariables>(SendGridEmailLogWidgetDocument, options);
      }
export function useSendGridEmailLogWidgetLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SendGridEmailLogWidgetQuery, SendGridEmailLogWidgetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SendGridEmailLogWidgetQuery, SendGridEmailLogWidgetQueryVariables>(SendGridEmailLogWidgetDocument, options);
        }
export type SendGridEmailLogWidgetQueryHookResult = ReturnType<typeof useSendGridEmailLogWidgetQuery>;
export type SendGridEmailLogWidgetLazyQueryHookResult = ReturnType<typeof useSendGridEmailLogWidgetLazyQuery>;
export type SendGridEmailLogWidgetQueryResult = Apollo.QueryResult<SendGridEmailLogWidgetQuery, SendGridEmailLogWidgetQueryVariables>;
export const AppleCareWidgetDocument = gql`
    query AppleCareWidget($orderId: ID!) {
  order(id: $orderId) {
    id
    lineItems {
      id
      appleCareAgreement {
        id
        expiresAt
        agreementNumber
        serialNumber
      }
    }
  }
}
    `;

/**
 * __useAppleCareWidgetQuery__
 *
 * To run a query within a React component, call `useAppleCareWidgetQuery` and pass it any options that fit your needs.
 * When your component renders, `useAppleCareWidgetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAppleCareWidgetQuery({
 *   variables: {
 *      orderId: // value for 'orderId'
 *   },
 * });
 */
export function useAppleCareWidgetQuery(baseOptions: Apollo.QueryHookOptions<AppleCareWidgetQuery, AppleCareWidgetQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AppleCareWidgetQuery, AppleCareWidgetQueryVariables>(AppleCareWidgetDocument, options);
      }
export function useAppleCareWidgetLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AppleCareWidgetQuery, AppleCareWidgetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AppleCareWidgetQuery, AppleCareWidgetQueryVariables>(AppleCareWidgetDocument, options);
        }
export type AppleCareWidgetQueryHookResult = ReturnType<typeof useAppleCareWidgetQuery>;
export type AppleCareWidgetLazyQueryHookResult = ReturnType<typeof useAppleCareWidgetLazyQuery>;
export type AppleCareWidgetQueryResult = Apollo.QueryResult<AppleCareWidgetQuery, AppleCareWidgetQueryVariables>;
export const CustomerInformationWidgetDocument = gql`
    query CustomerInformationWidget($orderId: ID!) {
  order(id: $orderId) {
    id
    customer {
      id
      email
      firstName
      lastName
      phoneNumber
    }
    billingAddress {
      addressee
      street1
      street2
      city
      usState
      postalCode
      countryCode
      company
      phone
    }
    shippingAddress {
      addressee
      street1
      street2
      city
      usState
      postalCode
      countryCode
      company
      phone
    }
  }
}
    `;

/**
 * __useCustomerInformationWidgetQuery__
 *
 * To run a query within a React component, call `useCustomerInformationWidgetQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomerInformationWidgetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomerInformationWidgetQuery({
 *   variables: {
 *      orderId: // value for 'orderId'
 *   },
 * });
 */
export function useCustomerInformationWidgetQuery(baseOptions: Apollo.QueryHookOptions<CustomerInformationWidgetQuery, CustomerInformationWidgetQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CustomerInformationWidgetQuery, CustomerInformationWidgetQueryVariables>(CustomerInformationWidgetDocument, options);
      }
export function useCustomerInformationWidgetLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CustomerInformationWidgetQuery, CustomerInformationWidgetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CustomerInformationWidgetQuery, CustomerInformationWidgetQueryVariables>(CustomerInformationWidgetDocument, options);
        }
export type CustomerInformationWidgetQueryHookResult = ReturnType<typeof useCustomerInformationWidgetQuery>;
export type CustomerInformationWidgetLazyQueryHookResult = ReturnType<typeof useCustomerInformationWidgetLazyQuery>;
export type CustomerInformationWidgetQueryResult = Apollo.QueryResult<CustomerInformationWidgetQuery, CustomerInformationWidgetQueryVariables>;
export const EditOrderModalDocument = gql`
    query EditOrderModal($orderId: ID!) {
  order(id: $orderId) {
    id
    orderNumber
    customer {
      id
    }
    billingAddress {
      addressee
      street1
      street2
      city
      usState
      postalCode
      countryCode
      company
      phone
    }
    shippingAddress {
      addressee
      street1
      street2
      city
      usState
      postalCode
      countryCode
      company
      phone
    }
  }
}
    `;

/**
 * __useEditOrderModalQuery__
 *
 * To run a query within a React component, call `useEditOrderModalQuery` and pass it any options that fit your needs.
 * When your component renders, `useEditOrderModalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEditOrderModalQuery({
 *   variables: {
 *      orderId: // value for 'orderId'
 *   },
 * });
 */
export function useEditOrderModalQuery(baseOptions: Apollo.QueryHookOptions<EditOrderModalQuery, EditOrderModalQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EditOrderModalQuery, EditOrderModalQueryVariables>(EditOrderModalDocument, options);
      }
export function useEditOrderModalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EditOrderModalQuery, EditOrderModalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EditOrderModalQuery, EditOrderModalQueryVariables>(EditOrderModalDocument, options);
        }
export type EditOrderModalQueryHookResult = ReturnType<typeof useEditOrderModalQuery>;
export type EditOrderModalLazyQueryHookResult = ReturnType<typeof useEditOrderModalLazyQuery>;
export type EditOrderModalQueryResult = Apollo.QueryResult<EditOrderModalQuery, EditOrderModalQueryVariables>;
export const SaveOrderDocument = gql`
    mutation SaveOrder($input: SaveSalesOrderInput!) {
  saveOrder(input: $input) {
    id
    billingAddress {
      addressee
      street1
      street2
      city
      usState
      postalCode
      countryCode
      company
      phone
    }
    shippingAddress {
      addressee
      street1
      street2
      city
      usState
      postalCode
      countryCode
      company
      phone
    }
  }
}
    `;
export type SaveOrderMutationFn = Apollo.MutationFunction<SaveOrderMutation, SaveOrderMutationVariables>;

/**
 * __useSaveOrderMutation__
 *
 * To run a mutation, you first call `useSaveOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveOrderMutation, { data, loading, error }] = useSaveOrderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveOrderMutation(baseOptions?: Apollo.MutationHookOptions<SaveOrderMutation, SaveOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveOrderMutation, SaveOrderMutationVariables>(SaveOrderDocument, options);
      }
export type SaveOrderMutationHookResult = ReturnType<typeof useSaveOrderMutation>;
export type SaveOrderMutationResult = Apollo.MutationResult<SaveOrderMutation>;
export type SaveOrderMutationOptions = Apollo.BaseMutationOptions<SaveOrderMutation, SaveOrderMutationVariables>;
export const ApiRequestModalDocument = gql`
    query ApiRequestModal($orderId: ID!) {
  order(id: $orderId) {
    id
    fulfillment {
      id
    }
  }
}
    `;

/**
 * __useApiRequestModalQuery__
 *
 * To run a query within a React component, call `useApiRequestModalQuery` and pass it any options that fit your needs.
 * When your component renders, `useApiRequestModalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useApiRequestModalQuery({
 *   variables: {
 *      orderId: // value for 'orderId'
 *   },
 * });
 */
export function useApiRequestModalQuery(baseOptions: Apollo.QueryHookOptions<ApiRequestModalQuery, ApiRequestModalQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ApiRequestModalQuery, ApiRequestModalQueryVariables>(ApiRequestModalDocument, options);
      }
export function useApiRequestModalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ApiRequestModalQuery, ApiRequestModalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ApiRequestModalQuery, ApiRequestModalQueryVariables>(ApiRequestModalDocument, options);
        }
export type ApiRequestModalQueryHookResult = ReturnType<typeof useApiRequestModalQuery>;
export type ApiRequestModalLazyQueryHookResult = ReturnType<typeof useApiRequestModalLazyQuery>;
export type ApiRequestModalQueryResult = Apollo.QueryResult<ApiRequestModalQuery, ApiRequestModalQueryVariables>;
export const Customer_FulfillmentStatusWidgetDocument = gql`
    query Customer_FulfillmentStatusWidget($orderId: ID!) {
  orderLite(input: {id: $orderId}) {
    id
    lifeCycle {
      label
      approvalType
      completedOn
    }
  }
}
    `;

/**
 * __useCustomer_FulfillmentStatusWidgetQuery__
 *
 * To run a query within a React component, call `useCustomer_FulfillmentStatusWidgetQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomer_FulfillmentStatusWidgetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomer_FulfillmentStatusWidgetQuery({
 *   variables: {
 *      orderId: // value for 'orderId'
 *   },
 * });
 */
export function useCustomer_FulfillmentStatusWidgetQuery(baseOptions: Apollo.QueryHookOptions<Customer_FulfillmentStatusWidgetQuery, Customer_FulfillmentStatusWidgetQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Customer_FulfillmentStatusWidgetQuery, Customer_FulfillmentStatusWidgetQueryVariables>(Customer_FulfillmentStatusWidgetDocument, options);
      }
export function useCustomer_FulfillmentStatusWidgetLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Customer_FulfillmentStatusWidgetQuery, Customer_FulfillmentStatusWidgetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Customer_FulfillmentStatusWidgetQuery, Customer_FulfillmentStatusWidgetQueryVariables>(Customer_FulfillmentStatusWidgetDocument, options);
        }
export type Customer_FulfillmentStatusWidgetQueryHookResult = ReturnType<typeof useCustomer_FulfillmentStatusWidgetQuery>;
export type Customer_FulfillmentStatusWidgetLazyQueryHookResult = ReturnType<typeof useCustomer_FulfillmentStatusWidgetLazyQuery>;
export type Customer_FulfillmentStatusWidgetQueryResult = Apollo.QueryResult<Customer_FulfillmentStatusWidgetQuery, Customer_FulfillmentStatusWidgetQueryVariables>;
export const Partner_FulfillmentStatusWidgetDocument = gql`
    query Partner_FulfillmentStatusWidget($orderId: ID!) {
  order(id: $orderId) {
    id
    lifeCycle {
      label
      approvalType
      completedOn
    }
  }
}
    `;

/**
 * __usePartner_FulfillmentStatusWidgetQuery__
 *
 * To run a query within a React component, call `usePartner_FulfillmentStatusWidgetQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartner_FulfillmentStatusWidgetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartner_FulfillmentStatusWidgetQuery({
 *   variables: {
 *      orderId: // value for 'orderId'
 *   },
 * });
 */
export function usePartner_FulfillmentStatusWidgetQuery(baseOptions: Apollo.QueryHookOptions<Partner_FulfillmentStatusWidgetQuery, Partner_FulfillmentStatusWidgetQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Partner_FulfillmentStatusWidgetQuery, Partner_FulfillmentStatusWidgetQueryVariables>(Partner_FulfillmentStatusWidgetDocument, options);
      }
export function usePartner_FulfillmentStatusWidgetLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Partner_FulfillmentStatusWidgetQuery, Partner_FulfillmentStatusWidgetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Partner_FulfillmentStatusWidgetQuery, Partner_FulfillmentStatusWidgetQueryVariables>(Partner_FulfillmentStatusWidgetDocument, options);
        }
export type Partner_FulfillmentStatusWidgetQueryHookResult = ReturnType<typeof usePartner_FulfillmentStatusWidgetQuery>;
export type Partner_FulfillmentStatusWidgetLazyQueryHookResult = ReturnType<typeof usePartner_FulfillmentStatusWidgetLazyQuery>;
export type Partner_FulfillmentStatusWidgetQueryResult = Apollo.QueryResult<Partner_FulfillmentStatusWidgetQuery, Partner_FulfillmentStatusWidgetQueryVariables>;
export const ItemFulfillmentWidgetDocument = gql`
    query ItemFulfillmentWidget($orderId: ID!) {
  order(id: $orderId) {
    id
    lineItems {
      id
      product {
        id
        sku
      }
      swaps {
        id
        quantity
        product {
          id
          sku
        }
      }
    }
    itemFulfillment {
      id
      lineItems {
        id
        quantity
        item {
          id
          sku
        }
        assignments {
          id
          inventoryNumber
        }
      }
    }
  }
}
    `;

/**
 * __useItemFulfillmentWidgetQuery__
 *
 * To run a query within a React component, call `useItemFulfillmentWidgetQuery` and pass it any options that fit your needs.
 * When your component renders, `useItemFulfillmentWidgetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useItemFulfillmentWidgetQuery({
 *   variables: {
 *      orderId: // value for 'orderId'
 *   },
 * });
 */
export function useItemFulfillmentWidgetQuery(baseOptions: Apollo.QueryHookOptions<ItemFulfillmentWidgetQuery, ItemFulfillmentWidgetQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ItemFulfillmentWidgetQuery, ItemFulfillmentWidgetQueryVariables>(ItemFulfillmentWidgetDocument, options);
      }
export function useItemFulfillmentWidgetLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ItemFulfillmentWidgetQuery, ItemFulfillmentWidgetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ItemFulfillmentWidgetQuery, ItemFulfillmentWidgetQueryVariables>(ItemFulfillmentWidgetDocument, options);
        }
export type ItemFulfillmentWidgetQueryHookResult = ReturnType<typeof useItemFulfillmentWidgetQuery>;
export type ItemFulfillmentWidgetLazyQueryHookResult = ReturnType<typeof useItemFulfillmentWidgetLazyQuery>;
export type ItemFulfillmentWidgetQueryResult = Apollo.QueryResult<ItemFulfillmentWidgetQuery, ItemFulfillmentWidgetQueryVariables>;
export const NetSuiteEligibilityDetailsDocument = gql`
    query NetSuiteEligibilityDetails($orderId: ID!) {
  netSuiteEligibilityDetails(orderId: $orderId) {
    orderId
    orderNumber
    customerInNetSuite
    customerEmail
    customerMissingReason
    allProductsInNetSuite
    missingProducts {
      sku
      name
      productId
    }
    hasShippingService
    requestedShippingService
    shippingServiceMissingReason
    storeHasDepartment
    storeHasLocation
    storeHasTaxItem
    storeMissingReason
    hasMappedPaymentMethod
    rawPaymentMethod
    paymentMethodMissingReason
    discountItemsSynced
    missingDiscountItems {
      discountItemId
      discountType
      rate
    }
    writeRequestGenerated
    orderInNetSuite
  }
  order(id: $orderId) {
    id
    netSuiteWriteRequest {
      id
      validationErrors
    }
    customer {
      id
      netSuiteWriteRequest {
        id
        validationErrors
      }
    }
  }
}
    `;

/**
 * __useNetSuiteEligibilityDetailsQuery__
 *
 * To run a query within a React component, call `useNetSuiteEligibilityDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useNetSuiteEligibilityDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNetSuiteEligibilityDetailsQuery({
 *   variables: {
 *      orderId: // value for 'orderId'
 *   },
 * });
 */
export function useNetSuiteEligibilityDetailsQuery(baseOptions: Apollo.QueryHookOptions<NetSuiteEligibilityDetailsQuery, NetSuiteEligibilityDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NetSuiteEligibilityDetailsQuery, NetSuiteEligibilityDetailsQueryVariables>(NetSuiteEligibilityDetailsDocument, options);
      }
export function useNetSuiteEligibilityDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NetSuiteEligibilityDetailsQuery, NetSuiteEligibilityDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NetSuiteEligibilityDetailsQuery, NetSuiteEligibilityDetailsQueryVariables>(NetSuiteEligibilityDetailsDocument, options);
        }
export type NetSuiteEligibilityDetailsQueryHookResult = ReturnType<typeof useNetSuiteEligibilityDetailsQuery>;
export type NetSuiteEligibilityDetailsLazyQueryHookResult = ReturnType<typeof useNetSuiteEligibilityDetailsLazyQuery>;
export type NetSuiteEligibilityDetailsQueryResult = Apollo.QueryResult<NetSuiteEligibilityDetailsQuery, NetSuiteEligibilityDetailsQueryVariables>;
export const SyncOrderToNetSuiteDocument = gql`
    mutation SyncOrderToNetSuite($orderId: ID!) {
  syncOrderToNetSuite(orderId: $orderId)
}
    `;
export type SyncOrderToNetSuiteMutationFn = Apollo.MutationFunction<SyncOrderToNetSuiteMutation, SyncOrderToNetSuiteMutationVariables>;

/**
 * __useSyncOrderToNetSuiteMutation__
 *
 * To run a mutation, you first call `useSyncOrderToNetSuiteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSyncOrderToNetSuiteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [syncOrderToNetSuiteMutation, { data, loading, error }] = useSyncOrderToNetSuiteMutation({
 *   variables: {
 *      orderId: // value for 'orderId'
 *   },
 * });
 */
export function useSyncOrderToNetSuiteMutation(baseOptions?: Apollo.MutationHookOptions<SyncOrderToNetSuiteMutation, SyncOrderToNetSuiteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SyncOrderToNetSuiteMutation, SyncOrderToNetSuiteMutationVariables>(SyncOrderToNetSuiteDocument, options);
      }
export type SyncOrderToNetSuiteMutationHookResult = ReturnType<typeof useSyncOrderToNetSuiteMutation>;
export type SyncOrderToNetSuiteMutationResult = Apollo.MutationResult<SyncOrderToNetSuiteMutation>;
export type SyncOrderToNetSuiteMutationOptions = Apollo.BaseMutationOptions<SyncOrderToNetSuiteMutation, SyncOrderToNetSuiteMutationVariables>;
export const CloseOrderDocument = gql`
    mutation CloseOrder($orderId: ID!) {
  closeOrder(orderId: $orderId) {
    id
    status {
      id
      name
      displayName
    }
  }
}
    `;
export type CloseOrderMutationFn = Apollo.MutationFunction<CloseOrderMutation, CloseOrderMutationVariables>;

/**
 * __useCloseOrderMutation__
 *
 * To run a mutation, you first call `useCloseOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCloseOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [closeOrderMutation, { data, loading, error }] = useCloseOrderMutation({
 *   variables: {
 *      orderId: // value for 'orderId'
 *   },
 * });
 */
export function useCloseOrderMutation(baseOptions?: Apollo.MutationHookOptions<CloseOrderMutation, CloseOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CloseOrderMutation, CloseOrderMutationVariables>(CloseOrderDocument, options);
      }
export type CloseOrderMutationHookResult = ReturnType<typeof useCloseOrderMutation>;
export type CloseOrderMutationResult = Apollo.MutationResult<CloseOrderMutation>;
export type CloseOrderMutationOptions = Apollo.BaseMutationOptions<CloseOrderMutation, CloseOrderMutationVariables>;
export const OrderSourceInformationWidgetDocument = gql`
    query OrderSourceInformationWidget($orderId: ID!) {
  loggedInUser {
    id
    isSuperAdmin
  }
  order(id: $orderId) {
    id
    urlToStoreRecord
    orderNumber
    customer {
      id
      email
    }
    netSuiteRecord {
      recordUrl
    }
    overallOrderStatus {
      id
      name
      displayName
    }
    status {
      id
      name
      displayName
    }
    e1DocumentIndex {
      id
      urlToE1Record
    }
    store {
      id
      type {
        id
        name
        displayName
      }
    }
  }
}
    `;

/**
 * __useOrderSourceInformationWidgetQuery__
 *
 * To run a query within a React component, call `useOrderSourceInformationWidgetQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrderSourceInformationWidgetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrderSourceInformationWidgetQuery({
 *   variables: {
 *      orderId: // value for 'orderId'
 *   },
 * });
 */
export function useOrderSourceInformationWidgetQuery(baseOptions: Apollo.QueryHookOptions<OrderSourceInformationWidgetQuery, OrderSourceInformationWidgetQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrderSourceInformationWidgetQuery, OrderSourceInformationWidgetQueryVariables>(OrderSourceInformationWidgetDocument, options);
      }
export function useOrderSourceInformationWidgetLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrderSourceInformationWidgetQuery, OrderSourceInformationWidgetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrderSourceInformationWidgetQuery, OrderSourceInformationWidgetQueryVariables>(OrderSourceInformationWidgetDocument, options);
        }
export type OrderSourceInformationWidgetQueryHookResult = ReturnType<typeof useOrderSourceInformationWidgetQuery>;
export type OrderSourceInformationWidgetLazyQueryHookResult = ReturnType<typeof useOrderSourceInformationWidgetLazyQuery>;
export type OrderSourceInformationWidgetQueryResult = Apollo.QueryResult<OrderSourceInformationWidgetQuery, OrderSourceInformationWidgetQueryVariables>;
export const CloseOrderAsCustomerDocument = gql`
    mutation CloseOrderAsCustomer($orderId: ID!) {
  closeOrderAsCustomer(orderId: $orderId) {
    id
  }
}
    `;
export type CloseOrderAsCustomerMutationFn = Apollo.MutationFunction<CloseOrderAsCustomerMutation, CloseOrderAsCustomerMutationVariables>;

/**
 * __useCloseOrderAsCustomerMutation__
 *
 * To run a mutation, you first call `useCloseOrderAsCustomerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCloseOrderAsCustomerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [closeOrderAsCustomerMutation, { data, loading, error }] = useCloseOrderAsCustomerMutation({
 *   variables: {
 *      orderId: // value for 'orderId'
 *   },
 * });
 */
export function useCloseOrderAsCustomerMutation(baseOptions?: Apollo.MutationHookOptions<CloseOrderAsCustomerMutation, CloseOrderAsCustomerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CloseOrderAsCustomerMutation, CloseOrderAsCustomerMutationVariables>(CloseOrderAsCustomerDocument, options);
      }
export type CloseOrderAsCustomerMutationHookResult = ReturnType<typeof useCloseOrderAsCustomerMutation>;
export type CloseOrderAsCustomerMutationResult = Apollo.MutationResult<CloseOrderAsCustomerMutation>;
export type CloseOrderAsCustomerMutationOptions = Apollo.BaseMutationOptions<CloseOrderAsCustomerMutation, CloseOrderAsCustomerMutationVariables>;
export const PartnerActionsWidgetDocument = gql`
    query PartnerActionsWidget($orderId: ID!) {
  loggedInUser {
    id
    isSuperAdmin
  }
  canInitiateReturnAuthorization(orderId: $orderId)
  canCloseOrder(orderId: $orderId)
  order(id: $orderId) {
    id
    status {
      id
      name
      displayName
    }
    returnAuthorizations {
      pageInfo {
        ...pageInfoFields
      }
      nodes {
        id
      }
    }
  }
}
    ${PageInfoFieldsFragmentDoc}`;

/**
 * __usePartnerActionsWidgetQuery__
 *
 * To run a query within a React component, call `usePartnerActionsWidgetQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerActionsWidgetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerActionsWidgetQuery({
 *   variables: {
 *      orderId: // value for 'orderId'
 *   },
 * });
 */
export function usePartnerActionsWidgetQuery(baseOptions: Apollo.QueryHookOptions<PartnerActionsWidgetQuery, PartnerActionsWidgetQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PartnerActionsWidgetQuery, PartnerActionsWidgetQueryVariables>(PartnerActionsWidgetDocument, options);
      }
export function usePartnerActionsWidgetLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PartnerActionsWidgetQuery, PartnerActionsWidgetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PartnerActionsWidgetQuery, PartnerActionsWidgetQueryVariables>(PartnerActionsWidgetDocument, options);
        }
export type PartnerActionsWidgetQueryHookResult = ReturnType<typeof usePartnerActionsWidgetQuery>;
export type PartnerActionsWidgetLazyQueryHookResult = ReturnType<typeof usePartnerActionsWidgetLazyQuery>;
export type PartnerActionsWidgetQueryResult = Apollo.QueryResult<PartnerActionsWidgetQuery, PartnerActionsWidgetQueryVariables>;
export const PaymentInformationWidgetDocument = gql`
    query PaymentInformationWidget($orderId: ID!) {
  orderLite(input: {id: $orderId}) {
    id
    shippingTotalCents
    taxTotalCents
    totalCents
    feeTotalCents
    discountTotalCents
    lineItems {
      id
      quantity
      itemTotalCents
      taxTotalCents
    }
    paymentMethod {
      id
      name
      displayName
    }
  }
}
    `;

/**
 * __usePaymentInformationWidgetQuery__
 *
 * To run a query within a React component, call `usePaymentInformationWidgetQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaymentInformationWidgetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaymentInformationWidgetQuery({
 *   variables: {
 *      orderId: // value for 'orderId'
 *   },
 * });
 */
export function usePaymentInformationWidgetQuery(baseOptions: Apollo.QueryHookOptions<PaymentInformationWidgetQuery, PaymentInformationWidgetQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PaymentInformationWidgetQuery, PaymentInformationWidgetQueryVariables>(PaymentInformationWidgetDocument, options);
      }
export function usePaymentInformationWidgetLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PaymentInformationWidgetQuery, PaymentInformationWidgetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PaymentInformationWidgetQuery, PaymentInformationWidgetQueryVariables>(PaymentInformationWidgetDocument, options);
        }
export type PaymentInformationWidgetQueryHookResult = ReturnType<typeof usePaymentInformationWidgetQuery>;
export type PaymentInformationWidgetLazyQueryHookResult = ReturnType<typeof usePaymentInformationWidgetLazyQuery>;
export type PaymentInformationWidgetQueryResult = Apollo.QueryResult<PaymentInformationWidgetQuery, PaymentInformationWidgetQueryVariables>;
export const ProductInformationWidgetDocument = gql`
    query ProductInformationWidget($orderId: ID!) {
  order(id: $orderId) {
    id
    totalCents
    feeLines {
      id
      name
      subtotalCents
      taxTotalCents
    }
    shippingLines {
      id
      name
      subtotalCents
      taxTotalCents
    }
    lineItems {
      id
      itemTotalCents
      taxTotalCents
      feeTotalCents
      discountTotalCents
      refundAmountCents
      quantity
      product {
        id
        name
        sku
      }
    }
  }
}
    `;

/**
 * __useProductInformationWidgetQuery__
 *
 * To run a query within a React component, call `useProductInformationWidgetQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductInformationWidgetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductInformationWidgetQuery({
 *   variables: {
 *      orderId: // value for 'orderId'
 *   },
 * });
 */
export function useProductInformationWidgetQuery(baseOptions: Apollo.QueryHookOptions<ProductInformationWidgetQuery, ProductInformationWidgetQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductInformationWidgetQuery, ProductInformationWidgetQueryVariables>(ProductInformationWidgetDocument, options);
      }
export function useProductInformationWidgetLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductInformationWidgetQuery, ProductInformationWidgetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductInformationWidgetQuery, ProductInformationWidgetQueryVariables>(ProductInformationWidgetDocument, options);
        }
export type ProductInformationWidgetQueryHookResult = ReturnType<typeof useProductInformationWidgetQuery>;
export type ProductInformationWidgetLazyQueryHookResult = ReturnType<typeof useProductInformationWidgetLazyQuery>;
export type ProductInformationWidgetQueryResult = Apollo.QueryResult<ProductInformationWidgetQuery, ProductInformationWidgetQueryVariables>;
export const ShippingInformationWidgetDocument = gql`
    query ShippingInformationWidget($orderId: ID!) {
  orderLite(input: {id: $orderId}) {
    id
    shippingAddress {
      street1
      street2
      city
      usState
      postalCode
    }
    shipment {
      id
      serviceCode
      carrierCode
      trackingNumber
      trackingUrl
    }
  }
}
    `;

/**
 * __useShippingInformationWidgetQuery__
 *
 * To run a query within a React component, call `useShippingInformationWidgetQuery` and pass it any options that fit your needs.
 * When your component renders, `useShippingInformationWidgetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useShippingInformationWidgetQuery({
 *   variables: {
 *      orderId: // value for 'orderId'
 *   },
 * });
 */
export function useShippingInformationWidgetQuery(baseOptions: Apollo.QueryHookOptions<ShippingInformationWidgetQuery, ShippingInformationWidgetQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ShippingInformationWidgetQuery, ShippingInformationWidgetQueryVariables>(ShippingInformationWidgetDocument, options);
      }
export function useShippingInformationWidgetLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ShippingInformationWidgetQuery, ShippingInformationWidgetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ShippingInformationWidgetQuery, ShippingInformationWidgetQueryVariables>(ShippingInformationWidgetDocument, options);
        }
export type ShippingInformationWidgetQueryHookResult = ReturnType<typeof useShippingInformationWidgetQuery>;
export type ShippingInformationWidgetLazyQueryHookResult = ReturnType<typeof useShippingInformationWidgetLazyQuery>;
export type ShippingInformationWidgetQueryResult = Apollo.QueryResult<ShippingInformationWidgetQuery, ShippingInformationWidgetQueryVariables>;
export const DeleteReturnAuthorizationDocument = gql`
    mutation DeleteReturnAuthorization($returnAuthorizationId: ID!) {
  deleteReturnAuthorization(id: $returnAuthorizationId)
}
    `;
export type DeleteReturnAuthorizationMutationFn = Apollo.MutationFunction<DeleteReturnAuthorizationMutation, DeleteReturnAuthorizationMutationVariables>;

/**
 * __useDeleteReturnAuthorizationMutation__
 *
 * To run a mutation, you first call `useDeleteReturnAuthorizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteReturnAuthorizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteReturnAuthorizationMutation, { data, loading, error }] = useDeleteReturnAuthorizationMutation({
 *   variables: {
 *      returnAuthorizationId: // value for 'returnAuthorizationId'
 *   },
 * });
 */
export function useDeleteReturnAuthorizationMutation(baseOptions?: Apollo.MutationHookOptions<DeleteReturnAuthorizationMutation, DeleteReturnAuthorizationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteReturnAuthorizationMutation, DeleteReturnAuthorizationMutationVariables>(DeleteReturnAuthorizationDocument, options);
      }
export type DeleteReturnAuthorizationMutationHookResult = ReturnType<typeof useDeleteReturnAuthorizationMutation>;
export type DeleteReturnAuthorizationMutationResult = Apollo.MutationResult<DeleteReturnAuthorizationMutation>;
export type DeleteReturnAuthorizationMutationOptions = Apollo.BaseMutationOptions<DeleteReturnAuthorizationMutation, DeleteReturnAuthorizationMutationVariables>;
export const GenerateReturnLabelDocument = gql`
    mutation GenerateReturnLabel($input: GenerateReturnLabelInput!) {
  generateReturnLabel(input: $input) {
    id
    shipment {
      id
    }
  }
}
    `;
export type GenerateReturnLabelMutationFn = Apollo.MutationFunction<GenerateReturnLabelMutation, GenerateReturnLabelMutationVariables>;

/**
 * __useGenerateReturnLabelMutation__
 *
 * To run a mutation, you first call `useGenerateReturnLabelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateReturnLabelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateReturnLabelMutation, { data, loading, error }] = useGenerateReturnLabelMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGenerateReturnLabelMutation(baseOptions?: Apollo.MutationHookOptions<GenerateReturnLabelMutation, GenerateReturnLabelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateReturnLabelMutation, GenerateReturnLabelMutationVariables>(GenerateReturnLabelDocument, options);
      }
export type GenerateReturnLabelMutationHookResult = ReturnType<typeof useGenerateReturnLabelMutation>;
export type GenerateReturnLabelMutationResult = Apollo.MutationResult<GenerateReturnLabelMutation>;
export type GenerateReturnLabelMutationOptions = Apollo.BaseMutationOptions<GenerateReturnLabelMutation, GenerateReturnLabelMutationVariables>;
export const InitiateRefundDocument = gql`
    mutation InitiateRefund($input: InitiateRefundInput!) {
  initiateRefund(input: $input) {
    id
  }
}
    `;
export type InitiateRefundMutationFn = Apollo.MutationFunction<InitiateRefundMutation, InitiateRefundMutationVariables>;

/**
 * __useInitiateRefundMutation__
 *
 * To run a mutation, you first call `useInitiateRefundMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInitiateRefundMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [initiateRefundMutation, { data, loading, error }] = useInitiateRefundMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useInitiateRefundMutation(baseOptions?: Apollo.MutationHookOptions<InitiateRefundMutation, InitiateRefundMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InitiateRefundMutation, InitiateRefundMutationVariables>(InitiateRefundDocument, options);
      }
export type InitiateRefundMutationHookResult = ReturnType<typeof useInitiateRefundMutation>;
export type InitiateRefundMutationResult = Apollo.MutationResult<InitiateRefundMutation>;
export type InitiateRefundMutationOptions = Apollo.BaseMutationOptions<InitiateRefundMutation, InitiateRefundMutationVariables>;
export const ReverseReturnAuthorizationRefundDenialDecisionDocument = gql`
    mutation ReverseReturnAuthorizationRefundDenialDecision($returnAuthorizationId: ID!) {
  reverseReturnAuthorizationRefundDenialDecision(
    returnAuthorizationId: $returnAuthorizationId
  ) {
    id
    refund {
      id
    }
  }
}
    `;
export type ReverseReturnAuthorizationRefundDenialDecisionMutationFn = Apollo.MutationFunction<ReverseReturnAuthorizationRefundDenialDecisionMutation, ReverseReturnAuthorizationRefundDenialDecisionMutationVariables>;

/**
 * __useReverseReturnAuthorizationRefundDenialDecisionMutation__
 *
 * To run a mutation, you first call `useReverseReturnAuthorizationRefundDenialDecisionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReverseReturnAuthorizationRefundDenialDecisionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reverseReturnAuthorizationRefundDenialDecisionMutation, { data, loading, error }] = useReverseReturnAuthorizationRefundDenialDecisionMutation({
 *   variables: {
 *      returnAuthorizationId: // value for 'returnAuthorizationId'
 *   },
 * });
 */
export function useReverseReturnAuthorizationRefundDenialDecisionMutation(baseOptions?: Apollo.MutationHookOptions<ReverseReturnAuthorizationRefundDenialDecisionMutation, ReverseReturnAuthorizationRefundDenialDecisionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReverseReturnAuthorizationRefundDenialDecisionMutation, ReverseReturnAuthorizationRefundDenialDecisionMutationVariables>(ReverseReturnAuthorizationRefundDenialDecisionDocument, options);
      }
export type ReverseReturnAuthorizationRefundDenialDecisionMutationHookResult = ReturnType<typeof useReverseReturnAuthorizationRefundDenialDecisionMutation>;
export type ReverseReturnAuthorizationRefundDenialDecisionMutationResult = Apollo.MutationResult<ReverseReturnAuthorizationRefundDenialDecisionMutation>;
export type ReverseReturnAuthorizationRefundDenialDecisionMutationOptions = Apollo.BaseMutationOptions<ReverseReturnAuthorizationRefundDenialDecisionMutation, ReverseReturnAuthorizationRefundDenialDecisionMutationVariables>;
export const Partner_ReturnAuthorizationActionsWidgetDocument = gql`
    query Partner_ReturnAuthorizationActionsWidget($returnAuthorizationId: ID!) {
  loggedInUser {
    id
  }
  canDeleteReturnAuthorization(id: $returnAuthorizationId)
  returnAuthorization(id: $returnAuthorizationId) {
    id
    order {
      id
    }
    store {
      id
      type {
        id
        name
        displayName
      }
    }
    itemReceipt {
      id
    }
    approval {
      id
      approvalType {
        id
        name
        displayName
      }
    }
    acceptance {
      id
      approvalType {
        id
        name
        displayName
      }
    }
    refund {
      id
      approvalType {
        id
        name
        displayName
      }
    }
    shipment {
      id
      labelUrl
    }
  }
}
    `;

/**
 * __usePartner_ReturnAuthorizationActionsWidgetQuery__
 *
 * To run a query within a React component, call `usePartner_ReturnAuthorizationActionsWidgetQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartner_ReturnAuthorizationActionsWidgetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartner_ReturnAuthorizationActionsWidgetQuery({
 *   variables: {
 *      returnAuthorizationId: // value for 'returnAuthorizationId'
 *   },
 * });
 */
export function usePartner_ReturnAuthorizationActionsWidgetQuery(baseOptions: Apollo.QueryHookOptions<Partner_ReturnAuthorizationActionsWidgetQuery, Partner_ReturnAuthorizationActionsWidgetQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Partner_ReturnAuthorizationActionsWidgetQuery, Partner_ReturnAuthorizationActionsWidgetQueryVariables>(Partner_ReturnAuthorizationActionsWidgetDocument, options);
      }
export function usePartner_ReturnAuthorizationActionsWidgetLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Partner_ReturnAuthorizationActionsWidgetQuery, Partner_ReturnAuthorizationActionsWidgetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Partner_ReturnAuthorizationActionsWidgetQuery, Partner_ReturnAuthorizationActionsWidgetQueryVariables>(Partner_ReturnAuthorizationActionsWidgetDocument, options);
        }
export type Partner_ReturnAuthorizationActionsWidgetQueryHookResult = ReturnType<typeof usePartner_ReturnAuthorizationActionsWidgetQuery>;
export type Partner_ReturnAuthorizationActionsWidgetLazyQueryHookResult = ReturnType<typeof usePartner_ReturnAuthorizationActionsWidgetLazyQuery>;
export type Partner_ReturnAuthorizationActionsWidgetQueryResult = Apollo.QueryResult<Partner_ReturnAuthorizationActionsWidgetQuery, Partner_ReturnAuthorizationActionsWidgetQueryVariables>;
export const CustomerReturnShippingWidgetDocument = gql`
    query CustomerReturnShippingWidget($returnAuthorizationId: ID!) {
  returnAuthorizationLite(id: $returnAuthorizationId) {
    id
    shipment {
      id
      trackingNumber
      trackingUrl
      labelUrl
    }
  }
}
    `;

/**
 * __useCustomerReturnShippingWidgetQuery__
 *
 * To run a query within a React component, call `useCustomerReturnShippingWidgetQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomerReturnShippingWidgetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomerReturnShippingWidgetQuery({
 *   variables: {
 *      returnAuthorizationId: // value for 'returnAuthorizationId'
 *   },
 * });
 */
export function useCustomerReturnShippingWidgetQuery(baseOptions: Apollo.QueryHookOptions<CustomerReturnShippingWidgetQuery, CustomerReturnShippingWidgetQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CustomerReturnShippingWidgetQuery, CustomerReturnShippingWidgetQueryVariables>(CustomerReturnShippingWidgetDocument, options);
      }
export function useCustomerReturnShippingWidgetLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CustomerReturnShippingWidgetQuery, CustomerReturnShippingWidgetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CustomerReturnShippingWidgetQuery, CustomerReturnShippingWidgetQueryVariables>(CustomerReturnShippingWidgetDocument, options);
        }
export type CustomerReturnShippingWidgetQueryHookResult = ReturnType<typeof useCustomerReturnShippingWidgetQuery>;
export type CustomerReturnShippingWidgetLazyQueryHookResult = ReturnType<typeof useCustomerReturnShippingWidgetLazyQuery>;
export type CustomerReturnShippingWidgetQueryResult = Apollo.QueryResult<CustomerReturnShippingWidgetQuery, CustomerReturnShippingWidgetQueryVariables>;
export const ItemReceiptWidgetDocument = gql`
    query ItemReceiptWidget($returnAuthorizationId: ID!) {
  returnAuthorization(id: $returnAuthorizationId) {
    id
    itemReceipt {
      id
      lineItems {
        id
        inventoryNumber
        refundAmountCents
        inventoryNumber
        product {
          id
          name
          sku
        }
      }
    }
  }
}
    `;

/**
 * __useItemReceiptWidgetQuery__
 *
 * To run a query within a React component, call `useItemReceiptWidgetQuery` and pass it any options that fit your needs.
 * When your component renders, `useItemReceiptWidgetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useItemReceiptWidgetQuery({
 *   variables: {
 *      returnAuthorizationId: // value for 'returnAuthorizationId'
 *   },
 * });
 */
export function useItemReceiptWidgetQuery(baseOptions: Apollo.QueryHookOptions<ItemReceiptWidgetQuery, ItemReceiptWidgetQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ItemReceiptWidgetQuery, ItemReceiptWidgetQueryVariables>(ItemReceiptWidgetDocument, options);
      }
export function useItemReceiptWidgetLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ItemReceiptWidgetQuery, ItemReceiptWidgetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ItemReceiptWidgetQuery, ItemReceiptWidgetQueryVariables>(ItemReceiptWidgetDocument, options);
        }
export type ItemReceiptWidgetQueryHookResult = ReturnType<typeof useItemReceiptWidgetQuery>;
export type ItemReceiptWidgetLazyQueryHookResult = ReturnType<typeof useItemReceiptWidgetLazyQuery>;
export type ItemReceiptWidgetQueryResult = Apollo.QueryResult<ItemReceiptWidgetQuery, ItemReceiptWidgetQueryVariables>;
export const Partner_ReturnAuthorizationLifeCycleWidgetDocument = gql`
    query Partner_ReturnAuthorizationLifeCycleWidget($returnAuthorizationId: ID!, $queryAsCustomer: Boolean!) {
  returnAuthorization(id: $returnAuthorizationId) @skip(if: $queryAsCustomer) {
    id
    lifeCycle {
      label
      approvalType
      completedOn
    }
    refund {
      id
      approvalType {
        id
        name
        displayName
      }
    }
  }
  returnAuthorizationLite(id: $returnAuthorizationId) @include(if: $queryAsCustomer) {
    id
    lifeCycle {
      label
      approvalType
      completedOn
    }
  }
}
    `;

/**
 * __usePartner_ReturnAuthorizationLifeCycleWidgetQuery__
 *
 * To run a query within a React component, call `usePartner_ReturnAuthorizationLifeCycleWidgetQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartner_ReturnAuthorizationLifeCycleWidgetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartner_ReturnAuthorizationLifeCycleWidgetQuery({
 *   variables: {
 *      returnAuthorizationId: // value for 'returnAuthorizationId'
 *      queryAsCustomer: // value for 'queryAsCustomer'
 *   },
 * });
 */
export function usePartner_ReturnAuthorizationLifeCycleWidgetQuery(baseOptions: Apollo.QueryHookOptions<Partner_ReturnAuthorizationLifeCycleWidgetQuery, Partner_ReturnAuthorizationLifeCycleWidgetQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Partner_ReturnAuthorizationLifeCycleWidgetQuery, Partner_ReturnAuthorizationLifeCycleWidgetQueryVariables>(Partner_ReturnAuthorizationLifeCycleWidgetDocument, options);
      }
export function usePartner_ReturnAuthorizationLifeCycleWidgetLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Partner_ReturnAuthorizationLifeCycleWidgetQuery, Partner_ReturnAuthorizationLifeCycleWidgetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Partner_ReturnAuthorizationLifeCycleWidgetQuery, Partner_ReturnAuthorizationLifeCycleWidgetQueryVariables>(Partner_ReturnAuthorizationLifeCycleWidgetDocument, options);
        }
export type Partner_ReturnAuthorizationLifeCycleWidgetQueryHookResult = ReturnType<typeof usePartner_ReturnAuthorizationLifeCycleWidgetQuery>;
export type Partner_ReturnAuthorizationLifeCycleWidgetLazyQueryHookResult = ReturnType<typeof usePartner_ReturnAuthorizationLifeCycleWidgetLazyQuery>;
export type Partner_ReturnAuthorizationLifeCycleWidgetQueryResult = Apollo.QueryResult<Partner_ReturnAuthorizationLifeCycleWidgetQuery, Partner_ReturnAuthorizationLifeCycleWidgetQueryVariables>;
export const Partner_ReturnShippingWidgetDocument = gql`
    query Partner_ReturnShippingWidget($returnAuthorizationId: ID!) {
  returnAuthorization(id: $returnAuthorizationId) {
    id
    order {
      id
      customer {
        id
        firstName
        lastName
      }
      shippingAddress {
        street1
        street2
        city
        usState
        postalCode
      }
    }
    shipment {
      id
      createdAt
      carrierCode
      trackingNumber
      trackingUrl
    }
  }
}
    `;

/**
 * __usePartner_ReturnShippingWidgetQuery__
 *
 * To run a query within a React component, call `usePartner_ReturnShippingWidgetQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartner_ReturnShippingWidgetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartner_ReturnShippingWidgetQuery({
 *   variables: {
 *      returnAuthorizationId: // value for 'returnAuthorizationId'
 *   },
 * });
 */
export function usePartner_ReturnShippingWidgetQuery(baseOptions: Apollo.QueryHookOptions<Partner_ReturnShippingWidgetQuery, Partner_ReturnShippingWidgetQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Partner_ReturnShippingWidgetQuery, Partner_ReturnShippingWidgetQueryVariables>(Partner_ReturnShippingWidgetDocument, options);
      }
export function usePartner_ReturnShippingWidgetLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Partner_ReturnShippingWidgetQuery, Partner_ReturnShippingWidgetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Partner_ReturnShippingWidgetQuery, Partner_ReturnShippingWidgetQueryVariables>(Partner_ReturnShippingWidgetDocument, options);
        }
export type Partner_ReturnShippingWidgetQueryHookResult = ReturnType<typeof usePartner_ReturnShippingWidgetQuery>;
export type Partner_ReturnShippingWidgetLazyQueryHookResult = ReturnType<typeof usePartner_ReturnShippingWidgetLazyQuery>;
export type Partner_ReturnShippingWidgetQueryResult = Apollo.QueryResult<Partner_ReturnShippingWidgetQuery, Partner_ReturnShippingWidgetQueryVariables>;
export const ReturnedProductsWidgetDocument = gql`
    query ReturnedProductsWidget($returnAuthorizationId: ID!, $queryAsCustomer: Boolean!) {
  returnAuthorizationLite(id: $returnAuthorizationId) @include(if: $queryAsCustomer) {
    id
    lineItems {
      id
      quantity
      productName
      sku
      reasonForReturn
    }
  }
  returnAuthorization(id: $returnAuthorizationId) @skip(if: $queryAsCustomer) {
    id
    lineItems {
      id
      quantity
      reasonForReturn
      refundAmountCents
      serialNumber
      product {
        id
        name
        sku
      }
    }
    itemReceipt {
      id
      lineItems {
        id
        refundAmountCents
        product {
          id
          sku
        }
      }
    }
  }
}
    `;

/**
 * __useReturnedProductsWidgetQuery__
 *
 * To run a query within a React component, call `useReturnedProductsWidgetQuery` and pass it any options that fit your needs.
 * When your component renders, `useReturnedProductsWidgetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReturnedProductsWidgetQuery({
 *   variables: {
 *      returnAuthorizationId: // value for 'returnAuthorizationId'
 *      queryAsCustomer: // value for 'queryAsCustomer'
 *   },
 * });
 */
export function useReturnedProductsWidgetQuery(baseOptions: Apollo.QueryHookOptions<ReturnedProductsWidgetQuery, ReturnedProductsWidgetQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReturnedProductsWidgetQuery, ReturnedProductsWidgetQueryVariables>(ReturnedProductsWidgetDocument, options);
      }
export function useReturnedProductsWidgetLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReturnedProductsWidgetQuery, ReturnedProductsWidgetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReturnedProductsWidgetQuery, ReturnedProductsWidgetQueryVariables>(ReturnedProductsWidgetDocument, options);
        }
export type ReturnedProductsWidgetQueryHookResult = ReturnType<typeof useReturnedProductsWidgetQuery>;
export type ReturnedProductsWidgetLazyQueryHookResult = ReturnType<typeof useReturnedProductsWidgetLazyQuery>;
export type ReturnedProductsWidgetQueryResult = Apollo.QueryResult<ReturnedProductsWidgetQuery, ReturnedProductsWidgetQueryVariables>;
export const ReturnAuthorizationSummaryWidgetDocument = gql`
    query ReturnAuthorizationSummaryWidget($returnAuthorizationId: ID!, $asCustomer: Boolean!) {
  returnAuthorizationLite(id: $returnAuthorizationId) @include(if: $asCustomer) {
    id
    returnNumber
    order {
      id
      orderNumber
      storeName
    }
  }
  returnAuthorization(id: $returnAuthorizationId) @skip(if: $asCustomer) {
    id
    returnNumber
    order {
      id
      orderNumber
    }
    store {
      id
      type {
        id
        name
        displayName
      }
    }
  }
}
    `;

/**
 * __useReturnAuthorizationSummaryWidgetQuery__
 *
 * To run a query within a React component, call `useReturnAuthorizationSummaryWidgetQuery` and pass it any options that fit your needs.
 * When your component renders, `useReturnAuthorizationSummaryWidgetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReturnAuthorizationSummaryWidgetQuery({
 *   variables: {
 *      returnAuthorizationId: // value for 'returnAuthorizationId'
 *      asCustomer: // value for 'asCustomer'
 *   },
 * });
 */
export function useReturnAuthorizationSummaryWidgetQuery(baseOptions: Apollo.QueryHookOptions<ReturnAuthorizationSummaryWidgetQuery, ReturnAuthorizationSummaryWidgetQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReturnAuthorizationSummaryWidgetQuery, ReturnAuthorizationSummaryWidgetQueryVariables>(ReturnAuthorizationSummaryWidgetDocument, options);
      }
export function useReturnAuthorizationSummaryWidgetLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReturnAuthorizationSummaryWidgetQuery, ReturnAuthorizationSummaryWidgetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReturnAuthorizationSummaryWidgetQuery, ReturnAuthorizationSummaryWidgetQueryVariables>(ReturnAuthorizationSummaryWidgetDocument, options);
        }
export type ReturnAuthorizationSummaryWidgetQueryHookResult = ReturnType<typeof useReturnAuthorizationSummaryWidgetQuery>;
export type ReturnAuthorizationSummaryWidgetLazyQueryHookResult = ReturnType<typeof useReturnAuthorizationSummaryWidgetLazyQuery>;
export type ReturnAuthorizationSummaryWidgetQueryResult = Apollo.QueryResult<ReturnAuthorizationSummaryWidgetQuery, ReturnAuthorizationSummaryWidgetQueryVariables>;
export const AsnSettingsWidgetDocument = gql`
    query AsnSettingsWidget($storeId: ID!) {
  orderProperties {
    id
    name
    displayName
  }
  asnFormat(storeId: $storeId) {
    id
    customColumnHeader
    defaultValue
    property {
      id
      name
      displayName
    }
  }
}
    `;

/**
 * __useAsnSettingsWidgetQuery__
 *
 * To run a query within a React component, call `useAsnSettingsWidgetQuery` and pass it any options that fit your needs.
 * When your component renders, `useAsnSettingsWidgetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAsnSettingsWidgetQuery({
 *   variables: {
 *      storeId: // value for 'storeId'
 *   },
 * });
 */
export function useAsnSettingsWidgetQuery(baseOptions: Apollo.QueryHookOptions<AsnSettingsWidgetQuery, AsnSettingsWidgetQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AsnSettingsWidgetQuery, AsnSettingsWidgetQueryVariables>(AsnSettingsWidgetDocument, options);
      }
export function useAsnSettingsWidgetLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AsnSettingsWidgetQuery, AsnSettingsWidgetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AsnSettingsWidgetQuery, AsnSettingsWidgetQueryVariables>(AsnSettingsWidgetDocument, options);
        }
export type AsnSettingsWidgetQueryHookResult = ReturnType<typeof useAsnSettingsWidgetQuery>;
export type AsnSettingsWidgetLazyQueryHookResult = ReturnType<typeof useAsnSettingsWidgetLazyQuery>;
export type AsnSettingsWidgetQueryResult = Apollo.QueryResult<AsnSettingsWidgetQuery, AsnSettingsWidgetQueryVariables>;
export const SaveAsnFormatDocument = gql`
    mutation SaveAsnFormat($input: SaveAsnFormatInput!) {
  saveAsnFormat(input: $input) {
    id
    customColumnHeader
    property {
      id
      name
      displayName
    }
  }
}
    `;
export type SaveAsnFormatMutationFn = Apollo.MutationFunction<SaveAsnFormatMutation, SaveAsnFormatMutationVariables>;

/**
 * __useSaveAsnFormatMutation__
 *
 * To run a mutation, you first call `useSaveAsnFormatMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveAsnFormatMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveAsnFormatMutation, { data, loading, error }] = useSaveAsnFormatMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveAsnFormatMutation(baseOptions?: Apollo.MutationHookOptions<SaveAsnFormatMutation, SaveAsnFormatMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveAsnFormatMutation, SaveAsnFormatMutationVariables>(SaveAsnFormatDocument, options);
      }
export type SaveAsnFormatMutationHookResult = ReturnType<typeof useSaveAsnFormatMutation>;
export type SaveAsnFormatMutationResult = Apollo.MutationResult<SaveAsnFormatMutation>;
export type SaveAsnFormatMutationOptions = Apollo.BaseMutationOptions<SaveAsnFormatMutation, SaveAsnFormatMutationVariables>;
export const AutomatedEmailReportSettingsWidgetDocument = gql`
    query AutomatedEmailReportSettingsWidget($storeId: ID!) {
  store(id: $storeId) {
    id
    automatedReportEmailRecipient
  }
}
    `;

/**
 * __useAutomatedEmailReportSettingsWidgetQuery__
 *
 * To run a query within a React component, call `useAutomatedEmailReportSettingsWidgetQuery` and pass it any options that fit your needs.
 * When your component renders, `useAutomatedEmailReportSettingsWidgetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAutomatedEmailReportSettingsWidgetQuery({
 *   variables: {
 *      storeId: // value for 'storeId'
 *   },
 * });
 */
export function useAutomatedEmailReportSettingsWidgetQuery(baseOptions: Apollo.QueryHookOptions<AutomatedEmailReportSettingsWidgetQuery, AutomatedEmailReportSettingsWidgetQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AutomatedEmailReportSettingsWidgetQuery, AutomatedEmailReportSettingsWidgetQueryVariables>(AutomatedEmailReportSettingsWidgetDocument, options);
      }
export function useAutomatedEmailReportSettingsWidgetLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AutomatedEmailReportSettingsWidgetQuery, AutomatedEmailReportSettingsWidgetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AutomatedEmailReportSettingsWidgetQuery, AutomatedEmailReportSettingsWidgetQueryVariables>(AutomatedEmailReportSettingsWidgetDocument, options);
        }
export type AutomatedEmailReportSettingsWidgetQueryHookResult = ReturnType<typeof useAutomatedEmailReportSettingsWidgetQuery>;
export type AutomatedEmailReportSettingsWidgetLazyQueryHookResult = ReturnType<typeof useAutomatedEmailReportSettingsWidgetLazyQuery>;
export type AutomatedEmailReportSettingsWidgetQueryResult = Apollo.QueryResult<AutomatedEmailReportSettingsWidgetQuery, AutomatedEmailReportSettingsWidgetQueryVariables>;
export const SaveAutomatedEmailReportRecipientDocument = gql`
    mutation SaveAutomatedEmailReportRecipient($storeId: ID!, $email: String!) {
  saveStore(input: {id: $storeId, automatedReportEmailRecipient: $email}) {
    id
    automatedReportEmailRecipient
  }
}
    `;
export type SaveAutomatedEmailReportRecipientMutationFn = Apollo.MutationFunction<SaveAutomatedEmailReportRecipientMutation, SaveAutomatedEmailReportRecipientMutationVariables>;

/**
 * __useSaveAutomatedEmailReportRecipientMutation__
 *
 * To run a mutation, you first call `useSaveAutomatedEmailReportRecipientMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveAutomatedEmailReportRecipientMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveAutomatedEmailReportRecipientMutation, { data, loading, error }] = useSaveAutomatedEmailReportRecipientMutation({
 *   variables: {
 *      storeId: // value for 'storeId'
 *      email: // value for 'email'
 *   },
 * });
 */
export function useSaveAutomatedEmailReportRecipientMutation(baseOptions?: Apollo.MutationHookOptions<SaveAutomatedEmailReportRecipientMutation, SaveAutomatedEmailReportRecipientMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveAutomatedEmailReportRecipientMutation, SaveAutomatedEmailReportRecipientMutationVariables>(SaveAutomatedEmailReportRecipientDocument, options);
      }
export type SaveAutomatedEmailReportRecipientMutationHookResult = ReturnType<typeof useSaveAutomatedEmailReportRecipientMutation>;
export type SaveAutomatedEmailReportRecipientMutationResult = Apollo.MutationResult<SaveAutomatedEmailReportRecipientMutation>;
export type SaveAutomatedEmailReportRecipientMutationOptions = Apollo.BaseMutationOptions<SaveAutomatedEmailReportRecipientMutation, SaveAutomatedEmailReportRecipientMutationVariables>;
export const BrandSettingsWidgetDocument = gql`
    query BrandSettingsWidget($storeId: ID!) {
  store(id: $storeId) {
    id
    name
    primaryColorHex
    secondaryColorHex
    buttonColorHex
    logoUrl
  }
}
    `;

/**
 * __useBrandSettingsWidgetQuery__
 *
 * To run a query within a React component, call `useBrandSettingsWidgetQuery` and pass it any options that fit your needs.
 * When your component renders, `useBrandSettingsWidgetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBrandSettingsWidgetQuery({
 *   variables: {
 *      storeId: // value for 'storeId'
 *   },
 * });
 */
export function useBrandSettingsWidgetQuery(baseOptions: Apollo.QueryHookOptions<BrandSettingsWidgetQuery, BrandSettingsWidgetQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BrandSettingsWidgetQuery, BrandSettingsWidgetQueryVariables>(BrandSettingsWidgetDocument, options);
      }
export function useBrandSettingsWidgetLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BrandSettingsWidgetQuery, BrandSettingsWidgetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BrandSettingsWidgetQuery, BrandSettingsWidgetQueryVariables>(BrandSettingsWidgetDocument, options);
        }
export type BrandSettingsWidgetQueryHookResult = ReturnType<typeof useBrandSettingsWidgetQuery>;
export type BrandSettingsWidgetLazyQueryHookResult = ReturnType<typeof useBrandSettingsWidgetLazyQuery>;
export type BrandSettingsWidgetQueryResult = Apollo.QueryResult<BrandSettingsWidgetQuery, BrandSettingsWidgetQueryVariables>;
export const SaveBrandDocument = gql`
    mutation SaveBrand($storeId: ID!, $storeName: String!, $primaryColorHex: String!, $secondaryColorHex: String!, $buttonColorHex: String!, $logo: EncodedFileInput) {
  saveStore(
    input: {id: $storeId, name: $storeName, brand: {primaryColorHex: $primaryColorHex, secondaryColorHex: $secondaryColorHex, buttonColorHex: $buttonColorHex, logo: $logo}}
  ) {
    id
    name
    primaryColorHex
    secondaryColorHex
    buttonColorHex
    logoUrl
  }
}
    `;
export type SaveBrandMutationFn = Apollo.MutationFunction<SaveBrandMutation, SaveBrandMutationVariables>;

/**
 * __useSaveBrandMutation__
 *
 * To run a mutation, you first call `useSaveBrandMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveBrandMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveBrandMutation, { data, loading, error }] = useSaveBrandMutation({
 *   variables: {
 *      storeId: // value for 'storeId'
 *      storeName: // value for 'storeName'
 *      primaryColorHex: // value for 'primaryColorHex'
 *      secondaryColorHex: // value for 'secondaryColorHex'
 *      buttonColorHex: // value for 'buttonColorHex'
 *      logo: // value for 'logo'
 *   },
 * });
 */
export function useSaveBrandMutation(baseOptions?: Apollo.MutationHookOptions<SaveBrandMutation, SaveBrandMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveBrandMutation, SaveBrandMutationVariables>(SaveBrandDocument, options);
      }
export type SaveBrandMutationHookResult = ReturnType<typeof useSaveBrandMutation>;
export type SaveBrandMutationResult = Apollo.MutationResult<SaveBrandMutation>;
export type SaveBrandMutationOptions = Apollo.BaseMutationOptions<SaveBrandMutation, SaveBrandMutationVariables>;
export const CsvOrderFormatSettingsWidgetDocument = gql`
    query CsvOrderFormatSettingsWidget($storeId: ID!) {
  orderProperties(onlyImportable: true) {
    id
    name
    displayName
  }
  store(id: $storeId) {
    id
    type {
      id
      name
      displayName
    }
    storeSettings {
      prefixNewOrders
    }
    customOrderFormatFlow {
      id
      propertyMapping {
        id
        sourceDataLabel
        defaultValueOnEmpty
        mapToProperty {
          id
          name
          displayName
        }
      }
    }
  }
}
    `;

/**
 * __useCsvOrderFormatSettingsWidgetQuery__
 *
 * To run a query within a React component, call `useCsvOrderFormatSettingsWidgetQuery` and pass it any options that fit your needs.
 * When your component renders, `useCsvOrderFormatSettingsWidgetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCsvOrderFormatSettingsWidgetQuery({
 *   variables: {
 *      storeId: // value for 'storeId'
 *   },
 * });
 */
export function useCsvOrderFormatSettingsWidgetQuery(baseOptions: Apollo.QueryHookOptions<CsvOrderFormatSettingsWidgetQuery, CsvOrderFormatSettingsWidgetQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CsvOrderFormatSettingsWidgetQuery, CsvOrderFormatSettingsWidgetQueryVariables>(CsvOrderFormatSettingsWidgetDocument, options);
      }
export function useCsvOrderFormatSettingsWidgetLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CsvOrderFormatSettingsWidgetQuery, CsvOrderFormatSettingsWidgetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CsvOrderFormatSettingsWidgetQuery, CsvOrderFormatSettingsWidgetQueryVariables>(CsvOrderFormatSettingsWidgetDocument, options);
        }
export type CsvOrderFormatSettingsWidgetQueryHookResult = ReturnType<typeof useCsvOrderFormatSettingsWidgetQuery>;
export type CsvOrderFormatSettingsWidgetLazyQueryHookResult = ReturnType<typeof useCsvOrderFormatSettingsWidgetLazyQuery>;
export type CsvOrderFormatSettingsWidgetQueryResult = Apollo.QueryResult<CsvOrderFormatSettingsWidgetQuery, CsvOrderFormatSettingsWidgetQueryVariables>;
export const SaveCustomOrderFormatFlowDocument = gql`
    mutation SaveCustomOrderFormatFlow($input: SaveCustomOrderFormatFlowInput!, $storeId: ID!, $prefixNewOrders: Boolean!) {
  saveStore(input: {id: $storeId, settings: {prefixNewOrders: $prefixNewOrders}}) {
    id
    storeSettings {
      prefixNewOrders
    }
  }
  saveCustomOrderFormatFlow(input: $input) {
    id
  }
}
    `;
export type SaveCustomOrderFormatFlowMutationFn = Apollo.MutationFunction<SaveCustomOrderFormatFlowMutation, SaveCustomOrderFormatFlowMutationVariables>;

/**
 * __useSaveCustomOrderFormatFlowMutation__
 *
 * To run a mutation, you first call `useSaveCustomOrderFormatFlowMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveCustomOrderFormatFlowMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveCustomOrderFormatFlowMutation, { data, loading, error }] = useSaveCustomOrderFormatFlowMutation({
 *   variables: {
 *      input: // value for 'input'
 *      storeId: // value for 'storeId'
 *      prefixNewOrders: // value for 'prefixNewOrders'
 *   },
 * });
 */
export function useSaveCustomOrderFormatFlowMutation(baseOptions?: Apollo.MutationHookOptions<SaveCustomOrderFormatFlowMutation, SaveCustomOrderFormatFlowMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveCustomOrderFormatFlowMutation, SaveCustomOrderFormatFlowMutationVariables>(SaveCustomOrderFormatFlowDocument, options);
      }
export type SaveCustomOrderFormatFlowMutationHookResult = ReturnType<typeof useSaveCustomOrderFormatFlowMutation>;
export type SaveCustomOrderFormatFlowMutationResult = Apollo.MutationResult<SaveCustomOrderFormatFlowMutation>;
export type SaveCustomOrderFormatFlowMutationOptions = Apollo.BaseMutationOptions<SaveCustomOrderFormatFlowMutation, SaveCustomOrderFormatFlowMutationVariables>;
export const CustomFieldsWidgetDocument = gql`
    query CustomFieldsWidget($storeId: ID!) {
  store(id: $storeId) {
    id
    creditCardDynamicDescriptor
    zenDeskUrl
    additionalSupportText
  }
}
    `;

/**
 * __useCustomFieldsWidgetQuery__
 *
 * To run a query within a React component, call `useCustomFieldsWidgetQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomFieldsWidgetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomFieldsWidgetQuery({
 *   variables: {
 *      storeId: // value for 'storeId'
 *   },
 * });
 */
export function useCustomFieldsWidgetQuery(baseOptions: Apollo.QueryHookOptions<CustomFieldsWidgetQuery, CustomFieldsWidgetQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CustomFieldsWidgetQuery, CustomFieldsWidgetQueryVariables>(CustomFieldsWidgetDocument, options);
      }
export function useCustomFieldsWidgetLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CustomFieldsWidgetQuery, CustomFieldsWidgetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CustomFieldsWidgetQuery, CustomFieldsWidgetQueryVariables>(CustomFieldsWidgetDocument, options);
        }
export type CustomFieldsWidgetQueryHookResult = ReturnType<typeof useCustomFieldsWidgetQuery>;
export type CustomFieldsWidgetLazyQueryHookResult = ReturnType<typeof useCustomFieldsWidgetLazyQuery>;
export type CustomFieldsWidgetQueryResult = Apollo.QueryResult<CustomFieldsWidgetQuery, CustomFieldsWidgetQueryVariables>;
export const SaveCustomFieldsDocument = gql`
    mutation SaveCustomFields($storeId: ID!, $creditCardDynamicDescriptor: String!, $zenDeskUrl: String!, $additionalSupportText: String!) {
  saveStore(
    input: {id: $storeId, creditCardDynamicDescriptor: $creditCardDynamicDescriptor, zenDeskUrl: $zenDeskUrl, additionalSupportText: $additionalSupportText}
  ) {
    id
    creditCardDynamicDescriptor
    zenDeskUrl
    additionalSupportText
  }
}
    `;
export type SaveCustomFieldsMutationFn = Apollo.MutationFunction<SaveCustomFieldsMutation, SaveCustomFieldsMutationVariables>;

/**
 * __useSaveCustomFieldsMutation__
 *
 * To run a mutation, you first call `useSaveCustomFieldsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveCustomFieldsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveCustomFieldsMutation, { data, loading, error }] = useSaveCustomFieldsMutation({
 *   variables: {
 *      storeId: // value for 'storeId'
 *      creditCardDynamicDescriptor: // value for 'creditCardDynamicDescriptor'
 *      zenDeskUrl: // value for 'zenDeskUrl'
 *      additionalSupportText: // value for 'additionalSupportText'
 *   },
 * });
 */
export function useSaveCustomFieldsMutation(baseOptions?: Apollo.MutationHookOptions<SaveCustomFieldsMutation, SaveCustomFieldsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveCustomFieldsMutation, SaveCustomFieldsMutationVariables>(SaveCustomFieldsDocument, options);
      }
export type SaveCustomFieldsMutationHookResult = ReturnType<typeof useSaveCustomFieldsMutation>;
export type SaveCustomFieldsMutationResult = Apollo.MutationResult<SaveCustomFieldsMutation>;
export type SaveCustomFieldsMutationOptions = Apollo.BaseMutationOptions<SaveCustomFieldsMutation, SaveCustomFieldsMutationVariables>;
export const DynamicDataExampleWidgetDocument = gql`
    query DynamicDataExampleWidget($id: ID!, $queryOrder: Boolean!) {
  sendGridOrder(id: $id) @include(if: $queryOrder)
  sendGridReturnAuthorization(id: $id) @skip(if: $queryOrder)
}
    `;

/**
 * __useDynamicDataExampleWidgetQuery__
 *
 * To run a query within a React component, call `useDynamicDataExampleWidgetQuery` and pass it any options that fit your needs.
 * When your component renders, `useDynamicDataExampleWidgetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDynamicDataExampleWidgetQuery({
 *   variables: {
 *      id: // value for 'id'
 *      queryOrder: // value for 'queryOrder'
 *   },
 * });
 */
export function useDynamicDataExampleWidgetQuery(baseOptions: Apollo.QueryHookOptions<DynamicDataExampleWidgetQuery, DynamicDataExampleWidgetQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DynamicDataExampleWidgetQuery, DynamicDataExampleWidgetQueryVariables>(DynamicDataExampleWidgetDocument, options);
      }
export function useDynamicDataExampleWidgetLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DynamicDataExampleWidgetQuery, DynamicDataExampleWidgetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DynamicDataExampleWidgetQuery, DynamicDataExampleWidgetQueryVariables>(DynamicDataExampleWidgetDocument, options);
        }
export type DynamicDataExampleWidgetQueryHookResult = ReturnType<typeof useDynamicDataExampleWidgetQuery>;
export type DynamicDataExampleWidgetLazyQueryHookResult = ReturnType<typeof useDynamicDataExampleWidgetLazyQuery>;
export type DynamicDataExampleWidgetQueryResult = Apollo.QueryResult<DynamicDataExampleWidgetQuery, DynamicDataExampleWidgetQueryVariables>;
export const E1SettingsWidgetDocument = gql`
    query E1SettingsWidget($storeId: ID!) {
  store(id: $storeId) {
    id
    partner {
      id
    }
  }
}
    `;

/**
 * __useE1SettingsWidgetQuery__
 *
 * To run a query within a React component, call `useE1SettingsWidgetQuery` and pass it any options that fit your needs.
 * When your component renders, `useE1SettingsWidgetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useE1SettingsWidgetQuery({
 *   variables: {
 *      storeId: // value for 'storeId'
 *   },
 * });
 */
export function useE1SettingsWidgetQuery(baseOptions: Apollo.QueryHookOptions<E1SettingsWidgetQuery, E1SettingsWidgetQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<E1SettingsWidgetQuery, E1SettingsWidgetQueryVariables>(E1SettingsWidgetDocument, options);
      }
export function useE1SettingsWidgetLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<E1SettingsWidgetQuery, E1SettingsWidgetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<E1SettingsWidgetQuery, E1SettingsWidgetQueryVariables>(E1SettingsWidgetDocument, options);
        }
export type E1SettingsWidgetQueryHookResult = ReturnType<typeof useE1SettingsWidgetQuery>;
export type E1SettingsWidgetLazyQueryHookResult = ReturnType<typeof useE1SettingsWidgetLazyQuery>;
export type E1SettingsWidgetQueryResult = Apollo.QueryResult<E1SettingsWidgetQuery, E1SettingsWidgetQueryVariables>;
export const SaveE1SettingsDocument = gql`
    mutation SaveE1Settings($id: ID!) {
  saveStore(input: {id: $id}) {
    id
    partner {
      id
    }
  }
}
    `;
export type SaveE1SettingsMutationFn = Apollo.MutationFunction<SaveE1SettingsMutation, SaveE1SettingsMutationVariables>;

/**
 * __useSaveE1SettingsMutation__
 *
 * To run a mutation, you first call `useSaveE1SettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveE1SettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveE1SettingsMutation, { data, loading, error }] = useSaveE1SettingsMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSaveE1SettingsMutation(baseOptions?: Apollo.MutationHookOptions<SaveE1SettingsMutation, SaveE1SettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveE1SettingsMutation, SaveE1SettingsMutationVariables>(SaveE1SettingsDocument, options);
      }
export type SaveE1SettingsMutationHookResult = ReturnType<typeof useSaveE1SettingsMutation>;
export type SaveE1SettingsMutationResult = Apollo.MutationResult<SaveE1SettingsMutation>;
export type SaveE1SettingsMutationOptions = Apollo.BaseMutationOptions<SaveE1SettingsMutation, SaveE1SettingsMutationVariables>;
export const EmailSettingsWidgetDocument = gql`
    query EmailSettingsWidget($storeId: ID!) {
  appEvents {
    id
    name
    displayName
  }
  store(id: $storeId) {
    id
    sendGridFromEmail
    sendGridFromName
    emailSettings {
      id
      templateId
      isActive
      appEvent {
        id
        name
        displayName
      }
    }
  }
}
    `;

/**
 * __useEmailSettingsWidgetQuery__
 *
 * To run a query within a React component, call `useEmailSettingsWidgetQuery` and pass it any options that fit your needs.
 * When your component renders, `useEmailSettingsWidgetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEmailSettingsWidgetQuery({
 *   variables: {
 *      storeId: // value for 'storeId'
 *   },
 * });
 */
export function useEmailSettingsWidgetQuery(baseOptions: Apollo.QueryHookOptions<EmailSettingsWidgetQuery, EmailSettingsWidgetQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EmailSettingsWidgetQuery, EmailSettingsWidgetQueryVariables>(EmailSettingsWidgetDocument, options);
      }
export function useEmailSettingsWidgetLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EmailSettingsWidgetQuery, EmailSettingsWidgetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EmailSettingsWidgetQuery, EmailSettingsWidgetQueryVariables>(EmailSettingsWidgetDocument, options);
        }
export type EmailSettingsWidgetQueryHookResult = ReturnType<typeof useEmailSettingsWidgetQuery>;
export type EmailSettingsWidgetLazyQueryHookResult = ReturnType<typeof useEmailSettingsWidgetLazyQuery>;
export type EmailSettingsWidgetQueryResult = Apollo.QueryResult<EmailSettingsWidgetQuery, EmailSettingsWidgetQueryVariables>;
export const SaveStoreEmailSettingsDocument = gql`
    mutation SaveStoreEmailSettings($input: SaveStoreEmailSettingsInput!) {
  saveStoreEmailSettings(input: $input) {
    id
    isActive
    templateId
    appEvent {
      id
      name
      displayName
    }
  }
}
    `;
export type SaveStoreEmailSettingsMutationFn = Apollo.MutationFunction<SaveStoreEmailSettingsMutation, SaveStoreEmailSettingsMutationVariables>;

/**
 * __useSaveStoreEmailSettingsMutation__
 *
 * To run a mutation, you first call `useSaveStoreEmailSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveStoreEmailSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveStoreEmailSettingsMutation, { data, loading, error }] = useSaveStoreEmailSettingsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveStoreEmailSettingsMutation(baseOptions?: Apollo.MutationHookOptions<SaveStoreEmailSettingsMutation, SaveStoreEmailSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveStoreEmailSettingsMutation, SaveStoreEmailSettingsMutationVariables>(SaveStoreEmailSettingsDocument, options);
      }
export type SaveStoreEmailSettingsMutationHookResult = ReturnType<typeof useSaveStoreEmailSettingsMutation>;
export type SaveStoreEmailSettingsMutationResult = Apollo.MutationResult<SaveStoreEmailSettingsMutation>;
export type SaveStoreEmailSettingsMutationOptions = Apollo.BaseMutationOptions<SaveStoreEmailSettingsMutation, SaveStoreEmailSettingsMutationVariables>;
export const LineItemUnbundlerWidgetDocument = gql`
    query LineItemUnbundlerWidget($storeId: ID!) {
  lineItemUnbundlingRules(storeId: $storeId) {
    pageInfo {
      ...pageInfoFields
    }
    nodes {
      id
      priceCents
      productName
      sku
      value
      comparisonOperator {
        id
        name
        displayName
      }
    }
  }
}
    ${PageInfoFieldsFragmentDoc}`;

/**
 * __useLineItemUnbundlerWidgetQuery__
 *
 * To run a query within a React component, call `useLineItemUnbundlerWidgetQuery` and pass it any options that fit your needs.
 * When your component renders, `useLineItemUnbundlerWidgetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLineItemUnbundlerWidgetQuery({
 *   variables: {
 *      storeId: // value for 'storeId'
 *   },
 * });
 */
export function useLineItemUnbundlerWidgetQuery(baseOptions: Apollo.QueryHookOptions<LineItemUnbundlerWidgetQuery, LineItemUnbundlerWidgetQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LineItemUnbundlerWidgetQuery, LineItemUnbundlerWidgetQueryVariables>(LineItemUnbundlerWidgetDocument, options);
      }
export function useLineItemUnbundlerWidgetLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LineItemUnbundlerWidgetQuery, LineItemUnbundlerWidgetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LineItemUnbundlerWidgetQuery, LineItemUnbundlerWidgetQueryVariables>(LineItemUnbundlerWidgetDocument, options);
        }
export type LineItemUnbundlerWidgetQueryHookResult = ReturnType<typeof useLineItemUnbundlerWidgetQuery>;
export type LineItemUnbundlerWidgetLazyQueryHookResult = ReturnType<typeof useLineItemUnbundlerWidgetLazyQuery>;
export type LineItemUnbundlerWidgetQueryResult = Apollo.QueryResult<LineItemUnbundlerWidgetQuery, LineItemUnbundlerWidgetQueryVariables>;
export const NetSuiteSettingsWidgetDocument = gql`
    query NetSuiteSettingsWidget($storeId: ID!) {
  store(id: $storeId) {
    id
    packingSlipInformation
    netSuiteClientInternalId
    type {
      id
      name
      displayName
    }
    salesChannel {
      id
      name
      displayName
    }
    department {
      id
    }
    inventoryLocation {
      id
    }
    brand {
      id
    }
    subsidiary {
      id
    }
    taxItem {
      id
    }
    salesRepresentativeEmployee {
      id
      fullName
    }
  }
}
    `;

/**
 * __useNetSuiteSettingsWidgetQuery__
 *
 * To run a query within a React component, call `useNetSuiteSettingsWidgetQuery` and pass it any options that fit your needs.
 * When your component renders, `useNetSuiteSettingsWidgetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNetSuiteSettingsWidgetQuery({
 *   variables: {
 *      storeId: // value for 'storeId'
 *   },
 * });
 */
export function useNetSuiteSettingsWidgetQuery(baseOptions: Apollo.QueryHookOptions<NetSuiteSettingsWidgetQuery, NetSuiteSettingsWidgetQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NetSuiteSettingsWidgetQuery, NetSuiteSettingsWidgetQueryVariables>(NetSuiteSettingsWidgetDocument, options);
      }
export function useNetSuiteSettingsWidgetLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NetSuiteSettingsWidgetQuery, NetSuiteSettingsWidgetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NetSuiteSettingsWidgetQuery, NetSuiteSettingsWidgetQueryVariables>(NetSuiteSettingsWidgetDocument, options);
        }
export type NetSuiteSettingsWidgetQueryHookResult = ReturnType<typeof useNetSuiteSettingsWidgetQuery>;
export type NetSuiteSettingsWidgetLazyQueryHookResult = ReturnType<typeof useNetSuiteSettingsWidgetLazyQuery>;
export type NetSuiteSettingsWidgetQueryResult = Apollo.QueryResult<NetSuiteSettingsWidgetQuery, NetSuiteSettingsWidgetQueryVariables>;
export const SaveNetSuiteSettingsDocument = gql`
    mutation SaveNetSuiteSettings($storeId: ID!, $salesChannel: SalesChannelName!, $departmentId: ID!, $subsidiaryId: ID!, $inventoryLocationId: ID!, $brandId: ID!, $taxItemId: ID!, $packingSlipInformation: String!, $netSuiteClientInternalId: String!, $salesRepresentativeEmployeeId: ID) {
  saveStore(
    input: {id: $storeId, salesChannelName: $salesChannel, departmentId: $departmentId, subsidiaryId: $subsidiaryId, inventoryLocationId: $inventoryLocationId, brandId: $brandId, taxItemId: $taxItemId, packingSlipInformation: $packingSlipInformation, netSuiteClientInternalId: $netSuiteClientInternalId, salesRepresentativeEmployeeId: $salesRepresentativeEmployeeId}
  ) {
    id
    department {
      id
    }
    inventoryLocation {
      id
    }
    subsidiary {
      id
    }
  }
}
    `;
export type SaveNetSuiteSettingsMutationFn = Apollo.MutationFunction<SaveNetSuiteSettingsMutation, SaveNetSuiteSettingsMutationVariables>;

/**
 * __useSaveNetSuiteSettingsMutation__
 *
 * To run a mutation, you first call `useSaveNetSuiteSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveNetSuiteSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveNetSuiteSettingsMutation, { data, loading, error }] = useSaveNetSuiteSettingsMutation({
 *   variables: {
 *      storeId: // value for 'storeId'
 *      salesChannel: // value for 'salesChannel'
 *      departmentId: // value for 'departmentId'
 *      subsidiaryId: // value for 'subsidiaryId'
 *      inventoryLocationId: // value for 'inventoryLocationId'
 *      brandId: // value for 'brandId'
 *      taxItemId: // value for 'taxItemId'
 *      packingSlipInformation: // value for 'packingSlipInformation'
 *      netSuiteClientInternalId: // value for 'netSuiteClientInternalId'
 *      salesRepresentativeEmployeeId: // value for 'salesRepresentativeEmployeeId'
 *   },
 * });
 */
export function useSaveNetSuiteSettingsMutation(baseOptions?: Apollo.MutationHookOptions<SaveNetSuiteSettingsMutation, SaveNetSuiteSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveNetSuiteSettingsMutation, SaveNetSuiteSettingsMutationVariables>(SaveNetSuiteSettingsDocument, options);
      }
export type SaveNetSuiteSettingsMutationHookResult = ReturnType<typeof useSaveNetSuiteSettingsMutation>;
export type SaveNetSuiteSettingsMutationResult = Apollo.MutationResult<SaveNetSuiteSettingsMutation>;
export type SaveNetSuiteSettingsMutationOptions = Apollo.BaseMutationOptions<SaveNetSuiteSettingsMutation, SaveNetSuiteSettingsMutationVariables>;
export const PaymentMethodWidgetDocument = gql`
    query PaymentMethodWidget($storeId: ID!) {
  allRawPaymentMethods(storeId: $storeId)
  store(id: $storeId) {
    id
    subsidiary {
      id
    }
    paymentMethodMappings {
      id
      isTaxable
      paymentMethodText
      paymentMethod {
        id
        name
        internalId
      }
    }
  }
}
    `;

/**
 * __usePaymentMethodWidgetQuery__
 *
 * To run a query within a React component, call `usePaymentMethodWidgetQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaymentMethodWidgetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaymentMethodWidgetQuery({
 *   variables: {
 *      storeId: // value for 'storeId'
 *   },
 * });
 */
export function usePaymentMethodWidgetQuery(baseOptions: Apollo.QueryHookOptions<PaymentMethodWidgetQuery, PaymentMethodWidgetQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PaymentMethodWidgetQuery, PaymentMethodWidgetQueryVariables>(PaymentMethodWidgetDocument, options);
      }
export function usePaymentMethodWidgetLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PaymentMethodWidgetQuery, PaymentMethodWidgetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PaymentMethodWidgetQuery, PaymentMethodWidgetQueryVariables>(PaymentMethodWidgetDocument, options);
        }
export type PaymentMethodWidgetQueryHookResult = ReturnType<typeof usePaymentMethodWidgetQuery>;
export type PaymentMethodWidgetLazyQueryHookResult = ReturnType<typeof usePaymentMethodWidgetLazyQuery>;
export type PaymentMethodWidgetQueryResult = Apollo.QueryResult<PaymentMethodWidgetQuery, PaymentMethodWidgetQueryVariables>;
export const SavePaymentMethodMappingsDocument = gql`
    mutation SavePaymentMethodMappings($input: SavePaymentMethodMappingsInput!) {
  savePaymentMethodMappings(input: $input)
}
    `;
export type SavePaymentMethodMappingsMutationFn = Apollo.MutationFunction<SavePaymentMethodMappingsMutation, SavePaymentMethodMappingsMutationVariables>;

/**
 * __useSavePaymentMethodMappingsMutation__
 *
 * To run a mutation, you first call `useSavePaymentMethodMappingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSavePaymentMethodMappingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [savePaymentMethodMappingsMutation, { data, loading, error }] = useSavePaymentMethodMappingsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSavePaymentMethodMappingsMutation(baseOptions?: Apollo.MutationHookOptions<SavePaymentMethodMappingsMutation, SavePaymentMethodMappingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SavePaymentMethodMappingsMutation, SavePaymentMethodMappingsMutationVariables>(SavePaymentMethodMappingsDocument, options);
      }
export type SavePaymentMethodMappingsMutationHookResult = ReturnType<typeof useSavePaymentMethodMappingsMutation>;
export type SavePaymentMethodMappingsMutationResult = Apollo.MutationResult<SavePaymentMethodMappingsMutation>;
export type SavePaymentMethodMappingsMutationOptions = Apollo.BaseMutationOptions<SavePaymentMethodMappingsMutation, SavePaymentMethodMappingsMutationVariables>;
export const RepairCodesWidgetDocument = gql`
    query RepairCodesWidget($storeId: ID!) {
  store(id: $storeId) {
    id
    repairCodes {
      id
      repairCode
    }
  }
}
    `;

/**
 * __useRepairCodesWidgetQuery__
 *
 * To run a query within a React component, call `useRepairCodesWidgetQuery` and pass it any options that fit your needs.
 * When your component renders, `useRepairCodesWidgetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRepairCodesWidgetQuery({
 *   variables: {
 *      storeId: // value for 'storeId'
 *   },
 * });
 */
export function useRepairCodesWidgetQuery(baseOptions: Apollo.QueryHookOptions<RepairCodesWidgetQuery, RepairCodesWidgetQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RepairCodesWidgetQuery, RepairCodesWidgetQueryVariables>(RepairCodesWidgetDocument, options);
      }
export function useRepairCodesWidgetLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RepairCodesWidgetQuery, RepairCodesWidgetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RepairCodesWidgetQuery, RepairCodesWidgetQueryVariables>(RepairCodesWidgetDocument, options);
        }
export type RepairCodesWidgetQueryHookResult = ReturnType<typeof useRepairCodesWidgetQuery>;
export type RepairCodesWidgetLazyQueryHookResult = ReturnType<typeof useRepairCodesWidgetLazyQuery>;
export type RepairCodesWidgetQueryResult = Apollo.QueryResult<RepairCodesWidgetQuery, RepairCodesWidgetQueryVariables>;
export const SaveRepairCodesDocument = gql`
    mutation SaveRepairCodes($input: SaveRepairCodesInput!) {
  saveRepairCodes(input: $input) {
    id
    repairCode
  }
}
    `;
export type SaveRepairCodesMutationFn = Apollo.MutationFunction<SaveRepairCodesMutation, SaveRepairCodesMutationVariables>;

/**
 * __useSaveRepairCodesMutation__
 *
 * To run a mutation, you first call `useSaveRepairCodesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveRepairCodesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveRepairCodesMutation, { data, loading, error }] = useSaveRepairCodesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveRepairCodesMutation(baseOptions?: Apollo.MutationHookOptions<SaveRepairCodesMutation, SaveRepairCodesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveRepairCodesMutation, SaveRepairCodesMutationVariables>(SaveRepairCodesDocument, options);
      }
export type SaveRepairCodesMutationHookResult = ReturnType<typeof useSaveRepairCodesMutation>;
export type SaveRepairCodesMutationResult = Apollo.MutationResult<SaveRepairCodesMutation>;
export type SaveRepairCodesMutationOptions = Apollo.BaseMutationOptions<SaveRepairCodesMutation, SaveRepairCodesMutationVariables>;
export const ReturnLabelSettingsWidgetDocument = gql`
    query ReturnLabelSettingsWidget($storeId: ID!) {
  store(id: $storeId) {
    id
    tier1PrintRequestLabelType
    printRequestFunctionInternalId
    printRequestLabelInternalId
    printRequestPrinterInternalId
  }
}
    `;

/**
 * __useReturnLabelSettingsWidgetQuery__
 *
 * To run a query within a React component, call `useReturnLabelSettingsWidgetQuery` and pass it any options that fit your needs.
 * When your component renders, `useReturnLabelSettingsWidgetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReturnLabelSettingsWidgetQuery({
 *   variables: {
 *      storeId: // value for 'storeId'
 *   },
 * });
 */
export function useReturnLabelSettingsWidgetQuery(baseOptions: Apollo.QueryHookOptions<ReturnLabelSettingsWidgetQuery, ReturnLabelSettingsWidgetQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReturnLabelSettingsWidgetQuery, ReturnLabelSettingsWidgetQueryVariables>(ReturnLabelSettingsWidgetDocument, options);
      }
export function useReturnLabelSettingsWidgetLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReturnLabelSettingsWidgetQuery, ReturnLabelSettingsWidgetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReturnLabelSettingsWidgetQuery, ReturnLabelSettingsWidgetQueryVariables>(ReturnLabelSettingsWidgetDocument, options);
        }
export type ReturnLabelSettingsWidgetQueryHookResult = ReturnType<typeof useReturnLabelSettingsWidgetQuery>;
export type ReturnLabelSettingsWidgetLazyQueryHookResult = ReturnType<typeof useReturnLabelSettingsWidgetLazyQuery>;
export type ReturnLabelSettingsWidgetQueryResult = Apollo.QueryResult<ReturnLabelSettingsWidgetQuery, ReturnLabelSettingsWidgetQueryVariables>;
export const SaveTier1PrintRequestLabelTypeDocument = gql`
    mutation SaveTier1PrintRequestLabelType($storeId: ID!, $tier1PrintRequestLabelType: String!, $printRequestFunctionInternalId: String!, $printRequestLabelInternalId: String!, $printRequestPrinterInternalId: String!) {
  saveStore(
    input: {id: $storeId, tier1PrintRequestLabelType: $tier1PrintRequestLabelType, printRequestFunctionInternalId: $printRequestFunctionInternalId, printRequestLabelInternalId: $printRequestLabelInternalId, printRequestPrinterInternalId: $printRequestPrinterInternalId}
  ) {
    id
    tier1PrintRequestLabelType
  }
}
    `;
export type SaveTier1PrintRequestLabelTypeMutationFn = Apollo.MutationFunction<SaveTier1PrintRequestLabelTypeMutation, SaveTier1PrintRequestLabelTypeMutationVariables>;

/**
 * __useSaveTier1PrintRequestLabelTypeMutation__
 *
 * To run a mutation, you first call `useSaveTier1PrintRequestLabelTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveTier1PrintRequestLabelTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveTier1PrintRequestLabelTypeMutation, { data, loading, error }] = useSaveTier1PrintRequestLabelTypeMutation({
 *   variables: {
 *      storeId: // value for 'storeId'
 *      tier1PrintRequestLabelType: // value for 'tier1PrintRequestLabelType'
 *      printRequestFunctionInternalId: // value for 'printRequestFunctionInternalId'
 *      printRequestLabelInternalId: // value for 'printRequestLabelInternalId'
 *      printRequestPrinterInternalId: // value for 'printRequestPrinterInternalId'
 *   },
 * });
 */
export function useSaveTier1PrintRequestLabelTypeMutation(baseOptions?: Apollo.MutationHookOptions<SaveTier1PrintRequestLabelTypeMutation, SaveTier1PrintRequestLabelTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveTier1PrintRequestLabelTypeMutation, SaveTier1PrintRequestLabelTypeMutationVariables>(SaveTier1PrintRequestLabelTypeDocument, options);
      }
export type SaveTier1PrintRequestLabelTypeMutationHookResult = ReturnType<typeof useSaveTier1PrintRequestLabelTypeMutation>;
export type SaveTier1PrintRequestLabelTypeMutationResult = Apollo.MutationResult<SaveTier1PrintRequestLabelTypeMutation>;
export type SaveTier1PrintRequestLabelTypeMutationOptions = Apollo.BaseMutationOptions<SaveTier1PrintRequestLabelTypeMutation, SaveTier1PrintRequestLabelTypeMutationVariables>;
export const SaveShippingServicesDocument = gql`
    mutation SaveShippingServices($input: SaveShippingServicesInput!) {
  saveShippingServices(input: $input)
}
    `;
export type SaveShippingServicesMutationFn = Apollo.MutationFunction<SaveShippingServicesMutation, SaveShippingServicesMutationVariables>;

/**
 * __useSaveShippingServicesMutation__
 *
 * To run a mutation, you first call `useSaveShippingServicesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveShippingServicesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveShippingServicesMutation, { data, loading, error }] = useSaveShippingServicesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveShippingServicesMutation(baseOptions?: Apollo.MutationHookOptions<SaveShippingServicesMutation, SaveShippingServicesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveShippingServicesMutation, SaveShippingServicesMutationVariables>(SaveShippingServicesDocument, options);
      }
export type SaveShippingServicesMutationHookResult = ReturnType<typeof useSaveShippingServicesMutation>;
export type SaveShippingServicesMutationResult = Apollo.MutationResult<SaveShippingServicesMutation>;
export type SaveShippingServicesMutationOptions = Apollo.BaseMutationOptions<SaveShippingServicesMutation, SaveShippingServicesMutationVariables>;
export const ShippingServiceWidgetDocument = gql`
    query ShippingServiceWidget($storeId: ID!) {
  notMappedRequestedShippingServices(storeId: $storeId)
  store(id: $storeId) {
    id
    subsidiary {
      id
    }
    shippingServices {
      id
      requestedShippingService
      shipItem {
        id
      }
      thirdPartyAccount {
        id
      }
    }
  }
}
    `;

/**
 * __useShippingServiceWidgetQuery__
 *
 * To run a query within a React component, call `useShippingServiceWidgetQuery` and pass it any options that fit your needs.
 * When your component renders, `useShippingServiceWidgetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useShippingServiceWidgetQuery({
 *   variables: {
 *      storeId: // value for 'storeId'
 *   },
 * });
 */
export function useShippingServiceWidgetQuery(baseOptions: Apollo.QueryHookOptions<ShippingServiceWidgetQuery, ShippingServiceWidgetQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ShippingServiceWidgetQuery, ShippingServiceWidgetQueryVariables>(ShippingServiceWidgetDocument, options);
      }
export function useShippingServiceWidgetLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ShippingServiceWidgetQuery, ShippingServiceWidgetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ShippingServiceWidgetQuery, ShippingServiceWidgetQueryVariables>(ShippingServiceWidgetDocument, options);
        }
export type ShippingServiceWidgetQueryHookResult = ReturnType<typeof useShippingServiceWidgetQuery>;
export type ShippingServiceWidgetLazyQueryHookResult = ReturnType<typeof useShippingServiceWidgetLazyQuery>;
export type ShippingServiceWidgetQueryResult = Apollo.QueryResult<ShippingServiceWidgetQuery, ShippingServiceWidgetQueryVariables>;
export const SaveSoftwareVersionsDocument = gql`
    mutation SaveSoftwareVersions($input: SaveSoftwareVersionsInput!) {
  saveSoftwareVersions(input: $input) {
    id
    name
  }
}
    `;
export type SaveSoftwareVersionsMutationFn = Apollo.MutationFunction<SaveSoftwareVersionsMutation, SaveSoftwareVersionsMutationVariables>;

/**
 * __useSaveSoftwareVersionsMutation__
 *
 * To run a mutation, you first call `useSaveSoftwareVersionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveSoftwareVersionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveSoftwareVersionsMutation, { data, loading, error }] = useSaveSoftwareVersionsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveSoftwareVersionsMutation(baseOptions?: Apollo.MutationHookOptions<SaveSoftwareVersionsMutation, SaveSoftwareVersionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveSoftwareVersionsMutation, SaveSoftwareVersionsMutationVariables>(SaveSoftwareVersionsDocument, options);
      }
export type SaveSoftwareVersionsMutationHookResult = ReturnType<typeof useSaveSoftwareVersionsMutation>;
export type SaveSoftwareVersionsMutationResult = Apollo.MutationResult<SaveSoftwareVersionsMutation>;
export type SaveSoftwareVersionsMutationOptions = Apollo.BaseMutationOptions<SaveSoftwareVersionsMutation, SaveSoftwareVersionsMutationVariables>;
export const SoftwareVersionsWidgetDocument = gql`
    query SoftwareVersionsWidget($storeId: ID!) {
  store(id: $storeId) {
    id
    softwareVersions {
      id
      name
    }
  }
}
    `;

/**
 * __useSoftwareVersionsWidgetQuery__
 *
 * To run a query within a React component, call `useSoftwareVersionsWidgetQuery` and pass it any options that fit your needs.
 * When your component renders, `useSoftwareVersionsWidgetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSoftwareVersionsWidgetQuery({
 *   variables: {
 *      storeId: // value for 'storeId'
 *   },
 * });
 */
export function useSoftwareVersionsWidgetQuery(baseOptions: Apollo.QueryHookOptions<SoftwareVersionsWidgetQuery, SoftwareVersionsWidgetQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SoftwareVersionsWidgetQuery, SoftwareVersionsWidgetQueryVariables>(SoftwareVersionsWidgetDocument, options);
      }
export function useSoftwareVersionsWidgetLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SoftwareVersionsWidgetQuery, SoftwareVersionsWidgetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SoftwareVersionsWidgetQuery, SoftwareVersionsWidgetQueryVariables>(SoftwareVersionsWidgetDocument, options);
        }
export type SoftwareVersionsWidgetQueryHookResult = ReturnType<typeof useSoftwareVersionsWidgetQuery>;
export type SoftwareVersionsWidgetLazyQueryHookResult = ReturnType<typeof useSoftwareVersionsWidgetLazyQuery>;
export type SoftwareVersionsWidgetQueryResult = Apollo.QueryResult<SoftwareVersionsWidgetQuery, SoftwareVersionsWidgetQueryVariables>;
export const SaveTriageReasonsDocument = gql`
    mutation SaveTriageReasons($input: SaveTriageReasonsInput!) {
  saveTriageReasons(input: $input) {
    id
    reasonText
  }
}
    `;
export type SaveTriageReasonsMutationFn = Apollo.MutationFunction<SaveTriageReasonsMutation, SaveTriageReasonsMutationVariables>;

/**
 * __useSaveTriageReasonsMutation__
 *
 * To run a mutation, you first call `useSaveTriageReasonsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveTriageReasonsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveTriageReasonsMutation, { data, loading, error }] = useSaveTriageReasonsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveTriageReasonsMutation(baseOptions?: Apollo.MutationHookOptions<SaveTriageReasonsMutation, SaveTriageReasonsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveTriageReasonsMutation, SaveTriageReasonsMutationVariables>(SaveTriageReasonsDocument, options);
      }
export type SaveTriageReasonsMutationHookResult = ReturnType<typeof useSaveTriageReasonsMutation>;
export type SaveTriageReasonsMutationResult = Apollo.MutationResult<SaveTriageReasonsMutation>;
export type SaveTriageReasonsMutationOptions = Apollo.BaseMutationOptions<SaveTriageReasonsMutation, SaveTriageReasonsMutationVariables>;
export const TriageReasonsWidgetDocument = gql`
    query TriageReasonsWidget($storeId: ID!) {
  store(id: $storeId) {
    id
    triageReasons {
      id
      reasonText
    }
  }
}
    `;

/**
 * __useTriageReasonsWidgetQuery__
 *
 * To run a query within a React component, call `useTriageReasonsWidgetQuery` and pass it any options that fit your needs.
 * When your component renders, `useTriageReasonsWidgetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTriageReasonsWidgetQuery({
 *   variables: {
 *      storeId: // value for 'storeId'
 *   },
 * });
 */
export function useTriageReasonsWidgetQuery(baseOptions: Apollo.QueryHookOptions<TriageReasonsWidgetQuery, TriageReasonsWidgetQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TriageReasonsWidgetQuery, TriageReasonsWidgetQueryVariables>(TriageReasonsWidgetDocument, options);
      }
export function useTriageReasonsWidgetLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TriageReasonsWidgetQuery, TriageReasonsWidgetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TriageReasonsWidgetQuery, TriageReasonsWidgetQueryVariables>(TriageReasonsWidgetDocument, options);
        }
export type TriageReasonsWidgetQueryHookResult = ReturnType<typeof useTriageReasonsWidgetQuery>;
export type TriageReasonsWidgetLazyQueryHookResult = ReturnType<typeof useTriageReasonsWidgetLazyQuery>;
export type TriageReasonsWidgetQueryResult = Apollo.QueryResult<TriageReasonsWidgetQuery, TriageReasonsWidgetQueryVariables>;
export const SaveTriageWorkflowsDocument = gql`
    mutation SaveTriageWorkflows($input: SaveTriageWorkflowsInput!) {
  saveTriageWorkflows(input: $input) {
    id
    name
    type {
      id
      name
      displayName
    }
    netSuiteBinInternalId
    isEnabled
  }
}
    `;
export type SaveTriageWorkflowsMutationFn = Apollo.MutationFunction<SaveTriageWorkflowsMutation, SaveTriageWorkflowsMutationVariables>;

/**
 * __useSaveTriageWorkflowsMutation__
 *
 * To run a mutation, you first call `useSaveTriageWorkflowsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveTriageWorkflowsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveTriageWorkflowsMutation, { data, loading, error }] = useSaveTriageWorkflowsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveTriageWorkflowsMutation(baseOptions?: Apollo.MutationHookOptions<SaveTriageWorkflowsMutation, SaveTriageWorkflowsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveTriageWorkflowsMutation, SaveTriageWorkflowsMutationVariables>(SaveTriageWorkflowsDocument, options);
      }
export type SaveTriageWorkflowsMutationHookResult = ReturnType<typeof useSaveTriageWorkflowsMutation>;
export type SaveTriageWorkflowsMutationResult = Apollo.MutationResult<SaveTriageWorkflowsMutation>;
export type SaveTriageWorkflowsMutationOptions = Apollo.BaseMutationOptions<SaveTriageWorkflowsMutation, SaveTriageWorkflowsMutationVariables>;
export const TriageWorkflowsWidgetDocument = gql`
    query TriageWorkflowsWidget($storeId: ID!) {
  store(id: $storeId) {
    id
    triageWorkflows {
      id
      name
      isEnabled
      type {
        id
        name
        displayName
      }
      netSuiteBinInternalId
    }
  }
}
    `;

/**
 * __useTriageWorkflowsWidgetQuery__
 *
 * To run a query within a React component, call `useTriageWorkflowsWidgetQuery` and pass it any options that fit your needs.
 * When your component renders, `useTriageWorkflowsWidgetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTriageWorkflowsWidgetQuery({
 *   variables: {
 *      storeId: // value for 'storeId'
 *   },
 * });
 */
export function useTriageWorkflowsWidgetQuery(baseOptions: Apollo.QueryHookOptions<TriageWorkflowsWidgetQuery, TriageWorkflowsWidgetQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TriageWorkflowsWidgetQuery, TriageWorkflowsWidgetQueryVariables>(TriageWorkflowsWidgetDocument, options);
      }
export function useTriageWorkflowsWidgetLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TriageWorkflowsWidgetQuery, TriageWorkflowsWidgetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TriageWorkflowsWidgetQuery, TriageWorkflowsWidgetQueryVariables>(TriageWorkflowsWidgetDocument, options);
        }
export type TriageWorkflowsWidgetQueryHookResult = ReturnType<typeof useTriageWorkflowsWidgetQuery>;
export type TriageWorkflowsWidgetLazyQueryHookResult = ReturnType<typeof useTriageWorkflowsWidgetLazyQuery>;
export type TriageWorkflowsWidgetQueryResult = Apollo.QueryResult<TriageWorkflowsWidgetQuery, TriageWorkflowsWidgetQueryVariables>;
export const BeginTriageModalDocument = gql`
    query BeginTriageModal($returnAuthorizationId: ID!) {
  tier1ReturnAuthorization(id: $returnAuthorizationId) {
    id
    returnNumber
    problemStatements
    customerComment
    itemReceipt {
      id
      serialNumber
      item {
        id
        sku
        name
      }
    }
    group {
      id
      referenceNumber
      store {
        id
      }
    }
  }
}
    `;

/**
 * __useBeginTriageModalQuery__
 *
 * To run a query within a React component, call `useBeginTriageModalQuery` and pass it any options that fit your needs.
 * When your component renders, `useBeginTriageModalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBeginTriageModalQuery({
 *   variables: {
 *      returnAuthorizationId: // value for 'returnAuthorizationId'
 *   },
 * });
 */
export function useBeginTriageModalQuery(baseOptions: Apollo.QueryHookOptions<BeginTriageModalQuery, BeginTriageModalQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BeginTriageModalQuery, BeginTriageModalQueryVariables>(BeginTriageModalDocument, options);
      }
export function useBeginTriageModalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BeginTriageModalQuery, BeginTriageModalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BeginTriageModalQuery, BeginTriageModalQueryVariables>(BeginTriageModalDocument, options);
        }
export type BeginTriageModalQueryHookResult = ReturnType<typeof useBeginTriageModalQuery>;
export type BeginTriageModalLazyQueryHookResult = ReturnType<typeof useBeginTriageModalLazyQuery>;
export type BeginTriageModalQueryResult = Apollo.QueryResult<BeginTriageModalQuery, BeginTriageModalQueryVariables>;
export const SaveTriageObservationDocument = gql`
    mutation SaveTriageObservation($input: SaveTriageObservationInput!) {
  saveTriageObservation(input: $input) {
    id
    observation {
      id
      createdTimestamp
      reasonText
      createdBy {
        id
        fullName
        email
      }
    }
  }
}
    `;
export type SaveTriageObservationMutationFn = Apollo.MutationFunction<SaveTriageObservationMutation, SaveTriageObservationMutationVariables>;

/**
 * __useSaveTriageObservationMutation__
 *
 * To run a mutation, you first call `useSaveTriageObservationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveTriageObservationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveTriageObservationMutation, { data, loading, error }] = useSaveTriageObservationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveTriageObservationMutation(baseOptions?: Apollo.MutationHookOptions<SaveTriageObservationMutation, SaveTriageObservationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveTriageObservationMutation, SaveTriageObservationMutationVariables>(SaveTriageObservationDocument, options);
      }
export type SaveTriageObservationMutationHookResult = ReturnType<typeof useSaveTriageObservationMutation>;
export type SaveTriageObservationMutationResult = Apollo.MutationResult<SaveTriageObservationMutation>;
export type SaveTriageObservationMutationOptions = Apollo.BaseMutationOptions<SaveTriageObservationMutation, SaveTriageObservationMutationVariables>;
export const CreditReturnAuthorizationModalDocument = gql`
    query CreditReturnAuthorizationModal($returnAuthorizationId: ID!) {
  tier1ReturnAuthorization(id: $returnAuthorizationId) {
    id
    itemReceipt {
      id
      serialNumber
    }
    group {
      id
      store {
        id
        triageWorkflows {
          id
          type {
            id
            name
            displayName
          }
        }
      }
    }
  }
}
    `;

/**
 * __useCreditReturnAuthorizationModalQuery__
 *
 * To run a query within a React component, call `useCreditReturnAuthorizationModalQuery` and pass it any options that fit your needs.
 * When your component renders, `useCreditReturnAuthorizationModalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCreditReturnAuthorizationModalQuery({
 *   variables: {
 *      returnAuthorizationId: // value for 'returnAuthorizationId'
 *   },
 * });
 */
export function useCreditReturnAuthorizationModalQuery(baseOptions: Apollo.QueryHookOptions<CreditReturnAuthorizationModalQuery, CreditReturnAuthorizationModalQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CreditReturnAuthorizationModalQuery, CreditReturnAuthorizationModalQueryVariables>(CreditReturnAuthorizationModalDocument, options);
      }
export function useCreditReturnAuthorizationModalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CreditReturnAuthorizationModalQuery, CreditReturnAuthorizationModalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CreditReturnAuthorizationModalQuery, CreditReturnAuthorizationModalQueryVariables>(CreditReturnAuthorizationModalDocument, options);
        }
export type CreditReturnAuthorizationModalQueryHookResult = ReturnType<typeof useCreditReturnAuthorizationModalQuery>;
export type CreditReturnAuthorizationModalLazyQueryHookResult = ReturnType<typeof useCreditReturnAuthorizationModalLazyQuery>;
export type CreditReturnAuthorizationModalQueryResult = Apollo.QueryResult<CreditReturnAuthorizationModalQuery, CreditReturnAuthorizationModalQueryVariables>;
export const SubmitQualityControlCheckDocument = gql`
    mutation SubmitQualityControlCheck($input: SubmitQualityControlCheckInput!) {
  submitQualityControlCheck(input: $input) {
    id
    qualityControlCheck {
      id
      createdTimestamp
    }
  }
}
    `;
export type SubmitQualityControlCheckMutationFn = Apollo.MutationFunction<SubmitQualityControlCheckMutation, SubmitQualityControlCheckMutationVariables>;

/**
 * __useSubmitQualityControlCheckMutation__
 *
 * To run a mutation, you first call `useSubmitQualityControlCheckMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitQualityControlCheckMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitQualityControlCheckMutation, { data, loading, error }] = useSubmitQualityControlCheckMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSubmitQualityControlCheckMutation(baseOptions?: Apollo.MutationHookOptions<SubmitQualityControlCheckMutation, SubmitQualityControlCheckMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubmitQualityControlCheckMutation, SubmitQualityControlCheckMutationVariables>(SubmitQualityControlCheckDocument, options);
      }
export type SubmitQualityControlCheckMutationHookResult = ReturnType<typeof useSubmitQualityControlCheckMutation>;
export type SubmitQualityControlCheckMutationResult = Apollo.MutationResult<SubmitQualityControlCheckMutation>;
export type SubmitQualityControlCheckMutationOptions = Apollo.BaseMutationOptions<SubmitQualityControlCheckMutation, SubmitQualityControlCheckMutationVariables>;
export const ReceiveTier1ReturnAuthorizationDocument = gql`
    mutation ReceiveTier1ReturnAuthorization($input: ReceiveTier1ReturnAuthorizationInput!) {
  receiveTier1ReturnAuthorization(input: $input) {
    id
    itemReceipt {
      id
      createdTimestamp
      createdBy {
        id
        fullName
      }
      serialNumber
      item {
        id
        sku
        name
      }
    }
  }
}
    `;
export type ReceiveTier1ReturnAuthorizationMutationFn = Apollo.MutationFunction<ReceiveTier1ReturnAuthorizationMutation, ReceiveTier1ReturnAuthorizationMutationVariables>;

/**
 * __useReceiveTier1ReturnAuthorizationMutation__
 *
 * To run a mutation, you first call `useReceiveTier1ReturnAuthorizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReceiveTier1ReturnAuthorizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [receiveTier1ReturnAuthorizationMutation, { data, loading, error }] = useReceiveTier1ReturnAuthorizationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useReceiveTier1ReturnAuthorizationMutation(baseOptions?: Apollo.MutationHookOptions<ReceiveTier1ReturnAuthorizationMutation, ReceiveTier1ReturnAuthorizationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReceiveTier1ReturnAuthorizationMutation, ReceiveTier1ReturnAuthorizationMutationVariables>(ReceiveTier1ReturnAuthorizationDocument, options);
      }
export type ReceiveTier1ReturnAuthorizationMutationHookResult = ReturnType<typeof useReceiveTier1ReturnAuthorizationMutation>;
export type ReceiveTier1ReturnAuthorizationMutationResult = Apollo.MutationResult<ReceiveTier1ReturnAuthorizationMutation>;
export type ReceiveTier1ReturnAuthorizationMutationOptions = Apollo.BaseMutationOptions<ReceiveTier1ReturnAuthorizationMutation, ReceiveTier1ReturnAuthorizationMutationVariables>;
export const ReceiveTier1ReturnAuthorizationModalDocument = gql`
    query ReceiveTier1ReturnAuthorizationModal($returnAuthorizationId: ID!) {
  tier1ReturnAuthorization(id: $returnAuthorizationId) {
    id
    expectedSerialNumber
    item {
      id
      sku
      name
    }
  }
}
    `;

/**
 * __useReceiveTier1ReturnAuthorizationModalQuery__
 *
 * To run a query within a React component, call `useReceiveTier1ReturnAuthorizationModalQuery` and pass it any options that fit your needs.
 * When your component renders, `useReceiveTier1ReturnAuthorizationModalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReceiveTier1ReturnAuthorizationModalQuery({
 *   variables: {
 *      returnAuthorizationId: // value for 'returnAuthorizationId'
 *   },
 * });
 */
export function useReceiveTier1ReturnAuthorizationModalQuery(baseOptions: Apollo.QueryHookOptions<ReceiveTier1ReturnAuthorizationModalQuery, ReceiveTier1ReturnAuthorizationModalQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReceiveTier1ReturnAuthorizationModalQuery, ReceiveTier1ReturnAuthorizationModalQueryVariables>(ReceiveTier1ReturnAuthorizationModalDocument, options);
      }
export function useReceiveTier1ReturnAuthorizationModalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReceiveTier1ReturnAuthorizationModalQuery, ReceiveTier1ReturnAuthorizationModalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReceiveTier1ReturnAuthorizationModalQuery, ReceiveTier1ReturnAuthorizationModalQueryVariables>(ReceiveTier1ReturnAuthorizationModalDocument, options);
        }
export type ReceiveTier1ReturnAuthorizationModalQueryHookResult = ReturnType<typeof useReceiveTier1ReturnAuthorizationModalQuery>;
export type ReceiveTier1ReturnAuthorizationModalLazyQueryHookResult = ReturnType<typeof useReceiveTier1ReturnAuthorizationModalLazyQuery>;
export type ReceiveTier1ReturnAuthorizationModalQueryResult = Apollo.QueryResult<ReceiveTier1ReturnAuthorizationModalQuery, ReceiveTier1ReturnAuthorizationModalQueryVariables>;
export const ReplaceItemModalDocument = gql`
    query ReplaceItemModal($returnAuthorizationId: ID!) {
  tier1ReturnAuthorization(id: $returnAuthorizationId) {
    id
    itemReceipt {
      id
      serialNumber
    }
    group {
      id
      store {
        id
        triageWorkflows {
          id
          type {
            id
            name
            displayName
          }
          netSuiteBinInternalId
        }
      }
    }
  }
}
    `;

/**
 * __useReplaceItemModalQuery__
 *
 * To run a query within a React component, call `useReplaceItemModalQuery` and pass it any options that fit your needs.
 * When your component renders, `useReplaceItemModalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReplaceItemModalQuery({
 *   variables: {
 *      returnAuthorizationId: // value for 'returnAuthorizationId'
 *   },
 * });
 */
export function useReplaceItemModalQuery(baseOptions: Apollo.QueryHookOptions<ReplaceItemModalQuery, ReplaceItemModalQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReplaceItemModalQuery, ReplaceItemModalQueryVariables>(ReplaceItemModalDocument, options);
      }
export function useReplaceItemModalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReplaceItemModalQuery, ReplaceItemModalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReplaceItemModalQuery, ReplaceItemModalQueryVariables>(ReplaceItemModalDocument, options);
        }
export type ReplaceItemModalQueryHookResult = ReturnType<typeof useReplaceItemModalQuery>;
export type ReplaceItemModalLazyQueryHookResult = ReturnType<typeof useReplaceItemModalLazyQuery>;
export type ReplaceItemModalQueryResult = Apollo.QueryResult<ReplaceItemModalQuery, ReplaceItemModalQueryVariables>;
export const RestockItemModalDocument = gql`
    query RestockItemModal($returnAuthorizationId: ID!) {
  tier1ReturnAuthorization(id: $returnAuthorizationId) {
    id
    group {
      id
      store {
        id
        triageWorkflows {
          id
          type {
            id
            name
            displayName
          }
          netSuiteBinInternalId
        }
      }
    }
    itemReceipt {
      id
      item {
        id
        name
        sku
      }
    }
    selectedTriage {
      ...returnAuthorizationTriageFields
    }
  }
}
    ${ReturnAuthorizationTriageFieldsFragmentDoc}`;

/**
 * __useRestockItemModalQuery__
 *
 * To run a query within a React component, call `useRestockItemModalQuery` and pass it any options that fit your needs.
 * When your component renders, `useRestockItemModalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRestockItemModalQuery({
 *   variables: {
 *      returnAuthorizationId: // value for 'returnAuthorizationId'
 *   },
 * });
 */
export function useRestockItemModalQuery(baseOptions: Apollo.QueryHookOptions<RestockItemModalQuery, RestockItemModalQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RestockItemModalQuery, RestockItemModalQueryVariables>(RestockItemModalDocument, options);
      }
export function useRestockItemModalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RestockItemModalQuery, RestockItemModalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RestockItemModalQuery, RestockItemModalQueryVariables>(RestockItemModalDocument, options);
        }
export type RestockItemModalQueryHookResult = ReturnType<typeof useRestockItemModalQuery>;
export type RestockItemModalLazyQueryHookResult = ReturnType<typeof useRestockItemModalLazyQuery>;
export type RestockItemModalQueryResult = Apollo.QueryResult<RestockItemModalQuery, RestockItemModalQueryVariables>;
export const ReturnItemModalDocument = gql`
    query ReturnItemModal($returnAuthorizationId: ID!) {
  tier1ReturnAuthorization(id: $returnAuthorizationId) {
    id
    itemReceipt {
      id
      serialNumber
    }
    group {
      id
      store {
        id
        triageWorkflows {
          id
          type {
            id
            name
            displayName
          }
          netSuiteBinInternalId
        }
      }
    }
  }
}
    `;

/**
 * __useReturnItemModalQuery__
 *
 * To run a query within a React component, call `useReturnItemModalQuery` and pass it any options that fit your needs.
 * When your component renders, `useReturnItemModalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReturnItemModalQuery({
 *   variables: {
 *      returnAuthorizationId: // value for 'returnAuthorizationId'
 *   },
 * });
 */
export function useReturnItemModalQuery(baseOptions: Apollo.QueryHookOptions<ReturnItemModalQuery, ReturnItemModalQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReturnItemModalQuery, ReturnItemModalQueryVariables>(ReturnItemModalDocument, options);
      }
export function useReturnItemModalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReturnItemModalQuery, ReturnItemModalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReturnItemModalQuery, ReturnItemModalQueryVariables>(ReturnItemModalDocument, options);
        }
export type ReturnItemModalQueryHookResult = ReturnType<typeof useReturnItemModalQuery>;
export type ReturnItemModalLazyQueryHookResult = ReturnType<typeof useReturnItemModalLazyQuery>;
export type ReturnItemModalQueryResult = Apollo.QueryResult<ReturnItemModalQuery, ReturnItemModalQueryVariables>;
export const ScrapItemModalDocument = gql`
    query ScrapItemModal($returnAuthorizationId: ID!) {
  tier1ReturnAuthorization(id: $returnAuthorizationId) {
    id
    itemReceipt {
      id
      serialNumber
    }
    group {
      id
      store {
        id
        triageWorkflows {
          id
          type {
            id
            name
            displayName
          }
          netSuiteBinInternalId
        }
      }
    }
  }
}
    `;

/**
 * __useScrapItemModalQuery__
 *
 * To run a query within a React component, call `useScrapItemModalQuery` and pass it any options that fit your needs.
 * When your component renders, `useScrapItemModalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useScrapItemModalQuery({
 *   variables: {
 *      returnAuthorizationId: // value for 'returnAuthorizationId'
 *   },
 * });
 */
export function useScrapItemModalQuery(baseOptions: Apollo.QueryHookOptions<ScrapItemModalQuery, ScrapItemModalQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ScrapItemModalQuery, ScrapItemModalQueryVariables>(ScrapItemModalDocument, options);
      }
export function useScrapItemModalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ScrapItemModalQuery, ScrapItemModalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ScrapItemModalQuery, ScrapItemModalQueryVariables>(ScrapItemModalDocument, options);
        }
export type ScrapItemModalQueryHookResult = ReturnType<typeof useScrapItemModalQuery>;
export type ScrapItemModalLazyQueryHookResult = ReturnType<typeof useScrapItemModalLazyQuery>;
export type ScrapItemModalQueryResult = Apollo.QueryResult<ScrapItemModalQuery, ScrapItemModalQueryVariables>;
export const TriageTier1ReturnAuthorizationDocument = gql`
    mutation TriageTier1ReturnAuthorization($input: TriageTier1ReturnAuthorizationInput!) {
  triageTier1ReturnAuthorization(input: $input) {
    id
    createdTimestamp
    itemReceipt {
      id
      createdTimestamp
    }
    observation {
      id
      createdTimestamp
    }
    selectedTriage {
      id
      createdTimestamp
      workflow {
        id
        type {
          id
          name
          displayName
        }
      }
    }
    group {
      id
      referenceNumber
      store {
        id
        name
      }
    }
  }
}
    `;
export type TriageTier1ReturnAuthorizationMutationFn = Apollo.MutationFunction<TriageTier1ReturnAuthorizationMutation, TriageTier1ReturnAuthorizationMutationVariables>;

/**
 * __useTriageTier1ReturnAuthorizationMutation__
 *
 * To run a mutation, you first call `useTriageTier1ReturnAuthorizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTriageTier1ReturnAuthorizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [triageTier1ReturnAuthorizationMutation, { data, loading, error }] = useTriageTier1ReturnAuthorizationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useTriageTier1ReturnAuthorizationMutation(baseOptions?: Apollo.MutationHookOptions<TriageTier1ReturnAuthorizationMutation, TriageTier1ReturnAuthorizationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TriageTier1ReturnAuthorizationMutation, TriageTier1ReturnAuthorizationMutationVariables>(TriageTier1ReturnAuthorizationDocument, options);
      }
export type TriageTier1ReturnAuthorizationMutationHookResult = ReturnType<typeof useTriageTier1ReturnAuthorizationMutation>;
export type TriageTier1ReturnAuthorizationMutationResult = Apollo.MutationResult<TriageTier1ReturnAuthorizationMutation>;
export type TriageTier1ReturnAuthorizationMutationOptions = Apollo.BaseMutationOptions<TriageTier1ReturnAuthorizationMutation, TriageTier1ReturnAuthorizationMutationVariables>;

      export interface PossibleTypesResultData {
        possibleTypes: {
          [key: string]: string[]
        }
      }
      const result: PossibleTypesResultData = {
  "possibleTypes": {
    "FulfillmentDestination": [
      "SmartPayMerchant"
    ],
    "Node": [
      "AppleCareAgreement",
      "AuditLogEvent",
      "ChatMessage",
      "Customer",
      "EligibleOrder",
      "ExternalOrder",
      "FulfillmentLineItem",
      "HttpRequest",
      "Invite",
      "Item",
      "ItemFulfillment",
      "JiraTicket",
      "LineItemUnbundler",
      "Listing",
      "ListingManagementStrategyTemplate",
      "ListingManagementStrategyTemplateGroup",
      "NetSuitePaymentMethod",
      "NetSuiteWriteRequest",
      "Order",
      "Partner",
      "PaymentMethodMapping",
      "Product",
      "ReturnAuthorization",
      "ReturnAuthorizationLineItem",
      "SendGridEmailRequest",
      "ShipItem",
      "ShippingService",
      "SiteUserFull",
      "SmartPayLeaseApplication",
      "Store",
      "ThirdPartyAccount",
      "Tier1ReturnAuthorization",
      "Tier1ReturnAuthorizationGroup",
      "UserRoleTemplate"
    ],
    "Page": [
      "AppleCareAgreementPage",
      "AuditLogEventPage",
      "ChatMessagePage",
      "CustomerPage",
      "EligibleOrderPage",
      "ExternalOrdersPage",
      "FulfillmentLineItemPage",
      "InvitePage",
      "ItemPage",
      "JiraTicketPage",
      "LineItemUnbundlerPage",
      "ListingManagementStrategyTemplatePage",
      "ListingPage",
      "NetSuiteWriteRequestPage",
      "OrderPage",
      "ProductsPage",
      "ReturnAuthorizationPage",
      "SendGridEmailRequestPage",
      "ShipItemPage",
      "SiteUserFullPage",
      "SmartPayLeaseApplicationPage",
      "StorePage",
      "ThirdPartyAccountPage",
      "Tier1ReturnAuthorizationGroupPage",
      "Tier1ReturnAuthorizationPage",
      "UserRoleTemplatePage"
    ],
    "StoreMetaData": [
      "SftpStoreMetaData",
      "ShopifyStoreMetaData",
      "Telgoo5StoreMetaData",
      "WooCommerceStoreMetaData"
    ]
  }
};
      export default result;
    